import {ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NzModalComponent, NzModalContentDirective, NzModalService} from 'ng-zorro-antd/modal';
import {NzMessageService} from 'ng-zorro-antd/message';
import {NzTableComponent, NzTableModule, NzThAddOnComponent} from 'ng-zorro-antd/table';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {NzButtonComponent, NzButtonModule} from 'ng-zorro-antd/button';
import {NzTooltipDirective, NzToolTipModule} from 'ng-zorro-antd/tooltip';
import {NzPopoverDirective, NzPopoverModule} from 'ng-zorro-antd/popover';
import {NzTimePickerModule} from 'ng-zorro-antd/time-picker';
import {NzIconDirective, NzIconModule} from 'ng-zorro-antd/icon';
import {NzInputDirective, NzInputModule} from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators
} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent, NzFormTextComponent} from 'ng-zorro-antd/form';
import {NzColDirective, NzRowDirective} from 'ng-zorro-antd/grid';
import {NzOptionComponent, NzSelectComponent, NzSelectModule} from 'ng-zorro-antd/select';
import {
  BulkApplyDocumentSectionPayload,
  BulkApplyEmergencyInstructionPayload,
  BulkDeleteDocumentSectionPayload,
  BulkDeleteEmergencyInstructionPayload,
  BulkEditDocumentSectionPayload,
  BulkEditEmergencyInstructionPayload,
  BulkApplyDocumentSectionResponse,
  BulkApplyEmergencyInstructionResponse,
  BulkPropertyMutationResponse,
  DistributionOverviewGroup,
  DistributionOverviewGroupProperty,
  DistributionOverviewGroupDetailsResponse,
  DistributionOverviewResponse,
  PromoteDistributionSourceResponse,
  DistributionStatusProperty,
  DistributionStatusResponse,
  DistributionStatusValue,
  PropertyBulkApplyScope,
  PropertyService
} from '../services/property.service';
import * as XLSX from 'xlsx';
import {NzRadioComponent, NzRadioGroupComponent, NzRadioModule} from 'ng-zorro-antd/radio';
import {NzSwitchModule} from 'ng-zorro-antd/switch';
import {NzCheckboxComponent, NzCheckboxModule} from 'ng-zorro-antd/checkbox';
import {TemplateService} from '../services/template.service';
import {CompanyService} from '../services/company.service';
import {Company, LandingProfile} from '../company/company.models';
import {NzAlertComponent} from 'ng-zorro-antd/alert';
import {NzPaginationComponent} from 'ng-zorro-antd/pagination';
import {ProgressService} from '../services/progress.service';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import {ReplaceSlashWithUnderscorePipe} from '../pipes/replace-slash-with-underscore.pipe';
import {ADDRESS_PATTERN} from '../constants/app.constants';
import {lastValueFrom, Subscription, firstValueFrom, Observable, Subject} from 'rxjs';
import {filter, finalize, finalize as rxFinalize, take, tap, map} from 'rxjs/operators';
import {NzCollapseComponent, NzCollapsePanelComponent} from 'ng-zorro-antd/collapse';
import {NzUploadComponent, NzUploadFile, NzUploadModule, NzUploadXHRArgs} from 'ng-zorro-antd/upload';
import {DomSanitizer} from '@angular/platform-browser';
import {NzImage, NzImageService} from 'ng-zorro-antd/image';
import {ActivatedRoute, Router} from '@angular/router';
import {NzDropDownModule} from 'ng-zorro-antd/dropdown';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {GermanPhoneNormalizerService} from '../services/german.phone.normalizer.service';
import { QrPosterDocumentService } from '../services/qr-poster-document.service';
import { SavedQrPosterTemplate } from '../models/qr-poster-template.model';
import {
  QrPosterPdfPreviewRender,
  QrPosterPdfPreviewService,
} from '../services/qr-poster-pdf-preview.service';
import { QrPosterRenderDescriptorResponse } from '../models/qr-poster-render-descriptor.model';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import {AuthService} from '../services/auth.service';
import {BillingService} from '../services/billing.service';
import { UpgradeContractModalComponent } from '../billing/upgrade-contract-modal.component';
import {AppMode, DEFAULT_APP_MODE} from '../models/app-mode.model';
import { TourActionRegistryService } from '../services/tour-action-registry.service';
import { ScrollingModule } from '@angular/cdk/scrolling';
import {NzDrawerModule} from 'ng-zorro-antd/drawer';
import {NzStepsModule} from 'ng-zorro-antd/steps';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {NzTagModule} from 'ng-zorro-antd/tag';
import {
  Employee,
  CaretakerContactPerson,
  EmergencyInstructionAction,
  EmergencyInstructionActionContactRef,
  EmergencyInstructionActionContactSourceType,
  EmergencyInstructionActionDocument,
  EmergencyInstructionActionType,
  HospitalityApplianceGuide,
  HospitalityAdditionalInfoDisplayEntry,
  HospitalityCheckInOwnedEntry,
  HospitalityCheckOutDisplayEntry,
  HospitalityCheckOutOwnedEntry,
  HospitalityHouseRuleOwnedEntry,
  HospitalityLink,
  HospitalityLinkDocument,
  Property,
  PropertyExternalReference,
  PropertyPmsDocument,
  PropertyDocumentSection,
  PropertyDocumentSectionUi,
  PropertyDocumentsResponse,
  PropertyTechnicalServiceAssignment,
  SavedHeaders,
  Service, EmergencyInstruction, EmergencyInstructionCategory, EmergencyInstructionScenarioKey, EmergencyInstructionStep, EmergencyInstructionUrgency,
} from './property-list.models';
import {
  defaultSavedHeaders,
  MANAGER_KEY_MAPPING,
  ACCOUNTANT_KEY_MAPPING,
  SEV_MANAGER_KEY_MAPPING,
  SERVICE_TYPE_TRANSLATION_KEYS,
  TECHNICAL_ASSETS_MANAGER_KEY_MAPPING,
} from './property-list.constants';
import {
  formatServiceTypeHeader,
  isPropertyMatch,
  PropertyListSearchConfiguration,
  splitAddress,
  VisibleEmployeeSearchField,
} from './property-list.helpers';
import { matchesPhoneSearch } from '../utils/search-normalization.utils';
import {
  createEmptyPropertyDocumentSection,
  normalizePropertyDocumentSection,
  normalizePropertyDocumentSectionFile,
  toSavablePropertyDocumentSections,
  validatePropertyDocumentSections,
} from './property-document-section.helpers';
import { PropertyListHospitalityMixin } from './property-list.hospitality.mixin';
import {HospitalityLinkPreviewComponent} from '../hospitality-link-preview/hospitality-link-preview.component';
import {NzBadgeModule} from 'ng-zorro-antd/badge';
import {NzProgressComponent} from 'ng-zorro-antd/progress';
import {TechnicalServicesSelectorComponent} from './technical-services-selector/technical-services-selector.component';
import {TechnicalServicesOrderingService} from './technical-services-selector/technical-services-ordering.service';
import {TechnicalServiceSelectionChange} from './technical-services-selector/technical-services-ordering.types';
import { InlineAddKind, PropertyInlineContactAddService } from './property-inline-contact-add.service';
import { ContactUpsertModalService } from '../contact-list/contact-upsert-modal.service';
import { openDocumentSectionFile } from '../landing-page/document-sections/document-sections.component';
import {
  createDefaultTechnicalServiceCategoryOrder,
  createEmptyTechnicalServiceHeaderOrder,
  normalizeTechnicalServiceCategoryOrder,
  TechnicalServiceCategoryOrder,
  TechnicalServiceHeaderOrder
} from '../utils/technical-service-categories';
import { isForbiddenError, shouldSuppressGenericError } from '../utils/http-error.utils';
import { getServiceTypes, normalizeServiceContact } from '../utils/service-type.utils';
import { PropertyImportService } from '../services/property-import.service';
import { PropertyImportJobStatusResponse, PropertyImportSource } from '../models/property-import.models';
import { PropertyImportProgressComponent } from './property-import-progress.component';
import {
  translatePropertyImportBestFailureMessage,
  translatePropertyImportJobMessage,
  translatePropertyImportMessage
} from '../utils/property-import-message.utils';
import { isValidGermanMobileNumber, isValidGermanPhoneNumber } from '../utils/validators/phone.validator';

const PROPERTIES_PRIMARY_ACTIONS_SELECTOR = '[data-tour="properties-primary-actions"]';
const PROPERTIES_PRIMARY_ACTIONS_STABLE_FRAMES = 2;
const PROPERTIES_PRIMARY_ACTIONS_MAX_STABILITY_FRAMES = 120;
const PROPERTIES_PRIMARY_ACTIONS_RECT_TOLERANCE_PX = 1;
const TOUR_MODAL_TARGET_STABLE_FRAMES = 2;
const TOUR_MODAL_TARGET_MAX_STABILITY_FRAMES = 120;

type HospitalityDetailsDrawerContext = {
  checkInOwned: HospitalityCheckInOwnedEntry[];
  checkInCompany: HospitalityCheckInOwnedEntry[];
  checkOutOwned: HospitalityCheckOutOwnedEntry[];
  checkOutCompany: HospitalityCheckOutDisplayEntry[];
  houseRulesOwned: HospitalityHouseRuleOwnedEntry[];
  houseRulesCompany: HospitalityHouseRuleOwnedEntry[];
  applianceGuidesOwned: HospitalityApplianceGuide[];
  applianceGuidesCompany: HospitalityApplianceGuide[];
  additionalInfoOwned: HospitalityAdditionalInfoDisplayEntry[];
  additionalInfoCompany: HospitalityAdditionalInfoDisplayEntry[];
};

type PropertyBulkEntity = 'document_section' | 'emergency_instruction';
type PropertyBulkAction = 'apply' | 'edit' | 'delete';
type BulkSourceExistenceStatus =
  | 'source'
  | 'copy_source_exists'
  | 'copy_source_deleted'
  | 'copy_source_property_deleted'
  | null;
type BulkDistributionStatusFilter = 'all' | 'missing' | 'copied' | 'modified' | 'actionable' | 'up_to_date' | 'review' | 'unavailable';
type DistributionOverviewGroupFilter = 'all' | 'used' | 'modified' | 'conflict' | 'source_deleted';
type DistributionOverviewGroupSort = 'priority' | 'most_used' | 'most_modified' | 'title';
type DistributionOverviewDetailsFilter = 'used' | 'modified' | 'missing' | 'legacy_conflict' | 'all';

interface BulkDistributionStatusFilterOption {
  value: BulkDistributionStatusFilter;
  labelKey: string;
  tooltipKey: string;
}

interface BulkTargetPropertyViewModel {
  property: Property;
  propertyId: string;
  label: string;
  searchText: string;
  status: DistributionStatusValue | null;
  statusLabelKey: string;
  statusTooltipKey: string;
  statusColor: string;
  disabled: boolean;
  disabledReasonKey: string | null;
  actionable: boolean;
}

interface PropertyBulkApplyContext {
  mode: PropertyBulkEntity;
  action: PropertyBulkAction;
  sourceProperty: Property;
  documentSection?: PropertyDocumentSectionUi;
  emergencyInstruction?: EmergencyInstruction;
}

type EmergencyInstructionSourceLanguage = 'de' | 'en';
type EmergencyInstructionBuilderActionType = 'none' | EmergencyInstructionActionType;
type EmergencyInstructionUnifiedCategoryKey = EmergencyInstructionCategory | EmergencyInstructionScenarioKey | '__blank__';

interface EmergencyInstructionBuilderStep extends EmergencyInstructionStep {
  description: string;
  iconKey?: string | null;
  urgency: EmergencyInstructionUrgency;
  action?: EmergencyInstructionAction | null;
  actionType: EmergencyInstructionBuilderActionType;
  selectedContactKey?: string | null;
  actionLabelManuallyEdited: boolean;
  lastAutoActionLabel?: string | null;
  selectedDocumentOptionKey?: string | null;
  isExpanded: boolean;
}

interface EmergencyInstructionTemplate {
  key: EmergencyInstructionUnifiedCategoryKey;
  scenarioKey: EmergencyInstructionScenarioKey;
  category: EmergencyInstructionCategory;
  title: string;
  iconKey: string;
  urgency: EmergencyInstructionUrgency;
  summary: string;
  steps: Array<{
    title: string;
    description: string;
    iconKey?: string;
    urgency?: EmergencyInstructionUrgency;
    action?: EmergencyInstructionAction | null;
  }>;
}

interface EmergencyInstructionDocumentOption {
  key: string;
  sectionTitle: string;
  file: EmergencyInstructionActionDocument | PropertyDocumentSection['files'][number];
  label: string;
}

interface EmergencyInstructionContactOption {
  key: string;
  field: 'phone' | 'email';
  sourceType: EmergencyInstructionActionContactSourceType;
  sourceId?: string | null;
  serviceType?: string | null;
  searchLabel: string;
  groupLabel: string;
  displayName: string;
  secondaryValue: string;
  previewLabel: string;
  autoLabelName: string;
  contactRef: EmergencyInstructionActionContactRef;
}

interface EmergencyInstructionContactOptionGroup {
  key: string;
  label: string;
  options: EmergencyInstructionContactOption[];
}

interface EmergencyInstructionContactPreview {
  label: string;
  value: string;
  groupLabel?: string | null;
  unresolved?: boolean;
}

interface EmergencyInstructionAssignedTechnicalServiceEntry {
  service: Service;
  sourceId: string | null;
  serviceType: string;
}

interface EmergencyInstructionBuilderDraft extends Omit<EmergencyInstruction, 'steps' | 'version' | 'sourceLanguage'> {
  version: 'v2';
  sourceLanguage: EmergencyInstructionSourceLanguage;
  selectedCategoryKey: EmergencyInstructionUnifiedCategoryKey;
  steps: EmergencyInstructionBuilderStep[];
}

interface EmergencyInstructionUnifiedCategoryOption {
  key: EmergencyInstructionUnifiedCategoryKey;
  iconKey: string;
  labelKey: string;
  kind: 'legacy' | 'scenario';
  templateKey?: EmergencyInstructionScenarioKey;
}

type EmergencyInstructionIconPickerTarget =
  | { type: 'guide' }
  | { type: 'step'; stepId: string };

interface QrSelectableProperty {
  _id: string;
  address: string;
  externalId: string | null;
  displayLabel: string;
  street: string;
  zipcode: string;
  city: string;
  profileGroupKey: string;
  profileGroupLabel: string;
}

interface QrSelectionGroup {
  key: string;
  label: string;
  properties: QrSelectableProperty[];
  selectedCount: number;
  totalCount: number;
  allSelected: boolean;
  someSelected: boolean;
}

interface QrSelectionViewModel {
  groups: QrSelectionGroup[];
  totalCount: number;
  filteredCount: number;
  selectedTotalCount: number;
  selectedFilteredCount: number;
}

@Component({
  selector: 'app-property-list',
  standalone: true,
  imports: [
    NzTableModule,
    NzInputModule,
    NzInputNumberModule,
    NzButtonModule,
    NzIconModule,
    FormsModule,
    TranslateModule,
    NzButtonComponent,
    NzTooltipDirective,
    NzIconDirective,
    NzTableComponent,
    NzThAddOnComponent,
    FormsModule,
    CommonModule,
    NzToolTipModule,
    NzPopoverModule,
    NzTableComponent,
    NzThAddOnComponent,
    NzInputDirective,
    NzModalComponent,
    NzModalContentDirective,
    NzFormItemComponent,
    NzFormLabelComponent,
    NzFormControlComponent,
    NzFormTextComponent,
    NzRowDirective,
    NzColDirective,
    ReactiveFormsModule,
    NzSelectComponent,
    NzOptionComponent,
    NzFormDirective,
    NzRadioGroupComponent,
    NzRadioComponent,
    NzRadioModule,
    NzSwitchModule,
    NzCheckboxComponent,
    NzCheckboxModule,
    NzAlertComponent,
    NzSelectModule,
    NzPaginationComponent,
    ReplaceSlashWithUnderscorePipe,
    NzCollapseComponent,
    NzCollapsePanelComponent,
    NzUploadComponent,
    NzUploadModule,
    NzDropDownModule,
    NzMenuModule,
    ScrollingModule,
    NzDrawerModule,
    NzTabsModule,
    NzTagModule,
    NzStepsModule,
    HospitalityLinkPreviewComponent,
    NzTimePickerModule,
    NzBadgeModule,
    NzProgressComponent,
    TechnicalServicesSelectorComponent,
    NzSpinModule,
    DragDropModule,
    PropertyImportProgressComponent
  ],
  providers: [
    NzModalService,
    NzMessageService,
    NzImageService,
    ContactUpsertModalService,
    PropertyInlineContactAddService
  ],
  templateUrl: './property-list.component.html',
  styleUrls: ['./property-list.component.less']
})
export class PropertyListComponent extends PropertyListHospitalityMixin implements OnInit, OnDestroy {
  managerKeyMapping: { [key: string]: keyof Employee } = MANAGER_KEY_MAPPING;

  technicalAssetsManagerKeyMapping: { [key: string]: keyof Employee } = TECHNICAL_ASSETS_MANAGER_KEY_MAPPING;

  sevManagerKeyMapping: { [key: string]: keyof Employee } = SEV_MANAGER_KEY_MAPPING;

  accountantKeyMapping: { [key: string]: keyof Employee } = ACCOUNTANT_KEY_MAPPING;

  readonly splitAddress = splitAddress;
  readonly formatServiceTypeHeader = formatServiceTypeHeader;
  readonly isPropertyMatch = isPropertyMatch;

  progressStatus: 'loading' | 'complete' | 'incomplete' = 'loading';
  progress = 0;
  private isProgressCheckInFlight = false;
  isQrPrintGuardChecking = false;
  progressInterval: any;
  private progressUpdateSubscription?: Subscription;
  importPollingInterval: any;
  currentImportJob: PropertyImportJobStatusResponse | null = null;
  selectedImportSource: PropertyImportSource = 'scanafy';
  private handledTerminalImportJobIds = new Set<string>();
  private dismissedFinishedImportJobId: string | null = null;
  private historicalImportJobId: string | null = null;
  historicalImportResultUnavailable = false;
  private importSuccessDismissTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private importSuccessDismissIntervalId: ReturnType<typeof setInterval> | null = null;
  importSuccessDismissCountdownSeconds: number | null = null;
  private readonly importSuccessAutoDismissMs = 9000;

  // Reference to the hidden file input element
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('bulkApplyInstructionConfirmContent', { static: true }) bulkApplyInstructionConfirmContent!: TemplateRef<unknown>;
  @ViewChild('qrPosterPreviewCanvas') qrPosterPreviewCanvas?: ElementRef<HTMLCanvasElement>;

  searchTerms: any = {
    globalTerm: '',
    street: '',
    zipcode: '',
    city: '',
    caretakerName: '',
    caretakerEmail: '',
    caretakerPhone: '',
    propertyManager: '',
    technicalAssetsManager: '',
    sevManager: '',
    accountant: '',
    technicalService: '',
  };

  isLoading = false;
  isPropertiesTableLoading = false;
  hasLoadedProperties = false;
  isSubmittingImportJob = false;
  appMode: AppMode = DEFAULT_APP_MODE;
  allProperties: Property[] = [];
  properties: Property[] = [];
  private readonly unregisterTourActions: Array<() => void> = [];
  propertiesPagination = {
    pageIndex: 1,
    pageSize: 5,
    total: 0
  };

  propertiesSort: { key: string; value: string | null } = { key: '', value: null };
  positionTypes: string[] = []; // Variable to hold position types
  displayedColumns = [
    'street', 'zipcode', 'city', 'caretakerName', 'caretakerPhone', 'caretakerEmail'
  ];
  maxManagers: number = 0; // Define maxManagers
  maxServices: number = 0; // Define maxServices
  maxTechnicalAssetsManagers: number = 0;
  wizardForm!: FormGroup; // Wizard form for dynamic inputs
  wizardVisible = false; // Control visibility of wizard modal
  downloadTemplateModalVisible = false;
  importConfirmModalVisible = false;
  increasePropertyLimitModalVisible = false;
  increasePropertyLimitSubmitting = false;
  increasePropertyLimitForm!: FormGroup;
  propertyUnitPriceNetYear: number | null = null;
  upgradeSettingsCurrency: string = 'EUR';
  pendingUpgrade: any = null;

  addModalVisible = false;
  addPropertyForm!: FormGroup;
  savedHeaders: SavedHeaders = defaultSavedHeaders;

  detailsDrawerTitle = '';
  detailsDrawerContext: HospitalityDetailsDrawerContext | null = null;

  // Form Group for Edit Modal
  editPropertyForm!: FormGroup;

  caretakers: Employee[] = [];
  private caretakerContactPersonOptionsLoaded = false;
  private caretakerContactPersonOptionsLoadFailed = false;
  private companyEmployeesAndServicesLoadPromise: Promise<void> | null = null;
  private addCaretakerContactPersonSelectionSubscription?: Subscription;
  private editCaretakerContactPersonSelectionSubscription?: Subscription;
  private readonly addCaretakerContactPersonSelectionCache = new Map<string, string[]>();
  private readonly editCaretakerContactPersonSelectionCache = new Map<string, string[]>();
  private addActiveCaretakerContactPersonSelectionCacheKey: string | null = null;
  private editActiveCaretakerContactPersonSelectionCacheKey: string | null = null;
  private editCaretakerContactPersonSelectionPropertyId: string | null = null;
  propertyManagersModel: Employee[] = [];
  technicalAssetsManagers: Employee[] = [];
  sevManagersModel: Employee[] = [];
  accountantsModel: Employee[] = [];
  technicalServicesModel: Service[] = [];
  private servicesByTypeCache = new Map<string, Service[]>();
  private totalServiceOptionCount = 0;
  technicalServiceTypes: string[] = [];
  technicalServiceHeaderOrder: TechnicalServiceHeaderOrder = createEmptyTechnicalServiceHeaderOrder();
  private pendingInlineCreatedServiceIds = new Set<string>();
  technicalServiceCategoryOrder: TechnicalServiceCategoryOrder = createDefaultTechnicalServiceCategoryOrder();
  landingPageEmergencyServicePlacementEnabled = false;
  landingPageEmergencyServiceTypes: string[] = [];

  // Define a mapping between service types and their translation keys
  serviceTypeTranslationKeys: { [key: string]: string } = SERVICE_TYPE_TRANSLATION_KEYS;


  selectedProperty!: Property;

  qrCodeModalVisible = false; // Control visibility of QR Code Modal
  allQrDownloadChoiceVisible = false;
  allQrDownloadLoading = false;
  allQrZipLoading = false;
  qrSelectionPropertyIds: Set<string> = new Set();
  qrSelectionSearchText = '';
  qrSelectionGroupBy: 'none' | 'city' | 'zipcode' | 'profile' = 'none';
  qrSelectableProperties: QrSelectableProperty[] = [];
  qrSelectionViewModel: QrSelectionViewModel = { groups: [], totalCount: 0, filteredCount: 0, selectedTotalCount: 0, selectedFilteredCount: 0 };
  qrExpandedGroupKeys: Set<string> = new Set();
  qrSelectionBusy = false;
  property!: Property;
  companyName: string = '';
  companyEmail: string = '';
  companyPhone: string = '';
  companyAddress: string = '';
  companyWebsite: string = '';
  themeColor: string | undefined = '';
  companyLogoUrl: string | undefined = '';
  landingProfiles: LandingProfile[] = [];
  multiLandingProfilesEnabled = false;
  readonly useCompanyLandingProfileValue = '__use_company__';
  availability: any = {};
  emergencyNumber: string | undefined = '';
  editModalVisible = false; // Control visibility of edit Modal
  visibleAddServiceTypes: string[] = [];
  visibleEditServiceTypes: string[] = [];
  isAddServicesStepRendering = false;
  isEditServicesStepRendering = false;
  private readonly serviceStepChunkSize = 6;
  private addServicesRenderHandle: ReturnType<typeof setTimeout> | null = null;
  private editServicesRenderHandle: ReturnType<typeof setTimeout> | null = null;

  isQrPosterPreviewLoading = false;
  isQrPosterPreviewReady = false;
  private qrPosterPreviewRender: QrPosterPdfPreviewRender | null = null;
  private qrPosterPreviewPdf: {
    propertyId: string;
    renderLanguage: 'de' | 'en';
    blob: Blob;
  } | null = null;
  private qrPosterPreviewRenderRequest = 0;
  private activeQrPosterTemplateId: string | null = null;
  savedQrPosterTemplates: SavedQrPosterTemplate[] = [];
  readonly automaticQrPosterTemplateValue = '__automatic_per_property_qr_poster_template__';
  selectedQrPosterTemplateId = this.automaticQrPosterTemplateValue;
  dynamicHeaders: SavedHeaders = { ...defaultSavedHeaders };

  private appModeSubscription?: Subscription;
  documentModalVisible = false;
  documentSections: PropertyDocumentSectionUi[] = [];
  pmsDocuments: PropertyPmsDocument[] = [];
  missingPmsDocuments: PropertyPmsDocument[] = [];
  showPmsTabs = false;
  documentTabIndex = 0;
  documentSaveAttempted = false;
  documentValidationMessageKey: string | null = null;
  documentModalHasUnsavedChanges = false;
  private readonly documentUploadRequestHandlers = new Map<string, (option: any) => Subscription>();
  private propertiesTableRefreshHandle: ReturnType<typeof setTimeout> | null = null;
  private readonly propertiesReady$ = new Subject<void>();
  private readonly primaryActionsReady$ = new Subject<void>();
  private propertyLicenseReady = false;
  private tourComponentDestroyed = false;
  private readonly allowedDocumentExtensions = new Set(['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'xls', 'xlsx']);
  // Cached document counters per property (sum of all files in all sections)
  documentCounts: Record<string, number> = {};
  private documentCountLoading = new Set<string>();
  instructionsModalVisible = false;
  instructionsModalLoading = false;
  instructionsSaving = false;
  instructionsProperty: Property | null = null;
  emergencyInstructions: EmergencyInstruction[] = [];
  private readonly emergencyInstructionRecordById = new Map<string, EmergencyInstruction>();
  emergencyInstructionTemplateHintVisible = false;
  private emergencyInstructionTemplateHintTimeout: ReturnType<typeof setTimeout> | null = null;
  emergencyInstructionForm!: FormGroup;
  emergencyInstructionSaveAttempted = false;
  emergencyInstructionSaveMessages: string[] = [];
  editingEmergencyInstructionId: string | null = null;
  emergencyInstructionDocumentOptions: EmergencyInstructionDocumentOption[] = [];
  readonly emergencyInstructionManualContactOptionValue = '__manual__';
  readonly emergencyInstructionUnresolvedContactOptionPrefix = '__unresolved__::';
  emergencyInstructionContactOptionsLoading = false;
  emergencyInstructionContactOptionGroups: Record<'phone' | 'email', EmergencyInstructionContactOptionGroup[]> = {
    phone: [],
    email: [],
  };
  private readonly emergencyInstructionContactOptionsByKey: Record<'phone' | 'email', Map<string, EmergencyInstructionContactOption>> = {
    phone: new Map<string, EmergencyInstructionContactOption>(),
    email: new Map<string, EmergencyInstructionContactOption>(),
  };
  private emergencyInstructionContactOptionsRefreshHandle: ReturnType<typeof setTimeout> | null = null;
  private readonly emergencyInstructionDocumentOptionsCache = new Map<string, EmergencyInstructionDocumentOption[]>();
  readonly emergencyInstructionMaxLengths = {
    title: 64,
    summary: 120,
    stepTitle: 64,
    stepDescription: 200,
    actionLabel: 20,
    phone: 64,
    email: 254,
    url: 2048,
  } as const;
  emergencyInstructionIconPickerVisible = false;
  emergencyInstructionIconPickerTarget: EmergencyInstructionIconPickerTarget | null = null;
  readonly emergencyInstructionIconOptions: Array<{ key: string; iconType: string; labelKey: string }> = [
    { key: 'warning', iconType: 'warning', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.WARNING' },
    { key: 'fire', iconType: 'fire', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.FIRE' },
    { key: 'alert', iconType: 'alert', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.ALERT' },
    { key: 'tool', iconType: 'tool', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.TOOL' },
    { key: 'phone', iconType: 'phone', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.PHONE' },
    { key: 'notification', iconType: 'notification', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.NOTIFICATION' },
    { key: 'home', iconType: 'home', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.HOME' },
    { key: 'safety', iconType: 'safety-certificate', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.SAFETY' },
    { key: 'file', iconType: 'file-text', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.FILE' },
    { key: 'team', iconType: 'team', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.TEAM' },
    { key: 'environment', iconType: 'environment', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.ENVIRONMENT' },
    { key: 'thunderbolt', iconType: 'thunderbolt', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.THUNDERBOLT' },
    { key: 'key', iconType: 'key', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.KEY' },
    { key: 'lock', iconType: 'lock', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.LOCK' },
    { key: 'unlock', iconType: 'unlock', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.UNLOCK' },
    { key: 'gateway', iconType: 'gateway', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.EXIT' },
    { key: 'build', iconType: 'build', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.BUILDING' },
    { key: 'shop', iconType: 'shop', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.BASEMENT' },
    { key: 'pushpin', iconType: 'pushpin', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.VALVE' },
    { key: 'camera', iconType: 'camera', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.CAMERA' },
    { key: 'security-scan', iconType: 'security-scan', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.SECURITY' },
    { key: 'customer-service', iconType: 'customer-service', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.HELP' },
    { key: 'info-circle', iconType: 'info-circle', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.INFO' },
    { key: 'compass', iconType: 'compass', labelKey: 'PROPERTY_INSTRUCTIONS.ICON.MAP' },
  ];
  readonly emergencyInstructionIconTypeByKey = this.emergencyInstructionIconOptions.reduce<Record<string, string>>((acc, option) => {
    acc[option.key] = option.iconType;
    acc[option.iconType] = option.iconType;
    return acc;
  }, {});
  readonly emergencyInstructionUnifiedCategoryOptions: EmergencyInstructionUnifiedCategoryOption[] = [
    // Concrete emergency scenarios first
    { key: 'fire_smoke', iconKey: 'fire', labelKey: 'PROPERTY_INSTRUCTIONS.SCENARIO.FIRE_SMOKE', kind: 'scenario', templateKey: 'fire_smoke' },
    { key: 'gas_smell', iconKey: 'alert', labelKey: 'PROPERTY_INSTRUCTIONS.SCENARIO.GAS_SMELL', kind: 'scenario', templateKey: 'gas_smell' },
    { key: 'water_damage', iconKey: 'tool', labelKey: 'PROPERTY_INSTRUCTIONS.SCENARIO.WATER_DAMAGE', kind: 'scenario', templateKey: 'water_damage' },
    { key: 'flooding', iconKey: 'environment', labelKey: 'PROPERTY_INSTRUCTIONS.SCENARIO.FLOODING', kind: 'scenario', templateKey: 'flooding' },
    { key: 'power_outage', iconKey: 'thunderbolt', labelKey: 'PROPERTY_INSTRUCTIONS.SCENARIO.POWER_OUTAGE', kind: 'scenario', templateKey: 'power_outage' },
    { key: 'evacuation', iconKey: 'gateway', labelKey: 'PROPERTY_INSTRUCTIONS.SCENARIO.EVACUATION', kind: 'scenario', templateKey: 'evacuation' },
    { key: 'general_emergency', iconKey: 'phone', labelKey: 'PROPERTY_INSTRUCTIONS.SCENARIO.GENERAL_EMERGENCY', kind: 'scenario', templateKey: 'general_emergency' },

    // Generic building-level categories after the scenario templates
    { key: 'key_access', iconKey: 'key', labelKey: 'PROPERTY_INSTRUCTIONS.CATEGORY.KEY_ACCESS', kind: 'legacy' },
    { key: 'main_shut_off', iconKey: 'pushpin', labelKey: 'PROPERTY_INSTRUCTIONS.CATEGORY.MAIN_SHUT_OFF', kind: 'legacy' },
    { key: 'emergency_tool_supply', iconKey: 'tool', labelKey: 'PROPERTY_INSTRUCTIONS.CATEGORY.EMERGENCY_TOOL_SUPPLY', kind: 'legacy' },
    { key: 'special_building_rule', iconKey: 'info-circle', labelKey: 'PROPERTY_INSTRUCTIONS.CATEGORY.SPECIAL_BUILDING_RULE', kind: 'legacy' },

    // Keep catch-all last
    { key: 'other', iconKey: 'question-circle', labelKey: 'PROPERTY_INSTRUCTIONS.CATEGORY.OTHER', kind: 'legacy' },
  ];
  emergencyInstructionBuilder: EmergencyInstructionBuilderDraft = this.createEmptyEmergencyInstructionDraft();
  bulkApplyModalVisible = false;
  pendingBulkSourceNavigation: { entityType: string; property: Property } | null = null;
  bulkApplySubmitting = false;
  bulkPromoteSourceSubmitting = false;
  bulkApplySearchTerm = '';
  bulkApplyScope: PropertyBulkApplyScope = 'selected';
  bulkApplySelectedPropertyIds: string[] = [];
  bulkApplyContext: PropertyBulkApplyContext | null = null;
  bulkSourceExistenceStatus: BulkSourceExistenceStatus = null;
  currentBulkEntity: PropertyBulkEntity | null = null;
  currentBulkAction: PropertyBulkAction = 'apply';
  bulkApplyInstructionConfirmMessage = '';
  bulkDistributionStatusLoading = false;
  bulkDistributionStatusFilter: BulkDistributionStatusFilter = 'all';
  bulkDistributionStatusByPropertyId = new Map<string, DistributionStatusProperty>();
  bulkDistributionStatusFilterOptionsCache: BulkDistributionStatusFilterOption[] = [];
  bulkApplyAllPropertyRows: BulkTargetPropertyViewModel[] = [];
  bulkApplyVisiblePropertyRows: BulkTargetPropertyViewModel[] = [];
  bulkApplySelectableFilteredPropertyIdsCache: string[] = [];
  bulkApplyResolvedTargetPropertyIdsCache: string[] = [];
  bulkApplySelectedPropertyIdSet = new Set<string>();
  bulkApplyAllFilteredSelectedCache = false;
  bulkApplyPartiallyFilteredSelectedCache = false;
  bulkApplyVisibleSelectedCountCache = 0;
  distributionOverviewModalVisible = false;
  distributionOverviewLoading = false;
  distributionOverviewEntityType: 'document_section' | 'emergency_instruction' = 'emergency_instruction';
  distributionOverviewGroups: DistributionOverviewGroup[] = [];
  distributionOverviewGroupSearchTerm = '';
  distributionOverviewGroupFilter: DistributionOverviewGroupFilter = 'all';
  distributionOverviewGroupSort: DistributionOverviewGroupSort = 'priority';
  readonly distributionOverviewFilterOptions: Array<{ value: DistributionOverviewGroupFilter; labelKey: string }> = [
    { value: 'all', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.FILTER_ALL' },
    { value: 'used', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.FILTER_USED' },
    { value: 'modified', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.FILTER_MODIFIED' },
    { value: 'conflict', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.FILTER_CONFLICT' },
    { value: 'source_deleted', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.FILTER_SOURCE_DELETED' },
  ];
  readonly distributionOverviewSortOptions: Array<{ value: DistributionOverviewGroupSort; labelKey: string }> = [
    { value: 'priority', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.SORT_PRIORITY' },
    { value: 'most_used', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.SORT_MOST_USED' },
    { value: 'most_modified', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.SORT_MOST_MODIFIED' },
    { value: 'title', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.SORT_TITLE' },
  ];
  selectedDistributionOverviewGroup: DistributionOverviewGroup | null = null;
  distributionOverviewDetailsVisible = false;
  distributionOverviewDetailsLoading = false;
  distributionOverviewDetails: DistributionOverviewGroup | null = null;
  distributionOverviewDetailsSearchTerm = '';
  distributionOverviewDetailsStatusFilter: DistributionOverviewDetailsFilter = 'used';
  readonly distributionOverviewDetailsFilterOptions: Array<{ value: DistributionOverviewDetailsFilter; labelKey: string; tooltipKey: string }> = [
    { value: 'used', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_FILTER_USED', tooltipKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_FILTER_TOOLTIP_USED' },
    { value: 'modified', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_FILTER_MODIFIED', tooltipKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_FILTER_TOOLTIP_MODIFIED' },
    { value: 'missing', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_FILTER_MISSING', tooltipKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_FILTER_TOOLTIP_MISSING' },
    { value: 'legacy_conflict', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_FILTER_LEGACY_CONFLICT', tooltipKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_FILTER_TOOLTIP_LEGACY_CONFLICT' },
    { value: 'all', labelKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_FILTER_ALL', tooltipKey: 'PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_FILTER_TOOLTIP_ALL' },
  ];

  readonly emergencyInstructionCategories: Array<{
    value: EmergencyInstructionCategory;
    iconType: string;
    labelKey: string;
  }> = [
    { value: 'key_access', iconType: 'key', labelKey: 'PROPERTY_INSTRUCTIONS.CATEGORY.KEY_ACCESS' },
    { value: 'main_shut_off', iconType: 'poweroff', labelKey: 'PROPERTY_INSTRUCTIONS.CATEGORY.MAIN_SHUT_OFF' },
    { value: 'emergency_tool_supply', iconType: 'tool', labelKey: 'PROPERTY_INSTRUCTIONS.CATEGORY.EMERGENCY_TOOL_SUPPLY' },
    { value: 'special_building_rule', iconType: 'warning', labelKey: 'PROPERTY_INSTRUCTIONS.CATEGORY.SPECIAL_BUILDING_RULE' },
    { value: 'other', iconType: 'question-circle', labelKey: 'PROPERTY_INSTRUCTIONS.CATEGORY.OTHER' },
  ];
  readonly emergencyInstructionCategoryIconByValue = this.emergencyInstructionCategories.reduce<Record<string, string>>((acc, entry) => {
    acc[entry.value] = entry.iconType;
    return acc;
  }, {});
  readonly emergencyInstructionCategoryLabelByValue = this.emergencyInstructionCategories.reduce<Record<string, string>>((acc, entry) => {
    acc[entry.value] = entry.labelKey;
    return acc;
  }, {});

  private readonly HOSPITALITY_DOCUMENT_MAX_SIZE_MB = 2;
  private hospitalityLinkDocumentUploads = new WeakMap<FormGroup, boolean>();
  private hospitalityLinkDocumentHandlers = new WeakMap<
    AbstractControl,
    (item: NzUploadXHRArgs) => Subscription
  >();

  get usedPropertiesCount(): number {
    return this.allProperties?.length ?? 0;
  }

  get showHausColumn(): boolean {
    return this.properties.some((p) => this.getHaussoftHausCode(p) !== null);
  }

  getHaussoftHausCode(property: Property): string | null {
    const refs = property.externalReferences;
    if (!Array.isArray(refs) || !refs.length) {
      return null;
    }
    const haussoftRef = refs.find(
      (ref) => ref.provider === 'haussoft' && ref.externalId
    );
    return haussoftRef ? haussoftRef.externalId : null;
  }

  hasHaussoftExternalReference(property: Property): boolean {
    return this.getHaussoftHausCode(property) !== null;
  }

  get licensedMaxProperties(): number | null {
    const max = (this.company as any)?.maxProperties;
    return typeof max === 'number' && Number.isFinite(max) ? max : null;
  }

  get remainingPropertiesCount(): number | null {
    const max = this.licensedMaxProperties;
    if (max === null) return null;
    return Math.max(max - this.usedPropertiesCount, 0);
  }

  get licenseUsagePercent(): number {
    const max = this.licensedMaxProperties;
    if (!max || max <= 0) return 0;
    return Math.min(100, Math.round((this.usedPropertiesCount / max) * 100));
  }

  get canManagePropertyLicense(): boolean {
    return this.authService.getCurrentCompanyRole() === 'company_admin' && this.licensedMaxProperties !== null;
  }

  get isPaidCompanyPlan(): boolean {
    const plan = String(this.company?.plan || '').toLowerCase();
    return ['pro', 'business'].includes(plan);
  }

  get propertyLimitIncreaseMin(): number {
    return Math.max((this.licensedMaxProperties ?? 0) + 1, this.usedPropertiesCount);
  }

  get propertyLimitIncreaseValidationMessage(): string | null {
    const control = this.increasePropertyLimitForm?.get('newMaxProperties');
    if (!control || (!control.touched && !control.dirty)) {
      return null;
    }

    if (control.hasError('required')) {
      return this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.ERROR_REQUIRED');
    }
    if (control.hasError('wholeNumber')) {
      return this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.ERROR_WHOLE_NUMBER');
    }
    if (control.hasError('mustExceedCurrent')) {
      return this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.ERROR_MUST_EXCEED_CURRENT');
    }
    if (control.hasError('belowUsed')) {
      return this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.ERROR_BELOW_USED');
    }
    return null;
  }

  get propertyLimitIncreaseConfirmationErrorMessage(): string | null {
    const control = this.increasePropertyLimitForm?.get('confirmedImmediateInvoice');
    if (!control || (!control.touched && !control.dirty)) {
      return null;
    }

    if (control.hasError('requiredTrue')) {
      return this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.ERROR_CONFIRM_REQUIRED');
    }

    return null;
  }

  private resolvePropertyLimitErrorMessage(error: any): string {
    switch (error?.code) {
      case 'COMPANY_ADMIN_REQUIRED':
        return this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.ERROR_COMPANY_ADMIN_REQUIRED');
      case 'PROPERTY_LIMIT_MUST_BE_POSITIVE_INTEGER':
        return this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.ERROR_WHOLE_NUMBER');
      case 'PROPERTY_LIMIT_MUST_EXCEED_CURRENT':
        return this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.ERROR_MUST_EXCEED_CURRENT');
      case 'PROPERTY_LIMIT_BELOW_USED':
        return this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.ERROR_BELOW_USED');
      default:
        return error?.message || this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.ERROR_SUBMIT');
    }
  }

  constructor(
    protected translate: TranslateService,
    private modal: NzModalService,
    private message: NzMessageService,
    protected fb: FormBuilder,
    private propertyService: PropertyService,
    private templateService: TemplateService,
    private companyService: CompanyService,
    private progressService: ProgressService,
    private propertyImportService: PropertyImportService,
    private sanitizer: DomSanitizer,
    private nzImageService: NzImageService,
    private route: ActivatedRoute,
    private router: Router,
    private dePhone: GermanPhoneNormalizerService,
    private qrPosterDocumentService: QrPosterDocumentService,
    private qrPosterPdfPreviewService: QrPosterPdfPreviewService,
    private authService: AuthService,
    private billingService: BillingService,
    private technicalServicesOrderingService: TechnicalServicesOrderingService,
    private contactUpsertModal: ContactUpsertModalService,
    private inlineContactAddService: PropertyInlineContactAddService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private tourActions: TourActionRegistryService) {
    super();
  }

  get isImportJobActive(): boolean {
    return !!this.currentImportJob && !this.isImportJobTerminal(this.currentImportJob.status);
  }

  get isImportBusy(): boolean {
    return this.isSubmittingImportJob || this.isImportJobActive;
  }

  get canDismissCurrentImportJob(): boolean {
    return !this.historicalImportJobId && !!this.currentImportJob && this.isImportJobTerminal(this.currentImportJob.status);
  }

  trackByPropertyId(index: number, property: Property): string {
    return property._id || index.toString();
  }

  trackByServiceType = (_: number, serviceType: string): string => serviceType;

  trackByServiceId = (_: number, service: Service): string =>
    this.getServiceIdentityKey(service) || `${service?.serviceName || 'service'}::${_}`;

  trackByApplianceGuide = (index: number, guide: HospitalityApplianceGuide): string => {
    const appliance = this.cleanString(guide.appliance) || index.toString();
    const summary = this.cleanString(guide.summary) || '';

    return [appliance, summary, this.trackBySteps(guide.steps), this.trackByLinks(guide.resources)].join('::');
  };

  trackByString(_: number, value: string | null | undefined): string {
    return value ?? '';
  }

  private trackBySteps(steps?: Array<string | null | undefined> | null): string {
    if (!Array.isArray(steps) || !steps.length) {
      return '';
    }
    return steps.map(step => step ?? '').join('|');
  }

  private trackByLinks(links?: Array<HospitalityLink | null | undefined> | null): string {
    if (!Array.isArray(links) || !links.length) {
      return '';
    }
    return links
      .map(link => {
        if (!link) {
          return '';
        }
        return `${link.label || ''}|${link.url || ''}`;
      })
      .join('||');
  }

  async ngOnInit(): Promise<void> {
    this.registerTourActions();
    this.appMode = this.authService.getAppMode();
    this.appModeSubscription = this.authService.getAppModeChanges().subscribe(mode => {
      this.appMode = mode;
      this.recomputeStepCaches();
    });
    this.recomputeStepCaches();
    await this.initializeComponent();
    await this.loadCompanyInfo();
    await this.loadSavedHeaders();
    // Populate the position types during component initialization
    this.positionTypes = this.getPositionTypes();

    this.wizardForm = this.fb.group({
      propertyManagers: this.fb.array([ // Add at least one default property manager
        this.fb.group({
          positionType: [null, Validators.required], // Required position type
          includeEmail: [false],
          includePhone: [false],
        }, { validators: this.emailOrPhoneRequiredValidator })
      ]),
      technicalServices: this.fb.array([
        this.fb.group({
          serviceType: [[]], // Ensure serviceType is an array
        })
      ])
    });

    this.increasePropertyLimitForm = this.fb.group({
      newMaxProperties: [null, [Validators.required, this.propertyLimitIncreaseValidator.bind(this)]],
      confirmedImmediateInvoice: [false, [Validators.requiredTrue]],
    });
    void this.loadUpgradeSettingsIfAdmin().finally(() => {
      this.propertyLicenseReady = true;
      this.notifyTourPropertiesReady();
    });

    await this.fetchProperties(); // Wait for properties to be fetched, which includes dynamic headers loading

    this.loadCompanyEmployeesAndServices();
    this.startProgressCheck();
    if (!this.route.snapshot.queryParamMap.has('importJobId')) {
      this.resumeActiveImportJobIfPermitted();
    }
    this.route.queryParams.subscribe(params => {
      this.loadHistoricalImportResult(params['importJobId']);
      if (params['globalTerm']) {
        this.searchTerms.globalTerm = decodeURIComponent(params['globalTerm']);
        this.onSearch();
      }
      const shouldOpen = params['openExcelWizard'] === '1';
      const shouldOpenAddProperty = params['openAddProperty'] === '1';

      if (shouldOpen && !this.wizardVisible) {
        this.openWizard();

        // remove it immediately so it can be triggered again
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { openExcelWizard: null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      }
      if (shouldOpenAddProperty && !this.addModalVisible) {
        void this.toggleAddModal();

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { openAddProperty: null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      }
    });
    this.initEmergencyInstructionForm();
  }

  async initializeComponent() {
    try {
      // Await headers loading to ensure it's populated
      await this.loadSavedHeaders();
      this.syncTechnicalServiceOrderingWithHeaders();
    } catch (error) {
      console.error('Error in component initialization:', error);
    }
  }

  openIncreasePropertyLimitModal(): void {
    if (!this.canManagePropertyLicense) {
      return;
    }

    void this.loadUpgradeSettings().finally(() => {
      if (!this.isPaidCompanyPlan) {
        if (this.pendingUpgrade?.contractStartDate) {
          const date = new Date(this.pendingUpgrade.contractStartDate);
          const dateStr = Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString(
            this.translate.currentLang === 'de' ? 'de-DE' : 'en-US',
            { day: '2-digit', month: '2-digit', year: 'numeric' }
          );
          this.message.info(this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.PENDING_UPGRADE', { date: dateStr }));
          return;
        }
        this.openUpgradeContractDraftModalForProperties();
        return;
      }

      const suggestedValue = Math.max((this.licensedMaxProperties ?? 0) + 1, this.usedPropertiesCount + 1);
      this.increasePropertyLimitForm.reset({
        newMaxProperties: suggestedValue,
        confirmedImmediateInvoice: false,
      });
      this.increasePropertyLimitModalVisible = true;
    });
  }

  closeIncreasePropertyLimitModal(): void {
    if (this.increasePropertyLimitSubmitting) {
      return;
    }
    this.increasePropertyLimitModalVisible = false;
  }

  submitIncreasePropertyLimit(): void {
    if (this.increasePropertyLimitSubmitting) {
      return;
    }

    this.increasePropertyLimitForm.markAllAsTouched();
    if (this.increasePropertyLimitForm.invalid || this.propertyLimitIncreaseValidationMessage) {
      return;
    }

    const newMaxProperties = Number(this.increasePropertyLimitForm.value.newMaxProperties);
    this.increasePropertyLimitSubmitting = true;
    this.billingService.increaseMyPropertyLimit(newMaxProperties)
      .pipe(rxFinalize(() => {
        this.increasePropertyLimitSubmitting = false;
      }))
      .subscribe({
        next: (response: {
          message: string;
          company: { _id: string; maxProperties: number; plan: string };
          usedProperties: number;
          remainingProperties: number;
        }) => {
          if (this.company) {
            this.company.maxProperties = response.company.maxProperties;
            this.company.plan = response.company.plan || this.company.plan;
          }
          this.message.success(this.translate.instant('PROPERTY_LIST.INCREASE_LIMIT.SUCCESS'));
          this.increasePropertyLimitModalVisible = false;
        },
        error: (error: any) => {
          if (error?.code === 'UPGRADE_REQUIRED') {
            this.openUpgradeContractDraftModalForProperties();
            return;
          }
          this.message.error(this.resolvePropertyLimitErrorMessage(error));
        }
      });
  }

  formatMoney(value: number | null | undefined): string {
    const amount = Number(value || 0);
    const lang = this.translate.currentLang || this.translate.defaultLang || 'de';
    const locale = lang.startsWith('de') ? 'de-DE' : 'en-US';
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  formatDistributionOverviewUpdatedAt(value: string | Date | undefined): string {
    if (!value) {
      return '';
    }

    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
      return '';
    }

    const lang = this.translate.currentLang || this.translate.defaultLang || 'de';
    const locale = lang.startsWith('de') ? 'de-DE' : 'en-US';

    return new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

  private loadUpgradeSettingsIfAdmin(): Promise<void> {
    if (this.authService.getCurrentCompanyRole() !== 'company_admin') {
      this.propertyUnitPriceNetYear = null;
      this.pendingUpgrade = null;
      return Promise.resolve();
    }
    return this.loadUpgradeSettings();
  }

  private loadUpgradeSettings(): Promise<void> {
    return new Promise((resolve) => {
      this.billingService.getUpgradeSettings().subscribe({
        next: (settings) => {
          this.propertyUnitPriceNetYear = Number.isFinite(Number(settings?.propertyUnitPriceNetYear)) ? Number(settings.propertyUnitPriceNetYear) : null;
          this.upgradeSettingsCurrency = String(settings?.currency || 'EUR');
          this.pendingUpgrade = settings?.pendingUpgrade || null;
          resolve();
        },
        error: () => {
          this.propertyUnitPriceNetYear = null;
          this.pendingUpgrade = null;
          resolve();
        },
      });
    });
  }

  ngOnDestroy(): void {
    this.tourComponentDestroyed = true;
    this.unregisterTourActions.splice(0).forEach((unregister) => unregister());
    this.propertiesReady$.complete();
    this.primaryActionsReady$.complete();
    // Clear interval when component is destroyed
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
    this.progressUpdateSubscription?.unsubscribe();
    this.stopImportPolling();
    this.clearImportDismissTimers();
    this.cancelServicesStepRender('add');
    this.cancelServicesStepRender('edit');
    this.qrPosterPreviewRenderRequest += 1;
    this.clearQrPosterPreview();
    if (this.appModeSubscription) {
      this.appModeSubscription.unsubscribe();
    }
    this.addCaretakerContactPersonSelectionSubscription?.unsubscribe();
    this.editCaretakerContactPersonSelectionSubscription?.unsubscribe();
  }

  private registerTourActions(): void {
    const unregisterPrimaryActions = this.tourActions.register(
      'properties.ensure-primary-actions-ready',
      async () => {
        const ready = await this.waitForTourPrimaryActionsReady();
        if (!ready) {
          return;
        }
        return { close: () => undefined };
      }
    );
    this.unregisterTourActions.push(
      unregisterPrimaryActions,
      this.tourActions.register('properties.open-first-files', async () => {
        await this.waitForTourPropertiesReady();
        const property = this.properties[0];
        if (!property) {
          return;
        }
        await this.openDocumentModal(property);
        if (!await this.waitForTourModalTarget('[data-tour="property-files-modal"]')) {
          this.closeDocumentModal();
          return;
        }
        return { close: () => this.closeDocumentModal() };
      }),
      this.tourActions.register('properties.open-first-instructions', async () => {
        await this.waitForTourPropertiesReady();
        return this.openFirstInstructionsForTour();
      }),
      this.tourActions.register('properties.open-first-qr-preview', async () => {
        await this.waitForTourPropertiesReady();
        const property = this.properties[0];
        if (!property) {
          return;
        }
        await this.togglePrintQRCodeModal(property);
        return { close: () => this.closeQrPosterPreview() };
      })
    );
  }

  private async openFirstInstructionsForTour(): Promise<{ close: () => void } | void> {
    const property = this.properties[0];
    if (!property || this.appMode !== 'emergency') {
      return;
    }
    this.openEmergencyInstructionsModal(property);
    if (!await this.waitForTourModalTarget('[data-tour="property-instructions-content"]')) {
      this.closeEmergencyInstructionsModal();
      return;
    }
    return { close: () => this.closeEmergencyInstructionsModal() };
  }

  private async waitForTourPropertiesReady(): Promise<void> {
    if (this.isTourPropertiesReady()) {
      return;
    }
    await firstValueFrom(this.propertiesReady$.pipe(
      filter(() => this.isTourPropertiesReady()),
      take(1)
    ));
  }

  private async waitForTourPrimaryActionsReady(): Promise<boolean> {
    if (this.isTourPrimaryActionsReady()) {
      return this.waitForTourPrimaryActionsTarget();
    }
    await firstValueFrom(this.primaryActionsReady$.pipe(
      filter(() => this.isTourPrimaryActionsReady()),
      take(1)
    ));
    return this.waitForTourPrimaryActionsTarget();
  }

  private async waitForTourPrimaryActionsTarget(): Promise<boolean> {
    await this.waitForTourAngularRender();
    if (this.tourComponentDestroyed) {
      return false;
    }

    let previousBounds: DOMRect | null = null;
    let stableFrames = 0;

    for (let frame = 0; frame < PROPERTIES_PRIMARY_ACTIONS_MAX_STABILITY_FRAMES; frame += 1) {
      const target = document.querySelector<HTMLElement>(PROPERTIES_PRIMARY_ACTIONS_SELECTOR);
      if (!target || !target.isConnected) {
        return false;
      }

      const bounds = target.getBoundingClientRect();
      if (bounds.width > 0 && bounds.height > 0 && previousBounds && this.hasStableTourBounds(previousBounds, bounds)) {
        stableFrames += 1;
      } else {
        stableFrames = 0;
      }
      previousBounds = bounds;

      if (bounds.width > 0 && bounds.height > 0 && stableFrames >= PROPERTIES_PRIMARY_ACTIONS_STABLE_FRAMES) {
        return true;
      }

      await this.nextTourAnimationFrame();
      if (this.tourComponentDestroyed) {
        return false;
      }
    }

    return false;
  }

  private async waitForTourAngularRender(): Promise<void> {
    if (!this.ngZone.isStable) {
      await firstValueFrom(this.ngZone.onStable.pipe(take(1)));
    }
    await this.nextTourAnimationFrame();
  }

  private nextTourAnimationFrame(): Promise<void> {
    return new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));
  }

  private hasStableTourBounds(left: DOMRect, right: DOMRect): boolean {
    return Math.abs(left.top - right.top) <= PROPERTIES_PRIMARY_ACTIONS_RECT_TOLERANCE_PX &&
      Math.abs(left.right - right.right) <= PROPERTIES_PRIMARY_ACTIONS_RECT_TOLERANCE_PX &&
      Math.abs(left.bottom - right.bottom) <= PROPERTIES_PRIMARY_ACTIONS_RECT_TOLERANCE_PX &&
      Math.abs(left.left - right.left) <= PROPERTIES_PRIMARY_ACTIONS_RECT_TOLERANCE_PX;
  }

  private async waitForTourModalTarget(selector: string): Promise<boolean> {
    let angularStable = this.ngZone.isStable;
    const stableSubscription = angularStable
      ? undefined
      : this.ngZone.onStable.pipe(take(1)).subscribe(() => {
        angularStable = true;
      });
    let previousTarget: HTMLElement | null = null;
    let previousBounds: DOMRect | null = null;
    let stableFrames = 0;

    try {
      for (let frame = 0; frame < TOUR_MODAL_TARGET_MAX_STABILITY_FRAMES; frame += 1) {
        if (this.tourComponentDestroyed) {
          return false;
        }

        if (angularStable) {
          const target = document.querySelector<HTMLElement>(selector);
          if (!target || !target.isConnected) {
            previousTarget = null;
            previousBounds = null;
            stableFrames = 0;
          } else {
            const bounds = target.getBoundingClientRect();
            if (bounds.width > 0 && bounds.height > 0) {
              stableFrames = previousTarget === target && previousBounds && this.hasStableTourBounds(previousBounds, bounds)
                ? stableFrames + 1
                : 0;
              previousTarget = target;
              previousBounds = bounds;
              if (stableFrames >= TOUR_MODAL_TARGET_STABLE_FRAMES) {
                return true;
              }
            } else {
              previousTarget = null;
              previousBounds = null;
              stableFrames = 0;
            }
          }
        }

        await this.nextTourAnimationFrame();
      }
    } finally {
      stableSubscription?.unsubscribe();
    }

    return false;
  }


  private isTourPropertiesReady(): boolean {
    return this.hasLoadedProperties && !this.isPropertiesTableLoading;
  }

  private isTourPrimaryActionsReady(): boolean {
    return this.isTourPropertiesReady() && this.propertyLicenseReady;
  }

  private notifyTourPropertiesReady(): void {
    if (this.isTourPropertiesReady()) {
      this.propertiesReady$.next();
    }
    if (this.isTourPrimaryActionsReady()) {
      this.primaryActionsReady$.next();
    }
  }

  startProgressCheck(): void {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }

    this.progressUpdateSubscription?.unsubscribe();
    this.progressUpdateSubscription = undefined;

    // Immediate fetch — don't wait for the first polling cycle
    this.fetchAndUpdateProgress().subscribe({
      error: () => this.handleBackgroundProgressCheckError()
    });

    this.progressUpdateSubscription = this.progressService.onProgressUpdate().subscribe(() => {
      if (!this.isProgressCheckInFlight) {
        this.fetchAndUpdateProgress().subscribe({
          error: () => this.handleBackgroundProgressCheckError()
        });
      }
    });

    this.progressInterval = setInterval(() => {
      if (this.progressStatus !== 'complete' && !this.isProgressCheckInFlight) {
        this.fetchAndUpdateProgress().subscribe({
          error: () => this.handleBackgroundProgressCheckError()
        });
      }
    }, 1000);
  }

  private handleBackgroundProgressCheckError(): void {
    this.progressStatus = 'loading';
  }

  private fetchAndUpdateProgress(): Observable<void> {
    this.isProgressCheckInFlight = true;

    return this.progressService.getProgress().pipe(
      tap((data: any) => {
        const progress = Number(data?.progress ?? 0);
        this.progress = progress;
        this.progressStatus = progress >= 100 ? 'complete' : 'incomplete';

        if (this.progressStatus === 'complete' && this.progressInterval) {
          clearInterval(this.progressInterval);
          this.progressInterval = null;
        }
      }),
      map(() => void 0),
      finalize(() => {
        this.isProgressCheckInFlight = false;
      })
    );
  }

  // Trigger file input click event
  triggerFileInput(): void {
    // Reset the input value to ensure the change event triggers for the same file
    this.fileInput.nativeElement.value = '';
    this.fileInput.nativeElement.click();
  }

  loadCompanyEmployeesAndServices(): Promise<void> {
    if (this.companyEmployeesAndServicesLoadPromise) {
      return this.companyEmployeesAndServicesLoadPromise;
    }

    this.caretakerContactPersonOptionsLoadFailed = false;
    const loadPromise = new Promise<void>((resolve) => {
      this.propertyService.fetchCompanyEmployeesAndServices().subscribe(
        (response: any) => {
          this.caretakers = this.sortByText(
            response.employees.filter((employee: { role: string }) => employee.role === 'Caretaker'),
            (c: any) => c?.name || ''
          );
          this.caretakerContactPersonOptionsLoaded = true;
          this.reconcileCaretakerContactPersonSelectionsInForms();

          this.propertyManagersModel = this.sortByText(
            response.employees.filter((employee: { role: string }) => employee.role === 'Property Manager'),
            (m: any) => m?.name || ''
          );

          this.technicalAssetsManagers = this.sortByText(
            response.employees.filter((employee: { role: string }) => employee.role === 'Technical Assets Manager'),
            (m: any) => m?.name || ''
          );

          this.sevManagersModel = this.sortByText(
            response.employees.filter((employee: { role: string }) => employee.role === 'Condominium Manager'),
            (m: any) => m?.name || ''
          );

          this.accountantsModel = this.sortByText(
            response.employees.filter((employee: { role: string }) => employee.role === 'Accountant'),
            (m: any) => m?.name || ''
          );

          this.technicalServicesModel = (response.services || []).map((service: Service) => normalizeServiceContact(service));
          this.rebuildServicesByTypeCache();
          resolve();
        },
        error => {
          console.error('Failed to load employees and services', error);
          this.caretakerContactPersonOptionsLoadFailed = true;
          this.technicalServicesModel = [];
          this.servicesByTypeCache = new Map();
          resolve();
        }
      );
    });

    this.companyEmployeesAndServicesLoadPromise = loadPromise.finally(() => {
      this.companyEmployeesAndServicesLoadPromise = null;
    });
    return this.companyEmployeesAndServicesLoadPromise;
  }

  private readonly nameCollator = new Intl.Collator(undefined, {
    sensitivity: 'base',
    numeric: true
  });

  private sortByText<T>(arr: T[], getText: (item: T) => string | null | undefined): T[] {
    return (arr || [])
      .slice()
      .sort((a, b) =>
        this.nameCollator.compare(
          (getText(a) || '').trim(),
          (getText(b) || '').trim()
        )
      );
  }

  addInlineCaretaker(form: FormGroup): void {
    this.inlineContactAddService.addForProperty({
      kind: 'caretaker',
      form,
      controlName: 'caretaker',
      reloadOptions: () => this.loadCompanyEmployeesAndServices()
    });
  }

  addInlinePropertyManager(form: FormGroup): void {
    this.inlineContactAddService.addForProperty({
      kind: 'propertyManager',
      form,
      controlName: 'propertyManagers',
      reloadOptions: () => this.loadCompanyEmployeesAndServices()
    });
  }

  addInlineTechnicalAssetsManager(form: FormGroup): void {
    this.inlineContactAddService.addForProperty({
      kind: 'technicalAssetsManager',
      form,
      controlName: 'technicalAssetsManagers',
      reloadOptions: () => this.loadCompanyEmployeesAndServices()
    });
  }

  addInlineSevManager(form: FormGroup): void {
    this.inlineContactAddService.addForProperty({
      kind: 'sevManager',
      form,
      controlName: 'sevManagers',
      reloadOptions: () => this.loadCompanyEmployeesAndServices()
    });
  }

  addInlineAccountant(form: FormGroup): void {
    this.inlineContactAddService.addForProperty({
      kind: 'accountant',
      form,
      controlName: 'accountants',
      reloadOptions: () => this.loadCompanyEmployeesAndServices()
    });
  }

  addInlineService(form: FormGroup, serviceHeaderKey: string): void {
    const forcedServiceType = this.technicalServicesOrderingService.getServiceByHeaderKey(serviceHeaderKey)?.serviceType;
    this.inlineContactAddService.addForProperty({
      kind: 'service',
      form,
      controlName: serviceHeaderKey,
      forcedServiceType,
      reloadOptions: () => this.loadCompanyEmployeesAndServices(),
      onCreated: (createdId) => this.pendingInlineCreatedServiceIds.add(createdId),
    });
  }

  async editCaretakerFromContactPerson(
    event: MouseEvent,
    caretakerValue: unknown,
    select?: NzSelectComponent
  ): Promise<void> {
    const caretakerId = this.getCaretakerContactPersonCaretakerId(caretakerValue);
    if (!caretakerId) return;
    const caretaker = this.caretakers.find((c) => String(c._id) === caretakerId);
    if (!caretaker) return;
    await this.editDropdownOption(event, 'caretaker', caretaker._id, select);
  }

  async editDropdownOption(
    event: MouseEvent,
    kind: InlineAddKind,
    id?: string | null,
    select?: NzSelectComponent
  ): Promise<void> {
    event.preventDefault();
    event.stopPropagation();

    const entityId = id ? String(id) : '';
    if (!entityId) return;

    let modalData: any = null;

    if (kind === 'caretaker') {
      const caretaker = this.caretakers.find(c => String(c._id) === entityId);
      if (!caretaker) return;
      modalData = { type: 'caretaker', contact: caretaker };
    }

    if (kind === 'propertyManager') {
      const manager = this.propertyManagersModel.find(m => String(m._id) === entityId);
      if (!manager) return;
      modalData = {
        type: 'employee',
        contact: manager,
        lockRole: true,
        forcedRole: 'Property Manager'
      };
    }

    if (kind === 'technicalAssetsManager') {
      const manager = this.technicalAssetsManagers.find(m => String(m._id) === entityId);
      if (!manager) return;
      modalData = {
        type: 'employee',
        contact: manager,
        lockRole: true,
        forcedRole: 'Technical Assets Manager'
      };
    }

    if (kind === 'sevManager') {
      const manager = this.sevManagersModel.find(m => String(m._id) === entityId);
      if (!manager) return;
      modalData = {
        type: 'employee',
        contact: manager,
        lockRole: true,
        forcedRole: 'Condominium Manager'
      };
    }

    if (kind === 'accountant') {
      const accountant = this.accountantsModel.find(m => String(m._id) === entityId);
      if (!accountant) return;
      modalData = {
        type: 'employee',
        contact: accountant,
        lockRole: true,
        forcedRole: 'Accountant'
      };
    }

    if (kind === 'service') {
      const service = this.technicalServicesModel.find(s => String(s._id) === entityId);
      if (!service) return;
      modalData = {
        type: 'service',
        contact: service
      };
    }

    const result = await lastValueFrom(this.contactUpsertModal.open(modalData));
    if (result?.entity) {
      await this.loadCompanyEmployeesAndServices();
    }
  }

  addressValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      // if value is empty, the required validator will handle it, so return null here
      return null;
    }

    const isValid = ADDRESS_PATTERN.test(control.value);

    if (!isValid) {
      return { invalidAddress: true };
    }
    return null;
  }

  createAddPropertyForm() {
    const formGroupConfig: { [key: string]: any } = {
      address: ['', [Validators.required, (control: AbstractControl) => this.addressValidator(control)]],
      hospitalityDetails: this.createHospitalityDetailsGroup(),
    };

    if (this.multiLandingProfilesEnabled) {
      formGroupConfig['landingProfileId'] = [this.useCompanyLandingProfileValue];
    }

    // Dynamically add controls based on savedHeaders
    if (this.savedHeaders?.caretakerHeaders?.includes('CARETAKER_NAME')) {
      formGroupConfig['caretaker'] = [null];
      formGroupConfig['caretakerContactPersonIds'] = [[]];
    }

    if (this.savedHeaders?.propertyManagerHeaders?.includes('PROPERTY_MANAGER_NAME')) {
      formGroupConfig['propertyManagers'] = [null];
    }

    if (this.savedHeaders?.technicalAssetsManagerHeaders?.includes('TECHNICAL_ASSETS_MANAGER_NAME')) {
      formGroupConfig['technicalAssetsManagers'] = [null];
    }

    if (this.savedHeaders?.sevManagerHeaders?.includes('CONDOMINIUM_MANAGER_NAME')) {
      formGroupConfig['sevManagers'] = [null];
    }

    if (this.savedHeaders?.accountantHeaders?.includes('ACCOUNTANT_NAME')) {
      formGroupConfig['accountants'] = [null];
    }

    // Handle technical services
    if (this.savedHeaders?.technicalServiceHeaders?.length) {
      this.technicalServiceTypes = this.savedHeaders.technicalServiceHeaders;
      this.technicalServiceTypes.forEach(serviceType => {
        formGroupConfig[serviceType] = [[]];
      });
    } else {
      this.technicalServiceTypes = [];
    }

    this.addPropertyForm = this.fb.group(
      formGroupConfig,
      { validators: this.requireAtLeastOneEnabledManagerSelectionValidator() }
    );
    this.bindCaretakerContactPersonSelection(this.addPropertyForm, 'add');
  }

  private createEditPropertyForm(): void {
    const formGroupConfig: { [key: string]: any } = {
      address: ['', [Validators.required, (control: AbstractControl) => this.addressValidator(control)]],
      hospitalityDetails: this.createHospitalityDetailsGroup(),
    };

    if (this.multiLandingProfilesEnabled) {
      formGroupConfig['landingProfileId'] = [this.useCompanyLandingProfileValue];
    }

    if (this.savedHeaders?.caretakerHeaders?.includes('CARETAKER_NAME')) {
      formGroupConfig['caretaker'] = [null];
      formGroupConfig['caretakerContactPersonIds'] = [[]];
    }

    if (this.savedHeaders?.propertyManagerHeaders?.includes('PROPERTY_MANAGER_NAME')) {
      formGroupConfig['propertyManagers'] = [null];
    }

    if (this.savedHeaders?.technicalAssetsManagerHeaders?.includes('TECHNICAL_ASSETS_MANAGER_NAME')) {
      formGroupConfig['technicalAssetsManagers'] = [null];
    }

    if (this.savedHeaders?.sevManagerHeaders?.includes('CONDOMINIUM_MANAGER_NAME')) {
      formGroupConfig['sevManagers'] = [null];
    }

    if (this.savedHeaders?.accountantHeaders?.includes('ACCOUNTANT_NAME')) {
      formGroupConfig['accountants'] = [null];
    }

    if (this.savedHeaders?.technicalServiceHeaders?.length) {
      this.technicalServiceTypes = this.savedHeaders.technicalServiceHeaders;
      this.technicalServiceTypes.forEach(serviceType => {
        formGroupConfig[serviceType] = [[]];
      });
    } else {
      this.technicalServiceTypes = [];
    }

    this.editPropertyForm = this.fb.group(
      formGroupConfig,
      { validators: this.requireAtLeastOneEnabledManagerSelectionValidator() }
    );
    this.bindCaretakerContactPersonSelection(this.editPropertyForm, 'edit');
  }

  private bindCaretakerContactPersonSelection(form: FormGroup, mode: 'add' | 'edit'): void {
    const control = form.get('caretaker');
    const contactPersonIdsControl = form.get('caretakerContactPersonIds');
    if (!control || !contactPersonIdsControl) {
      return;
    }

    if (mode === 'add') {
      this.addCaretakerContactPersonSelectionSubscription?.unsubscribe();
      this.addCaretakerContactPersonSelectionSubscription = control.valueChanges.subscribe((caretakerValue) => {
        this.handleCaretakerContactPersonCaretakerChange(form, 'add', caretakerValue);
      });
      return;
    }

    this.editCaretakerContactPersonSelectionSubscription?.unsubscribe();
    this.editCaretakerContactPersonSelectionSubscription = control.valueChanges.subscribe((caretakerValue) => {
      this.handleCaretakerContactPersonCaretakerChange(form, 'edit', caretakerValue);
    });
  }

  private getCaretakerContactPersonSelectionCache(mode: 'add' | 'edit'): Map<string, string[]> {
    return mode === 'add'
      ? this.addCaretakerContactPersonSelectionCache
      : this.editCaretakerContactPersonSelectionCache;
  }

  private getActiveCaretakerContactPersonSelectionCacheKey(mode: 'add' | 'edit'): string | null {
    return mode === 'add'
      ? this.addActiveCaretakerContactPersonSelectionCacheKey
      : this.editActiveCaretakerContactPersonSelectionCacheKey;
  }

  private setActiveCaretakerContactPersonSelectionCacheKey(mode: 'add' | 'edit', caretakerId: string | null): void {
    if (mode === 'add') {
      this.addActiveCaretakerContactPersonSelectionCacheKey = caretakerId;
      return;
    }
    this.editActiveCaretakerContactPersonSelectionCacheKey = caretakerId;
  }

  private resetCaretakerContactPersonSelectionCache(mode: 'add' | 'edit'): void {
    this.getCaretakerContactPersonSelectionCache(mode).clear();
    this.setActiveCaretakerContactPersonSelectionCacheKey(mode, null);
    if (mode === 'edit') {
      this.editCaretakerContactPersonSelectionPropertyId = null;
    }
  }

  private getCaretakerContactPersonCaretakerId(caretakerValue: unknown): string | null {
    const caretakerId = String(
      typeof caretakerValue === 'object' && caretakerValue !== null
        ? ((caretakerValue as { _id?: unknown; id?: unknown })._id
          || (caretakerValue as { id?: unknown }).id
          || '')
        : caretakerValue || ''
    ).trim();
    return caretakerId || null;
  }

  private rememberCaretakerContactPersonSelection(
    mode: 'add' | 'edit',
    caretakerId: string | null,
    value: unknown
  ): void {
    if (!caretakerId) {
      return;
    }
    this.getCaretakerContactPersonSelectionCache(mode).set(
      caretakerId,
      this.normalizeCaretakerContactPersonSelectionIds(value)
    );
  }

  private seedCaretakerContactPersonSelectionCache(form: FormGroup, mode: 'add' | 'edit'): void {
    const caretakerId = this.getCaretakerContactPersonCaretakerId(form.get('caretaker')?.value);
    const contactPersonIdsControl = form.get('caretakerContactPersonIds');
    if (!contactPersonIdsControl) {
      return;
    }

    const normalizedIds = caretakerId
      ? this.reconcileCaretakerContactPersonSelectionIds(caretakerId, contactPersonIdsControl.value)
      : [];
    contactPersonIdsControl.setValue(normalizedIds, { emitEvent: false });
    this.rememberCaretakerContactPersonSelection(mode, caretakerId, normalizedIds);
    this.setActiveCaretakerContactPersonSelectionCacheKey(mode, caretakerId);
  }

  private handleCaretakerContactPersonCaretakerChange(
    form: FormGroup,
    mode: 'add' | 'edit',
    caretakerValue: unknown
  ): void {
    const contactPersonIdsControl = form.get('caretakerContactPersonIds');
    if (!contactPersonIdsControl) {
      return;
    }

    const previousCaretakerId = this.getActiveCaretakerContactPersonSelectionCacheKey(mode);
    this.rememberCaretakerContactPersonSelection(mode, previousCaretakerId, contactPersonIdsControl.value);

    const caretakerId = this.getCaretakerContactPersonCaretakerId(caretakerValue);
    const cachedIds = caretakerId
      ? this.getCaretakerContactPersonSelectionCache(mode).get(caretakerId) || []
      : [];
    const restoredIds = caretakerId
      ? this.reconcileCaretakerContactPersonSelectionIds(caretakerId, cachedIds)
      : [];

    contactPersonIdsControl.setValue(restoredIds, { emitEvent: false });
    this.rememberCaretakerContactPersonSelection(mode, caretakerId, restoredIds);
    this.setActiveCaretakerContactPersonSelectionCacheKey(mode, caretakerId);
  }

  private getCaretakerContactPersonsForCaretaker(caretakerValue: unknown): CaretakerContactPerson[] {
    const caretakerId = this.getCaretakerContactPersonCaretakerId(caretakerValue);
    const caretaker = this.caretakers.find((candidate) => String(candidate._id || '') === caretakerId);
    const seen = new Set<string>();
    return (Array.isArray(caretaker?.contactPersons) ? caretaker.contactPersons : [])
      .filter((person): person is CaretakerContactPerson => {
        const id = String(person?._id || '').trim();
        const name = String(person?.name || '').trim();
        if (!id || !name || seen.has(id)) {
          return false;
        }
        seen.add(id);
        return true;
      })
      .sort((left, right) => Number(right.isPrimary) - Number(left.isPrimary));
  }

  getCaretakerContactPersonsForForm(form: FormGroup): CaretakerContactPerson[] {
    return this.getCaretakerContactPersonsForCaretaker(form.get('caretaker')?.value);
  }

  shouldShowCaretakerContactPersonSelection(form: FormGroup): boolean {
    const caretakerId = this.getCaretakerContactPersonCaretakerId(form.get('caretaker')?.value);
    if (!caretakerId) {
      return false;
    }

    return !this.caretakerContactPersonOptionsLoaded
      || this.getCaretakerContactPersonsForCaretaker(caretakerId).length > 0;
  }

  isCaretakerContactPersonOptionsLoaded(): boolean {
    return this.caretakerContactPersonOptionsLoaded;
  }

  getCaretakerContactPersonOptionsStatusKey(): string {
    return this.caretakerContactPersonOptionsLoadFailed
      ? 'PROPERTY_LIST.CARETAKER_CONTACT_PERSONS_LOAD_ERROR'
      : 'PROPERTY_LIST.CARETAKER_CONTACT_PERSONS_LOADING';
  }

  formatCaretakerContactPersonOption(person: CaretakerContactPerson): string {
    const parts = [String(person.name || '').trim()];
    if (person.position?.trim()) {
      parts.push(person.position.trim());
    }
    if (person.isPrimary) {
      parts.push(this.translate.instant('CONTACTS.PRIMARY_CONTACT_PERSON'));
    }
    return parts.filter(Boolean).join(' · ');
  }

  private normalizeCaretakerContactPersonSelectionIds(value: unknown): string[] {
    const seen = new Set<string>();
    return (Array.isArray(value) ? value : [])
      .map((entry) => String(
        typeof entry === 'object' && entry !== null
          ? ((entry as { _id?: unknown; id?: unknown })._id || (entry as { id?: unknown }).id || '')
          : entry || ''
      ).trim())
      .filter((id) => {
        if (!id || seen.has(id)) {
          return false;
        }
        seen.add(id);
        return true;
      });
  }

  private reconcileCaretakerContactPersonSelectionIds(caretakerValue: unknown, value: unknown): string[] {
    if (!this.caretakerContactPersonOptionsLoaded) {
      return this.normalizeCaretakerContactPersonSelectionIds(value);
    }

    const availableIds = new Set(
      this.getCaretakerContactPersonsForCaretaker(caretakerValue)
        .map((person) => String(person._id || '').trim())
        .filter(Boolean)
    );
    return this.normalizeCaretakerContactPersonSelectionIds(value)
      .filter((id) => availableIds.has(id));
  }

  private reconcileCaretakerContactPersonSelectionsInForms(): void {
    if (!this.caretakerContactPersonOptionsLoaded) {
      return;
    }

    ([
      { form: this.addPropertyForm, mode: 'add' as const },
      { form: this.editPropertyForm, mode: 'edit' as const }
    ]).forEach(({ form, mode }) => {
      if (!form?.contains('caretaker') || !form.contains('caretakerContactPersonIds')) {
        return;
      }

      const caretakerId = this.getCaretakerContactPersonCaretakerId(form.get('caretaker')?.value);
      const selectionCache = this.getCaretakerContactPersonSelectionCache(mode);
      const activeCaretakerId = this.getActiveCaretakerContactPersonSelectionCacheKey(mode);
      this.rememberCaretakerContactPersonSelection(
        mode,
        activeCaretakerId || caretakerId,
        form.get('caretakerContactPersonIds')?.value
      );

      Array.from(selectionCache.entries()).forEach(([cachedCaretakerId, cachedIds]) => {
        selectionCache.set(
          cachedCaretakerId,
          this.reconcileCaretakerContactPersonSelectionIds(cachedCaretakerId, cachedIds)
        );
      });

      const reconciledIds = caretakerId
        ? this.reconcileCaretakerContactPersonSelectionIds(
          caretakerId,
          selectionCache.get(caretakerId) || []
        )
        : [];
      form.get('caretakerContactPersonIds')?.setValue(reconciledIds, { emitEvent: false });
      this.rememberCaretakerContactPersonSelection(mode, caretakerId, reconciledIds);
      this.setActiveCaretakerContactPersonSelectionCacheKey(mode, caretakerId);
    });
  }

  private async ensureCaretakerContactPersonOptionsForSave(form: FormGroup): Promise<boolean> {
    if (!form.get('caretaker')?.value || this.caretakerContactPersonOptionsLoaded) {
      return true;
    }

    await this.loadCompanyEmployeesAndServices();
    if (!this.caretakerContactPersonOptionsLoaded) {
      this.message.error(this.translate.instant('PROPERTY_LIST.CARETAKER_CONTACT_PERSONS_LOAD_ERROR'));
      return false;
    }
    return true;
  }

  private getPropertySaveErrorMessage(error: unknown, fallbackKey: string): string {
    const response = error as { error?: { message?: string; errors?: Array<{ code?: string }> } };
    if (
      response?.error?.message === 'PROPERTY_VALIDATION_FAILED'
      && response.error.errors?.some((entry) => entry.code === 'INVALID_CARETAKER_CONTACT_PERSON')
    ) {
      return this.translate.instant('PROPERTY_LIST.CARETAKER_CONTACT_PERSONS_INVALID');
    }
    return this.translate.instant(fallbackKey);
  }

  private hasManagerWizardSelection(): boolean {
    return this.propertyManagers.controls.some((ctrl) => {
      const positionType = ctrl.get('positionType')?.value;
      return positionType === 'Property Manager' || positionType === 'Technical Assets Manager' || positionType === 'Condominium Manager' || positionType === 'Accountant';
    });
  }

  private hasPropertyManagerHeaderEnabled(): boolean {
    return !!this.savedHeaders?.propertyManagerHeaders?.includes('PROPERTY_MANAGER_NAME');
  }

  private hasTechnicalAssetsManagerHeaderEnabled(): boolean {
    return !!this.savedHeaders?.technicalAssetsManagerHeaders?.includes('TECHNICAL_ASSETS_MANAGER_NAME');
  }

  private hasAnyManagerHeaderEnabled(): boolean {
    return this.hasPropertyManagerHeaderEnabled() || this.hasTechnicalAssetsManagerHeaderEnabled() || this.hasSevManagerHeaderEnabled() || this.hasAccountantHeaderEnabled();
  }

  private hasSevManagerHeaderEnabled(): boolean {
    return !!this.savedHeaders?.sevManagerHeaders?.includes('CONDOMINIUM_MANAGER_NAME');
  }

  private hasAccountantHeaderEnabled(): boolean {
    return !!this.savedHeaders?.accountantHeaders?.includes('ACCOUNTANT_NAME');
  }

  private requireAtLeastOneEnabledManagerSelectionValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const propertyManagerEnabled = this.hasPropertyManagerHeaderEnabled();
      const technicalAssetsManagerEnabled = this.hasTechnicalAssetsManagerHeaderEnabled();
      const sevManagerEnabled = this.hasSevManagerHeaderEnabled();
      const accountantEnabled = this.hasAccountantHeaderEnabled();

      if (!propertyManagerEnabled && !technicalAssetsManagerEnabled && !sevManagerEnabled && !accountantEnabled) {
        return null;
      }

      const propertyManagerSelected = !!control.get('propertyManagers')?.value;
      const technicalAssetsManagerSelected = !!control.get('technicalAssetsManagers')?.value;
      const sevManagerSelected = !!control.get('sevManagers')?.value;
      const accountantSelected = !!control.get('accountants')?.value;

      if ((propertyManagerEnabled && propertyManagerSelected) || (technicalAssetsManagerEnabled && technicalAssetsManagerSelected) || (sevManagerEnabled && sevManagerSelected) || (accountantEnabled && accountantSelected)) {
        return null;
      }

      return { managerRequired: true };
    };
  }

  hasManagerSelectionError(form: FormGroup | null | undefined): boolean {
    return !!(form && form.hasError('managerRequired') && (form.dirty || form.touched));
  }

  getAvailableManagerLabels(): string[] {
    const labels: string[] = [];
    if (this.hasPropertyManagerHeaderEnabled()) {
      labels.push(this.translate.instant('PROPERTY_LIST.PROPERTY_MANAGER'));
    }
    if (this.hasTechnicalAssetsManagerHeaderEnabled()) {
      labels.push(this.translate.instant('PROPERTY_LIST.TECHNICAL_ASSETS_MANAGER'));
    }
    if (this.hasSevManagerHeaderEnabled()) {
      labels.push(this.translate.instant('PROPERTY_LIST.CONDOMINIUM_MANAGER'));
    }
    if (this.hasAccountantHeaderEnabled()) {
      labels.push(this.translate.instant('PROPERTY_LIST.ACCOUNTANT'));
    }
    return labels;
  }

  getManagerRequiredMessage(): string {
    const labels = this.getAvailableManagerLabels();
    if (labels.length === 1) {
      return this.translate.instant('PROPERTY_LIST.MANAGER_REQUIRED_SINGLE', { manager: labels[0] });
    }
    if (labels.length > 1) {
      return this.translate.instant('PROPERTY_LIST.MANAGER_REQUIRED_MULTIPLE', { managers: labels.join(', ') });
    }
    return this.translate.instant('PROPERTY_LIST.MANAGER_REQUIRED');
  }

  private markFormGroupForValidation(control: AbstractControl): void {
    control.markAsTouched();
    control.markAsDirty();
    control.updateValueAndValidity();

    if (control instanceof FormGroup || control instanceof FormArray) {
      Object.values(control.controls).forEach(child => {
        this.markFormGroupForValidation(child);
      });
    }
  }

  private applyManagerSelectionValidation(form: FormGroup): void {
    form.setValidators(this.requireAtLeastOneEnabledManagerSelectionValidator());
    form.updateValueAndValidity({ emitEvent: false });
  }

  // Method to get technical service form controls
  getTechnicalServiceFormControls(): { [key: string]: FormControl } {
    const controls: { [key: string]: FormControl } = {};
    this.technicalServiceTypes.forEach(serviceType => {
      controls[serviceType] = new FormControl<string[]>([]);
    });
    return controls;
  }
  // Load saved headers from the backend
  private rebuildPropertyFormsFromSavedHeaders(): void {
    this.createAddPropertyForm();
    this.createEditPropertyForm();
    this.adjustFormBasedOnHeaders();
  }

  private preserveCommonPropertyFormValues(form: FormGroup, previousRawValue: any): void {
    if (!form || !previousRawValue) {
      return;
    }

    form.get('address')?.setValue(previousRawValue.address ?? '', { emitEvent: false });

    ['caretaker', 'caretakerContactPersonIds', 'propertyManagers', 'technicalAssetsManagers', 'sevManagers', 'accountants', 'landingProfileId'].forEach((controlName) => {
      if (!form.contains(controlName) || previousRawValue[controlName] === undefined) {
        return;
      }
      const value = controlName === 'caretakerContactPersonIds'
        ? this.reconcileCaretakerContactPersonSelectionIds(
          previousRawValue.caretaker,
          previousRawValue.caretakerContactPersonIds
        )
        : previousRawValue[controlName];
      form.get(controlName)?.setValue(value, { emitEvent: false });
    });

    if (form.contains('caretaker') && form.contains('caretakerContactPersonIds')) {
      this.seedCaretakerContactPersonSelectionCache(
        form,
        form === this.addPropertyForm ? 'add' : 'edit'
      );
    }

    form.setControl('hospitalityDetails', this.createHospitalityDetailsGroup(previousRawValue.hospitalityDetails || undefined));

    this.technicalServiceTypes.forEach((serviceType) => {
      if (!form.contains(serviceType)) {
        return;
      }
      form.get(serviceType)?.setValue(
        this.normalizeServiceSelectionIds(previousRawValue[serviceType] || []),
        { emitEvent: false }
      );
    });

    this.applyManagerSelectionValidation(form);
  }

  private refreshOpenPropertyModalFormsFromSavedHeaders(): void {
    this.recomputeStepCaches();

    if (this.addModalVisible && this.addPropertyForm) {
      const previousStepKey = this.addSteps[this.currentAddStep]?.key;
      const previousStepIndex = this.currentAddStep;
      const previousRawValue = this.addPropertyForm.getRawValue();

      this.createAddPropertyForm();
      this.preserveCommonPropertyFormValues(this.addPropertyForm, previousRawValue);

      const nextIndex = this.addSteps.findIndex((step) => step.key === previousStepKey);
      this.setModalStep('add', nextIndex >= 0 ? nextIndex : Math.min(previousStepIndex, this.addSteps.length - 1), {
        forceImmediateServicesRender: true
      });
    }

    if (this.editModalVisible && this.editPropertyForm) {
      const previousStepKey = this.editSteps[this.currentEditStep]?.key;
      const previousStepIndex = this.currentEditStep;
      const previousRawValue = this.editPropertyForm.getRawValue();

      this.createEditPropertyForm();

      if (this.selectedProperty) {
        this.populateEditForm(this.selectedProperty);
      }

      this.preserveCommonPropertyFormValues(this.editPropertyForm, previousRawValue);

      const nextIndex = this.editSteps.findIndex((step) => step.key === previousStepKey);
      this.setModalStep('edit', nextIndex >= 0 ? nextIndex : Math.min(previousStepIndex, this.editSteps.length - 1), {
        forceImmediateServicesRender: true
      });
    }
  }

  async loadSavedHeaders(options: { rebuildPropertyForms?: boolean } = {}): Promise<void> {
    const { rebuildPropertyForms = true } = options;
    return new Promise((resolve, reject) => {
      this.templateService.getSavedHeaders().subscribe({
        next: (headers: SavedHeaders) => {
          this.savedHeaders = headers || { ...defaultSavedHeaders };
          this.dynamicHeaders = { ...defaultSavedHeaders, ...this.savedHeaders };
          this.technicalServiceTypes = this.savedHeaders.technicalServiceHeaders || [];
          if (rebuildPropertyForms) {
            this.rebuildPropertyFormsFromSavedHeaders();
          }
          resolve();
        },
        error: (error) => {
          console.error('Error loading saved headers:', error);
          this.savedHeaders = { ...defaultSavedHeaders };
          this.dynamicHeaders = { ...defaultSavedHeaders };
          reject(error);
        }
      });
    });
  }

  private syncTechnicalServiceOrderingWithHeaders(headers?: string[]): void {
    const selectedHeaders = Array.isArray(headers)
      ? headers
      : (this.savedHeaders?.technicalServiceHeaders || []);
    this.technicalServiceCategoryOrder = normalizeTechnicalServiceCategoryOrder(
      this.company?.technicalServiceCategoryOrder || this.technicalServiceCategoryOrder
    );
    this.technicalServiceHeaderOrder = this.technicalServicesOrderingService.normalizeHeaderOrder(
      this.company?.technicalServiceHeaderOrder || this.technicalServiceHeaderOrder,
      selectedHeaders
    );
  }

  // Adjust form dynamically based on headers
  adjustFormBasedOnHeaders() {
    // Since propertyManagers and technicalAssetsManagers are FormControls (not FormArray), we just set their values
    const propertyManagerControl = this.addPropertyForm.get('propertyManagers') as FormControl;
    const technicalAssetsManagerControl = this.addPropertyForm.get('technicalAssetsManagers') as FormControl;
    const sevManagerControl = this.addPropertyForm.get('sevManagers') as FormControl;
    const accountantControl = this.addPropertyForm.get('accountants') as FormControl;

    if (this.savedHeaders?.propertyManagerHeaders?.includes('PROPERTY_LIST.NAME')) {
      propertyManagerControl.setValue(null);
    } else {
      this.addPropertyForm.removeControl('propertyManagers');
    }

    if (this.savedHeaders?.technicalAssetsManagerHeaders?.includes('PROPERTY_LIST.NAME')) {
      technicalAssetsManagerControl.setValue(null);
    } else {
      this.addPropertyForm.removeControl('technicalAssetsManagers');
    }

    if (this.savedHeaders?.sevManagerHeaders?.includes('PROPERTY_LIST.NAME')) {
      sevManagerControl.setValue(null);
    } else {
      this.addPropertyForm.removeControl('sevManagers');
    }

    if (this.savedHeaders?.accountantHeaders?.includes('PROPERTY_LIST.NAME')) {
      accountantControl.setValue(null);
    } else {
      this.addPropertyForm.removeControl('accountants');
    }
  }

  // Toggle Add Modal visibility
  async toggleAddModal() {
    const willOpen = !this.addModalVisible;
    if (!willOpen) {
      this.addModalVisible = false;
      this.resetCaretakerContactPersonSelectionCache('add');
      return;
    }

    try {
      // Ensure technicalServiceTypes is populated
      if (!this.technicalServiceTypes || this.technicalServiceTypes.length === 0) {
        // Reload headers and wait for completion before creating the form
        await this.loadSavedHeaders();
      }

      // Recreate the form to ensure it has the correct controls
      this.resetCaretakerContactPersonSelectionCache('add');
      this.createAddPropertyForm();

      // ⬇️ ensure steps are computed and indices valid BEFORE opening
      this.recomputeStepCaches();
    } catch (error) {
      console.error('Failed to load headers:', error);
      return; // Exit if header loading fails
    }

    // Always start a new add-property session from the first step.
    this.setModalStep('add', 0, { forceImmediateServicesRender: true });

    // Open the modal after its form is ready.
    this.addModalVisible = true;
  }

  setupWizardFormWithSavedHeaders() {
    if (!this.wizardForm) {
      console.warn('setupWizardFormWithSavedHeaders: wizardForm not initialized, skipping');
      return;
    }
    if (this.savedHeaders) {
      // Clear and reset managers and services arrays in wizardForm
      this.propertyManagers.clear();
      this.technicalServices.clear();

      // Prefill Property Managers based on saved headers
      if (this.savedHeaders.propertyManagerHeaders?.includes('PROPERTY_MANAGER_NAME')) {
        const includeEmail = this.savedHeaders.propertyManagerHeaders.includes('PROPERTY_MANAGER_EMAIL');
        const includePhone = this.savedHeaders.propertyManagerHeaders.includes('PROPERTY_MANAGER_PHONE');

        const propertyManagerGroup = this.fb.group({
          positionType: ['Property Manager', Validators.required],
          includeEmail: [includeEmail],
          includePhone: [includePhone],
        }, { validators: this.emailOrPhoneRequiredValidator });
        this.propertyManagers.push(propertyManagerGroup);
      }

      // Prefill Technical Assets Managers based on saved headers
      if (this.savedHeaders.technicalAssetsManagerHeaders?.includes('TECHNICAL_ASSETS_MANAGER_NAME')) {
        const includeEmail = this.savedHeaders.technicalAssetsManagerHeaders.includes('TECHNICAL_ASSETS_MANAGER_EMAIL');
        const includePhone = this.savedHeaders.technicalAssetsManagerHeaders.includes('TECHNICAL_ASSETS_MANAGER_PHONE');

        const technicalAssetsManagerGroup = this.fb.group({
          positionType: ['Technical Assets Manager', Validators.required],
          includeEmail: [includeEmail],
          includePhone: [includePhone],
        }, { validators: this.emailOrPhoneRequiredValidator });
        this.propertyManagers.push(technicalAssetsManagerGroup);
      }

      if (this.savedHeaders.sevManagerHeaders?.includes('CONDOMINIUM_MANAGER_NAME')) {
        const includeEmail = this.savedHeaders.sevManagerHeaders.includes('CONDOMINIUM_MANAGER_EMAIL');
        const includePhone = this.savedHeaders.sevManagerHeaders.includes('CONDOMINIUM_MANAGER_PHONE');

        const sevManagerGroup = this.fb.group({
          positionType: ['Condominium Manager', Validators.required],
          includeEmail: [includeEmail],
          includePhone: [includePhone],
        }, { validators: this.emailOrPhoneRequiredValidator });
        this.propertyManagers.push(sevManagerGroup);
      }

      if (this.savedHeaders.accountantHeaders?.includes('ACCOUNTANT_NAME')) {
        const includeEmail = this.savedHeaders.accountantHeaders.includes('ACCOUNTANT_EMAIL');
        const includePhone = this.savedHeaders.accountantHeaders.includes('ACCOUNTANT_PHONE');

        const accountantGroup = this.fb.group({
          positionType: ['Accountant', Validators.required],
          includeEmail: [includeEmail],
          includePhone: [includePhone],
        }, { validators: this.emailOrPhoneRequiredValidator });
        this.propertyManagers.push(accountantGroup);
      }

      if (this.propertyManagers.length === 0) {
        this.propertyManagers.push(this.fb.group({
          positionType: [null, Validators.required],
          includeEmail: [false],
          includePhone: [false],
        }, { validators: this.emailOrPhoneRequiredValidator }));
      }

      // Prefill Technical Services based on saved headers
      const selectedServices = this.savedHeaders.technicalServiceHeaders || [];

      this.technicalServices.push(
        this.fb.group({
          serviceType: [selectedServices.length ? selectedServices : []], // Default to empty array if none
        })
      );
      this.syncTechnicalServiceOrderingWithHeaders(selectedServices);
    }
  }

  // Fetch properties from the backend
  async fetchProperties(): Promise<void> {
    this.isLoading = true;
    this.isPropertiesTableLoading = true;
    this.hasLoadedProperties = false;

    // Load saved headers first
    try {
      await this.loadSavedHeaders();

      // Now proceed to fetch properties
      this.propertyService.getProperties()
        .pipe(finalize(() => {
          this.isLoading = false;
          this.hasLoadedProperties = true;
          this.notifyTourPropertiesReady();
        }))
        .subscribe(
        (properties: Property[]) => {
          this.allProperties = properties;
          this.propertiesPagination.total = this.allProperties.length;
          this.schedulePropertiesTableRefresh(() => {
            this.maxTechnicalAssetsManagers = Math.max(
              ...properties.map(p => p.technicalAssetsManagers.length || 0)
            );

            this.updateMaxValues();
            this.updateDisplayedColumns();
            this.setupWizardFormWithSavedHeaders();
            this.syncTechnicalServiceOrderingWithHeaders();
            this.notifyTourPropertiesReady();
          });
        },
        (error: any) => {
          this.message.error(this.translate.instant('ERROR_MESSAGES.FETCH_FAILED'));
          console.error('Error fetching properties:', error);
          this.resetPropertiesTableLoading();
        }
      );
    } catch (error) {
      console.error("Error loading saved headers in fetchProperties:", error);
      this.message.error(this.translate.instant('PROPERTY_LIST.FAILED_TO_LOAD_HEADERS'));
      this.isLoading = false;
      this.hasLoadedProperties = true;
      this.resetPropertiesTableLoading();
      this.notifyTourPropertiesReady();
    }
  }

  private schedulePropertiesTableRefresh(afterRefresh?: () => void): void {
    this.isPropertiesTableLoading = true;

    if (this.propertiesTableRefreshHandle) {
      clearTimeout(this.propertiesTableRefreshHandle);
    }

    this.propertiesTableRefreshHandle = setTimeout(() => {
      this.propertiesTableRefreshHandle = null;
      this.applyPropertiesPagination();
      afterRefresh?.();
      this.isPropertiesTableLoading = false;
      this.notifyTourPropertiesReady();
    }, 0);
  }

  private resetPropertiesTableLoading(): void {
    if (this.propertiesTableRefreshHandle) {
      clearTimeout(this.propertiesTableRefreshHandle);
      this.propertiesTableRefreshHandle = null;
    }
    this.isPropertiesTableLoading = false;
  }

  // Calculate the maximum number of managers and services across all properties
  updateMaxValues(): void {
    this.maxManagers = Math.max(...this.properties.map(p => p.propertyManagers.length), 0);
    this.maxServices = Math.max(...this.properties.map(p => p.technicalServices.length), 0);
  }


  updateDisplayedColumns(): void {
    // Set maxManagers and maxServices based on the properties data
    this.maxManagers = Math.max(...this.properties.map(p => p.propertyManagers.length || 0));
    this.maxServices = Math.max(...this.properties.map(p => p.technicalServices.length || 0));

    // Clear previous dynamic columns and add the fixed ones.
    this.displayedColumns = ['street', 'zipcode', 'city', 'caretakerName', 'caretakerPhone', 'caretakerEmail'];

    // Dynamically add Property Manager columns.
    for (let i = 1; i <= this.maxManagers; i++) {
      this.displayedColumns.push(`propertyManager${i}Name`, `propertyManager${i}Email`, `propertyManager${i}Phone`);
    }

    // Dynamically add Technical Service columns.
    for (let i = 1; i <= this.maxServices; i++) {
      this.displayedColumns.push(`technicalService${i}Name`, `technicalService${i}Phone`);
    }
  }

  // Get the property managers form array
  get propertyManagers(): FormArray {
    return this.wizardForm.get('propertyManagers') as FormArray;
  }

  // Get the technical services form array
  get technicalServices(): FormArray {
    return this.wizardForm.get('technicalServices') as FormArray;
  }

  // Use this method to cast controls as FormGroup
  getFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  private emailOrPhoneRequiredValidator(group: AbstractControl): ValidationErrors | null {
    const includeEmail = group.get('includeEmail')?.value;
    const includePhone = group.get('includePhone')?.value;
    if (!includeEmail && !includePhone) {
      return { emailOrPhoneRequired: true };
    }
    return null;
  }

  addManager(type: 'propertyManagers'): void {
    const formArray = this.wizardForm.get(type) as FormArray;

    if (!formArray) {
      console.error(`FormArray ${type} not found or is null`);
      return;
    }

    // ✅ HARD LIMIT: max blocks = number of available position types (2)
    const max = this.positionTypes?.length || 3;
    if (formArray.length >= max) {
      return; // do nothing
    }

    formArray.push(
      this.fb.group({
        positionType: [null, Validators.required],
        includeEmail: [false],
        includePhone: [false],
      }, { validators: this.emailOrPhoneRequiredValidator })
    );
  }

  // Remove a property manager input
  removeManager(index: number): void {
    if (this.propertyManagers.length <= 1) {
      return; // keep minimum 1 block
    }
    this.propertyManagers.removeAt(index);
  }

  // Method to check if an option should be disabled
  isOptionDisabled(option: string): boolean {
    // Get a list of all currently selected position types in the form
    const selectedTypes = this.propertyManagers.controls
      .map(manager => manager.get('positionType')?.value)
      .filter(type => type); // Filter out empty or undefined values

    // Check if the option is already selected
    return selectedTypes.includes(option);
  }

  // Check if additional managers can be added
  canAddManager(): boolean {
    const max = this.positionTypes?.length || 3;
    return this.propertyManagers.length < max;
  }

  getPositionTypes(): string[] {
    return ['Property Manager', 'Technical Assets Manager', 'Condominium Manager', 'Accountant'];
  }

  onTechnicalServicesSelectionChange(change: TechnicalServiceSelectionChange): void {
    const control = this.technicalServices.at(0).get('serviceType');
    control?.setValue(change.selectedHeaderKeys);
    control?.markAsDirty();
    control?.updateValueAndValidity({ emitEvent: false });
    this.technicalServiceCategoryOrder = change.categoryOrder;
    this.technicalServiceHeaderOrder = change.headerOrder;
  }

  onTechnicalServicesOrderChange(change: TechnicalServiceSelectionChange): void {
    this.technicalServiceCategoryOrder = change.categoryOrder;
    this.technicalServiceHeaderOrder = change.headerOrder;
  }

  onEmergencyServicePlacementChange(serviceTypes: string[]): void {
    this.landingPageEmergencyServiceTypes = Array.from(new Set(serviceTypes));
  }

  // Open the wizard modal
  openWizard(): void {
    const init = async () => {
      // 1) Ensure headers are loaded
      await this.loadSavedHeaders({ rebuildPropertyForms: false });

      // 2) Rebuild the property‐manager/technical‐assets‐manager parts of the form
      if (!this.wizardForm) {
        console.warn('openWizard: wizardForm not initialized, cannot setup headers');
        return;
      }
      this.setupWizardFormWithSavedHeaders();

      // 3) **Initialize the multi‐select FormControl** from the loaded headers
      //    We assume technicalServices is a FormArray with one group at index 0
      const svcGroup = this.technicalServices.at(0);
      svcGroup.get('serviceType')!
        .patchValue(this.savedHeaders.technicalServiceHeaders || []);
      this.syncTechnicalServiceOrderingWithHeaders(this.savedHeaders.technicalServiceHeaders || []);
      this.landingPageEmergencyServicePlacementEnabled =
        this.company?.landingPageEmergencyServicePlacementEnabled === true;
      this.landingPageEmergencyServiceTypes = Array.isArray(this.company?.landingPageEmergencyServiceTypes)
        ? [...this.company.landingPageEmergencyServiceTypes]
        : [];

      // 4) Show the wizard
      this.wizardVisible = true;
    };

    // If we have *no* saved headers yet, load them first
    if (Object.values(this.savedHeaders).every(arr => Array.isArray(arr) && arr.length === 0)) {
      init().catch(err => {
        console.error("Error loading saved headers in openWizard:", err);
        this.message.error(this.translate.instant('PROPERTY_LIST.FAILED_TO_LOAD_HEADERS'));
      });
    } else {
      // Otherwise just re‐init immediately
      init().catch(err => {
        console.error("Error initializing wizard:", err);
        this.message.error(this.translate.instant('PROPERTY_LIST.FAILED_TO_LOAD_HEADERS'));
      });
    }
  }

  openLandingPageWizardFromPropertyModal(): void {
    // Opens the "Configure Landing Page" wizard modal on top of Add/Edit property modal
    this.openWizard();
  }

  openDownloadTemplateModal(): void {
    this.downloadTemplateModalVisible = true;
  }

  openImportConfirmModal(): void {
    this.selectedImportSource = 'scanafy';
    this.importConfirmModalVisible = true;
  }

  closeImportConfirmModal(): void {
    this.importConfirmModalVisible = false;
  }

  downloadTemplateFromImportModal(): void {
    this.closeImportConfirmModal();
    this.openDownloadTemplateModal();
  }

  continueToImportFromConfirmModal(): void {
    this.closeImportConfirmModal();
    this.triggerFileInput();
  }

  async saveLandingPageConfig(): Promise<void> {
    if (!this.canWriteTemplates) {
      return;
    }
    const columns = this.buildColumnsFromWizardForSave();
    if (!columns) return;

    await this.proceedWithTemplateDownload(columns, { downloadExcel: false });
    // proceedWithTemplateDownload will close the wizard on success
  }

  confirmDownloadTemplate(): void {
    this.downloadTemplateModalVisible = false;
    this.downloadTemplate(); // reuse existing validation + generation flow
  }

  private buildColumnsFromWizardForSave(): string[] | null {
    // Mark all controls as touched to trigger validation messages
    this.wizardForm.markAllAsTouched();

    if (!this.hasManagerWizardSelection()) {
      this.message.error(this.getManagerRequiredMessage());
      return null;
    }

    // Start with default headers (used to derive what gets saved)
    const columns: string[] = ['Address'];

    // Managers: enforce "email or phone" rule
    const managerCount = this.propertyManagers.length;
    for (let i = 0; i < managerCount; i++) {
      const managerGroup = this.propertyManagers.at(i);
      const positionType = managerGroup.get('positionType')?.value;

      const includeEmail = managerGroup.get('includeEmail')?.value === true;
      const includePhone = managerGroup.get('includePhone')?.value === true;

      if (managerGroup.hasError('emailOrPhoneRequired')) {
        managerGroup.get('includeEmail')?.markAsTouched();
        managerGroup.get('includePhone')?.markAsTouched();
        this.message.error(this.translate.instant('ERROR.PROVIDE_EMAIL_OR_PHONE'));
        return null;
      }

      if (positionType === 'Property Manager') {
        columns.push('Property Manager Name');
        if (includeEmail) columns.push('Property Manager Email');
        if (includePhone) columns.push('Property Manager Phone');
      } else if (positionType === 'Technical Assets Manager') {
        columns.push('Technical Assets Manager Name');
        if (includeEmail) columns.push('Technical Assets Manager Email');
        if (includePhone) columns.push('Technical Assets Manager Phone');
      } else if (positionType === 'Condominium Manager') {
        columns.push('Condominium Manager Name');
        if (includeEmail) columns.push('Condominium Manager Email');
        if (includePhone) columns.push('Condominium Manager Phone');
      } else if (positionType === 'Accountant') {
        columns.push('Accountant Name');
        if (includeEmail) columns.push('Accountant Email');
        if (includePhone) columns.push('Accountant Phone');
      }
    }

    // Caretaker columns still part of what is shown/configured in landing page
    const careTakerColumns: string[] = ['Caretaker Name', 'Caretaker Phone', 'Caretaker Email', 'Caretaker Address'];
    columns.push(...careTakerColumns);

    // Services selection required
    const serviceGroup = this.technicalServices.at(0);
    const serviceTypes: string[] = serviceGroup.get('serviceType')?.value || [];

    if (!serviceTypes.length) {
      serviceGroup.get('serviceType')?.setErrors({ required: true });
      serviceGroup.get('serviceType')?.markAsTouched();
    } else {
      for (const serviceType of serviceTypes) {
        const pairCount = this.getTemplateServicePairCount(serviceType);
        for (let i = 0; i < pairCount; i += 1) {
          columns.push(`${serviceType} Name`);
          columns.push(`${serviceType} Phone`);
        }
      }
    }

    if (this.wizardForm.invalid) {
      this.message.error(this.translate.instant('PROPERTY_LIST.PLEASE_FILL_OUT_REQUIRED_FIELDS'));
      return null;
    }

    return columns;
  }

  private getTemplateServicePairCount(serviceType: string): number {
    const maxInExistingProperties = this.allProperties.reduce((maxCount, property) => {
      const count = this.getServiceCompanies(property, serviceType).length;
      return Math.max(maxCount, count);
    }, 0);

    return Math.max(maxInExistingProperties, 1);
  }

  private buildExcelColumnsWithMobileNumbers(columns: string[]): string[] {
    const excelColumns: string[] = [];

    columns.forEach((column) => {
      excelColumns.push(column);

      if (column === 'Property Manager Phone') {
        excelColumns.push('Property Manager Mobile');
      } else if (column === 'Technical Assets Manager Phone') {
        excelColumns.push('Technical Assets Manager Mobile');
      } else if (column === 'Condominium Manager Phone') {
        excelColumns.push('Condominium Manager Mobile');
      } else if (column === 'Accountant Phone') {
        excelColumns.push('Accountant Mobile');
      } else if (column === 'Caretaker Phone') {
        excelColumns.push('Caretaker Mobile');
      } else if (column.endsWith(' Phone')) {
        excelColumns.push(column.replace(/ Phone$/, ' Mobile'));
      }
    });

    return excelColumns;
  }

  downloadTemplate(): void {
    const columns = this.buildColumnsFromWizardForSave();
    if (!columns) return;

    this.proceedWithTemplateDownload(columns, { downloadExcel: true });
  }

  private buildLandingPageAuditComparableHeaders(headers: SavedHeaders) {
    return {
      addressDetails: Array.isArray(headers?.addressDetails) ? [...headers.addressDetails] : [],
      propertyManagerHeaders: Array.isArray(headers?.propertyManagerHeaders) ? [...headers.propertyManagerHeaders] : [],
      technicalAssetsManagerHeaders: Array.isArray(headers?.technicalAssetsManagerHeaders) ? [...headers.technicalAssetsManagerHeaders] : [],
      sevManagerHeaders: Array.isArray(headers?.sevManagerHeaders) ? [...headers.sevManagerHeaders] : [],
      accountantHeaders: Array.isArray(headers?.accountantHeaders) ? [...headers.accountantHeaders] : [],
      technicalServiceHeaders: Array.isArray(headers?.technicalServiceHeaders) ? [...headers.technicalServiceHeaders] : [],
    };
  }

  private buildLandingPageAuditComparableOrder(
    categoryOrder: TechnicalServiceCategoryOrder,
    headerOrder: TechnicalServiceHeaderOrder,
    visibleServiceTypes: string[]
  ) {
    return {
      technicalServiceCategoryOrder: normalizeTechnicalServiceCategoryOrder(categoryOrder),
      technicalServiceHeaderOrder: this.technicalServicesOrderingService.normalizeHeaderOrder(
        headerOrder,
        visibleServiceTypes
      ),
    };
  }

  async proceedWithTemplateDownload(
    columns: string[],
    opts: { downloadExcel: boolean } = { downloadExcel: true }
  ): Promise<void> {

    // Step 1: Load savedHeaders if they're empty
    if (Object.values(this.savedHeaders).every(arr => Array.isArray(arr) && arr.length === 0)) {
      await this.loadSavedHeaders({ rebuildPropertyForms: false });
    }

    // Ensure savedHeaders has default values where arrays may be missing
    const newHeaders: SavedHeaders = {
      // address columns are fixed in your table
      addressDetails: ['street', 'zipcode', 'city'],

      // IMPORTANT: start empty so unchecked options are removed
      propertyManagerHeaders: [],
      technicalAssetsManagerHeaders: [],
      sevManagerHeaders: [],
      accountantHeaders: [],
      caretakerHeaders: [],
      technicalServiceHeaders: [],

      // will be recomputed from the arrays
      maxPropertyManagerCols: 0,
      maxTechnicalAssetsManagerCols: 0,
      maxSevManagerCols: 0,
      maxAccountantCols: 0,
    };
    // Step 2: Translation map for internal keys
    const internalKeyMap: { [key: string]: string } = {
      'ADDRESS': 'ADDRESS',
      'PROPERTY_MANAGER_NAME': 'PROPERTY_MANAGER_NAME',
      'PROPERTY_MANAGER_EMAIL': 'PROPERTY_MANAGER_EMAIL',
      'PROPERTY_MANAGER_PHONE': 'PROPERTY_MANAGER_PHONE',
      'PROPERTY_MANAGER_MOBILE': 'PROPERTY_MANAGER_MOBILE',
      'CARETAKER_NAME': 'CARETAKER_NAME',
      'CARETAKER_PHONE': 'CARETAKER_PHONE',
      'CARETAKER_MOBILE': 'CARETAKER_MOBILE',
      'CARETAKER_EMAIL': 'CARETAKER_EMAIL',
      'CARETAKER_ADDRESS': 'CARETAKER_ADDRESS',
      'TECHNICAL_ASSETS_MANAGER_NAME': 'TECHNICAL_ASSETS_MANAGER_NAME',
      'TECHNICAL_ASSETS_MANAGER_EMAIL': 'TECHNICAL_ASSETS_MANAGER_EMAIL',
      'TECHNICAL_ASSETS_MANAGER_PHONE': 'TECHNICAL_ASSETS_MANAGER_PHONE',
      'TECHNICAL_ASSETS_MANAGER_MOBILE': 'TECHNICAL_ASSETS_MANAGER_MOBILE',
      'CONDOMINIUM_MANAGER_NAME': 'CONDOMINIUM_MANAGER_NAME',
      'CONDOMINIUM_MANAGER_EMAIL': 'CONDOMINIUM_MANAGER_EMAIL',
      'CONDOMINIUM_MANAGER_PHONE': 'CONDOMINIUM_MANAGER_PHONE',
      'CONDOMINIUM_MANAGER_MOBILE': 'CONDOMINIUM_MANAGER_MOBILE',
      'ACCOUNTANT_NAME': 'ACCOUNTANT_NAME',
      'ACCOUNTANT_EMAIL': 'ACCOUNTANT_EMAIL',
      'ACCOUNTANT_PHONE': 'ACCOUNTANT_PHONE',
      'ACCOUNTANT_MOBILE': 'ACCOUNTANT_MOBILE',
      'GARAGE_DOOR_SERVICE': 'GARAGE_DOOR',
      'GAS_SUPPLY_EMERGENCY_SERVICE': 'GAS_SUPPLY_EMERGENCY_SERVICE',
      'METER_READING_SERVICE': 'METER_READING_SERVICE',
      'WATER_SUPPLY_SERVICE': 'WATER_SUPPLY',
      'POLICE_SERVICE': 'POLICE',
      'HEATING_SERVICE': 'HEATING',
      'SANITARY_SERVICE': 'SANITARY',
      'SMOKE_DETECTOR_SERVICE': 'SMOKE_DETECTOR',
      'ELEVATOR_SERVICE': 'ELEVATOR',
      'WINTER_SERVICE': 'WINTER_SERVICE',
      'ELECTRICAL_SERVICE': 'ELECTRICAL',
      'PIPE_BLOCKAGE_SERVICE': 'PIPE_BLOCKAGE',
      'CABLE_TELEVISION_SERVICE': 'CABLE_TELEVISION',
      'STAIRWELL_CLEANING_SERVICE': 'STAIRWELL_CLEANING',
      'LOCKSMITH_SERVICE': 'LOCKSMITH_SERVICE',
      'CHIMNEY_SWEEP_SERVICE': 'CHIMNEY_SWEEP',
      'BULK_WASTE_COLLECTION_SERVICE': 'BULK_WASTE_COLLECTION',
      'POWER_SUPPLY_EMERGENCY_SERVICE': 'POWER_SUPPLY_EMERGENCY_SERVICE',
      'GARDEN_MAINTENANCE_SERVICE': 'GARDEN_MAINTENANCE',
      'PEST_CONTROL_SERVICE': 'PEST_CONTROL',
      'ENERGY_SUPPLY_SERVICE': 'ENERGY_SUPPLY',
      'WASTE_DISPOSAL_SERVICE': 'WASTE_DISPOSAL',
      'BUILDING_INSURANCE_SERVICE': 'BUILDING_INSURANCE',
      'GAS_EMERGENCY_GAS_ODOR_SERVICE': 'GAS_EMERGENCY_GAS_ODOR',
      'RECYCLABLE_WASTE_DISPOSAL_SERVICE': 'RECYCLABLE_WASTE_DISPOSAL',
      'HEATING_OIL_SUPPLY_SERVICE': 'HEATING_OIL_SUPPLY',
      'DISTRICT_HEATING_SUPPLIER_SERVICE': 'DISTRICT_HEATING_SUPPLIER',
      'LIFTING_SYSTEMS_AND_PUMPS_SERVICE': 'LIFTING_SYSTEMS_AND_PUMPS',
      'ELECTRIC_STORAGE_HEATER_SERVICE': 'ELECTRIC_STORAGE_HEATER',
      'LOCKING_SYSTEM_MAINTENANCE_SERVICE': 'LOCKING_SYSTEM_MAINTENANCE',
      'GREEN_ROOF_MAINTENANCE_SERVICE': 'GREEN_ROOF_MAINTENANCE',
      'RENTAL_MAT_SERVICE_SERVICE': 'RENTAL_MAT_SERVICE',
      'STREET_AND_SIDEWALK_CLEANING_SERVICE': 'STREET_AND_SIDEWALK_CLEANING',
      'DOUBLE_PARKER_SERVICE': 'DOUBLE_PARKER',
      'GATE_GATE_SYSTEMS_SERVICE': 'GATE_GATE_SYSTEMS',
      'SEWER_BLOCKAGE_SERVICE': 'SEWER_BLOCKAGE',
      'SOLAR_SYSTEM_PVA_SERVICE': 'SOLAR_SYSTEM_PVA',
      'VENTILATION_SERVICE': 'VENTILATION',
      'APARTMENT_TRANSFER_STATION_DHW_HEATING_SERVICE': 'APARTMENT_TRANSFER_STATION_DHW_HEATING',
      'SMOKE_AND_HEAT_EXTRACTION_SYSTEM_SERVICE': 'SMOKE_AND_HEAT_EXTRACTION_SYSTEM',
      'FIRE_EXTINGUISHER_SERVICE': 'FIRE_EXTINGUISHER',
      'FIRE_DOORS_SERVICE': 'FIRE_DOORS',
      'FIRE_ALARM_SYSTEM_SERVICE': 'FIRE_ALARM_SYSTEM',
      'HEATING_COST_ALLOCATOR_SERVICE': 'HEATING_COST_ALLOCATOR',
      'WE_METER_SERVICE': 'WE_METER',
      'COATING_UG_SERVICE': 'COATING_UG',
      'WINDOWS_SERVICE': 'WINDOWS',
      'ROLLER_SHUTTER_RAFFSTORE_SERVICE': 'ROLLER_SHUTTER_RAFFSTORE',
      'DOORS_SERVICE': 'DOORS',
      'PROPERTY_DEVELOPER_SERVICE': 'PROPERTY_DEVELOPER',
      'GREEN_PRUNING_SERVICE': 'GREEN_PRUNING',
      'FIBER_INTERNET_SERVICE': 'FIBER_INTERNET',
      'LOCAL_HEATING_SUPPLIER_SERVICE': 'LOCAL_HEATING_SUPPLIER',
    };

    // Step 3: Process columns to merge into savedHeaders using standardized keys
    columns.forEach(column => {
      // Step 1: Normalize the column key to match the internalKeyMap format (e.g., "BULK_WASTE_COLLECTION" from "BULK_WASTE_COLLECTION Name")
      const normalizedServiceColumn = column.replace(/ (Name|Phone)$/, '').trim().replace(/ /g, "_").toUpperCase();
      const normalizedManagerColumn = column.trim().replace(/ /g, "_").toUpperCase();

      // Step 2: Retrieve the standardized key from internalKeyMap or fallback to the normalized column
      const internalManagerKey = internalKeyMap[normalizedManagerColumn] || normalizedManagerColumn;
      const internalServiceKey = internalKeyMap[normalizedServiceColumn] || normalizedServiceColumn;
      if (column.includes("Property Manager") && internalManagerKey && internalManagerKey.startsWith("PROPERTY_MANAGER") && internalManagerKey !== "PROPERTY_MANAGER") {
        if (!newHeaders.propertyManagerHeaders.includes(internalManagerKey)) {
          newHeaders.propertyManagerHeaders.push(internalManagerKey);
        }
      } else if (column.includes("Technical Assets Manager") && internalManagerKey && internalManagerKey.startsWith("TECHNICAL_ASSETS_MANAGER") && internalManagerKey !== "TECHNICAL_ASSETS_MANAGER") {
        if (internalManagerKey !== "TECHNICAL_ASSETS_MANAGER" && !newHeaders.technicalAssetsManagerHeaders.includes(internalManagerKey)) {
          newHeaders.technicalAssetsManagerHeaders.push(internalManagerKey);
        }
      } else if (column.includes("Condominium Manager") && internalManagerKey && internalManagerKey.startsWith("CONDOMINIUM_MANAGER") && internalManagerKey !== "CONDOMINIUM_MANAGER") {
        if (internalManagerKey !== "CONDOMINIUM_MANAGER" && !newHeaders.sevManagerHeaders.includes(internalManagerKey)) {
          newHeaders.sevManagerHeaders.push(internalManagerKey);
        }
      } else if (column.includes("Accountant") && internalManagerKey && internalManagerKey.startsWith("ACCOUNTANT") && internalManagerKey !== "ACCOUNTANT") {
        if (internalManagerKey !== "ACCOUNTANT" && !newHeaders.accountantHeaders.includes(internalManagerKey)) {
          newHeaders.accountantHeaders.push(internalManagerKey);
        }
      } else if (column.includes("Caretaker") && internalManagerKey && internalManagerKey.startsWith("CARETAKER")) {
        if (internalManagerKey !== "CARETAKER" && !newHeaders.caretakerHeaders.includes(internalManagerKey)) {
          newHeaders.caretakerHeaders.push(internalManagerKey);
        }
      }
    });

    const selectedServiceTypes = (
        this.technicalServices.at(0).get('serviceType')!.value || []
      ) as string[];

    newHeaders.technicalServiceHeaders = [...selectedServiceTypes];

    // Deduplicate
    newHeaders.propertyManagerHeaders = Array.from(new Set(newHeaders.propertyManagerHeaders));
    newHeaders.technicalAssetsManagerHeaders = Array.from(new Set(newHeaders.technicalAssetsManagerHeaders));
    newHeaders.sevManagerHeaders = Array.from(new Set(newHeaders.sevManagerHeaders));
    newHeaders.accountantHeaders = Array.from(new Set(newHeaders.accountantHeaders));
    newHeaders.caretakerHeaders = Array.from(new Set(newHeaders.caretakerHeaders));
    newHeaders.technicalServiceHeaders = Array.from(new Set(newHeaders.technicalServiceHeaders));

    const pendingHeaderOrder = this.technicalServicesOrderingService.normalizeHeaderOrder(
      this.technicalServiceHeaderOrder,
      newHeaders.technicalServiceHeaders
    );
    const pendingCategoryOrder = normalizeTechnicalServiceCategoryOrder(this.technicalServiceCategoryOrder);

    const savedHeaderSnapshot = JSON.stringify(
      this.buildLandingPageAuditComparableHeaders(this.savedHeaders)
    );
    const nextHeaderSnapshot = JSON.stringify(
      this.buildLandingPageAuditComparableHeaders(newHeaders)
    );
    const hasTemplateConfigChanges = savedHeaderSnapshot !== nextHeaderSnapshot;

    const currentOrderSnapshot = JSON.stringify(
      this.buildLandingPageAuditComparableOrder(
        normalizeTechnicalServiceCategoryOrder(
          this.company?.technicalServiceCategoryOrder || this.technicalServiceCategoryOrder
        ),
        this.technicalServicesOrderingService.normalizeHeaderOrder(
          this.company?.technicalServiceHeaderOrder || this.technicalServiceHeaderOrder,
          newHeaders.technicalServiceHeaders
        ),
        newHeaders.technicalServiceHeaders
      )
    );
    const nextOrderSnapshot = JSON.stringify(
      this.buildLandingPageAuditComparableOrder(
        pendingCategoryOrder,
        pendingHeaderOrder,
        newHeaders.technicalServiceHeaders
      )
    );
    const hasTechnicalServiceOrderChanges = currentOrderSnapshot !== nextOrderSnapshot;
    const currentEmergencyServiceTypes = Array.isArray(this.company?.landingPageEmergencyServiceTypes)
      ? this.company.landingPageEmergencyServiceTypes
      : [];
    const hasEmergencyServicePlacementChanges = JSON.stringify(currentEmergencyServiceTypes)
      !== JSON.stringify(this.landingPageEmergencyServiceTypes);

    // Colspan must match rendered sub-headers
    newHeaders.maxPropertyManagerCols = newHeaders.propertyManagerHeaders.length;
    newHeaders.maxTechnicalAssetsManagerCols = newHeaders.technicalAssetsManagerHeaders.length;
    newHeaders.maxSevManagerCols = newHeaders.sevManagerHeaders.length;
    newHeaders.maxAccountantCols = newHeaders.accountantHeaders.length;

    const canWriteTemplates = this.authService.hasPermission('company.templates.write');
    const shouldPersistTemplateConfig = !opts.downloadExcel && canWriteTemplates;
    if (shouldPersistTemplateConfig) {
      // Step 4: Attempt to save updated headers with error handling
      try {
        await this.templateService.saveHeaders(newHeaders, {
          suppressAudit: hasTechnicalServiceOrderChanges && !hasTemplateConfigChanges,
        }).toPromise();
        // Step 5: Reload saved headers after saving to ensure sync.
        // Do not rebuild wizard state here, because it can reset in-memory drag/drop order
        // from stale company data before the order patch call below.
        await this.loadSavedHeaders({ rebuildPropertyForms: false });
      } catch (error) {
        console.error('Error saving or loading headers:', error);
        if (!shouldSuppressGenericError(error)) {
          this.message.error(this.translate.instant('PROPERTY_LIST.FAILED_TO_SAVE_HEADERS'));
        }
        return; // Exit if saving headers fails
      }

      try {
        const companyId = this.company?._id;
        if (companyId) {
          const response = await lastValueFrom(
            this.companyService.updateTechnicalServiceHeaderOrder(
              companyId,
              pendingHeaderOrder,
              pendingCategoryOrder,
              this.landingPageEmergencyServiceTypes,
              {
                suppressAudit: !hasTechnicalServiceOrderChanges && !hasEmergencyServicePlacementChanges,
              }
            )
          );
          this.technicalServiceCategoryOrder = normalizeTechnicalServiceCategoryOrder(
            response?.technicalServiceCategoryOrder || pendingCategoryOrder
          );
          this.technicalServiceHeaderOrder = this.technicalServicesOrderingService.normalizeHeaderOrder(
            response?.technicalServiceHeaderOrder || pendingHeaderOrder,
            newHeaders.technicalServiceHeaders
          );
          if (this.company) {
            (this.company as any).technicalServiceCategoryOrder = this.technicalServiceCategoryOrder;
            (this.company as any).technicalServiceHeaderOrder = this.technicalServiceHeaderOrder;
            this.company.landingPageEmergencyServiceTypes = Array.isArray(response?.landingPageEmergencyServiceTypes)
              ? [...response.landingPageEmergencyServiceTypes]
              : [];
            this.landingPageEmergencyServiceTypes = [
              ...(this.company.landingPageEmergencyServiceTypes || [])
            ];
          }
        }
      } catch (error) {
        console.error('Error saving technical service header order:', error);
        if (!shouldSuppressGenericError(error)) {
          this.message.error(this.translate.instant('PROPERTY_LIST.TECHNICAL_SERVICES_ORDER_SAVE_FAILED'));
        }
        return;
      }
    }

    this.setupWizardFormWithSavedHeaders();
    this.syncTechnicalServiceOrderingWithHeaders(newHeaders.technicalServiceHeaders);

    // If the user only wanted to save the landing page configuration, stop here.
    if (!opts.downloadExcel) {
      this.refreshOpenPropertyModalFormsFromSavedHeaders();
      this.message.success(this.translate.instant('PROPERTY_LIST.CONFIG_SAVED_SUCCESS'));
      this.wizardVisible = false;
      this.progressService.notifyProgressUpdated();
      return;
    }

    const excelColumns = this.buildExcelColumnsWithMobileNumbers(columns);

    // Translation map with specific German terms for Property Manager and Caretaker roles
    const translationMap: { [key: string]: string } = {
      'ADDRESS': 'Adresse',
      'PROPERTY_MANAGER_NAME': 'Kaufmännische Objektbetreuung Name',
      'PROPERTY_MANAGER_EMAIL': 'Kaufmännische Objektbetreuung E-Mail',
      'PROPERTY_MANAGER_PHONE': 'Kaufmännische Objektbetreuung Telefon',
      'PROPERTY_MANAGER_MOBILE': 'Kaufmännische Objektbetreuung Mobil',
      'CARETAKER_NAME': 'Hausmeisterservice Name',
      'CARETAKER_PHONE': 'Hausmeisterservice Telefon',
      'CARETAKER_MOBILE': 'Hausmeisterservice Mobil',
      'CARETAKER_EMAIL': 'Hausmeisterservice E-Mail',
      'CARETAKER_ADDRESS': 'Hausmeisterservice Adresse',
      'TECHNICAL_ASSETS_MANAGER_NAME': 'Technische Objektbetreuung Name',
      'TECHNICAL_ASSETS_MANAGER_EMAIL': 'Technische Objektbetreuung E-Mail',
      'TECHNICAL_ASSETS_MANAGER_PHONE': 'Technische Objektbetreuung Telefon',
      'TECHNICAL_ASSETS_MANAGER_MOBILE': 'Technische Objektbetreuung Mobil',
      'CONDOMINIUM_MANAGER_NAME': 'SEV-Verwalter Name',
      'CONDOMINIUM_MANAGER_EMAIL': 'SEV-Verwalter E-Mail',
      'CONDOMINIUM_MANAGER_PHONE': 'SEV-Verwalter Telefon',
      'CONDOMINIUM_MANAGER_MOBILE': 'SEV-Verwalter Mobil',
      'ACCOUNTANT_NAME': 'Buchhaltung Name',
      'ACCOUNTANT_EMAIL': 'Buchhaltung E-Mail',
      'ACCOUNTANT_PHONE': 'Buchhaltung Telefon',
      'ACCOUNTANT_MOBILE': 'Buchhaltung Mobil',
      'GARAGE_DOOR': 'Garagentor',
      'GAS_SUPPLY_EMERGENCY_SERVICE': 'Gasversorgung/Störungsdienst',
      'METER_READING_SERVICE': 'Ablesedienst',
      'WATER_SUPPLY': 'Wasserversorgung',
      'POLICE': 'Polizei',
      'HEATING': 'Heizung',
      'SANITARY': 'Sanitär',
      'SMOKE_DETECTOR': 'Rauchmelder',
      'ELEVATOR': 'Aufzug',
      'WINTER_SERVICE': 'Winterdienst',
      'ELECTRICAL': 'Elektrik',
      'PIPE_BLOCKAGE': 'Rohrreinigung',
      'PIPE_BURST_WATER_DAMAGE': 'Rohrbruch & Wasserschaden',
      'CABLE_TELEVISION': 'Kabelfernsehen',
      'STAIRWELL_CLEANING': 'Treppenhausreinigung',
      'LOCKSMITH_SERVICE': 'Schlüsseldienst',
      'CHIMNEY_SWEEP': 'Schornsteinfeger',
      'BULK_WASTE_COLLECTION': 'Sperrmüllabholung',
      'POWER_SUPPLY_EMERGENCY_SERVICE': 'Stromversorger/Störungsdienst',
      'GARDEN_MAINTENANCE': 'Gartenpflege',
      'PEST_CONTROL': 'Schädlingsbekämpfung',
      'ENERGY_SUPPLY': 'Energieversorgung',
      'WASTE_DISPOSAL': 'Abfallentsorgung',
      'BUILDING_INSURANCE': 'Gebäudeversicherung',
      'GAS_EMERGENCY_GAS_ODOR': 'Gas-Störung, Gasgeruch',
      'RECYCLABLE_WASTE_DISPOSAL': 'Wertstoffentsorgung',
      'HEATING_OIL_SUPPLY': 'Heizölversorgung',
      'DISTRICT_HEATING_SUPPLIER': 'Fernwärmelieferant',
      'LIFTING_SYSTEMS_AND_PUMPS': 'Hebeanlagen und Pumpen',
      'ELECTRIC_STORAGE_HEATER': 'Nachtspeicherofen',
      'LOCKING_SYSTEM_MAINTENANCE': 'Schließanlage',
      'GREEN_ROOF_MAINTENANCE': 'Gründachpflege',
      'RENTAL_MAT_SERVICE': 'Mietmattenservice',
      'STREET_AND_SIDEWALK_CLEANING': 'Straßen- und Gehwegreinigung',
      'DOUBLE_PARKER': 'Doppelparker',
      'GATE_GATE_SYSTEMS': 'Tore/Toranlagen',
      'SEWER_BLOCKAGE': 'Kanal-/Rohrverstopfung',
      'SOLAR_SYSTEM_PVA': 'Solaranlage/PVA',
      'VENTILATION': 'Lüftung',
      'APARTMENT_TRANSFER_STATION_DHW_HEATING': 'Wohnungsübergabestation (WW/ Hzg)',
      'SMOKE_AND_HEAT_EXTRACTION_SYSTEM': 'Rauch- und Wärmeabzugsanlage',
      'FIRE_EXTINGUISHER': 'Feuerlöscher',
      'FIRE_DOORS': 'Brandschutztüren',
      'FIRE_ALARM_SYSTEM': 'Brandmeldeanlage',
      'HEATING_COST_ALLOCATOR': 'Heizkostenabrechner',
      'WE_METER': 'WE-Zähler',
      'COATING_UG': 'Beschichtung (TG)',
      'WINDOWS': 'Fenster',
      'ROLLER_SHUTTER_RAFFSTORE': 'Rollo/Raffstore',
      'DOORS': 'Türen',
      'ROOFER': 'Dachdecker',
      'PROPERTY_DEVELOPER': 'Bauträger',
      'GREEN_PRUNING': 'Grünschnitt',
      'FIBER_INTERNET': 'Glasfaser / Internet',
      'LOCAL_HEATING_SUPPLIER': 'Nahwärmeversorger',
    };

    // Translate columns using standardized keys for German Excel headers, handling both Name and Telefon for services
    const translatedHeaders = excelColumns.map(column => {
      // Normalize the column to match internalKeyMap format (replace spaces with underscores and uppercase)
      const normalizedColumn = column.replace(/ /g, "_").toUpperCase();
      const normalizedServiceColumn = column.replace(/ (Name|Phone|Mobile)$/, '').trim().replace(/[\s/-]+/g, "_").replace(/[()]/g, '').toUpperCase();
      // Retrieve the standardized key from internalKeyMap
      const standardizedKey = internalKeyMap[normalizedColumn]
        || internalKeyMap[normalizedServiceColumn]
        || column.split(" ")[0].toUpperCase().replace(/ /g, "_");
      // Retrieve the translated header from the map
      let translatedHeader = translationMap[standardizedKey] || column;
      // Append "Name" or "Telefon" if not already part of the translated header
      if (column.includes("Phone") && translationMap[standardizedKey] && !translatedHeader.includes("Telefon")) {
        translatedHeader = `${translatedHeader} Telefon`;
      } else if (column.includes("Mobile") && translationMap[standardizedKey] && !translatedHeader.includes("Mobil")) {
        translatedHeader = `${translatedHeader} Mobil`;
      } else if (column.includes("Name") && translationMap[standardizedKey] && !translatedHeader.includes("Name")) {
        translatedHeader = `${translatedHeader} Name`;
      }
      return translatedHeader;
    });
    this.generateExcelTemplate(translatedHeaders);
    this.progressService.notifyProgressUpdated(); // Notify progress
  }

  generateExcelTemplate(columns: string[]): void {
    // Generate the Excel sheet
    const worksheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(worksheet, [columns]);

    // Set the column widths based on content length
    const columnWidths = columns.map(col => ({ wch: col.length + 5 }));
    worksheet['!cols'] = columnWidths;
    // Generate data rows from allProperties if it exists
    if (this.allProperties && this.allProperties.length > 0) {
      const dataRows = this.allProperties.map(property => {
        const rowData = columns.map((column, columnIndex) => {
          const value = this.getPropertyValueForColumn(property, column, columnIndex, columns);
          return value;
        });
        return rowData;
      });

      // Add data rows to worksheet
      XLSX.utils.sheet_add_aoa(worksheet, dataRows, { origin: -1 });
    } else {
      // Extend the range to include additional empty rows (e.g., 50 rows total)
      const totalRows = 50; // Adjust as needed
      const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
      range.e.r = totalRows - 1;
      worksheet['!ref'] = XLSX.utils.encode_range(range);
    }

    // Apply text format to all cells in the worksheet
    const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[cellAddress] || { v: '' };
        cell.t = 's';
        cell.z = '@';
        worksheet[cellAddress] = cell;
      }
    }

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Eigenschaften Vorlage');

    // Define options to suppress Excel warnings about "Number stored as text"
    const options: XLSX.WritingOptions = {
      bookType: 'xlsx',
      ignoreEC: true,
      compression: true,
    };

    // Write and download the Excel file
    XLSX.writeFile(workbook, 'eigenschaften_vorlage.xlsx', options);

    // Show success and warning messages
    this.message.success(this.translate.instant('PROPERTY_LIST.TEMPLATE_DOWNLOAD_SUCCESS'));
    this.wizardVisible = false;
    // this.message.warning(this.translate.instant('PROPERTY_LIST.IMPORT_ADDRESS_WARNING'), { nzDuration: 10000 });
  }

  goToContacts(): void {
    this.modal.confirm({
      nzTitle: this.translate.instant('PROPERTY_LIST.CONFIRM_GO_TO_CONTACTS_TITLE'),
      nzContent: this.translate.instant('PROPERTY_LIST.CONFIRM_GO_TO_CONTACTS_CONTENT'),
      nzOkText: this.translate.instant('PROPERTY_LIST.GO_TO_CONTACTS_CONFIRM'),
      nzCancelText: this.translate.instant('PROPERTY_LIST.STAY_IN_PROPERTY_MODAL'),
      nzOnOk: () => {
        this.router.navigate(['/contacts']);
      }
    });
  }

  private getPropertyValueForColumn(property: any, column: string, columnIndex = 0, columns: string[] = []): string {
    const sameColumnBefore = columns
      .slice(0, columnIndex)
      .filter((existingColumn) => existingColumn === column)
      .length;

    switch (column) {
      case 'Address':
      case 'Adresse':
        return property.address || '';
      case 'Property Manager Name':
      case 'Immobilienverwaltung Name':
      case 'Kaufmännische Objektbetreuung Name':
        return property.propertyManagers?.[0]?.name || '';
      case 'Property Manager Email':
      case 'Immobilienverwaltung E-Mail':
      case 'Kaufmännische Objektbetreuung E-Mail':
        return property.propertyManagers?.[0]?.email || '';
      case 'Property Manager Phone':
      case 'Immobilienverwaltung Telefon':
      case 'Kaufmännische Objektbetreuung Telefon':
        return property.propertyManagers?.[0]?.phone || '';
      case 'Property Manager Mobile':
      case 'Immobilienverwaltung Mobil':
      case 'Kaufmännische Objektbetreuung Mobil':
        return property.propertyManagers?.[0]?.mobile || '';
      case 'Technical Assets Manager Name':
      case 'Technische Objektbetreuung Name':
        return property.technicalAssetsManagers?.[0]?.name || '';
      case 'Technical Assets Manager Email':
      case 'Technische Objektbetreuung E-Mail':
        return property.technicalAssetsManagers?.[0]?.email || '';
      case 'Technical Assets Manager Phone':
      case 'Technische Objektbetreuung Telefon':
        return property.technicalAssetsManagers?.[0]?.phone || '';
      case 'Technical Assets Manager Mobile':
      case 'Technische Objektbetreuung Mobil':
        return property.technicalAssetsManagers?.[0]?.mobile || '';
      case 'Condominium Manager Name':
      case 'SEV-Verwalter Name':
      case 'Sondereigentumsverwaltung Name':
        return property.sevManagers?.[0]?.name || '';
      case 'Condominium Manager Email':
      case 'SEV-Verwalter Email':
      case 'SEV-Verwalter E-Mail':
      case 'Sondereigentumsverwaltung Email':
      case 'Sondereigentumsverwaltung E-Mail':
        return property.sevManagers?.[0]?.email || '';
      case 'Condominium Manager Phone':
      case 'SEV-Verwalter Telefon':
      case 'Sondereigentumsverwaltung Telefon':
        return property.sevManagers?.[0]?.phone || '';
      case 'Condominium Manager Mobile':
      case 'SEV-Verwalter Mobil':
      case 'Sondereigentumsverwaltung Mobil':
        return property.sevManagers?.[0]?.mobile || '';
      case 'Accountant Name':
      case 'Buchhaltung Name':
        return property.accountants?.[0]?.name || '';
      case 'Accountant Email':
      case 'Buchhaltung Email':
      case 'Buchhaltung E-Mail':
        return property.accountants?.[0]?.email || '';
      case 'Accountant Phone':
      case 'Buchhaltung Telefon':
        return property.accountants?.[0]?.phone || '';
      case 'Accountant Mobile':
      case 'Buchhaltung Mobil':
        return property.accountants?.[0]?.mobile || '';
      case 'Caretaker Name':
      case 'Hausmeisterservice Name':
        return property.caretaker?.name || '';
      case 'Caretaker Phone':
      case 'Hausmeisterservice Telefon':
        return property.caretaker?.phone || '';
      case 'Caretaker Mobile':
      case 'Hausmeisterservice Mobil':
        return property.caretaker?.mobile || '';
      case 'Caretaker Email':
      case 'Hausmeisterservice E-Mail':
        return property.caretaker?.email || '';
      case 'Caretaker Address':
      case 'Hausmeisterservice Adresse':
        return property.caretaker?.address || '';
      default:
        // Handle technical services
        const value = this.getTechnicalServiceValueForColumn(property, column, sameColumnBefore);
        return value;
    }
  }

  private getTechnicalServiceValueForColumn(property: any, column: string, occurrenceIndex = 0): string {
    const serviceTypeMapping: { [key: string]: string } = {
      // German Service Type : English Equivalent
      'Heizung': 'Heating',
      'Sanitär': 'Sanitary',
      'Rauchmelder': 'Smoke Detector',
      'Aufzug': 'Elevator',
      'Winterdienst': 'Winter Service',
      'Elektrik': 'Electrical',
      'Garagentor': 'Garage Door',
      'Rohrverstopfung': 'Pipe Blockage',
      'Rohrreinigung': 'Pipe Blockage',
      'Rohrbruch & Wasserschaden': 'Pipe Burst & Water Damage',
      'Kabelfernsehen': 'Cable Television',
      'Treppenhausreinigung': 'Stairwell Cleaning',
      'Schlüsseldienst': 'Locksmith Service',
      'Schornsteinfeger': 'Chimney Sweep',
      'Ablesedienst': 'Meter Reading Service',
      'Sperrmüllabholung': 'Bulk Waste Collection',
      'Gasversorgung/Störungsdienst': 'Gas Supply/Emergency Service',
      'Stromversorger/Störungsdienst': 'Power Supply/Emergency Service',
      'Wasserversorgung': 'Water Supply',
      'Polizei': 'Police',
      'Gartenpflege': 'Garden Maintenance',
      'Schädlingsbekämpfung': 'Pest Control',
      'Energieversorgung': 'Energy Supply',
      'Abfallentsorgung': 'Waste Disposal',
      'Gebäudeversicherung': 'Building Insurance',
      'Gas-Störung, Gasgeruch': 'Gas Emergency/Gas Odor',
      'Wertstoffentsorgung': 'Recyclable Waste Disposal',
      'Heizölversorgung': 'Heating Oil Supply',
      'Fernwärmelieferant': 'District Heating Supplier',
      'Hebeanlagen und Pumpen': 'Lifting Systems and Pumps',
      'Nachtspeicherofen': 'Electric Storage Heater',
      'Schließanlage': 'Locking System Maintenance',
      'Gründachpflege': 'Green Roof Maintenance',
      'Mietmattenservice': 'Rental Mat Service',
      'Straßen- und Gehwegreinigung': 'Street and Sidewalk Cleaning',
      'Doppelparker': 'Double Parker',
      'Tore/Toranlagen': 'Gate/Gate Systems',
      'Kanal-/verstopfung': 'Sewer/Blockage',
      'Kanal-/Rohrverstopfung': 'Sewer/Blockage',
      'Solaranlage/PVA': 'Solar System/PVA',
      'Lüftung': 'Ventilation',
      'Wohnungsübergabestation (WW/ Hzg)': 'Apartment Transfer Station (DHW/Heating)',
      'Rauch- und Wärmeabzugsanlage': 'Smoke and Heat Extraction System',
      'Feuerlöscher': 'Fire Extinguisher',
      'Brandschutztüren': 'Fire Doors',
      'Brandmeldeanlage': 'Fire Alarm System',
      'Heizkostenabrechner': 'Heating Cost Allocator',
      'WE-Zähler': 'WE Meter',
      'Beschichtung (TG)': 'Coating (UG)',
      'Fenster': 'Windows',
      'Rollo/Raffstore': 'Roller Shutter/Raffstore',
      'Türen': 'Doors',
      'Dachdecker': 'Roofer',
      'Bauträger': 'Property Developer',
      'Grünschnitt': 'Green Pruning',
      'Glasfaser / Internet': 'Fiber / Internet',
      'Nahwärmeversorger': 'Local Heating Supplier',
    };

    // Column format: '{Service Type} Name', '{Service Type} Phone', '{Service Type} Mobile' or German equivalents
    const match = column.match(/^(.*) (Name|Phone|Telefon|Mobile|Mobil|Mobiltelefon|Handy|E-Mail|Email)$/i);
    if (match) {
      let serviceTypeName = match[1].trim();
      let field = '';
      const ending = match[2].toLowerCase();
      if (ending === 'name') {
        field = 'serviceName';
      } else if (ending === 'phone' || ending === 'telefon') {
        field = 'phone';
      } else if (ending === 'mobile' || ending === 'mobil' || ending === 'mobiltelefon' || ending === 'handy') {
        field = 'mobile';
      } else if (ending === 'e-mail' || ending === 'email') {
        field = 'email';
      } else {
        return '';
      }

      // Map German service type to English
      const mappedServiceTypeName = serviceTypeMapping[serviceTypeName] || serviceTypeName;

      // Normalize serviceTypeName to match the format in property.technicalServices
      const normalizedServiceTypeName = mappedServiceTypeName.replace(/[_\-\/]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();

      const servicesForType = (property.technicalServices || []).filter((s: any) => {
        // Normalize the serviceType in the property
        const normalizedServiceType = s.serviceType.replace(/[_\-\/]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
        return normalizedServiceType === normalizedServiceTypeName;
      });

      const service = servicesForType[occurrenceIndex];
      if (service) {
        return service?.[field] || '';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  // Toggle the QR Code Modal visibility
  async togglePrintQRCodeModal(property?: Property): Promise<void> {
    const shouldRefreshPreview = this.qrCodeModalVisible && !!property;
    if (property) {
      this.property = property;
      this.selectedProperty = property;
    }

    if (this.qrCodeModalVisible && !shouldRefreshPreview) {
      this.closeQrPosterPreview();
      return;
    }

    this.qrCodeModalVisible = true;
    this.isQrPosterPreviewLoading = true;
    this.clearQrPosterPreview();
    const requestId = ++this.qrPosterPreviewRenderRequest;
    const renderLanguage = this.getCurrentQrPosterRenderLanguage();
    void this.qrPosterPdfPreviewService.preload().catch(() => undefined);
    void this.qrPosterPdfPreviewService.prepareWorker().catch(() => undefined);

    try {
      const previewProperty = property || this.selectedProperty;
      if (!previewProperty?._id) {
        throw new Error('A property is required for the QR poster preview');
      }
      const previewPropertyId = String(previewProperty._id);

      const prestartedLogoBlob = lastValueFrom(
        this.propertyService.getQrPosterLogoBlob(previewPropertyId),
      );
      void prestartedLogoBlob.catch(() => undefined);

      const descriptorResponse = await this.getQrPosterRenderDescriptorForProperty(
        previewProperty,
        renderLanguage,
      );
      const pdfBlob = await this.qrPosterDocumentService.createPdfBlob(descriptorResponse, {
        renderSource: 'property-list-modal-preview',
        prestartedLogoBlob,
      });
      if (requestId !== this.qrPosterPreviewRenderRequest) {
        return;
      }
      this.qrPosterPreviewPdf = {
        propertyId: String(previewProperty._id),
        renderLanguage,
        blob: pdfBlob,
      };

      this.cdr.detectChanges();
      const canvas = this.qrPosterPreviewCanvas?.nativeElement;
      if (!canvas) {
        throw new Error('Unable to initialize the QR poster preview');
      }

      const previewRender = this.qrPosterPdfPreviewService.createFirstPageRender(pdfBlob, canvas);
      this.qrPosterPreviewRender = previewRender;
      await previewRender.completed;

      if (requestId !== this.qrPosterPreviewRenderRequest) {
        previewRender.dispose();
        return;
      }

      this.isQrPosterPreviewReady = true;
    } catch (error) {
      if (requestId !== this.qrPosterPreviewRenderRequest) {
        return;
      }
      this.clearQrPosterPreview();
      console.error('Failed to generate QR poster print proof:', error);
      this.message.error(this.translate.instant('QR_POSTER_TEMPLATE.TEST_PDF_ERROR'));
    } finally {
      if (requestId === this.qrPosterPreviewRenderRequest) {
        this.isQrPosterPreviewLoading = false;
      }
    }
  }

  closeQrPosterPreview(): void {
    this.qrPosterPreviewRenderRequest += 1;
    this.qrCodeModalVisible = false;
    this.isQrPosterPreviewLoading = false;
    this.clearQrPosterPreview();
  }

  private clearQrPosterPreview(): void {
    this.qrPosterPreviewRender?.dispose();
    this.qrPosterPreviewRender = null;
    this.qrPosterPreviewPdf = null;
    this.isQrPosterPreviewReady = false;
  }

  loadCompanyInfo(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.companyService.getCompanyDetails().subscribe({
        next: async (company: Company) => {
          this.company = company;
          this.companyName = company.name;
          this.companyEmail = company.email;
          this.companyPhone = company.phone;
          this.companyAddress = company.address;
          this.companyWebsite = company.website;
          this.companyLogoUrl = company.logoUrl;
          this.multiLandingProfilesEnabled = !!company.multiLandingProfilesEnabled;
          if (this.multiLandingProfilesEnabled) {
            try {
              const profiles = await lastValueFrom(this.companyService.listLandingProfiles(false));
              this.landingProfiles = Array.isArray(profiles) ? profiles : [];
            } catch (landingProfileError) {
              this.landingProfiles = [];
              console.error('Failed to load landing profiles', landingProfileError);
            }
          } else {
            this.landingProfiles = [];
          }
          this.availability = company.availability;
          this.emergencyNumber = company.emergencyNumber;
          this.themeColor = company.themeColor;
          this.buildCompanyHospitalityOptions();
          this.syncTechnicalServiceOrderingWithHeaders();
          try {
            const templateState = await lastValueFrom(this.companyService.getQrPosterTemplateState());
            this.savedQrPosterTemplates = Array.isArray(templateState?.templates) ? templateState.templates : [];
            this.activeQrPosterTemplateId = templateState?.activeTemplateId || null;
          } catch (templateStateError) {
            this.savedQrPosterTemplates = [];
            this.activeQrPosterTemplateId = null;
            console.error('Failed to load QR poster template state', templateStateError);
          }
          resolve();  // Resolve the promise when the data is loaded
        },
        error: (error) => {
          console.error('Failed to load company information', error);
          reject(error);  // Reject the promise on error
        }
      });
    });
  }

  async toggleEditModal(property?: Property): Promise<void> {
    const willOpen = !this.editModalVisible;
    if (!willOpen) {
      this.editModalVisible = false;
      this.resetCaretakerContactPersonSelectionCache('edit');
      return;
    }

    try {
      this.pendingInlineCreatedServiceIds.clear();
      // Ensure savedHeaders are loaded
      if (!this.savedHeaders) {
        await this.loadSavedHeaders();
      }

      this.resetCaretakerContactPersonSelectionCache('edit');
      this.createEditPropertyForm();

      // Load data if necessary
      if (
        !this.caretakerContactPersonOptionsLoaded
        || this.caretakers.length === 0
        || this.propertyManagersModel.length === 0
        || this.technicalAssetsManagers.length === 0
      ) {
        await this.loadCompanyEmployeesAndServices();
      }

      // ⬇️ ensure steps are computed and indices valid BEFORE opening
      this.recomputeStepCaches();

      this.setModalStep('edit', 0, { forceImmediateServicesRender: true });

      // Open the modal and patch its selected property only after options are available.
      this.editModalVisible = true;
      if (property) {
        this.selectedProperty = property;
        this.populateEditForm(property);
      }
    } catch (error) {
      console.error('Failed to load headers for edit modal:', error);
    }
  }

  getCustomRequestHandler(sectionOrIndex: PropertyDocumentSectionUi | number) {
    const section = typeof sectionOrIndex === 'number'
      ? this.documentSections[sectionOrIndex]
      : sectionOrIndex;

    if (!section) {
      return (option: any) => {
        option.onError?.(new Error('Invalid section'));
        return new Subscription();
      };
    }

    const existingHandler = this.documentUploadRequestHandlers.get(section.clientId);
    if (existingHandler) {
      return existingHandler;
    }

    const handler = (option: any) => {
      const sectionIndex = this.documentSections.findIndex(item => item.clientId === section.clientId);
      return this.handleFileRequest(option, sectionIndex);
    };

    this.documentUploadRequestHandlers.set(section.clientId, handler);
    return handler;
  }

  saveUploadedFiles() {
    if (!this.selectedProperty?._id) return;

    this.documentSaveAttempted = true;
    if (this.documentSections.length === 0) {
      this.documentValidationMessageKey = 'DOCUMENT_MODAL.EMPTY_SAVE_BLOCKED';
      this.createAutoValidationSection();
      return;
    }

    if (this.hasDocumentUploadsInProgress) {
      this.documentValidationMessageKey = 'DOCUMENT_MODAL.UPLOADS_IN_PROGRESS_BLOCKED';
      return;
    }

    const validation = this.applyDocumentSectionValidation(true);
    if (!validation.isValid) {
      this.documentValidationMessageKey = validation.hasSections && !validation.hasAnyValidSection
        ? 'DOCUMENT_MODAL.EMPTY_SAVE_BLOCKED'
        : 'DOCUMENT_MODAL.VALIDATION_SUMMARY';
      this.focusDocumentSection(this.getFirstInvalidDocumentSectionIndex());
      return;
    }

    this.documentValidationMessageKey = null;
    const cleanedSections = toSavablePropertyDocumentSections(this.documentSections);

    this.propertyService.saveDocuments(this.selectedProperty._id, cleanedSections)
      .subscribe({
        next: () => {
          if (!this.selectedProperty?._id) {
            this.message.success(this.translate.instant('DOCUMENT_MODAL.SAVE_SUCCESS'));
            return;
          }

          this.propertyService.getPropertyDocumentsAuth(this.selectedProperty._id).subscribe({
            next: (response) => {
              const normalized = Array.isArray(response)
                ? { scanafyUploads: response, pmsDocuments: [], missingPmsDocuments: [] }
                : response;
              const sections = normalized?.scanafyUploads || [];

              this.documentCounts[this.selectedProperty!._id!] = this.countDocumentsFromSections(sections);
              this.documentSections = sections.map((section: PropertyDocumentSection): PropertyDocumentSectionUi =>
                normalizePropertyDocumentSection({
                  ...section,
                  isPersisted: true,
                  filesTouched: false,
                  titleTouched: false,
                  files: (section.files || []).map((file) => ({
                    ...file,
                    safeUrl: file.url ? this.sanitizer.bypassSecurityTrustResourceUrl(file.url) : '',
                  })),
                })
              );
              this.syncEmergencyInstructionDocumentOptionsForProperty(this.selectedProperty!._id!, sections);
              this.documentModalHasUnsavedChanges = false;
              this.documentSaveAttempted = false;
              this.documentValidationMessageKey = null;
              this.message.success(this.translate.instant('DOCUMENT_MODAL.SAVE_SUCCESS'));
            },
            error: () => {
              this.message.error(this.translate.instant('DOCUMENT_MODAL.SAVE_FAILURE'));
            },
          });
        },
        error: (err) => {
          if (isForbiddenError(err)) {
            return;
          }
          const backendMessageKey = err?.error?.messageKey;
          if (err?.status === 400 && backendMessageKey) {
            this.documentSaveAttempted = true;
            this.documentValidationMessageKey = backendMessageKey;
            this.applyDocumentSectionValidation(true);
            return;
          }
          this.message.error(this.translate.instant('DOCUMENT_MODAL.SAVE_FAILURE'));
        }
      });
  }

  isSaveDisabled(): boolean {
    return this.hasDocumentUploadsInProgress;
  }

  async openDocumentModal(property: Property): Promise<void> {
    this.selectedProperty = property;
    this.documentModalVisible = true;
    this.showPmsTabs = false;
    this.documentModalHasUnsavedChanges = false;
    this.resetDocumentValidationState();
    await this.fetchExistingDocuments(property._id!);
  }

  fetchExistingDocuments(propertyId: string) {
    this.propertyService.getPropertyDocumentsAuth(propertyId).subscribe({
      next: (response) => {
        const normalized = Array.isArray(response)
          ? {
            scanafyUploads: response,
            pmsDocuments: [],
            missingPmsDocuments: [],
          }
          : response;

        const sections = normalized?.scanafyUploads || [];

        this.documentCounts[propertyId] = this.countDocumentsFromSections(sections);

        this.documentSections = sections.map((section: PropertyDocumentSection): PropertyDocumentSectionUi =>
          normalizePropertyDocumentSection({
            ...section,
            isPersisted: true,
            files: (section.files || []).map((file: PropertyDocumentSection['files'][number]) => ({
              ...file,
              safeUrl: file.url
                ? this.sanitizer.bypassSecurityTrustResourceUrl(file.url)
                : '',
            })),
          })
        );
        this.syncEmergencyInstructionDocumentOptionsForProperty(propertyId, sections);

        this.pmsDocuments = normalized?.pmsDocuments || [];
        this.missingPmsDocuments = normalized?.missingPmsDocuments || [];
        this.showPmsTabs = (this.pmsDocuments.length + this.missingPmsDocuments.length) > 0;
      },
      error: () => {
        this.showPmsTabs = false;
        this.message.error(this.translate.instant('DOCUMENT_MODAL.LOAD_FAILURE'));
      },
    });
  }

  closeDocumentModal() {
    this.documentModalVisible = false;
    this.closeBulkApplyModal();
    this.documentSections = [];
    this.pmsDocuments = [];
    this.missingPmsDocuments = [];
    this.showPmsTabs = false;
    this.documentTabIndex = 0;
    this.documentModalHasUnsavedChanges = false;
    this.documentUploadRequestHandlers.clear();
    this.resetDocumentValidationState();
  }

  private resetDocumentValidationState(): void {
    this.documentSaveAttempted = false;
    this.documentValidationMessageKey = null;
  }

  get hasDocumentUploadsInProgress(): boolean {
    return this.documentSections.some(section => (section.uploadingCount || 0) > 0);
  }

  createAutoValidationSection(): void {
    if (this.documentSections.length > 0) {
      this.applyDocumentSectionValidation(true);
      this.focusDocumentSection(0);
      return;
    }

    this.documentSections = [
      createEmptyPropertyDocumentSection({
        titleTouched: true,
        filesTouched: true,
      }),
    ];
    this.applyDocumentSectionValidation(true);
    this.focusDocumentSection(0);
  }

  private focusDocumentSection(index: number): void {
    setTimeout(() => {
      const input = document.getElementById(`section-title-${index}`) as HTMLInputElement | null;
      input?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      input?.focus();
    });
  }

  private getFirstInvalidDocumentSectionIndex(): number {
    const index = this.documentSections.findIndex(section =>
      !!section.validationErrors?.titleRequired || !!section.validationErrors?.filesRequired
    );
    return index >= 0 ? index : 0;
  }

  private applyDocumentSectionValidation(markTouched = false): {
    hasSections: boolean;
    hasAnyValidSection: boolean;
    isValid: boolean;
  } {
    const validation = validatePropertyDocumentSections(this.documentSections);

    this.documentSections.forEach((section, index) => {
      const validatedSection = validation.sections[index];
      section.validationErrors = validatedSection?.validationErrors || {
        titleRequired: false,
        filesRequired: false,
      };
      if (markTouched) {
        section.titleTouched = true;
        section.filesTouched = true;
      }
    });

    return {
      hasSections: validation.hasSections,
      hasAnyValidSection: validation.hasAnyValidSection,
      isValid: validation.isValid,
    };
  }

  private syncDocumentValidationState(): void {
    if (!this.documentSaveAttempted) {
      return;
    }

    const validation = this.applyDocumentSectionValidation();
    this.documentValidationMessageKey = validation.isValid
      ? null
      : validation.hasSections && !validation.hasAnyValidSection
        ? 'DOCUMENT_MODAL.EMPTY_SAVE_BLOCKED'
        : 'DOCUMENT_MODAL.VALIDATION_SUMMARY';
  }

  onSectionTitleBlur(index: number): void {
    const section = this.documentSections[index];
    if (!section) {
      return;
    }

    section.titleTouched = true;
    this.syncDocumentValidationState();
  }

  onSectionTitleChange(index: number): void {
    const section = this.documentSections[index];
    if (!section) {
      return;
    }

    if (section.validationErrors?.titleRequired) {
      section.titleTouched = true;
    }
    this.documentModalHasUnsavedChanges = true;
    this.syncDocumentValidationState();
  }

  shouldShowSectionTitleError(section: PropertyDocumentSectionUi): boolean {
    return !!section.validationErrors?.titleRequired && !!(section.titleTouched || this.documentSaveAttempted);
  }

  shouldShowSectionFilesError(section: PropertyDocumentSectionUi): boolean {
    return !!section.validationErrors?.filesRequired && !!(section.filesTouched || this.documentSaveAttempted);
  }

  trackByDocumentSection = (_index: number, section: PropertyDocumentSectionUi): string =>
    section.clientId;

  trackByDocumentFile = (_index: number, file: PropertyDocumentSectionUi['files'][number]): string =>
    file.clientId;

  getPmsDocumentTitle(document: PropertyPmsDocument): string {
    return document.title || document.fileName || 'Document';
  }

  getPmsBadgeLabel(document: PropertyPmsDocument): string {
    if (document.status === 'missing') {
      return 'Missing from PMS';
    }
    return `Synced (${this.formatProviderLabel(document.provider)})`;
  }

  formatProviderLabel(provider?: string): string {
    if (!provider) {
      return 'PMS';
    }
    return provider
      .split('-')
      .map(part => part ? part[0].toUpperCase() + part.slice(1) : '')
      .join(' ');
  }

  addSection() {
    this.documentSections.push(createEmptyPropertyDocumentSection());
    this.documentModalHasUnsavedChanges = true;
    this.syncDocumentValidationState();
  }

  removeSection(index: number) {
    const section = this.documentSections[index];
    if ((section?.uploadingCount || 0) > 0) {
      this.documentValidationMessageKey = 'DOCUMENT_MODAL.UPLOADS_IN_PROGRESS_BLOCKED';
      return;
    }

    this.modal.confirm({
      nzTitle: this.translate.instant('DOCUMENT_MODAL.CONFIRM_DELETE_SECTION_TITLE'),
      nzContent: this.translate.instant('DOCUMENT_MODAL.CONFIRM_DELETE_SECTION_MESSAGE'),
      nzOkText: this.translate.instant('DOCUMENT_MODAL.DELETE'),
      nzOkDanger: true,
      nzCancelText: this.translate.instant('DOCUMENT_MODAL.CANCEL'),
      nzOnOk: () => {
        if (!section?.isPersisted) {
          this.documentSections.splice(index, 1);
          this.documentModalHasUnsavedChanges = true;
          if (this.selectedProperty?._id) {
            this.documentCounts[this.selectedProperty._id] = this.countDocumentsFromSections(this.documentSections);
            this.syncEmergencyInstructionDocumentOptionsForProperty(this.selectedProperty._id, this.documentSections);
          }
          this.syncDocumentValidationState();
          return Promise.resolve();
        }

        return this.propertyService
          .deleteSection(this.selectedProperty!._id!, index)
          .toPromise()
          .then(async (response: any) => {
            this.documentSections.splice(index, 1);
            if (this.selectedProperty?._id) {
              this.documentCounts[this.selectedProperty._id] = this.countDocumentsFromSections(this.documentSections);
              this.syncEmergencyInstructionDocumentOptionsForProperty(this.selectedProperty._id, this.documentSections);
            }
            const instructionsProperty = this.instructionsProperty;
            if (response?.resetEmergencyInstructionActions && instructionsProperty && instructionsProperty._id === this.selectedProperty?._id) {
              await this.refreshEmergencyInstructionsForProperty(instructionsProperty);
            }
            this.syncDocumentValidationState();
            this.message.success(this.translate.instant('DOCUMENT_MODAL.REMOVE_SECTION_SUCCESS'));
          })
          .catch((err) => {
            if (isForbiddenError(err)) {
              return;
            }
            this.message.error(this.translate.instant('DOCUMENT_MODAL.REMOVE_SECTION_FAILURE'));
          });
      }
    });
  }


  handleFileRequest = (option: any, sectionIndex: number): Subscription => {
    if (sectionIndex < 0 || !this.documentSections[sectionIndex]) {
      option.onError?.(new Error('Invalid section'));
      return new Subscription();
    }

    const rawFile = option.file as File;
    const extension = this.getFileExtension(rawFile?.name);
    if (!extension || !this.allowedDocumentExtensions.has(extension)) {
      const errorText = this.translate.instant('DOCUMENT_MODAL.ERRORS.UNSUPPORTED_FILE_TYPE');
      const hintText = this.translate.instant('DOCUMENT_MODAL.ERRORS.SUPPORTED_TYPES_HINT');
      this.message.error(`${errorText} ${hintText}`.trim());
      option.onError?.(new Error('Unsupported file type'));
      return new Subscription();
    }

    this.markSectionUploadStarted(sectionIndex, rawFile?.name);

    return this.propertyService.uploadFile(this.selectedProperty._id!, rawFile, sectionIndex)
      .pipe(finalize(() => this.markSectionUploadFinished(sectionIndex, rawFile?.name)))
      .subscribe({
        next: (res) => {
          const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.url);
          const uploadedFile = normalizePropertyDocumentSectionFile({
            fileName: res.originalName,
            url: res.url,
            fileType: res.fileType,
            s3Key: res.s3Key,
            uploadedAt: new Date(),
            safeUrl
          });
          this.documentSections[sectionIndex].files.push(uploadedFile);
          this.documentSections[sectionIndex].filesTouched = true;
          this.documentModalHasUnsavedChanges = true;
          this.syncDocumentValidationState();
          if (this.selectedProperty?._id) {
            this.documentCounts[this.selectedProperty._id] = this.countDocumentsFromSections(this.documentSections);
            this.syncEmergencyInstructionDocumentOptionsForProperty(this.selectedProperty._id, this.documentSections);
          }
          option.onSuccess?.({}, rawFile);
        },
        error: () => {
          option.onError?.(new Error('Upload failed'));
        }
      });
  };

  private getFileExtension(fileName?: string): string {
    const name = (fileName || '').trim();
    const dotIndex = name.lastIndexOf('.');
    if (dotIndex < 0) {
      return '';
    }
    return name.slice(dotIndex + 1).toLowerCase();
  }

  removeFile(sectionIndex: number, file: { fileName: string; url: string; s3Key?: string }) {
    // safe check
    if (!this.selectedProperty?._id || !file.s3Key) {
      this.message.error(this.translate.instant('DOCUMENT_MODAL.MISSING_DATA'));
      return;
    }
    if ((this.documentSections[sectionIndex]?.uploadingCount || 0) > 0) {
      this.documentValidationMessageKey = 'DOCUMENT_MODAL.UPLOADS_IN_PROGRESS_BLOCKED';
      return;
    }

    this.propertyService.deleteFile(this.selectedProperty._id, file.s3Key)
      .subscribe({
        next: async (response) => {
          const section = this.documentSections[sectionIndex];
          if (section) {
            section.files = section.files.filter(f => f.s3Key !== file.s3Key && f.url !== file.url);
            section.filesTouched = true;
            this.documentModalHasUnsavedChanges = true;
            if (response?.sectionRemoved || (section.isPersisted && section.files.length === 0)) {
              this.documentSections.splice(sectionIndex, 1);
            }
          }
          this.syncDocumentValidationState();
          if (this.selectedProperty?._id) {
            this.documentCounts[this.selectedProperty._id] = this.countDocumentsFromSections(this.documentSections);
            this.syncEmergencyInstructionDocumentOptionsForProperty(this.selectedProperty._id, this.documentSections);
          }
          const instructionsProperty = this.instructionsProperty;
          if (response?.resetEmergencyInstructionActions && instructionsProperty && instructionsProperty._id === this.selectedProperty?._id) {
            await this.refreshEmergencyInstructionsForProperty(instructionsProperty);
          }
          this.message.success(this.translate.instant('DOCUMENT_MODAL.REMOVE_SUCCESS'));
        },
        error: (err) => {
          if (isForbiddenError(err)) {
            return;
          }
          this.message.error(this.translate.instant('DOCUMENT_MODAL.REMOVE_FAILURE'));
        }
      });
  }

  private markSectionUploadStarted(sectionIndex: number, fileName?: string): void {
    const section = this.documentSections[sectionIndex];
    if (!section) {
      return;
    }

    section.uploadingCount = (section.uploadingCount || 0) + 1;
    section.uploadingFileNames = fileName
      ? [...(section.uploadingFileNames || []), fileName]
      : [...(section.uploadingFileNames || [])];
    section.filesTouched = true;
  }

  private markSectionUploadFinished(sectionIndex: number, fileName?: string): void {
    const section = this.documentSections[sectionIndex];
    if (!section) {
      return;
    }

    section.uploadingCount = Math.max((section.uploadingCount || 0) - 1, 0);
    const names = [...(section.uploadingFileNames || [])];
    const nameIndex = names.findIndex(name => name === (fileName || ''));
    if (nameIndex >= 0) {
      names.splice(nameIndex, 1);
    }
    section.uploadingFileNames = names;

    if (!this.hasDocumentUploadsInProgress && this.documentValidationMessageKey === 'DOCUMENT_MODAL.UPLOADS_IN_PROGRESS_BLOCKED') {
      this.documentValidationMessageKey = null;
    }
    this.syncDocumentValidationState();
  }

  openDocumentSectionBulkApply(section: PropertyDocumentSectionUi, index: number): void {
    this.openDocumentSectionBulkAction(section, index, 'apply');
  }

  openDocumentSectionBulkEdit(section: PropertyDocumentSectionUi, index: number): void {
    this.openDocumentSectionBulkAction(section, index, 'edit');
  }

  openDocumentSectionBulkDelete(section: PropertyDocumentSectionUi, index: number): void {
    this.openDocumentSectionBulkAction(section, index, 'delete');
  }

  private openDocumentSectionBulkAction(
    section: PropertyDocumentSectionUi,
    index: number,
    action: PropertyBulkAction
  ): void {
    if (!this.selectedProperty?._id) {
      return;
    }

    if ((section.uploadingCount || 0) > 0) {
      this.documentValidationMessageKey = 'DOCUMENT_MODAL.UPLOADS_IN_PROGRESS_BLOCKED';
      return;
    }

    const validation = validatePropertyDocumentSections([section]).sections[0];
    section.validationErrors = validation?.validationErrors || {
      titleRequired: false,
      filesRequired: false,
    };
    section.titleTouched = true;
    section.filesTouched = true;
    this.documentSaveAttempted = true;

    if (action !== 'delete' && !validation?.isValid) {
      this.documentValidationMessageKey = 'DOCUMENT_MODAL.VALIDATION_SUMMARY';
      this.focusDocumentSection(index);
      return;
    }

    if (!this.canUseDocumentSectionBulkActions(section)) {
      const reason = this.getDocumentSectionBulkActionDisabledReason(section);
      const message = reason ? this.translate.instant(reason) : this.translate.instant('DOCUMENT_MODAL.BULK_ACTIONS_REQUIRE_SAVE');
      this.message.warning(message);
      return;
    }

    this.documentValidationMessageKey = null;
    this.openBulkApplyModal({
      mode: 'document_section',
      action,
      sourceProperty: this.selectedProperty,
      documentSection: section,
    });
  }

  openEmergencyInstructionBulkApply(instruction: EmergencyInstruction): void {
    this.openEmergencyInstructionBulkAction(instruction, 'apply');
  }

  openEmergencyInstructionBulkEdit(instruction: EmergencyInstruction): void {
    this.openEmergencyInstructionBulkAction(instruction, 'edit');
  }

  openEmergencyInstructionBulkDelete(instruction: EmergencyInstruction): void {
    this.openEmergencyInstructionBulkAction(instruction, 'delete');
  }

  private openEmergencyInstructionBulkAction(
    instruction: EmergencyInstruction,
    action: PropertyBulkAction
  ): void {
    if (!this.instructionsProperty?._id) {
      return;
    }

    if (action !== 'delete' && !this.isEmergencyInstructionValidForBulkApply(instruction)) {
      this.message.warning(this.translate.instant('PROPERTY_INSTRUCTIONS.VALIDATION_REQUIRED'));
      return;
    }

    this.openBulkApplyModal({
      mode: 'emergency_instruction',
      action,
      sourceProperty: this.instructionsProperty,
      emergencyInstruction: instruction,
    });
  }

  private openBulkApplyModal(context: PropertyBulkApplyContext): void {
    this.bulkApplyContext = context;
    this.currentBulkEntity = context.mode;
    this.currentBulkAction = context.action;
    this.bulkSourceExistenceStatus = this.isBulkSourceItemCopied(context) ? null : 'source';
    this.bulkApplyModalVisible = true;
    this.bulkApplySubmitting = false;
    this.bulkPromoteSourceSubmitting = false;
    this.bulkApplySearchTerm = '';
    this.bulkApplyScope = 'selected';
    this.setBulkApplySelectedPropertyIds([]);
    this.bulkDistributionStatusFilter = 'all';
    this.bulkDistributionStatusByPropertyId.clear();
    this.refreshBulkDistributionFilterOptions();
    this.refreshBulkTargetPropertyRows();
    void this.loadBulkDistributionStatus(context);
  }

  closeBulkApplyModal(): void {
    this.bulkApplyModalVisible = false;
    this.bulkApplySubmitting = false;
    this.bulkPromoteSourceSubmitting = false;
    this.bulkApplySearchTerm = '';
    this.bulkApplyScope = 'selected';
    this.setBulkApplySelectedPropertyIds([]);
    this.bulkApplyContext = null;
    this.bulkSourceExistenceStatus = null;
    this.currentBulkEntity = null;
    this.currentBulkAction = 'apply';
    this.bulkDistributionStatusLoading = false;
    this.bulkDistributionStatusFilter = 'all';
    this.bulkDistributionStatusByPropertyId.clear();
    this.bulkDistributionStatusFilterOptionsCache = [];
    this.bulkApplyAllPropertyRows = [];
    this.bulkApplyVisiblePropertyRows = [];
    this.bulkApplySelectableFilteredPropertyIdsCache = [];
    this.bulkApplyResolvedTargetPropertyIdsCache = [];
    this.bulkApplyAllFilteredSelectedCache = false;
    this.bulkApplyPartiallyFilteredSelectedCache = false;
    this.bulkApplyVisibleSelectedCountCache = 0;
  }

  onBulkApplyScopeChange(scope: PropertyBulkApplyScope): void {
    this.bulkApplyScope = scope;

    if (scope === 'selected') {
      this.setBulkApplySelectedPropertyIds([]);
      return;
    }
    this.refreshBulkApplySelectionState();
  }

  isBulkApplyPropertySelected(propertyId?: string): boolean {
    if (!propertyId) {
      return false;
    }
    return this.bulkApplySelectedPropertyIdSet.has(propertyId);
  }

  toggleBulkApplyPropertySelection(propertyId: string, checked: boolean): void {
    if (!propertyId) {
      return;
    }
    if (propertyId === this.bulkApplyCurrentPropertyId) {
      this.setBulkApplySelectedPropertyIds(this.bulkApplySelectedPropertyIds.filter((id) => id !== propertyId));
      return;
    }
    if (this.isBulkTargetPropertyIdDisabled(propertyId)) {
      this.setBulkApplySelectedPropertyIds(this.bulkApplySelectedPropertyIds.filter((id) => id !== propertyId));
      return;
    }

    if (checked) {
      if (!this.bulkApplySelectedPropertyIds.includes(propertyId)) {
        this.setBulkApplySelectedPropertyIds([...this.bulkApplySelectedPropertyIds, propertyId]);
      }
      return;
    }

    this.setBulkApplySelectedPropertyIds(this.bulkApplySelectedPropertyIds.filter((id) => id !== propertyId));
  }

  clearBulkApplySelection(): void {
    this.setBulkApplySelectedPropertyIds([]);
  }

  toggleBulkApplyFilteredSelection(checked: boolean): void {
    const filteredIds = this.bulkApplySelectableFilteredPropertyIds;

    if (!filteredIds.length) {
      return;
    }

    if (checked) {
      this.setBulkApplySelectedPropertyIds(Array.from(new Set([
        ...this.bulkApplySelectedPropertyIds,
        ...filteredIds,
      ])));
      return;
    }

    const filteredIdSet = new Set(filteredIds);
    this.setBulkApplySelectedPropertyIds(this.bulkApplySelectedPropertyIds.filter((id) => !filteredIdSet.has(id)));
  }

  trackByPropertyOption = (_index: number, property: Property): string =>
    property._id || property.address;

  trackByBulkTargetPropertyRow = (_index: number, row: BulkTargetPropertyViewModel): string =>
    row.propertyId;

  confirmBulkApply(): void {
    const context = this.bulkApplyContext;
    const sourcePropertyId = context?.sourceProperty?._id;
    if (!context || !sourcePropertyId) {
      return;
    }
    if (this.isBulkSourceStatusPendingForMutation) {
      this.message.warning(this.translate.instant('PROPERTY_BULK_APPLY.BULK_ACTION_WAITING_FOR_SOURCE_STATUS'));
      return;
    }
    if (this.isBulkFamilyMutationBlockedFromCopy) {
      const blockedReasonKey = this.bulkApplyBlockedReasonKey;
      if (blockedReasonKey) {
        this.message.warning(this.translate.instant(blockedReasonKey));
      }
      return;
    }

    const targetPropertyIds = this.bulkApplyResolvedTargetPropertyIds;
    if (!targetPropertyIds.length) {
      this.message.warning(this.translate.instant('PROPERTY_BULK_APPLY.TARGET_REQUIRED'));
      return;
    }

    const targetCount = targetPropertyIds.length;
    const title = this.translate.instant(this.bulkApplyConfirmTitleKey);
    const instructionHasStepDocuments = context.mode === 'emergency_instruction'
      && context.action !== 'delete'
      && this.emergencyInstructionHasStepDocuments(context.emergencyInstruction);
    const content = this.translate.instant(this.bulkApplyConfirmContentKey, {
      count: targetCount,
      title: this.bulkApplySourceTitle,
    });

    this.bulkApplyInstructionConfirmMessage = content;

    this.modal.confirm({
      nzTitle: title,
      nzContent: instructionHasStepDocuments
        ? this.bulkApplyInstructionConfirmContent
        : content,
      nzOkText: this.translate.instant(this.bulkApplyConfirmButtonKey),
      nzCancelText: this.translate.instant('PROPERTY_BULK_APPLY.CANCEL_ACTION'),
      nzOkDanger: context.action === 'delete',
      nzOnOk: async () => {
        this.bulkApplySubmitting = true;

        try {
          await this.executeBulkAction(context, sourcePropertyId, targetPropertyIds);
        } catch (err) {
          if (!isForbiddenError(err)) {
            const errorKey = this.bulkApplyErrorMessageKey;
            this.message.error(this.translate.instant(errorKey));
          }
          throw err;
        } finally {
          this.bulkApplySubmitting = false;
        }
      },
    });
  }

  private async executeBulkAction(
    context: PropertyBulkApplyContext,
    sourcePropertyId: string,
    targetPropertyIds: string[]
  ): Promise<void> {
    if (context.mode === 'document_section' && context.documentSection) {
      if (context.action === 'apply') {
        const response = await lastValueFrom(
          this.propertyService.bulkApplyDocumentSection(sourcePropertyId, {
            scope: this.bulkApplyScope,
            targetPropertyIds: this.bulkApplyScope === 'selected' ? targetPropertyIds : undefined,
            sourceItemId: context.documentSection._id,
            match: this.buildDocumentSectionBulkMatch(context.documentSection),
            section: toSavablePropertyDocumentSections([context.documentSection])[0],
          } as BulkApplyDocumentSectionPayload)
        );
        await this.handleDocumentSectionBulkApplySuccess(response);
        return;
      }

      const payload = {
        scope: this.bulkApplyScope,
        targetPropertyIds: this.bulkApplyScope === 'selected' ? targetPropertyIds : undefined,
        sourceItemId: context.documentSection._id,
        match: this.buildDocumentSectionBulkMatch(context.documentSection),
      };

      const response = context.action === 'edit'
        ? await lastValueFrom(
          this.propertyService.bulkEditDocumentSection(sourcePropertyId, {
            ...payload,
            payload: {
              section: toSavablePropertyDocumentSections([context.documentSection])[0],
            },
          } as BulkEditDocumentSectionPayload)
        )
        : await lastValueFrom(
          this.propertyService.bulkDeleteDocumentSection(sourcePropertyId, payload as BulkDeleteDocumentSectionPayload)
        );
      await this.handleDocumentSectionBulkMutationSuccess(context.action, response);
      return;
    }

    if (context.mode === 'emergency_instruction' && context.emergencyInstruction) {
      if (context.action === 'apply') {
        const response = await lastValueFrom(
          this.propertyService.bulkApplyEmergencyInstruction(sourcePropertyId, {
            scope: this.bulkApplyScope,
            targetPropertyIds: this.bulkApplyScope === 'selected' ? targetPropertyIds : undefined,
            sourceItemId: this.normalizeEmergencyInstructionId(context.emergencyInstruction._id || (context.emergencyInstruction as { id?: unknown }).id) || undefined,
            match: this.buildEmergencyInstructionBulkMatch(
              context.emergencyInstruction,
              this.normalizeEmergencyInstructionId(sourcePropertyId) || sourcePropertyId,
            ),
            instruction: this.toEmergencyInstructionBulkPayload(context.emergencyInstruction),
          } as BulkApplyEmergencyInstructionPayload)
        );
        await this.handleEmergencyInstructionBulkApplySuccess(response);
        return;
      }

      const payload = {
        scope: this.bulkApplyScope,
        targetPropertyIds: this.bulkApplyScope === 'selected' ? targetPropertyIds : undefined,
        sourceItemId: this.normalizeEmergencyInstructionId(context.emergencyInstruction._id || (context.emergencyInstruction as { id?: unknown }).id) || undefined,
        match: this.buildEmergencyInstructionBulkMatch(
          context.emergencyInstruction,
          this.normalizeEmergencyInstructionId(sourcePropertyId) || sourcePropertyId,
        ),
      };

      const response = context.action === 'edit'
        ? await lastValueFrom(
          this.propertyService.bulkEditEmergencyInstruction(sourcePropertyId, {
            ...payload,
            payload: {
              instruction: this.toEmergencyInstructionBulkPayload(context.emergencyInstruction),
            },
          } as BulkEditEmergencyInstructionPayload)
        )
        : await lastValueFrom(
          this.propertyService.bulkDeleteEmergencyInstruction(sourcePropertyId, payload as BulkDeleteEmergencyInstructionPayload)
        );
      await this.handleEmergencyInstructionBulkMutationSuccess(context.action, response);
    }
  }

  private async handleDocumentSectionBulkApplySuccess(response: BulkApplyDocumentSectionResponse): Promise<void> {
    const targetPropertyIds = response?.targetPropertyIds || [];
    const context = this.bulkApplyContext;

    this.refreshDocumentCountsForPropertyIds(targetPropertyIds);

    if (
      context?.mode === 'document_section'
      && context.documentSection
      && context.sourceProperty?._id
      && targetPropertyIds.includes(context.sourceProperty._id)
    ) {
      context.documentSection.isPersisted = true;
      if (this.selectedProperty?._id === context.sourceProperty._id) {
        this.documentCounts[this.selectedProperty._id] = this.countDocumentsFromSections(this.documentSections);
      }
    }

    this.closeBulkApplyModal();
    this.message.success(this.translate.instant('PROPERTY_BULK_APPLY.DOCUMENT_SUCCESS', {
      count: response.appliedPropertyCount,
      created: response.createdSections,
      merged: response.mergedSections,
      skipped: response.duplicateFilesSkipped,
    }));
  }

  private async handleEmergencyInstructionBulkApplySuccess(
    response: BulkApplyEmergencyInstructionResponse
  ): Promise<void> {
    const targetPropertyIds = response?.targetPropertyIds || [];
    const context = this.bulkApplyContext;

    if (context?.mode === 'emergency_instruction' && context.emergencyInstruction) {
      await this.refreshEmergencyInstructionsForPropertyIds(targetPropertyIds);

      if (this.emergencyInstructionHasStepDocuments(context.emergencyInstruction)) {
        this.refreshDocumentCountsForPropertyIds(targetPropertyIds);
      }
    }

    if (this.instructionsProperty?._id && targetPropertyIds.includes(this.instructionsProperty._id)) {
      await this.refreshEmergencyInstructionsForProperty(this.instructionsProperty);
    }

    this.closeBulkApplyModal();
    this.message.success(this.translate.instant('PROPERTY_BULK_APPLY.INSTRUCTION_SUCCESS', {
      count: response.appliedPropertyCount,
    }));
    if (response?.results?.length && response.summary) {
      this.showBulkMutationDetailsIfNeeded(response as BulkPropertyMutationResponse);
    }
  }

  private async handleDocumentSectionBulkMutationSuccess(
    action: Exclude<PropertyBulkAction, 'apply'>,
    response: BulkPropertyMutationResponse
  ): Promise<void> {
    const successfulTargetPropertyIds = (response?.results || [])
      .filter((result) => result.status === (action === 'delete' ? 'deleted' : 'updated') && result.propertyId)
      .map((result) => result.propertyId as string);

    this.refreshDocumentCountsForPropertyIds(successfulTargetPropertyIds);

    if (
      action === 'delete'
      && this.instructionsProperty?._id
      && successfulTargetPropertyIds.includes(this.instructionsProperty._id)
    ) {
      await this.refreshEmergencyInstructionsForProperty(this.instructionsProperty);
    }

    this.closeBulkApplyModal();
    this.message.success(this.translate.instant(
      action === 'edit'
        ? 'PROPERTY_BULK_APPLY.DOCUMENT_EDIT_SUCCESS'
        : 'PROPERTY_BULK_APPLY.DOCUMENT_DELETE_SUCCESS',
      {
        count: action === 'edit' ? response.summary.updated : response.summary.deleted,
        skipped: response.summary.skipped,
        notFound: response.summary.notFound,
        errors: response.summary.errors,
      }
    ));
    this.showBulkMutationDetailsIfNeeded(response);
  }

  private async handleEmergencyInstructionBulkMutationSuccess(
    action: Exclude<PropertyBulkAction, 'apply'>,
    response: BulkPropertyMutationResponse
  ): Promise<void> {
    const successfulTargetPropertyIds = (response?.results || [])
      .filter((result) => result.status === (action === 'delete' ? 'deleted' : 'updated') && result.propertyId)
      .map((result) => result.propertyId as string);

    await this.refreshEmergencyInstructionsForPropertyIds(successfulTargetPropertyIds);

    if (
      action === 'edit'
      && this.bulkApplyContext?.mode === 'emergency_instruction'
      && this.emergencyInstructionHasStepDocuments(this.bulkApplyContext.emergencyInstruction)
    ) {
      this.refreshDocumentCountsForPropertyIds(successfulTargetPropertyIds);
    }

    this.closeBulkApplyModal();
    this.message.success(this.translate.instant(
      action === 'edit'
        ? 'PROPERTY_BULK_APPLY.INSTRUCTION_EDIT_SUCCESS'
        : 'PROPERTY_BULK_APPLY.INSTRUCTION_DELETE_SUCCESS',
      {
        count: action === 'edit' ? response.summary.updated : response.summary.deleted,
        skipped: response.summary.skipped,
        notFound: response.summary.notFound,
        errors: response.summary.errors,
      }
    ));
    this.showBulkMutationDetailsIfNeeded(response);
  }

  private async handlePromoteBulkSourceSuccess(
    context: PropertyBulkApplyContext,
    _response: PromoteDistributionSourceResponse
  ): Promise<void> {
    this.applyPromotedBulkSourceLocally(context);
    this.bulkSourceExistenceStatus = 'source';
    await this.loadBulkDistributionStatus(context);
    this.message.success(this.translate.instant('PROPERTY_BULK_APPLY.PROMOTE_SOURCE_SUCCESS'));
  }

  private getPromoteSourceErrorMessageKey(error: unknown): string {
    const code = (error as { error?: { code?: string } } | null)?.error?.code;
    if (code === 'SOURCE_STILL_EXISTS') {
      return 'PROPERTY_BULK_APPLY.PROMOTE_SOURCE_SOURCE_EXISTS';
    }
    if (code === 'PROMOTION_CONFLICT') {
      return 'PROPERTY_BULK_APPLY.PROMOTE_SOURCE_CONFLICT';
    }
    return 'PROPERTY_BULK_APPLY.PROMOTE_SOURCE_FAILED';
  }

  private applyPromotedBulkSourceLocally(context: PropertyBulkApplyContext): void {
    const propertyId = context.sourceProperty?._id;
    if (!propertyId) {
      return;
    }

    if (context.mode === 'document_section' && context.documentSection) {
      const sourceSectionId = this.normalizeBulkMatchId(context.documentSection._id);
      this.clearDocumentSectionPromotionProvenance(context.documentSection);
      this.documentSections = this.documentSections.map((section) => {
        if (this.normalizeBulkMatchId(section?._id) !== sourceSectionId) {
          return section;
        }
        this.clearDocumentSectionPromotionProvenance(section);
        return section;
      });
      this.documentSections = [...this.documentSections];
      this.patchDocumentSectionsForProperty(propertyId, this.documentSections);
      return;
    }

    if (context.mode === 'emergency_instruction' && context.emergencyInstruction) {
      const sourceInstructionId = this.normalizeEmergencyInstructionId(
        context.emergencyInstruction._id || (context.emergencyInstruction as { id?: unknown }).id
      );
      this.clearEmergencyInstructionPromotionProvenance(context.emergencyInstruction);
      const nextInstructions = this.emergencyInstructions.map((instruction) => {
        if (this.normalizeEmergencyInstructionId(instruction._id || (instruction as { id?: unknown }).id) !== sourceInstructionId) {
          return instruction;
        }
        this.clearEmergencyInstructionPromotionProvenance(instruction);
        return instruction;
      });
      this.setEmergencyInstructionRecords(nextInstructions);
      this.patchEmergencyInstructions(propertyId, this.emergencyInstructions);
    }
  }

  private toEmergencyInstructionBulkPayload(instruction: EmergencyInstruction): EmergencyInstruction {
    return JSON.parse(JSON.stringify(instruction));
  }

  private buildDocumentSectionBulkMatch(section: PropertyDocumentSectionUi): BulkEditDocumentSectionPayload['match'] {
    return {
      sectionId: section._id,
      sourceSectionId: section.originSectionId || section._id,
      originSectionId: section.originSectionId || section._id,
      originPropertyId: section.originPropertyId || this.bulkApplyContext?.sourceProperty?._id || undefined,
      bulkGroupId: section.bulkGroupId || undefined,
      fingerprint: this.buildDocumentSectionFingerprint(section),
      fileFingerprint: this.buildDocumentSectionFileFingerprint(section),
      normalizedTitle: this.normalizeBulkText(section.title),
    };
  }

  private buildEmergencyInstructionBulkMatch(
    instruction: EmergencyInstruction,
    sourcePropertyId?: string | null,
  ): BulkEditEmergencyInstructionPayload['match'] {
    const normalizedInstructionId = this.normalizeEmergencyInstructionId(instruction._id || (instruction as { id?: unknown }).id) || undefined;
    return {
      instructionId: normalizedInstructionId,
      sourceInstructionId: instruction.originInstructionId || normalizedInstructionId,
      originInstructionId: instruction.originInstructionId || normalizedInstructionId,
      originPropertyId: instruction.originPropertyId || sourcePropertyId || undefined,
      bulkGroupId: instruction.bulkGroupId,
      fingerprint: this.buildEmergencyInstructionFingerprint(instruction),
      category: this.normalizeBulkText(instruction.category),
      scenarioKey: this.normalizeBulkText(instruction.scenarioKey),
      title: this.normalizeBulkText(instruction.title),
    };
  }

  private buildDocumentSectionFingerprint(section: PropertyDocumentSectionUi): string {
    return JSON.stringify({
      title: this.normalizeBulkText(section.title),
      fileCount: section.files.length,
      files: section.files
        .map((file) => this.buildDocumentFingerprintToken(file))
        .filter(Boolean)
        .sort(),
    });
  }

  private buildDocumentSectionFileFingerprint(section: PropertyDocumentSectionUi): string {
    return JSON.stringify(
      section.files
        .map((file) => this.buildDocumentFingerprintToken(file))
        .filter(Boolean)
        .sort()
    );
  }

  private buildEmergencyInstructionFingerprint(instruction: EmergencyInstruction): string {
    return JSON.stringify({
      category: this.normalizeBulkText(instruction.category),
      title: this.normalizeBulkText(instruction.title),
      who: this.normalizeBulkText(instruction.who),
      how: this.normalizeBulkText(instruction.how),
      showPhoneNumber: Boolean(instruction.showPhoneNumber),
      phone: this.normalizeBulkText(instruction.phone),
      version: this.normalizeBulkText(instruction.version),
      scenarioKey: this.normalizeBulkText(instruction.scenarioKey),
      sourceLanguage: this.normalizeBulkText(instruction.sourceLanguage),
      iconKey: this.normalizeBulkText(instruction.iconKey),
      urgency: this.normalizeBulkText(instruction.urgency),
      summary: this.normalizeBulkText(instruction.summary),
      steps: (instruction.steps || []).map((step) => ({
        title: this.normalizeBulkText(step.title),
        description: this.normalizeBulkText(step.description),
        iconKey: this.normalizeBulkText(step.iconKey),
        urgency: this.normalizeBulkText(step.urgency),
        action: step.action ? {
          type: this.normalizeBulkText(step.action.type),
          label: this.normalizeBulkText(step.action.label),
          phone: step.action.type === 'phone' && step.action.contactRef?.mode === 'assigned_property_contact'
            ? ''
            : this.normalizeBulkText(step.action.phone),
          email: step.action.type === 'email' && step.action.contactRef?.mode === 'assigned_property_contact'
            ? ''
            : this.normalizeBulkText(step.action.email),
          url: this.normalizeBulkText(step.action.url),
          document: step.action.document ? this.buildDocumentFingerprintToken(step.action.document) : null,
          contactRef: step.action.contactRef?.mode === 'assigned_property_contact'
            ? {
              mode: this.normalizeBulkText(step.action.contactRef.mode),
              sourceType: this.normalizeBulkText(step.action.contactRef.sourceType),
              serviceType: this.normalizeBulkText(step.action.contactRef.serviceType),
              field: this.normalizeBulkText(step.action.contactRef.field),
            }
            : {
              mode: this.normalizeBulkText(step.action.contactRef?.mode),
              field: this.normalizeBulkText(step.action.contactRef?.field),
            },
        } : null,
      })),
    });
  }

  private buildDocumentFingerprintToken(file: {
    sourceS3Key?: string;
    s3Key?: string;
    originalName?: string;
    fileName?: string;
    name?: string;
    url?: string;
    fileType?: string;
  }): string {
    const base = [
      file.sourceS3Key,
      file.s3Key,
      file.originalName,
      file.fileName,
      file.name,
      file.url,
    ]
      .map((value) => this.normalizeBulkText(value))
      .find(Boolean) || '';
    const fileType = this.normalizeBulkText(file.fileType);
    return base && fileType ? `${base}|${fileType}` : base || fileType;
  }

  private normalizeBulkText(value: unknown): string {
    return typeof value === 'string' ? value.trim().toLowerCase() : '';
  }

  private showBulkMutationDetailsIfNeeded(response: BulkPropertyMutationResponse): void {
    if (!response?.results?.length) {
      return;
    }

    const detailLines = response.results
      .filter((result) => ['not_found', 'skipped', 'error'].includes(result.status))
      .map((result) => {
        const label = result.address || result.propertyId || this.translate.instant('PROPERTY_BULK_APPLY.UNKNOWN_PROPERTY');
        const statusLabel = this.translate.instant(`PROPERTY_BULK_APPLY.RESULT_STATUS.${result.status.toUpperCase()}`);
        const reasonKey = result.reason
          ? `PROPERTY_BULK_APPLY.RESULT_REASON.${result.reason}`
          : '';
        const reasonLabel = reasonKey ? this.translate.instant(reasonKey) : '';
        const reasonSuffix = reasonLabel && reasonLabel !== reasonKey ? ` (${reasonLabel})` : '';
        return `${label}: ${statusLabel}${reasonSuffix}`;
      });

    if (!detailLines.length) {
      return;
    }

    this.modal.info({
      nzTitle: this.translate.instant('PROPERTY_BULK_APPLY.RESULT_DETAILS_TITLE'),
      nzContent: detailLines.join('<br/>'),
      nzOkText: this.translate.instant('PROPERTY_BULK_APPLY.CLOSE_ACTION'),
    });
  }

  private refreshDocumentCountsForPropertyIds(propertyIds: string[]): void {
    const targetIdSet = new Set((propertyIds || []).filter(Boolean));
    if (!targetIdSet.size) {
      return;
    }

    const targetProperties = this.allProperties.filter((property) => property._id && targetIdSet.has(property._id));
    targetProperties.forEach((property) => {
      delete this.documentCounts[property._id as string];
      this.emergencyInstructionDocumentOptionsCache.delete(property._id as string);
    });

    this.preloadDocumentCounts(targetProperties);
  }

  private emergencyInstructionHasStepDocuments(instruction?: EmergencyInstruction | null): boolean {
    const rawSteps = (instruction as { steps?: Array<{ action?: any }> } | null | undefined)?.steps;
    const steps = Array.isArray(rawSteps)
      ? rawSteps
      : [];

    return steps.some((step) =>
      step?.action?.type === 'document'
      && Boolean(step.action.document?.fileName || step.action.document?.s3Key || step.action.document?.url)
    );
  }

  private isEmergencyInstructionValidForBulkApply(instruction: EmergencyInstruction): boolean {
    const title = (instruction?.title || '').trim();
    if (!instruction?.category || !title) {
      return false;
    }
    if (Array.isArray(instruction.steps) && instruction.steps.length > 0) {
      return instruction.steps.every((step) => {
        if (!step.title?.trim()) {
          return false;
        }
        if (step.action?.type === 'phone') {
          return Boolean(step.action.phone?.trim());
        }
        if (step.action?.type === 'link') {
          return Boolean(step.action.url?.trim());
        }
        if (step.action?.type === 'document') {
          return Boolean(step.action.document?.fileName);
        }
        return true;
      });
    }

    const phone = (instruction?.phone || '').trim();
    return !instruction?.showPhoneNumber || Boolean(phone);
  }

  private refreshEmergencyInstructionsForProperty(property: Property): Promise<void> {
    if (!property?._id) {
      return Promise.resolve();
    }

    return lastValueFrom(
      this.propertyService.getEmergencyInstructions(property._id, property.companyId || this.company?._id)
    ).then((instructions) => {
      const nextInstructions = (instructions || []).map((instruction) => this.normalizeEmergencyInstructionRecord(instruction));
      if (this.instructionsProperty?._id === property._id) {
        this.emergencyInstructions = nextInstructions;
        this.scheduleEmergencyInstructionContactOptionsRefresh(this.instructionsProperty);
      }
      this.patchEmergencyInstructions(property._id as string, nextInstructions);
    });
  }

  private refreshEmergencyInstructionsForPropertyIds(propertyIds: string[]): Promise<void> {
    const uniqueIds = Array.from(new Set((propertyIds || []).filter(Boolean)));
    const targets = uniqueIds
      .map((propertyId) => this.allProperties.find((property) => property._id === propertyId))
      .filter((property): property is Property => !!property?._id);

    return Promise.all(targets.map((property) => this.refreshEmergencyInstructionsForProperty(property))).then(() => undefined);
  }

  get bulkApplyCurrentPropertyId(): string | null {
    return this.bulkApplyContext?.sourceProperty?._id || null;
  }

  get bulkApplyFilteredProperties(): Property[] {
    return this.bulkApplyVisiblePropertyRows.map((row) => row.property);
  }

  get bulkApplyResolvedTargetPropertyIds(): string[] {
    return this.bulkApplyResolvedTargetPropertyIdsCache;
  }

  get bulkApplySelectedCount(): number {
    return this.bulkApplyResolvedTargetPropertyIdsCache.length;
  }

  get bulkApplyFilteredSelectedCount(): number {
    return this.bulkApplyVisibleSelectedCountCache;
  }

  get bulkApplyAllFilteredSelected(): boolean {
    return this.bulkApplyAllFilteredSelectedCache;
  }

  get bulkApplyPartiallyFilteredSelected(): boolean {
    return this.bulkApplyPartiallyFilteredSelectedCache;
  }

  get bulkApplyConfirmDisabled(): boolean {
    return !this.bulkApplyContext
      || this.bulkApplySubmitting
      || this.bulkApplySelectedCount === 0
      || this.isBulkSourceStatusPendingForMutation
      || this.isBulkFamilyMutationBlockedFromCopy;
  }

  get isBulkSourceStatusPendingForMutation(): boolean {
    if (this.currentBulkAction !== 'edit' && this.currentBulkAction !== 'delete') {
      return false;
    }

    return this.isBulkSourceItemCopied()
      && (this.bulkDistributionStatusLoading || this.bulkSourceExistenceStatus === null);
  }

  get isBulkFamilyMutationBlockedFromCopy(): boolean {
    if (this.currentBulkAction !== 'edit' && this.currentBulkAction !== 'delete') {
      return false;
    }

    return [
      'copy_source_exists',
      'copy_source_deleted',
      'copy_source_property_deleted',
    ].includes(this.bulkSourceExistenceStatus || '');
  }

  get bulkApplyBlockedReasonKey(): string | null {
    if (this.isBulkSourceStatusPendingForMutation) {
      return 'PROPERTY_BULK_APPLY.BULK_ACTION_WAITING_FOR_SOURCE_STATUS';
    }

    if (!this.isBulkFamilyMutationBlockedFromCopy) {
      return null;
    }

    switch (this.bulkSourceExistenceStatus) {
      case 'copy_source_deleted':
        return 'PROPERTY_BULK_APPLY.BULK_ACTION_BLOCKED_SOURCE_DELETED';
      case 'copy_source_property_deleted':
        return 'PROPERTY_BULK_APPLY.BULK_ACTION_BLOCKED_SOURCE_PROPERTY_DELETED';
      case 'copy_source_exists':
      default:
        return 'PROPERTY_BULK_APPLY.BULK_ACTION_BLOCKED_FROM_COPY';
    }
  }

  get showBulkCopyBanner(): boolean {
    return !!this.bulkSourceExistenceStatus && this.bulkSourceExistenceStatus !== 'source';
  }

  get bulkCopyBannerType(): 'info' | 'warning' {
    return this.bulkSourceExistenceStatus === 'copy_source_exists' ? 'info' : 'warning';
  }

  get bulkCopyBannerKey(): string | null {
    switch (this.bulkSourceExistenceStatus) {
      case 'copy_source_exists':
        return 'PROPERTY_BULK_APPLY.COPY_SOURCE_EXISTS_BANNER';
      case 'copy_source_deleted':
        return 'PROPERTY_BULK_APPLY.COPY_SOURCE_DELETED_BANNER';
      case 'copy_source_property_deleted':
        return 'PROPERTY_BULK_APPLY.COPY_SOURCE_PROPERTY_DELETED_BANNER';
      default:
        return null;
    }
  }

  get showOpenSourcePropertyAction(): boolean {
    return this.bulkSourceExistenceStatus === 'copy_source_exists';
  }

  get showPromoteSourceAction(): boolean {
    if (!this.isBulkSourceItemCopied()) {
      return false;
    }
    return this.bulkSourceExistenceStatus === 'copy_source_deleted'
      || this.bulkSourceExistenceStatus === 'copy_source_property_deleted';
  }

  async confirmPromoteBulkSource(): Promise<void> {
    const context = this.bulkApplyContext;
    const propertyId = context?.sourceProperty?._id;
    if (!context || !propertyId) {
      return;
    }

    const itemId = context.mode === 'document_section'
      ? this.normalizeBulkMatchId(context.documentSection?._id)
      : this.normalizeEmergencyInstructionId(
        context.emergencyInstruction?._id || (context.emergencyInstruction as { id?: unknown } | undefined)?.id
      );

    if (!itemId) {
      this.message.error(this.translate.instant('PROPERTY_BULK_APPLY.PROMOTE_SOURCE_FAILED'));
      return;
    }

    this.modal.confirm({
      nzTitle: this.translate.instant('PROPERTY_BULK_APPLY.PROMOTE_SOURCE_CONFIRM_TITLE'),
      nzContent: this.translate.instant('PROPERTY_BULK_APPLY.PROMOTE_SOURCE_CONFIRM_MESSAGE'),
      nzOkText: this.translate.instant('PROPERTY_BULK_APPLY.PROMOTE_SOURCE_CONFIRM_OK'),
      nzCancelText: this.translate.instant('PROPERTY_BULK_APPLY.CANCEL_ACTION'),
      nzOnOk: async () => {
        this.bulkPromoteSourceSubmitting = true;
        try {
          const response = await lastValueFrom(this.propertyService.promoteDistributionSource(propertyId, {
            entityType: context.mode,
            itemId,
          }));
          await this.handlePromoteBulkSourceSuccess(context, response);
        } catch (error) {
          if (!isForbiddenError(error)) {
            this.message.error(this.translate.instant(this.getPromoteSourceErrorMessageKey(error)));
          }
          throw error;
        } finally {
          this.bulkPromoteSourceSubmitting = false;
        }
      },
    });
  }

  get bulkApplyPickerTitleKey(): string {
    const prefix = this.bulkApplyContext?.mode === 'document_section' ? 'DOCUMENT' : 'INSTRUCTION';
    const action = (this.bulkApplyContext?.action || 'apply').toUpperCase();
    return `PROPERTY_BULK_APPLY.${prefix}_${action}_PICKER_TITLE`;
  }

  get bulkApplyPickerDescriptionKey(): string {
    const prefix = this.bulkApplyContext?.mode === 'document_section' ? 'DOCUMENT' : 'INSTRUCTION';
    const action = (this.bulkApplyContext?.action || 'apply').toUpperCase();
    return `PROPERTY_BULK_APPLY.${prefix}_${action}_PICKER_DESCRIPTION`;
  }

  get bulkApplyConfirmTitleKey(): string {
    const prefix = this.bulkApplyContext?.mode === 'document_section' ? 'DOCUMENT' : 'INSTRUCTION';
    const action = (this.bulkApplyContext?.action || 'apply').toUpperCase();
    return `PROPERTY_BULK_APPLY.CONFIRM_${prefix}_${action}_TITLE`;
  }

  get bulkApplyConfirmContentKey(): string {
    const prefix = this.bulkApplyContext?.mode === 'document_section' ? 'DOCUMENT' : 'INSTRUCTION';
    const action = (this.bulkApplyContext?.action || 'apply').toUpperCase();
    const suffix = this.bulkApplyScope === 'all' && this.bulkApplyContext?.action === 'delete' ? '_ALL' : '';
    return `PROPERTY_BULK_APPLY.CONFIRM_${prefix}_${action}_CONTENT${suffix}`;
  }

  get bulkApplyConfirmButtonKey(): string {
    if (this.bulkApplyContext?.action === 'edit') {
      return 'PROPERTY_BULK_APPLY.CONFIRM_EDIT_ACTION';
    }
    if (this.bulkApplyContext?.action === 'delete') {
      return 'PROPERTY_BULK_APPLY.CONFIRM_DELETE_ACTION';
    }
    return 'PROPERTY_BULK_APPLY.CONFIRM_ACTION';
  }

  get bulkApplyErrorMessageKey(): string {
    const prefix = this.bulkApplyContext?.mode === 'document_section' ? 'DOCUMENT' : 'INSTRUCTION';
    const action = (this.bulkApplyContext?.action || 'apply').toUpperCase();
    return `PROPERTY_BULK_APPLY.${prefix}_${action}_ERROR`;
  }

  get bulkApplySourceTitle(): string {
    if (this.bulkApplyContext?.mode === 'document_section') {
      return this.bulkApplyContext.documentSection?.title || '';
    }
    return this.bulkApplyContext?.emergencyInstruction?.title || '';
  }

  get bulkApplySourceSummary(): string {
    if (this.bulkApplyContext?.mode === 'document_section') {
      const fileCount = this.bulkApplyContext.documentSection?.files?.length || 0;
      return this.translate.instant('PROPERTY_BULK_APPLY.DOCUMENT_SOURCE_SUMMARY', { count: fileCount });
    }
    return this.bulkApplyContext?.emergencyInstruction?.summary
      || this.bulkApplyContext?.emergencyInstruction?.who
      || '';
  }

  get bulkApplyCurrentPropertyLabel(): string {
    const sourceProperty = this.bulkApplyContext?.sourceProperty;
    return sourceProperty
      ? this.getBulkApplyPropertyLabel(sourceProperty)
      : this.translate.instant('PROPERTY_BULK_APPLY.CURRENT_PROPERTY');
  }

  get bulkApplySourcePropertyLabel(): string {
    if (this.isBulkSourceItemCopied()) {
      const originPropertyId = this.getBulkSourceOriginPropertyId();
      if (originPropertyId) {
        const label = this.getBulkApplyPropertyLabelById(originPropertyId);
        if (label) {
          return label;
        }
      }
    }
    return this.bulkApplyCurrentPropertyLabel;
  }

  get bulkApplySourceTypeKey(): string {
    return this.bulkApplyContext?.mode === 'document_section'
      ? 'PROPERTY_BULK_APPLY.TYPE_DOCUMENT_SECTION'
      : 'PROPERTY_BULK_APPLY.TYPE_EMERGENCY_INSTRUCTION';
  }

  get bulkApplySourceActionSummary(): string {
    const item = this.bulkApplySourceTitle;
    const property = this.bulkApplyCurrentPropertyLabel;
    switch (this.bulkApplyContext?.action) {
      case 'edit':
        return this.translate.instant('PROPERTY_BULK_APPLY.ACTION_SUMMARY_EDIT', { item, property });
      case 'delete':
        return this.translate.instant('PROPERTY_BULK_APPLY.ACTION_SUMMARY_DELETE', { item, property });
      case 'apply':
      default:
        return this.translate.instant('PROPERTY_BULK_APPLY.ACTION_SUMMARY_APPLY', { item, property });
    }
  }

  get bulkApplySelectionSummary(): string {
    const labels = this.bulkApplyResolvedTargetPropertyIds
      .slice(0, 3)
      .map((propertyId) => this.getBulkApplyPropertyLabelById(propertyId))
      .filter(Boolean);

    return labels.join(', ');
  }

  get distributionOverviewTitleKey(): string {
    return 'PROPERTY_DISTRIBUTION_OVERVIEW.MODAL_TITLE';
  }

  get filteredDistributionOverviewGroups(): DistributionOverviewGroup[] {
    const searchTerm = this.normalizeBulkText(this.distributionOverviewGroupSearchTerm);
    const filtered = this.distributionOverviewGroups.filter((group) => {
      if (searchTerm) {
        const title = this.normalizeBulkText(group.rootItemTitle);
        const sourceProperty = this.normalizeBulkText(group.sourcePropertyAddress);
        if (!title.includes(searchTerm) && !sourceProperty.includes(searchTerm)) {
          return false;
        }
      }

      if (this.distributionOverviewGroupFilter === 'all') {
        return true;
      }
      if (this.distributionOverviewGroupFilter === 'source_deleted') {
        return Boolean(group.sourceDeleted);
      }
      if (this.distributionOverviewGroupFilter === 'used') {
        return (group.summary?.copied || 0) > 0
          || (group.summary?.modified || 0) > 0
          || (group.summary?.legacyMatch || 0) > 0
          || (group.summary?.conflict || 0) > 0
          || (group.sourceDeleted && group.propertyCount > 0);
      }
      if (this.distributionOverviewGroupFilter === 'modified') {
        return (group.summary?.modified || 0) > 0;
      }
      if (this.distributionOverviewGroupFilter === 'conflict') {
        return (group.summary?.conflict || 0) > 0;
      }
      return true;
    });

    return [...filtered].sort((first, second) => {
      if (this.distributionOverviewGroupSort === 'most_used') {
        return (second.propertyCount || 0) - (first.propertyCount || 0)
          || String(first.rootItemTitle || '').localeCompare(String(second.rootItemTitle || ''));
      }
      if (this.distributionOverviewGroupSort === 'most_modified') {
        return (second.summary?.modified || 0) - (first.summary?.modified || 0)
          || String(first.rootItemTitle || '').localeCompare(String(second.rootItemTitle || ''));
      }
      if (this.distributionOverviewGroupSort === 'title') {
        return String(first.rootItemTitle || '').localeCompare(String(second.rootItemTitle || ''));
      }

      const firstPriority = this.getDistributionOverviewGroupPriority(first);
      const secondPriority = this.getDistributionOverviewGroupPriority(second);
      if (firstPriority !== secondPriority) {
        return firstPriority - secondPriority;
      }
      if ((second.propertyCount || 0) !== (first.propertyCount || 0)) {
        return (second.propertyCount || 0) - (first.propertyCount || 0);
      }
      return String(first.rootItemTitle || '').localeCompare(String(second.rootItemTitle || ''));
    });
  }

  get filteredDistributionOverviewDetailProperties(): DistributionOverviewGroupProperty[] {
    const properties: DistributionOverviewGroupProperty[] = this.distributionOverviewDetails?.properties || [];
    const searchTerm = this.normalizeBulkText(this.distributionOverviewDetailsSearchTerm);
    return properties.filter((property) => {
      if (searchTerm) {
        const address = this.normalizeBulkText(property.address);
        if (!address.includes(searchTerm)) {
          return false;
        }
      }

      switch (this.distributionOverviewDetailsStatusFilter) {
        case 'used':
          return ['source', 'copied', 'modified'].includes(property.status);
        case 'modified':
          return property.status === 'modified';
        case 'missing':
          return property.status === 'missing';
        case 'legacy_conflict':
          return ['legacy_match', 'conflict'].includes(property.status);
        case 'all':
        default:
          return true;
      }
    });
  }

  private getBulkApplyPropertyLabelById(propertyId: string): string {
    const property = this.allProperties.find((item) => item._id === propertyId);
    return property ? this.getBulkApplyPropertyLabel(property) : '';
  }

  onBulkApplySearchTermChange(value: string): void {
    this.bulkApplySearchTerm = value || '';
    this.refreshBulkTargetPropertyRows();
  }

  openDistributionOverview(entityType: 'document_section' | 'emergency_instruction'): void {
    this.distributionOverviewEntityType = entityType;
    this.distributionOverviewModalVisible = true;
    this.distributionOverviewGroupSearchTerm = '';
    this.distributionOverviewGroupFilter = 'all';
    this.distributionOverviewGroupSort = 'priority';
    this.selectedDistributionOverviewGroup = null;
    this.distributionOverviewDetailsVisible = false;
    this.distributionOverviewDetails = null;
    void this.loadDistributionOverview();
  }

  closeDistributionOverview(): void {
    this.distributionOverviewModalVisible = false;
    this.distributionOverviewLoading = false;
    this.distributionOverviewGroupSearchTerm = '';
    this.distributionOverviewGroupFilter = 'all';
    this.distributionOverviewGroupSort = 'priority';
    this.distributionOverviewGroups = [];
    this.selectedDistributionOverviewGroup = null;
  }

  closeDistributionOverviewDetails(): void {
    this.distributionOverviewDetailsVisible = false;
    this.distributionOverviewDetailsLoading = false;
    this.distributionOverviewDetailsSearchTerm = '';
    this.distributionOverviewDetailsStatusFilter = 'used';
    this.distributionOverviewDetails = null;
    this.selectedDistributionOverviewGroup = null;
  }

  private async loadDistributionOverview(): Promise<void> {
    this.distributionOverviewLoading = true;
    try {
      const response = await lastValueFrom(this.propertyService.getDistributionOverview(this.distributionOverviewEntityType));
      this.applyDistributionOverview(response);
    } catch (error) {
      this.distributionOverviewGroups = [];
      if (!isForbiddenError(error)) {
        this.message.error(this.translate.instant('PROPERTY_DISTRIBUTION_OVERVIEW.LOAD_ERROR'));
      }
    } finally {
      this.distributionOverviewLoading = false;
    }
  }

  private applyDistributionOverview(response: DistributionOverviewResponse | null | undefined): void {
    this.distributionOverviewGroups = [...(response?.groups || [])];
  }

  async openDistributionOverviewDetails(group: DistributionOverviewGroup): Promise<void> {
    this.selectedDistributionOverviewGroup = group;
    this.distributionOverviewDetailsVisible = true;
    this.distributionOverviewDetailsLoading = true;
    this.distributionOverviewDetailsSearchTerm = '';
    this.distributionOverviewDetailsStatusFilter = 'used';
    try {
      const response = await lastValueFrom(this.propertyService.getDistributionOverviewDetails(
        this.distributionOverviewEntityType,
        group.rootItemId,
        group.sourcePropertyId,
      ));
      this.distributionOverviewDetails = response?.group || null;
    } catch (error) {
      this.distributionOverviewDetails = null;
      if (!isForbiddenError(error)) {
        this.message.error(this.translate.instant('PROPERTY_DISTRIBUTION_OVERVIEW.LOAD_ERROR'));
      }
    } finally {
      this.distributionOverviewDetailsLoading = false;
    }
  }

  getDistributionOverviewSourcePropertyLabel(group: DistributionOverviewGroup): string {
    if (group.sourceDeleted && group.sourcePropertyAddress) {
      return this.translate.instant('PROPERTY_DISTRIBUTION_OVERVIEW.SOURCE_ITEM_DELETED_FROM_PROPERTY', {
        address: group.sourcePropertyAddress,
      });
    }
    if (group.sourceDeleted) {
      return this.translate.instant('PROPERTY_DISTRIBUTION_OVERVIEW.SOURCE_UNKNOWN_DELETED');
    }
    if (group.sourcePropertyAddress) {
      return group.sourcePropertyAddress;
    }
    return this.translate.instant('PROPERTY_DISTRIBUTION_OVERVIEW.SOURCE_UNKNOWN_DELETED');
  }

  getDistributionOverviewTypeLabelKey(): string {
    return this.distributionOverviewEntityType === 'document_section'
      ? 'PROPERTY_BULK_APPLY.TYPE_DOCUMENT_SECTION'
      : 'PROPERTY_BULK_APPLY.TYPE_EMERGENCY_INSTRUCTION';
  }

  getDistributionOverviewStatusFilterTooltipKey(value: DistributionOverviewGroupFilter): string {
    if (value === 'all') {
      return 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_ALL';
    }
    if (value === 'source_deleted') {
      return 'PROPERTY_DISTRIBUTION_OVERVIEW.SOURCE_DELETED_TOOLTIP';
    }
    if (value === 'used') {
      return 'PROPERTY_DISTRIBUTION_OVERVIEW.FILTER_USED_TOOLTIP';
    }
    if (value === 'modified') {
      return this.getBulkDistributionStatusTooltipKey('modified');
    }
    if (value === 'conflict') {
      return this.getBulkDistributionStatusTooltipKey('conflict');
    }
    return 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_ALL';
  }

  getDistributionOverviewGroupPriority(group: DistributionOverviewGroup): number {
    if ((group.summary?.conflict || 0) > 0) {
      return 0;
    }
    if ((group.summary?.modified || 0) > 0) {
      return 1;
    }
    if (group.sourceDeleted) {
      return 2;
    }
    return 3;
  }

  private async loadBulkDistributionStatus(context: PropertyBulkApplyContext): Promise<void> {
    const sourcePropertyId = context?.sourceProperty?._id;
    if (!sourcePropertyId) {
      this.bulkDistributionStatusByPropertyId.clear();
      this.bulkSourceExistenceStatus = null;
      return;
    }

    const request = context.mode === 'document_section'
      ? {
        entityType: 'document_section' as const,
        entityId: context.documentSection?._id || '',
        bulkGroupId: context.documentSection?.bulkGroupId || undefined,
      }
      : {
        entityType: 'emergency_instruction' as const,
        entityId: this.normalizeEmergencyInstructionId(
          context.emergencyInstruction?._id || (context.emergencyInstruction as { id?: unknown } | undefined)?.id
        ) || '',
        bulkGroupId: context.emergencyInstruction?.bulkGroupId || undefined,
      };

    if (!request.entityId) {
      this.bulkDistributionStatusByPropertyId.clear();
      this.bulkSourceExistenceStatus = null;
      return;
    }

    this.bulkDistributionStatusLoading = true;
    try {
      const debug = this.isBulkDistributionDebugEnabled();
      const response = await lastValueFrom(this.propertyService.getDistributionStatus(sourcePropertyId, { ...request, debug }));
      this.applyBulkDistributionStatus(response);
      this.bulkSourceExistenceStatus = this.inferBulkSourceExistenceStatus(context, response);
      if (debug) {
        this.logBulkDistributionStatusDebug(request.entityType, request.entityId, sourcePropertyId, response);
      }
    } catch (error) {
      this.bulkDistributionStatusByPropertyId.clear();
      this.bulkSourceExistenceStatus = this.isBulkSourceItemCopied(context) ? null : 'source';
      if (!isForbiddenError(error)) {
        this.message.error(this.translate.instant('PROPERTY_BULK_APPLY.DISTRIBUTION_STATUS_ERROR'));
      }
    } finally {
      this.bulkDistributionStatusLoading = false;
    }
  }

  private applyBulkDistributionStatus(response: DistributionStatusResponse | null | undefined): void {
    const nextMap = new Map<string, DistributionStatusProperty>();
    (response?.properties || []).forEach((entry) => {
      const propertyId = this.normalizeBulkApplyPropertyId(entry?.propertyId);
      if (propertyId) {
        nextMap.set(propertyId, {
          ...entry,
          propertyId,
        });
      }
    });
    this.bulkDistributionStatusByPropertyId = nextMap;
    this.refreshBulkTargetPropertyRows();
  }

  private inferBulkSourceExistenceStatus(
    context: PropertyBulkApplyContext | null,
    response: DistributionStatusResponse | null | undefined,
  ): BulkSourceExistenceStatus {
    if (!this.isBulkSourceItemCopied(context)) {
      return 'source';
    }
    if (response?.sourcePropertyDeleted) {
      return 'copy_source_property_deleted';
    }
    if (response?.sourceItemDeleted) {
      return 'copy_source_deleted';
    }
    return 'copy_source_exists';
  }

  getBulkDistributionStatus(propertyId?: string | null): DistributionStatusProperty | null {
    const normalizedPropertyId = this.normalizeBulkApplyPropertyId(propertyId);
    if (!normalizedPropertyId) {
      return null;
    }
    return this.bulkDistributionStatusByPropertyId.get(normalizedPropertyId) || null;
  }

  get bulkDistributionStatusFilterOptions(): BulkDistributionStatusFilterOption[] {
    return this.bulkDistributionStatusFilterOptionsCache;
  }

  private refreshBulkDistributionFilterOptions(): void {
    switch (this.currentBulkAction) {
      case 'edit':
        this.bulkDistributionStatusFilterOptionsCache = [
          { value: 'all', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_ALL_PROPERTIES', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_ALL_PROPERTIES' },
          { value: 'actionable', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_CAN_BE_UPDATED', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_CAN_BE_UPDATED' },
          { value: 'modified', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_MODIFIED_COPY', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_MODIFIED_COPY' },
          { value: 'up_to_date', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_ALREADY_UP_TO_DATE', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_ALREADY_UP_TO_DATE' },
          { value: 'review', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_NEEDS_REVIEW', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_NEEDS_REVIEW' },
          { value: 'unavailable', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_UNAVAILABLE', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_UNAVAILABLE' },
        ];
        break;
      case 'delete':
        this.bulkDistributionStatusFilterOptionsCache = [
          { value: 'all', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_ALL_PROPERTIES', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_ALL_PROPERTIES' },
          { value: 'actionable', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_CAN_BE_DELETED', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_CAN_BE_DELETED' },
          { value: 'modified', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_MODIFIED_COPY', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_MODIFIED_COPY' },
          { value: 'up_to_date', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_ALREADY_UP_TO_DATE', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_ALREADY_UP_TO_DATE' },
          { value: 'review', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_NEEDS_REVIEW', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_NEEDS_REVIEW' },
          { value: 'unavailable', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_UNAVAILABLE', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_UNAVAILABLE' },
        ];
        break;
      default:
        this.bulkDistributionStatusFilterOptionsCache = [
          { value: 'all', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_ALL_PROPERTIES', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_ALL_PROPERTIES' },
          { value: 'missing', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_NOT_COPIED_YET', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_NOT_COPIED_YET' },
          { value: 'copied', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_ALREADY_COPIED', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_ALREADY_COPIED' },
          { value: 'modified', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_MODIFIED_COPY', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_MODIFIED_COPY' },
          { value: 'review', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_NEEDS_REVIEW', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_NEEDS_REVIEW' },
          { value: 'unavailable', labelKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_UNAVAILABLE', tooltipKey: 'PROPERTY_BULK_APPLY.STATUS_FILTER_TOOLTIP_UNAVAILABLE' },
        ];
        break;
    }
  }

  onBulkDistributionStatusFilterChange(filter: BulkDistributionStatusFilter): void {
    this.bulkDistributionStatusFilter = filter;
    this.refreshBulkTargetPropertyRows();
  }

  private refreshBulkTargetPropertyRows(): void {
    const debug = this.isBulkDistributionDebugEnabled();
    if (debug) {
      console.time('bulk-target-rows-build');
    }

    const rows = this.bulkApplyTargetableProperties
      .map((property) => this.buildBulkTargetPropertyRow(property))
      .filter((row): row is BulkTargetPropertyViewModel => !!row)
      .sort((a, b) => a.label.localeCompare(b.label));

    this.bulkApplyAllPropertyRows = rows;

    const term = this.bulkApplySearchTerm.trim().toLowerCase();
    this.bulkApplyVisiblePropertyRows = rows.filter((row) => {
      if (this.bulkDistributionStatusFilter !== 'all' && !this.matchesBulkDistributionFilterRow(row, this.bulkDistributionStatusFilter)) {
        return false;
      }
      if (!term) {
        return true;
      }
      return row.searchText.includes(term);
    });

    this.refreshBulkApplySelectionState();

    if (debug) {
      console.timeEnd('bulk-target-rows-build');
    }
  }

  private refreshBulkApplySelectionState(): void {
    this.sanitizeBulkApplySelectionForDisabledTargets();

    this.bulkApplySelectableFilteredPropertyIdsCache = this.bulkApplyVisiblePropertyRows
      .filter((row) => row.actionable)
      .map((row) => row.propertyId);

    const actionableTargetIds = new Set(
      this.bulkApplyAllPropertyRows
        .filter((row) => row.actionable)
        .map((row) => row.propertyId)
    );

    if (this.bulkApplyScope === 'all') {
      this.bulkApplyResolvedTargetPropertyIdsCache = Array.from(actionableTargetIds);
    } else {
      this.bulkApplyResolvedTargetPropertyIdsCache = Array.from(new Set(this.bulkApplySelectedPropertyIds))
        .filter((id) => actionableTargetIds.has(id));
    }

    this.bulkApplyVisibleSelectedCountCache = this.bulkApplySelectedPropertyIds.filter((id) =>
      this.bulkApplySelectableFilteredPropertyIdsCache.includes(id)
    ).length;
    this.bulkApplyAllFilteredSelectedCache = this.bulkApplySelectableFilteredPropertyIdsCache.length > 0
      && this.bulkApplySelectableFilteredPropertyIdsCache.every((id) => this.bulkApplySelectedPropertyIdSet.has(id));
    this.bulkApplyPartiallyFilteredSelectedCache = this.bulkApplyVisibleSelectedCountCache > 0 && !this.bulkApplyAllFilteredSelectedCache;
  }

  private buildBulkTargetPropertyRow(property: Property): BulkTargetPropertyViewModel | null {
    const propertyId = this.normalizeBulkApplyPropertyId(property?._id);
    if (!propertyId) {
      return null;
    }

    const label = this.getBulkApplyPropertyLabel(property);
    const status = this.bulkDistributionStatusByPropertyId.get(propertyId)?.status || null;
    const actionBlockedReasonKey = this.getBulkActionBlockedReasonKey();
    const disabled = !!actionBlockedReasonKey || this.isBulkTargetPropertyIdDisabled(propertyId);
    const actionable = !actionBlockedReasonKey && this.isBulkTargetPropertyActionableById(propertyId);
    const disabledReasonKey = actionBlockedReasonKey || this.getBulkTargetPropertyDisabledReasonKey(property);

    return {
      property,
      propertyId,
      label,
      searchText: `${label.toLowerCase()} ${String((property as any)?.name || '').toLowerCase()}`,
      status,
      statusLabelKey: this.getBulkDistributionStatusLabelKey(status),
      statusTooltipKey: this.getBulkDistributionStatusTooltipKey(status),
      statusColor: this.getBulkDistributionStatusColor(status),
      disabled,
      disabledReasonKey,
      actionable,
    };
  }

  private getBulkActionBlockedReasonKey(): string | null {
    if (this.currentBulkAction !== 'edit' && this.currentBulkAction !== 'delete') {
      return null;
    }
    return this.bulkApplyBlockedReasonKey;
  }

  getBulkDistributionStatusLabelKey(status?: DistributionStatusValue | null): string {
    switch (status) {
      case 'source':
        return 'PROPERTY_BULK_APPLY.STATUS_SOURCE';
      case 'copied':
        return 'PROPERTY_BULK_APPLY.STATUS_COPIED';
      case 'missing':
        return 'PROPERTY_BULK_APPLY.STATUS_MISSING';
      case 'modified':
        return 'PROPERTY_BULK_APPLY.STATUS_MODIFIED';
      case 'legacy_match':
        return 'PROPERTY_BULK_APPLY.STATUS_LEGACY_MATCH';
      case 'conflict':
        return 'PROPERTY_BULK_APPLY.STATUS_CONFLICT';
      default:
        return 'PROPERTY_BULK_APPLY.STATUS_MISSING';
    }
  }

  getBulkDistributionStatusTooltipKey(status?: DistributionStatusValue | null): string {
    switch (status) {
      case 'source':
        return 'PROPERTY_BULK_APPLY.STATUS_TOOLTIP_SOURCE';
      case 'copied':
        return 'PROPERTY_BULK_APPLY.STATUS_TOOLTIP_COPIED';
      case 'missing':
        return 'PROPERTY_BULK_APPLY.STATUS_TOOLTIP_MISSING';
      case 'modified':
        return 'PROPERTY_BULK_APPLY.STATUS_TOOLTIP_MODIFIED';
      case 'legacy_match':
        return 'PROPERTY_BULK_APPLY.STATUS_TOOLTIP_LEGACY_MATCH';
      case 'conflict':
        return 'PROPERTY_BULK_APPLY.STATUS_TOOLTIP_CONFLICT';
      default:
        return 'PROPERTY_BULK_APPLY.STATUS_TOOLTIP_MISSING';
    }
  }

  getDistributionStatusTooltipKey(status?: DistributionStatusValue | null): string {
    if (status === 'conflict') {
      return 'PROPERTY_DISTRIBUTION_OVERVIEW.STATUS_TOOLTIP_CONFLICT';
    }
    return this.getBulkDistributionStatusTooltipKey(status);
  }

  private matchesBulkDistributionFilterRow(row: BulkTargetPropertyViewModel, filter: BulkDistributionStatusFilter): boolean {
    const status = row.status;
    const isUnavailable = row.disabled;

    switch (filter) {
      case 'missing':
        return status === 'missing';
      case 'copied':
        return status === 'copied';
      case 'modified':
        return status === 'modified';
      case 'actionable':
        return row.actionable;
      case 'up_to_date':
        return status === 'copied' && !isUnavailable;
      case 'review':
        return status === 'legacy_match' || status === 'conflict';
      case 'unavailable':
        return isUnavailable;
      case 'all':
      default:
        return true;
    }
  }

  getBulkDistributionStatusColor(status?: DistributionStatusValue | null): string {
    switch (status) {
      case 'source':
        return 'processing';
      case 'copied':
        return 'success';
      case 'modified':
        return 'warning';
      case 'legacy_match':
        return 'gold';
      case 'conflict':
        return 'error';
      default:
        return 'default';
    }
  }

  private get bulkApplyTargetableProperties(): Property[] {
    const sourcePropertyId = this.bulkApplyCurrentPropertyId;
    return [...(this.allProperties || [])].filter((property) =>
      !!property._id && property._id !== sourcePropertyId
    );
  }

  get bulkApplySelectableFilteredPropertyIds(): string[] {
    return this.bulkApplySelectableFilteredPropertyIdsCache;
  }

  private getBulkApplyPropertyLabel(property: Property): string {
    return (property.address || '').trim() || this.translate.instant('PROPERTY_BULK_APPLY.UNKNOWN_PROPERTY');
  }

  private normalizeBulkApplyPropertyId(value: unknown): string | null {
    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed || null;
    }
    if (value && typeof value === 'object' && '_id' in (value as Record<string, unknown>)) {
      return this.normalizeBulkApplyPropertyId((value as { _id?: unknown })._id);
    }
    if (value && typeof value === 'object' && 'id' in (value as Record<string, unknown>)) {
      return this.normalizeBulkApplyPropertyId((value as { id?: unknown }).id);
    }
    if (typeof value === 'number') {
      return String(value);
    }
    return null;
  }

  private normalizeBulkMatchId(value: unknown): string | null {
    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed || null;
    }
    if (typeof value === 'number') {
      return String(value);
    }
    if (value && typeof value === 'object' && '_id' in (value as Record<string, unknown>)) {
      return this.normalizeBulkMatchId((value as { _id?: unknown })._id);
    }
    if (value && typeof value === 'object' && 'id' in (value as Record<string, unknown>)) {
      return this.normalizeBulkMatchId((value as { id?: unknown }).id);
    }
    return null;
  }

  isDocumentSectionCopy(section: PropertyDocumentSection): boolean {
    const currentPropertyId = this.normalizeBulkApplyPropertyId(this.selectedProperty?._id);
    const currentSectionId = this.normalizeBulkMatchId(section?._id);
    const originSectionId = this.normalizeBulkMatchId(section?.originSectionId);
    const originPropertyId = this.normalizeBulkApplyPropertyId(section?.originPropertyId);
    const clonedFromSectionId = this.normalizeBulkMatchId(section?.clonedFromSectionId);

    return Boolean(
      clonedFromSectionId
      || (originSectionId && currentSectionId && originSectionId !== currentSectionId)
      || (originPropertyId && currentPropertyId && originPropertyId !== currentPropertyId)
    );
  }

  isEmergencyInstructionCopy(instruction: EmergencyInstruction): boolean {
    const currentPropertyId = this.normalizeBulkApplyPropertyId(this.instructionsProperty?._id);
    const currentInstructionId = this.normalizeEmergencyInstructionId(
      instruction?._id || (instruction as { id?: unknown } | undefined)?.id
    );
    const originInstructionId = this.normalizeEmergencyInstructionId(instruction?.originInstructionId);
    const originPropertyId = this.normalizeBulkApplyPropertyId(instruction?.originPropertyId);
    const clonedFromInstructionId = this.normalizeEmergencyInstructionId(instruction?.clonedFromInstructionId);

    return Boolean(
      clonedFromInstructionId
      || (originInstructionId && currentInstructionId && originInstructionId !== currentInstructionId)
      || (originPropertyId && currentPropertyId && originPropertyId !== currentPropertyId)
    );
  }

  getCopySourcePropertyTooltip(originPropertyId: unknown): string {
    const normalizedOriginPropertyId = this.normalizeBulkApplyPropertyId(originPropertyId);
    const sourceProperty = normalizedOriginPropertyId
      ? this.allProperties.find((property) => property._id === normalizedOriginPropertyId)
      : null;

    return sourceProperty
      ? this.getBulkApplyPropertyLabel(sourceProperty)
      : this.translate.instant('PROPERTY_DISTRIBUTION_OVERVIEW.SOURCE_PROPERTY_UNAVAILABLE');
  }

  isBulkSourceItemCopied(context: PropertyBulkApplyContext | null = this.bulkApplyContext): boolean {
    if (!context) {
      return false;
    }

    if (context.mode === 'document_section') {
      const section = context.documentSection;
      const currentPropertyId = this.normalizeBulkApplyPropertyId(context.sourceProperty?._id);
      const currentSectionId = this.normalizeBulkMatchId(section?._id);
      const originSectionId = this.normalizeBulkMatchId(section?.originSectionId);
      const originPropertyId = this.normalizeBulkApplyPropertyId(section?.originPropertyId);
      const clonedFromSectionId = this.normalizeBulkMatchId(section?.clonedFromSectionId);

      return Boolean(
        clonedFromSectionId
        || (originSectionId && currentSectionId && originSectionId !== currentSectionId)
        || (originPropertyId && currentPropertyId && originPropertyId !== currentPropertyId)
      );
    }

    const instruction = context.emergencyInstruction;
    const currentPropertyId = this.normalizeBulkApplyPropertyId(context.sourceProperty?._id);
    const currentInstructionId = this.normalizeEmergencyInstructionId(
      instruction?._id || (instruction as { id?: unknown } | undefined)?.id
    );
    const originInstructionId = this.normalizeEmergencyInstructionId(instruction?.originInstructionId);
    const originPropertyId = this.normalizeBulkApplyPropertyId(instruction?.originPropertyId);
    const clonedFromInstructionId = this.normalizeEmergencyInstructionId(instruction?.clonedFromInstructionId);

    return Boolean(
      clonedFromInstructionId
      || (originInstructionId && currentInstructionId && originInstructionId !== currentInstructionId)
      || (originPropertyId && currentPropertyId && originPropertyId !== currentPropertyId)
    );
  }

  getBulkSourceOriginPropertyId(context: PropertyBulkApplyContext | null = this.bulkApplyContext): string | null {
    if (!context) {
      return null;
    }

    const originPropertyId = context.mode === 'document_section'
      ? context.documentSection?.originPropertyId
      : context.emergencyInstruction?.originPropertyId;

    return this.normalizeBulkApplyPropertyId(originPropertyId);
  }

  async navigateToBulkSourceProperty(event?: MouseEvent): Promise<void> {
    event?.stopPropagation();
    event?.preventDefault();

    const sourcePropertyId = this.getBulkSourceOriginPropertyId();
    if (!sourcePropertyId) {
      this.message.warning(this.translate.instant('PROPERTY_BULK_APPLY.OPEN_SOURCE_PROPERTY_NOT_FOUND'));
      return;
    }

    const sourceProperty = this.allProperties.find((property) => property._id === sourcePropertyId);
    if (!sourceProperty) {
      this.message.warning(this.translate.instant('PROPERTY_BULK_APPLY.OPEN_SOURCE_PROPERTY_NOT_FOUND'));
      return;
    }

    const bulkEntity = this.currentBulkEntity;

    this.pendingBulkSourceNavigation = {
      entityType: bulkEntity || '',
      property: sourceProperty,
    };

    if (bulkEntity === 'document_section') {
      this.documentModalVisible = false;
    } else {
      this.instructionsModalVisible = false;
    }
    this.closeBulkApplyModal();
  }

  onBulkApplyModalAfterClose(): void {
    const pending = this.pendingBulkSourceNavigation;
    if (!pending) {
      return;
    }
    this.pendingBulkSourceNavigation = null;

    if (pending.entityType === 'document_section') {
      this.openDocumentModal(pending.property);
    } else {
      this.openEmergencyInstructionsModal(pending.property);
    }
  }

  isBulkTargetPropertyDisabled(property: Property, context: PropertyBulkApplyContext | null = this.bulkApplyContext): boolean {
    return this.isBulkTargetPropertyIdDisabled(this.normalizeBulkApplyPropertyId(property?._id), context);
  }

  getBulkTargetPropertyDisabledReasonKey(property: Property, context: PropertyBulkApplyContext | null = this.bulkApplyContext): string | null {
    if (!this.isBulkTargetPropertyDisabled(property, context)) {
      return null;
    }

    const propertyId = this.normalizeBulkApplyPropertyId(property?._id);
    if (this.isBulkTargetPropertyDisabledByActionStatus(propertyId, context)) {
      return 'PROPERTY_BULK_APPLY.NO_COPIED_ITEM_FOR_ACTION';
    }

    return context?.action === 'apply'
      ? 'PROPERTY_BULK_APPLY.SOURCE_PROPERTY_ALREADY_HAS_ROOT_ITEM'
      : 'PROPERTY_BULK_APPLY.SOURCE_PROPERTY_DISABLED_FROM_COPY';
  }

  private isBulkTargetPropertyIdDisabled(
    propertyId: string | null | undefined,
    context: PropertyBulkApplyContext | null = this.bulkApplyContext,
  ): boolean {
    const normalizedPropertyId = this.normalizeBulkApplyPropertyId(propertyId);
    if (this.getBulkActionBlockedReasonKey()) {
      return true;
    }
    const originPropertyId = this.getBulkSourceOriginPropertyId(context);
    const currentPropertyId = this.bulkApplyCurrentPropertyId;

    if (!normalizedPropertyId || !originPropertyId || !this.isBulkSourceItemCopied(context)) {
      return this.isBulkTargetPropertyDisabledByActionStatus(normalizedPropertyId, context);
    }

    if (normalizedPropertyId === originPropertyId && normalizedPropertyId !== currentPropertyId) {
      return true;
    }

    return this.isBulkTargetPropertyDisabledByActionStatus(normalizedPropertyId, context);
  }

  private isBulkTargetPropertyDisabledByActionStatus(
    propertyId: string | null | undefined,
    context: PropertyBulkApplyContext | null = this.bulkApplyContext,
  ): boolean {
    const normalizedPropertyId = this.normalizeBulkApplyPropertyId(propertyId);
    if (!normalizedPropertyId) {
      return false;
    }
    if (context?.action !== 'edit' && context?.action !== 'delete') {
      return false;
    }

    return this.getBulkDistributionStatus(normalizedPropertyId)?.status === 'missing';
  }

  isBulkTargetPropertyActionable(property: Property, action: PropertyBulkAction = this.currentBulkAction): boolean {
    return this.isBulkTargetPropertyActionableById(this.normalizeBulkApplyPropertyId(property?._id), action);
  }

  private isBulkTargetPropertyActionableById(
    propertyId: string | null | undefined,
    action: PropertyBulkAction = this.currentBulkAction,
  ): boolean {
    const normalizedPropertyId = this.normalizeBulkApplyPropertyId(propertyId);
    if (!normalizedPropertyId || this.isBulkTargetPropertyIdDisabled(normalizedPropertyId)) {
      return false;
    }

    if (action === 'edit' || action === 'delete') {
      const status = this.getBulkDistributionStatus(normalizedPropertyId)?.status || null;
      return status === 'copied' || status === 'modified';
    }

    return true;
  }

  private sanitizeBulkApplySelectionForDisabledTargets(): void {
    const nextIds = this.bulkApplySelectedPropertyIds.filter((id) => !this.isBulkTargetPropertyIdDisabled(id));
    const changed = nextIds.length !== this.bulkApplySelectedPropertyIds.length
      || nextIds.some((id, index) => id !== this.bulkApplySelectedPropertyIds[index]);
    if (changed) {
      this.bulkApplySelectedPropertyIds = nextIds;
      this.bulkApplySelectedPropertyIdSet = new Set(nextIds);
    }
  }

  private setBulkApplySelectedPropertyIds(ids: string[]): void {
    const nextIds = Array.from(new Set((ids || []).filter(Boolean)));
    this.bulkApplySelectedPropertyIds = nextIds;
    this.bulkApplySelectedPropertyIdSet = new Set(nextIds);
    this.refreshBulkApplySelectionState();
  }

  private isBulkDistributionDebugEnabled(): boolean {
    try {
      return typeof window !== 'undefined' && window.localStorage?.getItem('debugBulkDistributionStatus') === '1';
    } catch (error) {
      return false;
    }
  }

  private logBulkDistributionStatusDebug(
    entityType: 'document_section' | 'emergency_instruction',
    entityId: string,
    sourcePropertyId: string,
    response: DistributionStatusResponse | null | undefined
  ): void {
    if (!response) {
      return;
    }

    const propertyRows = this.bulkApplyTargetableProperties.map((property) => {
      const propertyId = this.normalizeBulkApplyPropertyId(property._id);
      const backendStatus = propertyId ? this.bulkDistributionStatusByPropertyId.get(propertyId) : null;
      return {
        sourcePropertyId,
        entityType,
        entityId,
        propertyId,
        address: property.address,
        backendStatus: backendStatus?.status || null,
        matchedBy: backendStatus?.matchedBy || null,
        matchedItemId: backendStatus?.matchedItemId || null,
        frontendPropertyId: propertyId,
        finalRenderedStatus: backendStatus?.status || null,
      };
    });

    console.groupCollapsed('[BulkDistributionStatus] debug');
    console.log('response.debug', response.debug);
    console.table(propertyRows);
    propertyRows
      .filter((row) => !row.backendStatus && row.propertyId)
      .forEach((row) => console.warn('[BulkDistributionStatus] missing status for target property id', row.propertyId));
    console.groupEnd();
  }

  openImagePreview(imageUrl: string): void {
    const images: NzImage[] = [
      {
        src: imageUrl,
        alt: 'Preview',
      }
    ];
    this.nzImageService.preview(images);
  }

  private normalizeServiceTypeKey(value: string | null | undefined): string {
    return (value || '')
      .toString()
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  private buildPropertyServiceAssignmentsForPrefill(property: Property): PropertyTechnicalServiceAssignment[] {
    const normalizedAssignments = Array.isArray(property.technicalServiceAssignments)
      ? property.technicalServiceAssignments
          .map((assignment) => ({
            serviceId: this.getEmergencyInstructionContactSourceId({
              sourceId: assignment?.serviceId,
              _id: assignment?.serviceId,
              id: assignment?.serviceId,
            }) || '',
            serviceType: assignment?.serviceType || ''
          }))
          .filter((assignment) => !!assignment.serviceId && !!this.normalizeServiceTypeKey(assignment.serviceType))
      : [];

    const assignedServiceIds = new Set(normalizedAssignments.map((assignment) => assignment.serviceId));
    const fallbackAssignments = (property.technicalServices || [])
      .map((service) => ({
        serviceId: String(service?._id || '').trim(),
        serviceType: service?.serviceType || ''
      }))
      .filter((assignment) => (
        !!assignment.serviceId
        && !!this.normalizeServiceTypeKey(assignment.serviceType)
        && !assignedServiceIds.has(assignment.serviceId)
      ));

    return [...normalizedAssignments, ...fallbackAssignments];
  }

  private buildEmergencyInstructionAssignmentPreviewProperty(formData: any): Property | null {
    if (!this.selectedProperty) {
      return null;
    }

    const technicalServiceAssignments = this.buildTechnicalServiceAssignmentsFromFormValue(formData);
    const selectedTechnicalServiceIds = Array.from(new Set(
      technicalServiceAssignments.map((assignment) => assignment.serviceId)
    ));
    const technicalServices: Service[] = selectedTechnicalServiceIds
      .map((serviceId: string) => this.technicalServicesModel.find((service) => service._id === serviceId))
      .filter((service): service is Service => service !== undefined);

    return {
      ...this.selectedProperty,
      caretaker: this.caretakers.find((caretaker) => caretaker._id === formData.caretaker) || null,
      caretakerContactPersonIds: this.reconcileCaretakerContactPersonSelectionIds(
        formData.caretaker,
        formData.caretakerContactPersonIds
      ),
      propertyManagers: formData.propertyManagers
        ? [this.propertyManagersModel.find((manager) => manager._id === formData.propertyManagers)]
          .filter((manager): manager is Employee => Boolean(manager))
        : [],
      technicalAssetsManagers: formData.technicalAssetsManagers
        ? [this.technicalAssetsManagers.find((manager) => manager._id === formData.technicalAssetsManagers)]
          .filter((manager): manager is Employee => Boolean(manager))
        : [],
      sevManagers: formData.sevManagers
        ? [this.sevManagersModel.find((manager) => manager._id === formData.sevManagers)]
          .filter((manager): manager is Employee => Boolean(manager))
        : [],
      accountants: formData.accountants
        ? [this.accountantsModel.find((accountant) => accountant._id === formData.accountants)]
          .filter((accountant): accountant is Employee => Boolean(accountant))
        : [],
      technicalServices,
      technicalServiceAssignments,
    };
  }

  private buildEmergencyInstructionAssignmentResetPlan(
    oldProperty: Property | null | undefined,
    formData: any,
  ): {
      resets: Array<{
        instructionId?: string;
        instructionTitle: string;
        stepId: string;
        stepTitle: string;
        sourceType: EmergencyInstructionActionContactSourceType;
        field: 'phone' | 'email';
        serviceType?: string | null;
      }>;
    } {
    if (!oldProperty?.emergencyInstructions?.length) {
      return { resets: [] };
    }

    const previewProperty = this.buildEmergencyInstructionAssignmentPreviewProperty(formData);
    if (!previewProperty) {
      return { resets: [] };
    }

    const phoneOptions = this.buildEmergencyInstructionContactOptions(previewProperty, 'phone')
      .flatMap((group) => group.options);
    const emailOptions = this.buildEmergencyInstructionContactOptions(previewProperty, 'email')
      .flatMap((group) => group.options);

    const resets: Array<{
      instructionId?: string;
      instructionTitle: string;
      stepId: string;
      stepTitle: string;
      sourceType: EmergencyInstructionActionContactSourceType;
      field: 'phone' | 'email';
      serviceType?: string | null;
    }> = [];

    const findReplacement = (
      options: EmergencyInstructionContactOption[],
      actionType: 'phone' | 'email',
      contactRef: EmergencyInstructionActionContactRef,
    ): EmergencyInstructionContactOption | null => {
      const normalizedSourceType = this.normalizeEmergencyInstructionContactKeyPart(contactRef.sourceType || '');
      const normalizedSourceId = this.normalizeEmergencyInstructionContactKeyPart(contactRef.sourceId || '');
      const normalizedServiceType = this.normalizeEmergencyInstructionContactKeyPart(contactRef.serviceType || '');

      if (normalizedSourceType === 'technical_service') {
        const exactTechnicalServiceMatch = options.find((option) =>
          option.field === actionType
          && this.normalizeEmergencyInstructionContactKeyPart(option.sourceType) === normalizedSourceType
          && this.normalizeEmergencyInstructionContactKeyPart(option.sourceId || '') === normalizedSourceId
          && this.normalizeEmergencyInstructionContactKeyPart(option.serviceType || '') === normalizedServiceType
        );
        if (exactTechnicalServiceMatch) {
          return exactTechnicalServiceMatch;
        }

        if (!normalizedServiceType) {
          return null;
        }

        return options.find((option) =>
          option.field === actionType
          && this.normalizeEmergencyInstructionContactKeyPart(option.sourceType) === normalizedSourceType
          && this.normalizeEmergencyInstructionContactKeyPart(option.serviceType || '') === normalizedServiceType
        ) || null;
      }

      const exactEmployeeMatch = normalizedSourceId
        ? options.find((option) =>
          option.field === actionType
          && this.normalizeEmergencyInstructionContactKeyPart(option.sourceType) === normalizedSourceType
          && this.normalizeEmergencyInstructionContactKeyPart(option.sourceId || '') === normalizedSourceId
        )
        : null;
      if (exactEmployeeMatch) {
        return exactEmployeeMatch;
      }

      if (normalizedSourceType === 'caretaker_contact_person') {
        return null;
      }

      return options.find((option) =>
        option.field === actionType
        && this.normalizeEmergencyInstructionContactKeyPart(option.sourceType) === normalizedSourceType
      ) || null;
    };

    (oldProperty.emergencyInstructions || []).forEach((instruction) => {
      (instruction.steps || []).forEach((step) => {
        const action = step.action;
        const actionType = action?.type;
        const contactRef = action?.contactRef;

        if (!action || (actionType !== 'phone' && actionType !== 'email')) {
          return;
        }

        if (!contactRef || contactRef.mode !== 'assigned_property_contact' || !contactRef.sourceType) {
          return;
        }

        const options = actionType === 'phone' ? phoneOptions : emailOptions;
        const replacement = findReplacement(options, actionType, contactRef);
        if (replacement) {
          return;
        }

        resets.push({
          instructionId: instruction._id,
          instructionTitle: instruction.title || '',
          stepId: step.id,
          stepTitle: step.title || '',
          sourceType: contactRef.sourceType,
          field: actionType,
          serviceType: contactRef.serviceType || null,
        });
      });
    });

    return { resets };
  }

  private confirmEmergencyInstructionAssignmentResets(): Promise<boolean> {
    return new Promise((resolve) => {
      this.modal.confirm({
        nzTitle: this.translate.instant('PROPERTY_INSTRUCTIONS.SYNC_RESET_CONFIRM_TITLE'),
        nzContent: this.translate.instant('PROPERTY_INSTRUCTIONS.SYNC_RESET_CONFIRM_CONTENT'),
        nzOkText: this.translate.instant('PROPERTY_INSTRUCTIONS.SYNC_RESET_CONFIRM_OK'),
        nzCancelText: this.translate.instant('PROPERTY_INSTRUCTIONS.SYNC_RESET_CONFIRM_CANCEL'),
        nzOnOk: () => {
          resolve(true);
          return Promise.resolve();
        },
        nzOnCancel: () => {
          resolve(false);
        },
      });
    });
  }

  private rebuildServicesByTypeCache(): void {
    const buckets = new Map<string, Map<string, Service>>();

    (this.technicalServicesModel || []).forEach((service) => {
      const normalizedService = normalizeServiceContact(service);
      const serviceId = this.getServiceIdentityKey(normalizedService);
      if (!serviceId) {
        return;
      }

      getServiceTypes(normalizedService).forEach((serviceType) => {
        const bucketKey = this.normalizeServiceTypeKey(serviceType);
        if (!bucketKey) {
          return;
        }

        if (!buckets.has(bucketKey)) {
          buckets.set(bucketKey, new Map<string, Service>());
        }

        buckets.get(bucketKey)!.set(serviceId, normalizedService);
      });
    });

    this.servicesByTypeCache = new Map(
      Array.from(buckets.entries()).map(([bucketKey, services]) => ([
        bucketKey,
        this.sortByText(Array.from(services.values()), (service) => service?.serviceName || '')
      ]))
    );
    this.totalServiceOptionCount = Array.from(this.servicesByTypeCache.values())
      .reduce((sum, services) => sum + services.length, 0);
  }

  private cancelServicesStepRender(mode: 'add' | 'edit'): void {
    const handle = mode === 'add' ? this.addServicesRenderHandle : this.editServicesRenderHandle;
    if (handle) {
      clearTimeout(handle);
    }

    if (mode === 'add') {
      this.addServicesRenderHandle = null;
    } else {
      this.editServicesRenderHandle = null;
    }
  }

  private setVisibleServiceTypes(mode: 'add' | 'edit', count: number): void {
    const visibleTypes = Array.from(new Set(this.technicalServiceTypes.slice(0, count)));
    if (mode === 'add') {
      this.visibleAddServiceTypes = visibleTypes;
    } else {
      this.visibleEditServiceTypes = visibleTypes;
    }
  }

  private getServiceIdentityKey(service: Service | null | undefined): string {
    if (!service) {
      return '';
    }

    const explicitId = String(service._id || '').trim();
    if (explicitId) {
      return explicitId;
    }

    const fallbackName = String(service.serviceName || '').trim();
    const fallbackPhone = String(service.phone || '').trim();
    const fallbackMobile = String(service.mobile || '').trim();
    const fallbackKey = [fallbackName, fallbackPhone, fallbackMobile]
      .filter(Boolean)
      .join('::');

    return fallbackKey;
  }

  getServiceOptionValue(service: Service | null | undefined): string {
    return this.getServiceIdentityKey(service);
  }

  private normalizeServiceSelectionIds(values: unknown): string[] {
    const normalized = new Set<string>();

    (Array.isArray(values) ? values : [values]).forEach((value) => {
      const normalizedValue = String(value || '').trim();
      if (!normalizedValue) {
        return;
      }

      normalized.add(normalizedValue);
    });

    return Array.from(normalized);
  }

  private normalizeServicesStepControlSelections(form: FormGroup | null | undefined): void {
    if (!form) {
      return;
    }

    this.technicalServiceTypes.forEach((serviceType) => {
      const control = form.get(serviceType);
      if (!control) {
        return;
      }

      const normalizedSelection = this.normalizeServiceSelectionIds(control.value);
      const currentSelection = Array.isArray(control.value) ? control.value.map((value: unknown) => String(value || '').trim()) : [];

      if (
        normalizedSelection.length === currentSelection.length
        && normalizedSelection.every((value, index) => value === currentSelection[index])
      ) {
        return;
      }

      control.setValue(normalizedSelection, { emitEvent: false });
    });
  }

  private shouldStageServicesStepRender(): boolean {
    return this.technicalServiceTypes.length > this.serviceStepChunkSize
      || this.totalServiceOptionCount > 250;
  }

  private isServicesStepActive(mode: 'add' | 'edit'): boolean {
    const step = mode === 'add'
      ? this.addSteps[this.currentAddStep]
      : this.editSteps[this.currentEditStep];

    return step?.key === 'services';
  }

  private scheduleServicesStepRender(mode: 'add' | 'edit', forceImmediate = false): void {
    this.cancelServicesStepRender(mode);

    const totalTypes = this.technicalServiceTypes.length;
    if (!totalTypes || forceImmediate || !this.shouldStageServicesStepRender()) {
      this.setVisibleServiceTypes(mode, totalTypes);
      if (mode === 'add') {
        this.isAddServicesStepRendering = false;
      } else {
        this.isEditServicesStepRendering = false;
      }
      return;
    }

    if (mode === 'add') {
      this.isAddServicesStepRendering = true;
    } else {
      this.isEditServicesStepRendering = true;
    }
    this.setVisibleServiceTypes(mode, 0);

    const renderChunk = () => {
      if (!this.isServicesStepActive(mode)) {
        this.cancelServicesStepRender(mode);
        return;
      }

      const currentVisible = mode === 'add'
        ? this.visibleAddServiceTypes.length
        : this.visibleEditServiceTypes.length;
      const nextVisible = Math.min(currentVisible + this.serviceStepChunkSize, totalTypes);
      this.setVisibleServiceTypes(mode, nextVisible);

      if (nextVisible >= totalTypes) {
        if (mode === 'add') {
          this.isAddServicesStepRendering = false;
          this.addServicesRenderHandle = null;
        } else {
          this.isEditServicesStepRendering = false;
          this.editServicesRenderHandle = null;
        }
        return;
      }

      const handle = setTimeout(renderChunk, 0);
      if (mode === 'add') {
        this.addServicesRenderHandle = handle;
      } else {
        this.editServicesRenderHandle = handle;
      }
    };

    const handle = setTimeout(renderChunk, 0);
    if (mode === 'add') {
      this.addServicesRenderHandle = handle;
    } else {
      this.editServicesRenderHandle = handle;
    }
  }

  private setModalStep(mode: 'add' | 'edit', index: number, options?: { forceImmediateServicesRender?: boolean }): void {
    const steps = mode === 'add' ? this.addSteps : this.editSteps;
    if (!Number.isInteger(index) || index < 0 || index >= steps.length) {
      return;
    }

    if (mode === 'add') {
      this.currentAddStep = index;
    } else {
      this.currentEditStep = index;
    }

    if (steps[index]?.key === 'services') {
      this.normalizeServicesStepControlSelections(mode === 'add' ? this.addPropertyForm : this.editPropertyForm);
      this.scheduleServicesStepRender(mode, !!options?.forceImmediateServicesRender);
      return;
    }

    this.cancelServicesStepRender(mode);
    this.setVisibleServiceTypes(mode, this.technicalServiceTypes.length);
    if (mode === 'add') {
      this.isAddServicesStepRendering = false;
    } else {
      this.isEditServicesStepRendering = false;
    }
  }

  override onEditStepIndexChange(index: number): void {
    this.setModalStep('edit', index);
  }

  override onAddStepIndexChange(index: number): void {
    this.setModalStep('add', index);
  }

  override nextEditStep(): void {
    this.setModalStep('edit', this.currentEditStep + 1);
  }

  override prevEditStep(): void {
    this.setModalStep('edit', this.currentEditStep - 1);
  }

  override nextAddStep(): void {
    this.setModalStep('add', this.currentAddStep + 1);
  }

  override prevAddStep(): void {
    this.setModalStep('add', this.currentAddStep - 1);
  }

  private resolveServiceBucketType(serviceKey: string): string {
    return this.technicalServicesOrderingService.getServiceByHeaderKey(serviceKey)?.serviceType || serviceKey;
  }

  private buildTechnicalServiceAssignmentsFromFormValue(formValue: any): PropertyTechnicalServiceAssignment[] {
    const assignments: PropertyTechnicalServiceAssignment[] = [];
    const seen = new Set<string>();

    this.technicalServiceTypes.forEach((serviceKey) => {
      const assignedServiceType = this.resolveServiceBucketType(serviceKey);
      const selectedValue = formValue[serviceKey];
      const selectedIds = Array.isArray(selectedValue)
        ? selectedValue.filter(Boolean)
        : (selectedValue ? [selectedValue] : []);

      selectedIds.forEach((serviceId: string) => {
        const normalizedServiceId = String(serviceId || '').trim();
        if (!normalizedServiceId) {
          return;
        }

        const identity = `${normalizedServiceId}::${assignedServiceType}`;
        if (seen.has(identity)) {
          return;
        }

        seen.add(identity);
        assignments.push({
          serviceId: normalizedServiceId,
          serviceType: assignedServiceType
        });
      });
    });

    return assignments;
  }

  getServicesByType(serviceType: string): Service[] {
    return this.servicesByTypeCache.get(this.normalizeServiceTypeKey(serviceType)) || [];
  }

  private getLandingProfileId(property?: Property | null): string | null {
    const landingProfileId = property?.landingProfileId;
    const normalizedId = typeof landingProfileId === 'string'
      ? landingProfileId
      : landingProfileId?._id;

    return typeof normalizedId === 'string' && normalizedId.trim()
      ? normalizedId.trim()
      : null;
  }

  private getLandingProfileSelectionValue(property: Property): string {
    const assignedProfileId = this.getLandingProfileId(property);

    if (!assignedProfileId) {
      return this.useCompanyLandingProfileValue;
    }

    return this.landingProfiles.some((profile) => profile._id === assignedProfileId)
      ? assignedProfileId
      : this.useCompanyLandingProfileValue;
  }

  private mapLandingProfileFormValueToPayload(value: string | null | undefined): string | null {
    const normalizedValue = typeof value === 'string' ? value.trim() : '';
    if (!normalizedValue || normalizedValue === this.useCompanyLandingProfileValue) {
      return null;
    }
    return normalizedValue;
  }

  populateEditForm(property: Property): void {
    const propertyId = String(property?._id || '').trim() || null;
    if (
      this.editCaretakerContactPersonSelectionPropertyId
      && this.editCaretakerContactPersonSelectionPropertyId !== propertyId
    ) {
      this.resetCaretakerContactPersonSelectionCache('edit');
    }
    this.editCaretakerContactPersonSelectionPropertyId = propertyId;

    const formValue: any = {
      address: property.address,
    };

    if (this.multiLandingProfilesEnabled && this.editPropertyForm.contains('landingProfileId')) {
      formValue['landingProfileId'] = this.getLandingProfileSelectionValue(property);
    }

    if (this.savedHeaders?.caretakerHeaders?.includes('CARETAKER_NAME')) {
      formValue['caretaker'] = property.caretaker ? property.caretaker._id : null;
      formValue['caretakerContactPersonIds'] = this.reconcileCaretakerContactPersonSelectionIds(
        formValue['caretaker'],
        property.caretakerContactPersonIds
      );
    }

    const propertyManagers = Array.isArray(property.propertyManagers) ? property.propertyManagers : [];
    const technicalAssetsManagers = Array.isArray(property.technicalAssetsManagers) ? property.technicalAssetsManagers : [];
    const sevManagers = Array.isArray(property.sevManagers) ? property.sevManagers : [];
    const accountants = Array.isArray(property.accountants) ? property.accountants : [];

    if (this.savedHeaders?.propertyManagerHeaders?.includes('PROPERTY_MANAGER_NAME')) {
      formValue['propertyManagers'] = propertyManagers.length > 0 ? propertyManagers[0]._id : null;
    }

    if (this.savedHeaders?.technicalAssetsManagerHeaders?.includes('TECHNICAL_ASSETS_MANAGER_NAME')) {
      formValue['technicalAssetsManagers'] = technicalAssetsManagers.length > 0 ? technicalAssetsManagers[0]._id : null;
    }

    if (this.savedHeaders?.sevManagerHeaders?.includes('CONDOMINIUM_MANAGER_NAME')) {
      formValue['sevManagers'] = sevManagers.length > 0 ? sevManagers[0]._id : null;
    }

    if (this.savedHeaders?.accountantHeaders?.includes('ACCOUNTANT_NAME')) {
      formValue['accountants'] = accountants.length > 0 ? accountants[0]._id : null;
    }

    const servicesByType = new Map<string, string[]>();
    const propertyAssignments = this.buildPropertyServiceAssignmentsForPrefill(property);

    propertyAssignments.forEach((assignment) => {
      const serviceId = String(assignment?.serviceId || '').trim();
      const serviceTypeKey = this.normalizeServiceTypeKey(assignment?.serviceType || '');
      if (!serviceId || !serviceTypeKey) {
        return;
      }
      if (!servicesByType.has(serviceTypeKey)) {
        servicesByType.set(serviceTypeKey, []);
      }
      const current = servicesByType.get(serviceTypeKey)!;
      if (!current.includes(serviceId)) {
        current.push(serviceId);
      }
    });

    this.technicalServiceTypes.forEach((serviceType) => {
      const control = this.editPropertyForm.get(serviceType);
      if (!control) {
        return;
      }
      control.setValue(this.normalizeServiceSelectionIds(servicesByType.get(serviceType) || []));
    });

    this.editPropertyForm.setControl('hospitalityDetails', this.createHospitalityDetailsGroup(property.hospitalityDetails || undefined));
    this.editPropertyForm.patchValue(formValue, { emitEvent: false });
    this.seedCaretakerContactPersonSelectionCache(this.editPropertyForm, 'edit');
    this.applyManagerSelectionValidation(this.editPropertyForm);
  }

  private focusFirstInvalidStep(form: FormGroup, mode: 'add' | 'edit'): void {
    const stepKey = this.getFirstInvalidStepKey(form);
    if (!stepKey) return;

    this.jumpToStep(stepKey, mode);

    // wait for DOM to update after step change then scroll to first error
    setTimeout(() => this.scrollFirstErrorIntoView(mode), 0);
  }

  private getFirstInvalidStepKey(form: FormGroup): 'basics' | 'contacts' | 'services' | 'hospitality' | null {
    // 1) Basics
    if (form.get('address')?.invalid) return 'basics';

    // 2) Contacts
    const contactsControls = ['caretaker', 'propertyManagers', 'technicalAssetsManagers', 'sevManagers', 'accountants'];
    if (contactsControls.some(k => form.get(k)?.invalid)) return 'contacts';
    if (form.hasError('managerRequired')) return 'contacts';

    // 3) Services (dynamic technical service type controls)
    if ((this.technicalServiceTypes || []).some(serviceType => form.get(serviceType)?.invalid)) return 'services';

    // 4) Hospitality details
    const hosp = form.get('hospitalityDetails');
    if (hosp && hosp.invalid) {
      // In hospitality mode the hospitality form is visible under basics too
      return this.isHospitalityMode() ? 'basics' : 'hospitality';
    }

    return null;
  }

  private jumpToStep(stepKey: string, mode: 'add' | 'edit'): void {
    const steps = mode === 'add' ? (this as any).addSteps : (this as any).editSteps;
    const idx = Array.isArray(steps) ? steps.findIndex((s: any) => s?.key === stepKey) : -1;

    if (idx >= 0) {
      this.setModalStep(mode, idx, { forceImmediateServicesRender: true });
    } else {
      this.setModalStep(mode, 0, { forceImmediateServicesRender: true });
    }
  }

  private scrollFirstErrorIntoView(mode: 'add' | 'edit'): void {
    const rootSelector = mode === 'add' ? '.property-add-form' : '.property-edit-form';
    const root = document.querySelector(rootSelector);
    if (!root) return;

    // first invalid form item
    const errorItem = root.querySelector('.ant-form-item-has-error') as HTMLElement | null;
    if (!errorItem) return;

    errorItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  async saveEditProperty(): Promise<void> {
    if (!(await this.ensureCaretakerContactPersonOptionsForSave(this.editPropertyForm))) {
      return;
    }

    if (this.editPropertyForm.valid) {
      const formData = this.editPropertyForm.value;
      const resetPlan = this.buildEmergencyInstructionAssignmentResetPlan(this.selectedProperty, formData);
      if (resetPlan.resets.length > 0) {
        const confirmed = await this.confirmEmergencyInstructionAssignmentResets();
        if (!confirmed) {
          return;
        }
      }

      const technicalServiceAssignments = this.buildTechnicalServiceAssignmentsFromFormValue(formData);
      const selectedTechnicalServiceIds = Array.from(new Set(
        technicalServiceAssignments.map((assignment) => assignment.serviceId)
      ));

      // Map to Service objects and filter out undefined values with a type predicate
      const technicalServices: Service[] = selectedTechnicalServiceIds
        .map((serviceId: string) => this.technicalServicesModel.find(service => service._id === serviceId))
        .filter((service): service is Service => service !== undefined);

      const selectedCaretaker =
        this.caretakers.find(c => c._id === formData.caretaker) || null;
      const hospitalityDetailsPayload = this.extractHospitalityDetails(this.editPropertyForm) ?? null;
      const suppressAuditForInlineCreate = this.shouldSuppressPropertyAuditForInlineCreatedServices({
        formData,
        selectedTechnicalServiceIds,
        selectedCaretakerId: selectedCaretaker?._id || null,
      });

      const property: Property = {
        address: formData.address,
        // send a real caretaker object when selected, otherwise NULL (not a dummy object)
        caretaker: selectedCaretaker,
        caretakerContactPersonIds: selectedCaretaker
          ? this.reconcileCaretakerContactPersonSelectionIds(
            selectedCaretaker._id,
            formData.caretakerContactPersonIds
          )
          : [],
        landingProfileId: this.multiLandingProfilesEnabled
          ? this.mapLandingProfileFormValueToPayload(formData.landingProfileId)
          : null,
        propertyManagers: formData.propertyManagers
          ? [this.propertyManagersModel.find(m => m._id === formData.propertyManagers)]
            .filter(Boolean) as Employee[]
          : [],
        technicalAssetsManagers: formData.technicalAssetsManagers
          ? [this.technicalAssetsManagers.find(t => t._id === formData.technicalAssetsManagers)]
            .filter(Boolean) as Employee[]
          : [],
        sevManagers: formData.sevManagers
          ? [this.sevManagersModel.find(m => m._id === formData.sevManagers)]
            .filter(Boolean) as Employee[]
          : [],
        accountants: formData.accountants
          ? [this.accountantsModel.find(m => m._id === formData.accountants)]
            .filter(Boolean) as Employee[]
          : [],
        technicalServices: technicalServices,
        technicalServiceAssignments,
        // keep or remove companyId depending on your API needs
        companyId: this.selectedProperty?.companyId || this.company?.['_id'],
        hospitalityDetails: hospitalityDetailsPayload as any,
      };
      (property as any).suppressAudit = suppressAuditForInlineCreate;

      if (this.selectedProperty && this.selectedProperty._id) {
        this.propertyService.updateProperty(this.selectedProperty._id, property).subscribe({
          next: async (response) => {
            this.editModalVisible = false;
            this.resetCaretakerContactPersonSelectionCache('edit');
            this.pendingInlineCreatedServiceIds.clear();
            await this.fetchProperties(); // Refresh the property list
            this.progressService.notifyProgressUpdated();
            // Display success message
            const message = this.translate.instant('PROPERTY_LIST.UPDATE_SUCCESS', { address: formData.address });
            this.message.success(message);

            // Reset the form if needed
            this.editPropertyForm.reset();
          },
          error: (err) => {
            if (shouldSuppressGenericError(err)) {
              return;
            }
            if (err.status === 400 && err.error?.message === 'Property limit reached') {
              this.message.error(this.translate.instant('PROPERTY_LIST.MAX_PROPERTIES_REACHED'));
            } else if (err.message === 'Address already exists for another property') {
              this.message.error(this.translate.instant('PROPERTY_LIST.DUPLICATE_ADDRESS_ERROR'));
            } else {
              this.message.error(this.getPropertySaveErrorMessage(err, 'PROPERTY_LIST.UPDATE_ERROR'));
            }
          }
        });
      }
    } else {
      this.markFormGroupForValidation(this.editPropertyForm);
      this.focusFirstInvalidStep(this.editPropertyForm, 'edit');

      // Only check for specific errors on key fields
      const hostContactPhoneControl = this.editPropertyForm.get('hospitalityDetails.hostContact.phone');
      const addressControl = this.editPropertyForm.get('address');
      if (this.appMode === 'hospitality' && hostContactPhoneControl?.hasError('invalidPhone')) {
        this.message.error(this.translate.instant('HOSPITALITY_FIELDS.HOST_CONTACT_PHONE_INVALID'));
      } else if (addressControl?.hasError('required')) {
        this.message.error(this.translate.instant('PROPERTY_LIST.ADDRESS_REQUIRED'));
      } else if (addressControl?.hasError('invalidAddress')) {
        this.message.error(this.translate.instant('FORM_ERRORS.ADDRESS_ERROR'));
      } else if (this.hasManagerSelectionError(this.editPropertyForm)) {
        this.message.error(this.getManagerRequiredMessage());
      } else {
        this.message.error(this.translate.instant('PROPERTY_LIST.FORM_INVALID'));
      }
    }
  }

  private shouldSuppressPropertyAuditForInlineCreatedServices(options: {
    formData: any;
    selectedTechnicalServiceIds: string[];
    selectedCaretakerId: string | null;
  }): boolean {
    if (!this.selectedProperty || !this.pendingInlineCreatedServiceIds.size) {
      return false;
    }

    const previousServiceIds = Array.isArray(this.selectedProperty.technicalServices)
      ? this.selectedProperty.technicalServices.map((service: any) => String(service?._id || service?.id || service || '').trim()).filter(Boolean)
      : [];
    const nextServiceIds = options.selectedTechnicalServiceIds.map((id) => String(id || '').trim()).filter(Boolean);

    const addedIds = nextServiceIds.filter((id) => !previousServiceIds.includes(id));
    const removedIds = previousServiceIds.filter((id) => !nextServiceIds.includes(id));

    if (!addedIds.length || removedIds.length) {
      return false;
    }

    if (!addedIds.every((id) => this.pendingInlineCreatedServiceIds.has(id))) {
      return false;
    }

    const previousCaretakerId = String(this.selectedProperty.caretaker?._id || this.selectedProperty.caretaker || '').trim() || null;
    const previousPropertyManagerId = String(this.selectedProperty.propertyManagers?.[0]?._id || '').trim() || null;
    const previousTechnicalAssetsManagerId = String(this.selectedProperty.technicalAssetsManagers?.[0]?._id || '').trim() || null;
    const previousSevManagerId = String(this.selectedProperty.sevManagers?.[0]?._id || '').trim() || null;
    const previousAccountantId = String(this.selectedProperty.accountants?.[0]?._id || '').trim() || null;
    const nextPropertyManagerId = String(options.formData.propertyManagers || '').trim() || null;
    const nextTechnicalAssetsManagerId = String(options.formData.technicalAssetsManagers || '').trim() || null;
    const nextSevManagerId = String(options.formData.sevManagers || '').trim() || null;
    const nextAccountantId = String(options.formData.accountants || '').trim() || null;

    return (
      String(this.selectedProperty.address || '') === String(options.formData.address || '')
      && previousCaretakerId === options.selectedCaretakerId
      && previousPropertyManagerId === nextPropertyManagerId
      && previousTechnicalAssetsManagerId === nextTechnicalAssetsManagerId
      && previousSevManagerId === nextSevManagerId
      && previousAccountantId === nextAccountantId
    );
  }

  filterOptions(searchValue: string, item: any): boolean {
    const search = (searchValue || '').toLowerCase().trim();
    const label = ((item?.nzLabel ?? '') + '').toLowerCase();
    return label.includes(search);
  }

  private async canPrintQrCodes(): Promise<boolean> {
    if (this.isQrPrintGuardChecking) {
      return false;
    }

    this.isQrPrintGuardChecking = true;
    try {
      if (this.progressStatus !== 'complete') {
        await firstValueFrom(this.fetchAndUpdateProgress());
      }

      if (this.progressStatus !== 'complete') {
        this.message.warning(
          this.translate.instant('PROGRESS.INCOMPLETE_SETUP_MESSAGE', { percent: this.progress })
        );
        return false;
      }

      return true;
    } catch (error) {
      this.message.error(
        this.translate.instant('PROGRESS.CHECK_FAILED_MESSAGE')
      );
      return false;
    } finally {
      this.isQrPrintGuardChecking = false;
    }
  }

  printQRCode(): void {
    const renderLanguage = this.getCurrentQrPosterRenderLanguage();
    this.canPrintQrCodes().then((allowed: boolean) => {
      if (!allowed) return;
      this.printQRCodeForOneProperty(this.selectedProperty, renderLanguage);
    });
  }

  async printQRCodeForOneProperty(
    property: Property | undefined,
    renderLanguage: 'de' | 'en',
  ) {
    if (!property?._id || !property.companyId) {
      console.error('Cannot generate QR code PDF: missing property identifiers.');
      return;
    }

    try {
      const previewPdf = this.getCachedQrPosterPreviewPdf(property, renderLanguage);
      if (previewPdf) {
        saveAs(previewPdf, this.getSinglePropertyPdfFilename(property));
        return;
      }

      const descriptorResponse = await this.getQrPosterRenderDescriptorForProperty(property, renderLanguage);
      await this.qrPosterDocumentService.download(
        descriptorResponse,
        this.getSinglePropertyPdfFilename(property),
        {
          renderSource: 'property-list-single-pdf',
        },
      );
    } catch (error) {
      console.error('Failed to generate canonical QR code PDF:', error);
      this.message.error(this.translate.instant('QR_POSTER_TEMPLATE.TEST_PDF_ERROR'));
    }
  }

  private getCachedQrPosterPreviewPdf(
    property: Property,
    renderLanguage: 'de' | 'en',
  ): Blob | null {
    if (
      !property._id
      || !this.qrPosterPreviewPdf
      || this.qrPosterPreviewPdf.propertyId !== String(property._id)
      || this.qrPosterPreviewPdf.renderLanguage !== renderLanguage
    ) {
      return null;
    }

    return this.qrPosterPreviewPdf.blob;
  }

  private getCurrentQrPosterRenderLanguage(): 'de' | 'en' {
    return this.translate.currentLang === 'en' ? 'en' : 'de';
  }

  private getQrPosterRenderDescriptorForProperty(
    property: Property,
    language: 'de' | 'en',
    templateId?: string | null,
  ): Promise<QrPosterRenderDescriptorResponse> {
    if (!property._id) {
      return Promise.reject(new Error('A property ID is required for QR poster rendering'));
    }

    return lastValueFrom(this.propertyService.getQrPosterRenderDescriptor(
      String(property._id),
      language,
      false,
      this.normalizeQrPosterTemplateSelection(templateId),
    ));
  }

  private normalizeQrPosterTemplateSelection(templateId?: string | null): string | null {
    return templateId && templateId !== this.automaticQrPosterTemplateValue ? templateId : null;
  }

  private getUniqueZipEntryFilename(filename: string, usedFilenames: Set<string>): string {
    if (!usedFilenames.has(filename)) {
      usedFilenames.add(filename);
      return filename;
    }

    const dotIndex = filename.lastIndexOf('.');
    const baseName = dotIndex > 0 ? filename.slice(0, dotIndex) : filename;
    const extension = dotIndex > 0 ? filename.slice(dotIndex) : '';
    let counter = 2;
    let candidate = `${baseName} (${counter})${extension}`;

    while (usedFilenames.has(candidate)) {
      counter += 1;
      candidate = `${baseName} (${counter})${extension}`;
    }

    usedFilenames.add(candidate);
    return candidate;
  }


  private sanitizeFilenameSegment(value: string): string {
    return String(value ?? '')
      .trim()
      .replace(/[<>:"/\\|?*\u0000-\u001f]/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  private getSinglePropertyPdfFilename(property: Property | undefined): string {
    const hausCode = property ? this.getHaussoftHausCode(property) : null;
    const propertyAddress = this.sanitizeFilenameSegment(property?.address || 'Property') || 'Property';
    const timestamp = this.formatQrPosterFilenameTimestamp(new Date());
    const sanitizedHausCode = this.sanitizeFilenameSegment(hausCode || '');

    if (sanitizedHausCode) {
      return `${sanitizedHausCode}_${propertyAddress}_QR_Code_${timestamp}.pdf`;
    }
    return `${propertyAddress}_QR_Code_${timestamp}.pdf`;
  }

  async generateAllQRCodesPdf(templateId?: string | null) {
    if (!(await this.canPrintQrCodes())) {
      return;
    }

    const selectedProperties = this.getSelectedQrProperties();
    if (!selectedProperties.length) {
      this.message.error(this.translate.instant('PROPERTY_LIST.QR_DOWNLOAD_CHOICE.NO_PROPERTIES_SELECTED'));
      return;
    }
    const renderLanguage = this.getCurrentQrPosterRenderLanguage();
    try {
      const descriptorResponses = await Promise.all(selectedProperties.map((property) =>
        this.getQrPosterRenderDescriptorForProperty(property, renderLanguage, templateId)
      ));
      const pdfBlob = await this.qrPosterDocumentService.createCombinedPdfBlob(descriptorResponses, {
        renderSource: 'property-list-combined-pdf',
      });

      const companyName = this.company?.name || 'Company';
      const now = new Date();
      const timestamp = this.formatQrPosterFilenameTimestamp(now);
      const pdfFilename = `${companyName}_QR_Codes_${timestamp}.pdf`;
      saveAs(pdfBlob, pdfFilename);
    } catch (error) {
      console.error('Failed to generate canonical combined QR code PDF:', error);
      this.message.error(this.translate.instant('QR_POSTER_TEMPLATE.TEST_PDF_ERROR'));
    }
  }

  private formatQrPosterFilenameTimestamp(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}_${hours}-${minutes}`;
  }

  openAllQrDownloadChoiceModal(): void {
    this.canPrintQrCodes().then((allowed: boolean) => {
      if (!allowed) return;

      this.qrSelectionPropertyIds = new Set();
      this.qrSelectionSearchText = '';
      this.qrSelectionGroupBy = 'none';
      this.selectedQrPosterTemplateId = this.automaticQrPosterTemplateValue;
      this.buildQrSelectableProperties();
      this.rebuildQrSelectionViewModel();
      this.allQrDownloadChoiceVisible = true;
    });
  }

  closeAllQrDownloadChoiceModal(): void {
    if (this.allQrDownloadLoading || this.allQrZipLoading) {
      return;
    }

    this.allQrDownloadChoiceVisible = false;
  }

  private buildQrSelectableProperties(): void {
    this.qrSelectableProperties = this.allProperties
      .filter((p) => !!p._id)
      .map((p) => {
        const address = p.address || '';
        const externalId = this.getHaussoftHausCode(p)?.trim() || null;
        const displayLabel = externalId ? `${externalId} \u00B7 ${address}` : address;
        const profile = typeof p.landingProfileId === 'object' && p.landingProfileId
          ? p.landingProfileId
          : null;
        const profileId = profile?._id || (typeof p.landingProfileId === 'string' ? p.landingProfileId : '');
        const profileName = profile?.profileName || '';
        const inactiveSuffix = profile?.active === false
          ? ` (${this.translate.instant('COMPANY_PAGE.LANDING_PROFILES.INACTIVE')})`
          : '';

        return {
          _id: p._id!,
          address,
          externalId,
          displayLabel,
          profileGroupKey: profileId && profileName ? `profile:${profileId}` : '__company__',
          profileGroupLabel: profileName
            ? `${profileName}${inactiveSuffix}`
            : this.translate.instant('PROPERTY_LIST.LANDING_PROFILE_USE_COMPANY'),
          ...splitAddress(address),
        };
      });
  }

  private rebuildQrSelectionViewModel(): void {
    const allVm = this.qrSelectableProperties;
    const sel = this.qrSelectionPropertyIds;

    const search = this.qrSelectionSearchText.toLowerCase().trim();
    let filtered = allVm;
    let isFiltered = false;
    if (search) {
      filtered = allVm.filter((p) =>
        p.address.toLowerCase().includes(search)
        || p.street.toLowerCase().includes(search)
        || p.zipcode.toLowerCase().includes(search)
        || p.city.toLowerCase().includes(search)
        || p._id.toLowerCase().includes(search)
        || (p.externalId && p.externalId.toLowerCase().includes(search))
      );
      isFiltered = true;
    }

    const groups: QrSelectionGroup[] = [];
    let selectedTotalCount = 0;
    let selectedFilteredCount = 0;

    if (this.qrSelectionGroupBy === 'none') {
      let sc = 0;
      for (const p of filtered) {
        if (sel.has(p._id)) sc++;
      }
      selectedFilteredCount = sc;
      if (!isFiltered) {
        selectedTotalCount = sc;
      }
      groups.push({
        key: '__all__',
        label: '',
        properties: filtered,
        selectedCount: sc,
        totalCount: filtered.length,
        allSelected: sc === filtered.length && filtered.length > 0,
        someSelected: sc > 0 && sc < filtered.length,
      });
    } else {
      const groupMap = new Map<string, QrSelectableProperty[]>();
      for (const p of filtered) {
        const key = this.qrSelectionGroupBy === 'city'
          ? (p.city || '')
          : this.qrSelectionGroupBy === 'zipcode'
            ? (p.zipcode || '')
            : p.profileGroupKey;
        if (!groupMap.has(key)) {
          groupMap.set(key, []);
        }
        groupMap.get(key)!.push(p);
      }
      const sortedKeys = [...groupMap.keys()].sort((a, b) => a.localeCompare(b));
      for (const key of sortedKeys) {
        const props = groupMap.get(key)!;
        let sc = 0;
        for (const p of props) {
          if (sel.has(p._id)) sc++;
        }
        selectedFilteredCount += sc;
        groups.push({
          key,
          label: this.qrSelectionGroupBy === 'profile'
            ? props[0].profileGroupLabel
            : key || this.translate.instant('PROPERTY_LIST.QR_DOWNLOAD_CHOICE.UNKNOWN_GROUP'),
          properties: props,
          selectedCount: sc,
          totalCount: props.length,
          allSelected: sc === props.length && props.length > 0,
          someSelected: sc > 0 && sc < props.length,
        });
      }
    }

    if (isFiltered || this.qrSelectionGroupBy !== 'none') {
      for (const p of allVm) {
        if (sel.has(p._id)) selectedTotalCount++;
      }
    }

    this.qrSelectionViewModel = { groups, totalCount: allVm.length, filteredCount: filtered.length, selectedTotalCount, selectedFilteredCount };
  }

  private updateQrSelectionCounts(): void {
    const sel = this.qrSelectionPropertyIds;
    const prev = this.qrSelectionViewModel;
    let filteredSel = 0;

    const groups = prev.groups.map((group) => {
      let sc = 0;
      for (const p of group.properties) {
        if (sel.has(p._id)) sc++;
      }
      filteredSel += sc;
      return {
        ...group,
        selectedCount: sc,
        allSelected: sc === group.totalCount && group.totalCount > 0,
        someSelected: sc > 0 && sc < group.totalCount,
      };
    });

    this.qrSelectionViewModel = {
      ...prev,
      groups,
      selectedTotalCount: sel.size,
      selectedFilteredCount: filteredSel,
    };
  }

  onQrSelectionSearchChange(value: string): void {
    this.qrSelectionSearchText = value;
    this.rebuildQrSelectionViewModel();
  }

  get hasQrSelectionSearch(): boolean {
    return !!this.qrSelectionSearchText.trim();
  }

  onQrSelectionGroupByChange(value: 'none' | 'city' | 'zipcode' | 'profile'): void {
    this.qrSelectionGroupBy = value;
    this.qrExpandedGroupKeys.clear();
    this.rebuildQrSelectionViewModel();
  }

  private async runQrSelectionOperation(operation: () => void): Promise<void> {
    if (this.qrSelectionBusy) {
      return;
    }

    this.qrSelectionBusy = true;
    this.cdr.detectChanges();
    await this.waitForAnimationFrame();

    try {
      operation();

      this.cdr.detectChanges();
      await this.waitForAnimationFrame();
      await this.waitForAnimationFrame();
    } finally {
      this.qrSelectionBusy = false;
      this.cdr.detectChanges();
    }
  }

  private waitForAnimationFrame(): Promise<void> {
    return new Promise((resolve) => requestAnimationFrame(() => resolve()));
  }

  toggleQrGroupExpand(key: string): void {
    if (this.qrExpandedGroupKeys.has(key)) {
      this.qrExpandedGroupKeys.delete(key);
    } else {
      this.qrExpandedGroupKeys.add(key);
    }
  }

  toggleQrProperty(propertyId: string): void {
    if (!propertyId) { return; }
    const next = new Set(this.qrSelectionPropertyIds);
    if (next.has(propertyId)) {
      next.delete(propertyId);
    } else {
      next.add(propertyId);
    }
    this.qrSelectionPropertyIds = next;
    this.updateQrSelectionCounts();
  }

  toggleQrGroup(group: QrSelectionGroup): void {
    const select = !group.allSelected;
    void this.runQrSelectionOperation(() => {
      const next = new Set(this.qrSelectionPropertyIds);
      for (const p of group.properties) {
        if (select) {
          next.add(p._id);
        } else {
          next.delete(p._id);
        }
      }
      this.qrSelectionPropertyIds = next;
      this.updateQrSelectionCounts();
    });
  }

  selectAllQrProperties(): void {
    void this.runQrSelectionOperation(() => {
      this.qrSelectionPropertyIds = new Set(this.qrSelectableProperties.map((p) => p._id));
      this.updateQrSelectionCounts();
    });
  }

  clearAllQrSelection(): void {
    void this.runQrSelectionOperation(() => {
      this.qrSelectionPropertyIds = new Set();
      this.updateQrSelectionCounts();
    });
  }

  selectQrVisible(): void {
    void this.runQrSelectionOperation(() => {
      const next = new Set(this.qrSelectionPropertyIds);
      for (const group of this.qrSelectionViewModel.groups) {
        for (const p of group.properties) {
          next.add(p._id);
        }
      }
      this.qrSelectionPropertyIds = next;
      this.updateQrSelectionCounts();
    });
  }

  clearQrVisible(): void {
    void this.runQrSelectionOperation(() => {
      const next = new Set(this.qrSelectionPropertyIds);
      for (const group of this.qrSelectionViewModel.groups) {
        for (const p of group.properties) {
          next.delete(p._id);
        }
      }
      this.qrSelectionPropertyIds = next;
      this.updateQrSelectionCounts();
    });
  }

  trackByQrSelectionGroup(_: number, group: QrSelectionGroup): string {
    return group.key;
  }

  trackByQrSelectionProperty(_: number, property: QrSelectableProperty): string {
    return property._id;
  }

  private getSelectedQrProperties(): Property[] {
    return this.allProperties.filter((p) => this.qrSelectionPropertyIds.has(p._id || ''));
  }

  get showQrProfileGrouping(): boolean {
    return this.multiLandingProfilesEnabled && this.landingProfiles.some((profile) => profile.active !== false);
  }

  get showQrPosterTemplateSelector(): boolean {
    return this.savedQrPosterTemplates.length > 0;
  }

  async downloadAllQrCodesAsSinglePdf(): Promise<void> {
    const selectedProperties = this.getSelectedQrProperties();
    if (!selectedProperties.length) {
      this.message.error(this.translate.instant('PROPERTY_LIST.QR_DOWNLOAD_CHOICE.NO_PROPERTIES_SELECTED'));
      return;
    }

    this.allQrDownloadLoading = true;

    try {
      await this.generateAllQRCodesPdf(this.selectedQrPosterTemplateId);
      this.allQrDownloadChoiceVisible = false;
    } finally {
      this.allQrDownloadLoading = false;
    }
  }

  async downloadAllQrCodesAsZip(): Promise<void> {
    if (!(await this.canPrintQrCodes())) {
      return;
    }

    const selectedProperties = this.getSelectedQrProperties();
    if (!selectedProperties.length) {
      this.message.error(this.translate.instant('PROPERTY_LIST.QR_DOWNLOAD_CHOICE.NO_PROPERTIES_SELECTED'));
      return;
    }
    const renderLanguage = this.getCurrentQrPosterRenderLanguage();
    this.allQrZipLoading = true;

    try {
      const zip = new JSZip();
      const usedFilenames = new Set<string>();

      for (const property of selectedProperties) {
        const descriptorResponse = await this.getQrPosterRenderDescriptorForProperty(
          property,
          renderLanguage,
          this.selectedQrPosterTemplateId,
        );
        const pdfBlob = await this.qrPosterDocumentService.createPdfBlob(descriptorResponse, {
          renderSource: 'property-list-zip-pdf',
        });
        const filename = this.getUniqueZipEntryFilename(
          this.getSinglePropertyPdfFilename(property),
          usedFilenames
        );
        zip.file(filename, pdfBlob);
      }

      const zipBlob = await zip.generateAsync({ type: 'blob' });
      saveAs(zipBlob, this.getAllQrCodesZipFilename());
      this.message.success(this.translate.instant('PROPERTY_LIST.QR_DOWNLOAD_CHOICE.ZIP_SUCCESS'));
      this.allQrDownloadChoiceVisible = false;
    } catch (error) {
      console.error('Failed to generate QR code ZIP:', error);
      this.message.error(this.translate.instant('PROPERTY_LIST.QR_DOWNLOAD_CHOICE.ZIP_ERROR'));
    } finally {
      this.allQrZipLoading = false;
    }
  }

  private getAllQrCodesZipFilename(): string {
    const companyName = this.company?.name || 'Company';
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const timestamp = `${year}-${month}-${day}`;

    return `${companyName}_QR_Codes_${timestamp}.zip`;
  }

  // Show confirmation modal to delete the selected property
  async deleteProperty(property: Property): Promise<void> {
    if (!property._id) {
      // Handle case when property._id is undefined or null
      this.message.error(this.translate.instant('PROPERTY_LIST.DELETE_ERROR_ID_UNDEFINED'));
      return;
    }

    this.modal.confirm({
      nzTitle: this.translate.instant('PROPERTY_LIST.CONFIRM_DELETE_TITLE'),
      nzContent: `${this.translate.instant('PROPERTY_LIST.CONFIRM_DELETE_CONTENT')} ${property.address}`,
      nzOkText: this.translate.instant('PROPERTY_LIST.CONFIRM_DELETE_OK'),
      nzCancelText: this.translate.instant('PROPERTY_LIST.CONFIRM_DELETE_CANCEL'),
      nzOnOk: () => {
        this.isLoading = true;
        // Call backend service to delete the property
        this.propertyService.deleteProperty(property._id!)
          .pipe(finalize(() => {
            this.isLoading = false;
          }))
          .subscribe({
          next: async () => {
            // Remove the deleted property from the list
            this.allProperties = this.allProperties.filter(p => p._id !== property._id);
            this.propertiesPagination.total = this.allProperties.length;
            await this.fetchProperties();
            this.progressService.notifyProgressUpdated();
            const message = this.translate.instant('PROPERTY_LIST.DELETE_SUCCESS', { address: property.address });
            this.message.success(message);
          },
          error: (err) => {
            // Handle error case
            console.error('Error deleting property:', err);
            if (!shouldSuppressGenericError(err)) {
              this.message.error(this.translate.instant('PROPERTY_LIST.DELETE_ERROR'));
            }
          }
        });
      }
    });
  }

  // Save new property logic
  async saveNewProperty(): Promise<void> {
    if (!(await this.ensureCaretakerContactPersonOptionsForSave(this.addPropertyForm))) {
      return;
    }

    this.markFormGroupForValidation(this.addPropertyForm);
    if (this.addPropertyForm.valid) {
      const formValue = this.addPropertyForm.value;

      const technicalServiceAssignments = this.buildTechnicalServiceAssignmentsFromFormValue(formValue);
      const selectedTechnicalServiceIds = Array.from(new Set(
        technicalServiceAssignments.map((assignment) => assignment.serviceId)
      ));
      // Map the IDs to Service objects and filter out undefined values
      const technicalServices: Service[] = selectedTechnicalServiceIds
        .map((serviceId: string) => this.technicalServicesModel.find(service => service._id === serviceId))
        .filter((service): service is Service => service !== undefined);
      const hospitalityDetailsPayload = this.extractHospitalityDetails(this.addPropertyForm) ?? null;
      // Prepare the new property object
      const newProperty: Property = {
        address: formValue.address,
        caretaker: formValue.caretaker || null, // ensure null if nothing selected
        caretakerContactPersonIds: formValue.caretaker
          ? this.reconcileCaretakerContactPersonSelectionIds(
            formValue.caretaker,
            formValue.caretakerContactPersonIds
          )
          : [],
        landingProfileId: this.multiLandingProfilesEnabled
          ? this.mapLandingProfileFormValueToPayload(formValue.landingProfileId)
          : null,
        propertyManagers: formValue.propertyManagers ? [formValue.propertyManagers].filter(Boolean) : [],
        technicalAssetsManagers: formValue.technicalAssetsManagers ? [formValue.technicalAssetsManagers].filter(Boolean) : [],
        sevManagers: formValue.sevManagers ? [formValue.sevManagers].filter(Boolean) : [],
        accountants: formValue.accountants ? [formValue.accountants].filter(Boolean) : [],
        technicalServices: technicalServices,
        technicalServiceAssignments,
        hospitalityDetails: hospitalityDetailsPayload as any,
      };

      // Call service to save the new property
      this.propertyService.createProperty(newProperty).subscribe({
        next: async (savedProperty) => {
          this.addModalVisible = false;
          this.resetCaretakerContactPersonSelectionCache('add');
          await this.fetchProperties(); // Refresh the property list
          this.progressService.notifyProgressUpdated();

          // Display success message
          const message = this.translate.instant('PROPERTY_LIST.ADD_SUCCESS', { address: formValue.address });
          this.message.success(message);

          // Reset the form if needed
          this.addPropertyForm.reset();
          this.addPropertyForm.setControl('hospitalityDetails', this.createHospitalityDetailsGroup());
        },
        error: (err) => {
          if (shouldSuppressGenericError(err)) {
            return;
          }
          // Check if the error is related to property limit
          if (err?.message === 'Property limit reached') {
            this.message.error(this.translate.instant('PROPERTY_LIST.MAX_PROPERTIES_REACHED'));
          } else if (err.message === 'Address already exists for another property') {
            this.message.error(this.translate.instant('PROPERTY_LIST.DUPLICATE_ADDRESS_ERROR'));
          } else {
            // Handle other errors
            this.message.error(this.getPropertySaveErrorMessage(err, 'PROPERTY_LIST.ADD_ERROR'));
          }
        }
      });
    } else {
      this.focusFirstInvalidStep(this.addPropertyForm, 'add');
      // Only check for specific errors on key fields
      const hostContactPhoneControl = this.addPropertyForm.get('hospitalityDetails.hostContact.phone');
      const addressControl = this.addPropertyForm.get('address');
      if (this.appMode === 'hospitality' && hostContactPhoneControl?.hasError('invalidPhone')) {
        this.message.error(this.translate.instant('HOSPITALITY_FIELDS.HOST_CONTACT_PHONE_INVALID'));
      } else if (addressControl?.hasError('required')) {
        this.message.error(this.translate.instant('PROPERTY_LIST.ADDRESS_REQUIRED'));
      } else if (addressControl?.hasError('invalidAddress')) {
        this.message.error(this.translate.instant('FORM_ERRORS.ADDRESS_ERROR'));
      } else if (this.hasManagerSelectionError(this.addPropertyForm)) {
        this.message.error(this.getManagerRequiredMessage());
      } else {
        this.message.error(this.translate.instant('PROPERTY_LIST.FORM_INVALID'));
      }
    }
  }

// Validate email format
  validateEmail(email: string): boolean {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

// Validate phone number format (simple validation for digits only)
  validatePhoneNumber(phone: string): boolean {
    return isValidGermanPhoneNumber(phone);
  }

  validateMobileNumber(mobile: string): boolean {
    return isValidGermanMobileNumber(mobile);
  }

// Upload and import properties from a filled Excel file
  async importProperties(event: any): Promise<void> {
    if (!this.savedHeaders || !this.hasAnyManagerHeaderEnabled()) {
      this.message.error(this.translate.instant('PROPERTY_LIST.MANAGER_HEADERS_REQUIRED'));
      return;
    }

    const file = event.target.files[0];
    if (file) {
      const selectedSource = this.selectedImportSource || 'scanafy';
      if (selectedSource === 'scanafy') {
        let invalidEntries: string[];
        try {
          invalidEntries = await this.validateImportFileLocally(file);
        } catch (_err) {
          this.message.error(this.translate.instant('PROPERTY_LIST.IMPORT_FAILED'));
          if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
          }
          return;
        }

        if (invalidEntries.length > 0) {
          this.modal.error({
            nzTitle: this.translate.instant('PROPERTY_LIST.IMPORT_VALIDATION_FAILED'),
            nzContent: invalidEntries.join('<br/>'),
          });
          if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
          }
          return;
        }
      }

      this.dismissedFinishedImportJobId = null;
      this.clearImportDismissTimers();
      this.isSubmittingImportJob = true;
      this.propertyImportService.createImportJob(file, selectedSource)
        .pipe(finalize(() => {
          this.isSubmittingImportJob = false;
          if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
          }
        }))
        .subscribe({
          next: (response) => {
            if (this.route.snapshot.queryParamMap.has('importJobId')) {
              void this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { importJobId: null },
                queryParamsHandling: 'merge',
                replaceUrl: true,
              });
            }
            this.startImportPolling(response.jobId, response.pollAfterMs || 1000);
          },
          error: (err) => {
            if (shouldSuppressGenericError(err)) {
              return;
            }
            this.message.error(translatePropertyImportMessage(err?.error, this.translate, 'PROPERTY_LIST.IMPORT_FAILED'));
          },
        });
    }
  }

  private validateImportFileLocally(file: File): Promise<string[]> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        try {
          const binaryStr = e.target?.result;
          const workbook = XLSX.read(binaryStr, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = this.buildImportRowsFromWorksheet(worksheet);
          const invalidEntries: string[] = [];

          jsonData.forEach((row: Record<string, any>, index: number) => {
            if (row['Caretaker Email'] && !this.validateEmail(row['Caretaker Email'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.CARETAKER_EMAIL')
              }));
            }
            if (row['Caretaker Phone'] && !this.validatePhoneNumber(row['Caretaker Phone'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.CARETAKER_PHONE')
              }));
            }
            if (row['Caretaker Mobile'] && !this.validateMobileNumber(row['Caretaker Mobile'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.CARETAKER_MOBILE')
              }));
            }

            if (row['Property Manager Email'] && !this.validateEmail(row['Property Manager Email'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.PROPERTY_MANAGER_EMAIL')
              }));
            }
            if (row['Property Manager Phone'] && !this.validatePhoneNumber(row['Property Manager Phone'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.PROPERTY_MANAGER_PHONE')
              }));
            }
            if (row['Property Manager Mobile'] && !this.validateMobileNumber(row['Property Manager Mobile'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.PROPERTY_MANAGER_MOBILE')
              }));
            }

            if (row['Technical Assets Manager Email'] && !this.validateEmail(row['Technical Assets Manager Email'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.TECHNICAL_ASSETS_MANAGER_EMAIL')
              }));
            }
            if (row['Technical Assets Manager Phone'] && !this.validatePhoneNumber(row['Technical Assets Manager Phone'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.TECHNICAL_ASSETS_MANAGER_PHONE')
              }));
            }
            if (row['Technical Assets Manager Mobile'] && !this.validateMobileNumber(row['Technical Assets Manager Mobile'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.TECHNICAL_ASSETS_MANAGER_MOBILE')
              }));
            }

            if (row['Condominium Manager Email'] && !this.validateEmail(row['Condominium Manager Email'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.CONDOMINIUM_MANAGER_EMAIL')
              }));
            }
            if (row['Condominium Manager Phone'] && !this.validatePhoneNumber(row['Condominium Manager Phone'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.CONDOMINIUM_MANAGER_PHONE')
              }));
            }
            if (row['Condominium Manager Mobile'] && !this.validateMobileNumber(row['Condominium Manager Mobile'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.CONDOMINIUM_MANAGER_MOBILE')
              }));
            }

            if (row['Accountant Email'] && !this.validateEmail(row['Accountant Email'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.ACCOUNTANT_EMAIL')
              }));
            }
            if (row['Accountant Phone'] && !this.validatePhoneNumber(row['Accountant Phone'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.ACCOUNTANT_PHONE')
              }));
            }
            if (row['Accountant Mobile'] && !this.validateMobileNumber(row['Accountant Mobile'])) {
              invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                row: index + 1,
                field: this.translate.instant('PROPERTY_LIST.ACCOUNTANT_MOBILE')
              }));
            }

            this.technicalServiceTypes.forEach(service => {
              const phoneValues = this.getImportRowValues(row, `${service} Phone`);
              phoneValues.forEach((phoneValue) => {
                if (phoneValue && !this.validatePhoneNumber(phoneValue)) {
                  invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                    row: index + 1,
                    field: `${service} ${this.translate.instant('PROPERTY_LIST.PHONE')}`
                  }));
                }
              });
              const mobileValues = this.getImportRowValues(row, `${service} Mobile`);
              mobileValues.forEach((mobileValue) => {
                if (mobileValue && !this.validateMobileNumber(mobileValue)) {
                  invalidEntries.push(this.translate.instant('PROPERTY_LIST.INVALID_ENTRY', {
                    row: index + 1,
                    field: `${service} ${this.translate.instant('PROPERTY_LIST.MOBILE')}`
                  }));
                }
              });
            });
          });

          resolve(invalidEntries);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsBinaryString(file);
    });
  }

  private buildImportRowsFromWorksheet(worksheet: XLSX.WorkSheet): Record<string, string>[] {
    const rows = XLSX.utils.sheet_to_json<(string | number | null)[]>(worksheet, {
      header: 1,
      defval: '',
      raw: false,
    });

    if (!rows.length) {
      return [];
    }

    const headers = (rows[0] || []).map((headerCell) => String(headerCell || '').trim());
    const dataRows = rows.slice(1);

    return dataRows
      .filter((row) => Array.isArray(row) && row.some((cell) => String(cell ?? '').trim().length > 0))
      .map((row) => {
        const normalizedRow: Record<string, string> = {};
        const headerOccurrences = new Map<string, number>();

        headers.forEach((header, columnIndex) => {
          if (!header) {
            return;
          }
          const rawValue = row[columnIndex];
          const value = String(rawValue ?? '').trim();
          if (!value) {
            return;
          }

          const occurrence = headerOccurrences.get(header) || 0;
          const key = occurrence === 0 ? header : `${header}__${occurrence}`;
          headerOccurrences.set(header, occurrence + 1);
          normalizedRow[key] = value;
        });

        return normalizedRow;
      });
  }

  private getImportRowValues(row: Record<string, any>, baseKey: string): string[] {
    if (!row || typeof row !== 'object') {
      return [];
    }

    return Object.keys(row)
      .filter((key) => key === baseKey || key.startsWith(`${baseKey}__`))
      .map((key) => String(row[key] ?? '').trim())
      .filter((value) => value.length > 0);
  }

  private startImportPolling(jobId: string, pollAfterMs = 1000, historical = false): void {
    this.stopImportPolling();
    this.clearImportDismissTimers();
    this.historicalImportJobId = historical ? jobId : null;
    this.historicalImportResultUnavailable = false;
    if (this.currentImportJob && this.currentImportJob.jobId !== jobId && this.isImportJobTerminal(this.currentImportJob.status)) {
      this.currentImportJob = null;
    }
    this.importPollingInterval = setInterval(() => {
      this.fetchImportJob(jobId, historical);
    }, pollAfterMs);
    this.fetchImportJob(jobId, historical);
  }

  private stopImportPolling(): void {
    if (this.importPollingInterval) {
      clearInterval(this.importPollingInterval);
      this.importPollingInterval = null;
    }
  }

  private fetchImportJob(jobId: string, historical = false): void {
    this.propertyImportService.getImportJob(jobId).subscribe({
      next: (job) => {
        if (this.dismissedFinishedImportJobId === job.jobId && this.isImportJobTerminal(job.status)) {
          return;
        }
        this.currentImportJob = job;
        if (this.isImportJobTerminal(job.status)) {
          this.stopImportPolling();
          if (!historical) {
            void this.handleTerminalImportJob(job);
          }
        }
      },
      error: (err) => {
        this.stopImportPolling();
        if (historical) {
          this.currentImportJob = null;
          this.historicalImportResultUnavailable = true;
          return;
        }
        if (shouldSuppressGenericError(err)) {
          return;
        }
      }
    });
  }

  private loadHistoricalImportResult(rawJobId: unknown): void {
    const jobId = typeof rawJobId === 'string' ? rawJobId.trim() : '';
    if (!jobId) {
      const historicalJobId = this.historicalImportJobId;
      if (historicalJobId) {
        this.stopImportPolling();
        this.historicalImportJobId = null;
        this.historicalImportResultUnavailable = false;
        if (this.currentImportJob?.jobId === historicalJobId) {
          this.currentImportJob = null;
        }
      }
      return;
    }
    if (jobId === this.historicalImportJobId) {
      return;
    }
    this.stopImportPolling();
    this.clearImportDismissTimers();
    this.historicalImportJobId = jobId;
    this.currentImportJob = null;
    this.historicalImportResultUnavailable = false;
    if (!/^[a-f\d]{24}$/i.test(jobId)) {
      this.historicalImportResultUnavailable = true;
      return;
    }
    this.startImportPolling(jobId, 1000, true);
  }

  private async handleTerminalImportJob(job: PropertyImportJobStatusResponse): Promise<void> {
    if (this.handledTerminalImportJobIds.has(job.jobId)) {
      return;
    }

    this.handledTerminalImportJobIds.add(job.jobId);
    this.clearImportDismissTimers();

    if (job.status === 'completed') {
      const completionMessage = translatePropertyImportJobMessage(job, this.translate, 'PROPERTY_IMPORT.SUCCESS_MESSAGE');
      if (job.createdCount === 0 && job.updatedCount === 0) {
        this.message.info(completionMessage);
      } else {
        this.message.success(completionMessage);
      }
      await this.fetchProperties();
      this.loadCompanyEmployeesAndServices();
      this.progressService.notifyProgressUpdated();
      this.scheduleImportSuccessAutoDismiss(job.jobId);
      return;
    }

    if (job.status === 'completed_with_errors') {
      this.message.warning(translatePropertyImportJobMessage(job, this.translate, 'PROPERTY_IMPORT.PARTIAL_MESSAGE'));
      await this.fetchProperties();
      this.loadCompanyEmployeesAndServices();
      this.progressService.notifyProgressUpdated();
      return;
    }

    this.message.error(translatePropertyImportBestFailureMessage(job, this.translate, 'PROPERTY_IMPORT.FAILED_MESSAGE'));
  }

  private resumeActiveImportJobIfPermitted(): void {
    if (!this.authService.hasPermission('company.properties.import')) {
      return;
    }
    this.resumeActiveImportJob();
  }

  private resumeActiveImportJob(): void {
    this.propertyImportService.getActiveImportJob().subscribe({
      next: (response) => {
        if (response?.job?.jobId && !this.isImportJobTerminal(response.job.status)) {
          this.startImportPolling(response.job.jobId);
        }
      },
      error: () => {
        // keep page usable even if resume lookup fails
      }
    });
  }

  private isImportJobTerminal(status: string | null | undefined): boolean {
    return status === 'completed' || status === 'completed_with_errors' || status === 'failed';
  }

  dismissCurrentImportJob(): void {
    if (!this.currentImportJob || !this.isImportJobTerminal(this.currentImportJob.status)) {
      return;
    }

    this.dismissedFinishedImportJobId = this.currentImportJob.jobId;
    this.currentImportJob = null;
    this.clearImportDismissTimers();
  }

  private scheduleImportSuccessAutoDismiss(jobId: string): void {
    this.clearImportDismissTimers();

    const totalSeconds = Math.max(1, Math.ceil(this.importSuccessAutoDismissMs / 1000));
    this.importSuccessDismissCountdownSeconds = totalSeconds;

    this.importSuccessDismissIntervalId = setInterval(() => {
      if (this.importSuccessDismissCountdownSeconds === null) {
        return;
      }

      this.importSuccessDismissCountdownSeconds = Math.max(0, this.importSuccessDismissCountdownSeconds - 1);
    }, 1000);

    this.importSuccessDismissTimeoutId = setTimeout(() => {
      if (this.currentImportJob?.jobId === jobId && this.currentImportJob.status === 'completed') {
        this.dismissCurrentImportJob();
      }
    }, this.importSuccessAutoDismissMs);
  }

  private clearImportDismissTimers(): void {
    if (this.importSuccessDismissTimeoutId) {
      clearTimeout(this.importSuccessDismissTimeoutId);
      this.importSuccessDismissTimeoutId = null;
    }

    if (this.importSuccessDismissIntervalId) {
      clearInterval(this.importSuccessDismissIntervalId);
      this.importSuccessDismissIntervalId = null;
    }

    this.importSuccessDismissCountdownSeconds = null;
  }

  getUniqueServiceNames(): string[] {
    if (!this.savedHeaders || !this.savedHeaders.technicalServiceHeaders) {
      return [];
    }

    // Convert each service key from savedHeaders to a display-friendly format
    return this.savedHeaders.technicalServiceHeaders.map(serviceKey =>
      this.formatServiceTypeHeader(serviceKey)
    );
  }

  getServiceCompanies(property: Property, serviceKey: string): Service[] {
    const normalizedKey = this.normalizeServiceTypeKey(serviceKey);
    const services = Array.isArray(property?.technicalServices) ? property.technicalServices : [];
    return services.filter((service) => {
      const primaryType = this.normalizeServiceTypeKey(service?.serviceType);
      return !!primaryType && primaryType === normalizedKey;
    });
  }

  getServicePrimaryCompany(property: Property, serviceKey: string): Service | null {
    const companies = this.getServiceCompanies(property, serviceKey);
    return companies.length ? companies[0] : null;
  }

  getServicePrimaryPhone(property: Property, serviceKey: string): string | null {
    return this.getServicePrimaryCompany(property, serviceKey)?.phone || null;
  }

  getServicePrimaryNameDisplay(property: Property, serviceKey: string): string | null {
    const companies = this.getServiceCompanies(property, serviceKey);
    if (!companies.length) {
      return null;
    }

    const firstName = companies[0]?.serviceName || null;
    if (!firstName) {
      return null;
    }

    if (companies.length === 1) {
      return firstName;
    }

    return `${firstName} ${this.translate.instant('PROPERTY_LIST.MORE_SUFFIX', { count: companies.length - 1 })}`;
  }

  getServiceTooltipText(property: Property, serviceKey: string): string {
    const companies = this.getServiceCompanies(property, serviceKey);
    if (!companies.length) {
      return 'N/A';
    }

    return companies
      .map((company) => {
        const serviceName = company?.serviceName || 'N/A';
        const formattedContact = this.getServiceTooltipContactDisplay(company);
        return `${serviceName} - ${formattedContact}`;
      })
      .join('\n');
  }

  private getServiceTooltipContactDisplay(service: Service | null | undefined): string {
    return this.formatGermanPhoneNumber(service?.phone)
      || this.formatGermanPhoneNumber(service?.mobile)
      || 'N/A';
  }

  getPropertyManagerField(property: Property, header: string): string | null {
    const key = this.managerKeyMapping?.[header];
    if (!key) {
      return null;
    }
    return this.extractEmployeeField(property.propertyManagers, key);
  }

  getTechnicalAssetsManagerField(property: Property, header: string): string | null {
    const key = this.technicalAssetsManagerKeyMapping?.[header];
    if (!key) {
      return null;
    }
    return this.extractEmployeeField(property.technicalAssetsManagers, key);
  }

  getSevManagerField(property: Property, header: string): string | null {
    const key = this.sevManagerKeyMapping?.[header];
    if (!key) {
      return null;
    }
    return this.extractEmployeeField(property.sevManagers, key);
  }

  getAccountantField(property: Property, header: string): string | null {
    const key = this.accountantKeyMapping?.[header];
    if (!key) {
      return null;
    }
    return this.extractEmployeeField(property.accountants, key);
  }

  private extractEmployeeField(
    employees: Employee[] | null | undefined,
    key: keyof Employee,
  ): string | null {
    if (!employees?.length) {
      return null;
    }
    const primary = employees[0];
    const value = primary?.[key];
    return typeof value === 'string' ? value : null;
  }

  onSearchDebounced = this.debounce(() => {
    this.onSearch();
  }, 300);

// Debounce function
  debounce(func: Function, wait: number) {
    let timeout: any;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    };
  }

  onSearch(): void {
    this.propertiesPagination.pageIndex = 1; // Reset to first page when searching
    this.schedulePropertiesTableRefresh();
  }

  clearGlobalSearch(): void {
    if (!this.searchTerms.globalTerm) {
      return;
    }

    this.searchTerms.globalTerm = '';
    this.onSearch();
  }

  hasActiveNonGlobalPropertySearchFilters(): boolean {
    return Object.entries(this.searchTerms).some(([key, value]) =>
      key !== 'globalTerm' &&
      typeof value === 'string' &&
      value.trim().length > 0
    );
  }

  clearAllPropertySearchFilters(): void {
    (Object.keys(this.searchTerms) as Array<keyof typeof this.searchTerms>).forEach((key) => {
      if (typeof this.searchTerms[key] === 'string') {
        this.searchTerms[key] = '';
      }
    });

    this.onSearch();
  }

  onPropertiesPageIndexChange(pageIndex: number): void {
    this.propertiesPagination.pageIndex = pageIndex;
    this.schedulePropertiesTableRefresh();
  }

  onPropertiesPageSizeChange(pageSize: number): void {
    this.propertiesPagination.pageSize = pageSize;
    this.propertiesPagination.pageIndex = 1; // Reset to first page when changing page size
    this.schedulePropertiesTableRefresh();
  }

  applyPropertiesPagination(): void {
    const start = (this.propertiesPagination.pageIndex - 1) * this.propertiesPagination.pageSize;
    const end = this.propertiesPagination.pageIndex * this.propertiesPagination.pageSize;

    // Only apply email search filter if searchEmail is not empty
    let filteredProperties = this.allProperties;
    // Global term search (search across multiple fields)
    if (this.searchTerms.globalTerm.trim()) {
      const globalSearchTerm = this.searchTerms.globalTerm.toLowerCase();
      const searchConfiguration = this.buildPropertyListSearchConfiguration();
      filteredProperties = filteredProperties.filter((property) =>
        this.isPropertyMatch(property, globalSearchTerm, searchConfiguration)
      );
    }

    // Search by specific fields
    if (this.searchTerms.street.trim()) {
      filteredProperties = filteredProperties.filter((property) =>
        this.splitAddress(property.address).street
          .toLowerCase()
          .includes(this.searchTerms.street.toLowerCase())
      );
    }

    if (this.searchTerms.zipcode.trim()) {
      filteredProperties = filteredProperties.filter((property) =>
        this.splitAddress(property.address).zipcode
          .toLowerCase()
          .includes(this.searchTerms.zipcode.toLowerCase())
      );
    }

    if (this.searchTerms.city.trim()) {
      filteredProperties = filteredProperties.filter((property) =>
        this.splitAddress(property.address).city
          .toLowerCase()
          .includes(this.searchTerms.city.toLowerCase())
      );
    }

    if (this.searchTerms.caretakerName.trim()) {
      filteredProperties = filteredProperties.filter((property) =>
        property.caretaker?.name
          ?.toLowerCase()
          .includes(this.searchTerms.caretakerName.toLowerCase())
      );
    }

    if (this.searchTerms.caretakerEmail.trim()) {
      filteredProperties = filteredProperties.filter((property) =>
        property.caretaker?.email
          ?.toLowerCase()
          .includes(this.searchTerms.caretakerEmail.toLowerCase())
      );
    }

    if (this.searchTerms.caretakerPhone.trim()) {
      filteredProperties = filteredProperties.filter((property) =>
        matchesPhoneSearch(property.caretaker?.phone, this.searchTerms.caretakerPhone)
      );
    }

    if (this.searchTerms.propertyManager.trim()) {
      filteredProperties = filteredProperties.filter((property) =>
        property.propertyManagers.some((manager) =>
          manager.name
            .toLowerCase()
            .includes(this.searchTerms.propertyManager.toLowerCase())
        )
      );
    }

    if (this.searchTerms.technicalAssetsManager.trim()) {
      filteredProperties = filteredProperties.filter((property) =>
        property.technicalAssetsManagers.some((tam) =>
          tam.name
            .toLowerCase()
            .includes(this.searchTerms.technicalAssetsManager.toLowerCase())
        )
      );
    }

    if (this.searchTerms.sevManager.trim()) {
      filteredProperties = filteredProperties.filter((property) =>
        (property.sevManagers || []).some((manager) =>
          manager.name
            .toLowerCase()
            .includes(this.searchTerms.sevManager.toLowerCase())
        )
      );
    }

    if (this.searchTerms.accountant.trim()) {
      filteredProperties = filteredProperties.filter((property) =>
        (property.accountants || []).some((accountant) =>
          accountant.name
            .toLowerCase()
            .includes(this.searchTerms.accountant.toLowerCase())
        )
      );
    }

    if (this.searchTerms.technicalService.trim()) {
      filteredProperties = filteredProperties.filter((property) =>
        property.technicalServices.some((service) =>
          service.serviceName
            .toLowerCase()
            .includes(this.searchTerms.technicalService.toLowerCase())
        )
      );
    }

    this.propertiesPagination.total = filteredProperties.length; // Update total count after filtering
    this.properties = filteredProperties.slice(start, end); // Apply pagination to filtered logs

    // Preload document counters for the currently visible page
    this.preloadDocumentCounts(this.properties);
  }

  private buildPropertyListSearchConfiguration(): PropertyListSearchConfiguration {
    if (this.isHospitalityMode()) {
      return { hospitalityMode: true };
    }

    const headers = this.resolvedDynamicHeaders;
    return {
      includeHausCode: this.showHausColumn,
      propertyManagerFields: this.getVisibleEmployeeSearchFields(
        headers.propertyManagerHeaders,
        this.managerKeyMapping
      ),
      technicalAssetsManagerFields: this.getVisibleEmployeeSearchFields(
        headers.technicalAssetsManagerHeaders,
        this.technicalAssetsManagerKeyMapping
      ),
      sevManagerFields: this.getVisibleEmployeeSearchFields(headers.sevManagerHeaders, this.sevManagerKeyMapping),
      accountantFields: this.getVisibleEmployeeSearchFields(headers.accountantHeaders, this.accountantKeyMapping),
      technicalServiceTypes: headers.technicalServiceHeaders || [],
    };
  }

  private getVisibleEmployeeSearchFields(
    headers: string[] | undefined,
    mapping: Record<string, keyof Employee>
  ): VisibleEmployeeSearchField[] {
    return (headers || []).reduce<VisibleEmployeeSearchField[]>((fields, header) => {
      const field = mapping[header];
      if (field === 'name' || field === 'email' || field === 'phone' || field === 'mobile') {
        fields.push(field);
      }
      return fields;
    }, []);
  }

  applyPropertiesSorting(): void {
    if (this.propertiesSort.key && this.propertiesSort.value) {
      const sortOrder = this.propertiesSort.value === 'ascend' ? 1 : -1;

      this.allProperties.sort((a, b) => {
        let aVal: string = '';
        let bVal: string = '';

        switch (this.propertiesSort.key) {
          case 'street':
            aVal = this.splitAddress(a.address).street.toLowerCase();
            bVal = this.splitAddress(b.address).street.toLowerCase();
            break;
          case 'zipcode':
            aVal = this.splitAddress(a.address).zipcode.toLowerCase();
            bVal = this.splitAddress(b.address).zipcode.toLowerCase();
            break;
          case 'city':
            aVal = this.splitAddress(a.address).city.toLowerCase();
            bVal = this.splitAddress(b.address).city.toLowerCase();
            break;
          case 'caretakerName':
            aVal = a.caretaker?.name?.toLowerCase() || '';
            bVal = b.caretaker?.name?.toLowerCase() || '';
            break;
          // Add other cases for sorting other nested properties like property managers or services
          default:
            const key = this.propertiesSort.key as keyof Property;
            if (a[key] && b[key]) {
              aVal = a[key]!.toString().toLowerCase();
              bVal = b[key]!.toString().toLowerCase();
            }
            break;
        }

        // Sorting based on the extracted values
        return aVal < bVal ? -1 * sortOrder : aVal > bVal ? 1 * sortOrder : 0;
      });
    }
  }

  onPropertiesSortChange(key: string, value: any): void {
    this.propertiesSort = { key, value };
    this.applyPropertiesSorting();
    this.schedulePropertiesTableRefresh(); // Adjust pagination after sorting
  }

  override openDetailsDrawer(property: Property): void {
    super.openDetailsDrawer(property);
    this.detailsDrawerContext = this.buildDetailsDrawerContext(property);
    this.updateDetailsDrawerTitle();
  }

  formatGermanPhoneNumber(phone?: string | null, defaultNdc?: string): string {
    if (!phone) return '';
    return this.dePhone.normalize(phone, { defaultNdc }).display;
  }

  private updateDetailsDrawerTitle(): void {
    const property = this.detailsProperty;
    if (!property) {
      this.detailsDrawerTitle = '';
      return;
    }

    const address = property.address ?? '';

    try {
      const parts = this.splitAddress(address || '');
      const street = (parts.street || '').trim();
      const city = (parts.city || '').trim();
      const title = street && city ? `${street}, ${city}` : street || city || address || '';

      this.detailsDrawerTitle = title || '';
    } catch (error) {
      this.detailsDrawerTitle = address || '';
    }
  }

  isNA(value: string | undefined | null): boolean {
    return value === null || value === undefined || value === 'N/A';
  }

  override closeDetailsDrawer(): void {
    super.closeDetailsDrawer();
    this.detailsDrawerContext = null;
    this.detailsDrawerTitle = '';
  }

  private buildDetailsDrawerContext(property?: Property | null): HospitalityDetailsDrawerContext {
    const details = property?.hospitalityDetails ?? null;
    return {
      checkInOwned: this.getCheckInEntriesForDisplay(details),
      checkInCompany: this.getCheckInCompanyEntriesForDisplay(details),
      checkOutOwned: this.getCheckOutOwnedEntriesForDisplay(details),
      checkOutCompany: this.getCheckOutCompanyEntriesForDisplay(details),
      houseRulesOwned: this.getHouseRuleEntriesForDisplay(details),
      houseRulesCompany: this.getHouseRuleCompanyEntriesForDisplay(details),
      applianceGuidesOwned: this.getApplianceGuideOwnedEntriesForDisplay(details),
      applianceGuidesCompany: this.getApplianceGuideCompanyEntriesForDisplay(details),
      additionalInfoOwned: this.getAdditionalInfoOwnedEntriesForDisplay(details),
      additionalInfoCompany: this.getAdditionalInfoCompanyEntriesForDisplay(details),
    };
  }

  get resolvedDynamicHeaders(): SavedHeaders {
    return this.dynamicHeaders || defaultSavedHeaders;
  }

  get totalWidth() {
    const headers = this.resolvedDynamicHeaders;
    const addressCols = 3 * 320;
    const pmCols = (headers.propertyManagerHeaders?.length ?? 0) * 180;
    const tamCols = (headers.technicalAssetsManagerHeaders?.length ?? 0) * 180;
    const sevCols = (headers.sevManagerHeaders?.length ?? 0) * 180;
    const accountantCols = (headers.accountantHeaders?.length ?? 0) * 180;
    const svcCols = (headers.technicalServiceHeaders?.length ?? 0) * 2 * 180;
    const actionsCol = 140;
    const hausCol = this.showHausColumn ? 100 : 0;
    return addressCols + pmCols + tamCols + sevCols + accountantCols + svcCols + actionsCol + hausCol;
  }
  get hasAnyHeadersConfigured(): boolean {
    const h = this.savedHeaders;
    if (!h) return false;
    return [
      h.addressDetails,
      h.propertyManagerHeaders,
      h.technicalAssetsManagerHeaders,
      h.sevManagerHeaders,
      h.accountantHeaders,
      h.caretakerHeaders,
      h.technicalServiceHeaders
    ].some(arr => Array.isArray(arr) && arr.length > 0);
  }

  getHospitalityLinkDocumentUploadHandler(
    form: FormGroup,
    linkGroup: AbstractControl
  ): (item: NzUploadXHRArgs) => Subscription {
    let handler = this.hospitalityLinkDocumentHandlers.get(linkGroup);
    if (!handler) {
      handler = this.hospitalityLinkDocumentUploadHandler(form, linkGroup);
      this.hospitalityLinkDocumentHandlers.set(linkGroup, handler);
    }
    return handler;
  }

  hospitalityLinkDocumentUploadHandler(form: FormGroup, linkGroup: AbstractControl): (item: NzUploadXHRArgs) => Subscription {
    return (item: NzUploadXHRArgs): Subscription => {
      const uploadFile = this.normalizeNzUploadFile(item);
      const file = uploadFile.originFileObj as File | undefined;
      if (!file) {
        item.onError?.(new Error('No file provided'), uploadFile);
        return new Subscription();
      }

      const propertyId = this.getHospitalityLinkPropertyId(form);
      if (!propertyId) {
        this.message.error(this.translate.instant('HOSPITALITY_FIELDS.DOCUMENT_SAVE_BEFORE_UPLOAD'));
        item.onError?.(new Error('Missing property id'), uploadFile);
        return new Subscription();
      }

      if (!this.validateHospitalityDocumentSize(file)) {
        item.onError?.(new Error('File too large'), uploadFile);
        return new Subscription();
      }

      if (!(linkGroup instanceof FormGroup)) {
        item.onError?.(new Error('Invalid form group'), uploadFile);
        return new Subscription();
      }

      this.setHospitalityLinkDocumentUploading(linkGroup, true);

      const subscription = this.propertyService
        .uploadHospitalityLinkDocument(propertyId, file)
        .pipe(finalize(() => this.setHospitalityLinkDocumentUploading(linkGroup, false)))
        .subscribe({
          next: (document) => {
            this.patchHospitalityLinkDocument(linkGroup, document);
            item.onSuccess?.(document, uploadFile, {} as XMLHttpRequest);
          },
          error: (error) => {
            this.message.error(this.translate.instant('HOSPITALITY_FIELDS.DOCUMENT_UPLOAD_ERROR'));
            item.onError?.(error, uploadFile);
          },
        });

      return subscription;
    };
  }

  canUploadHospitalityLinkDocument(form: FormGroup): boolean {
    return !!this.getHospitalityLinkPropertyId(form);
  }

  isHospitalityLinkDocumentUploading(linkGroup: AbstractControl): boolean {
    if (!(linkGroup instanceof FormGroup)) {
      return false;
    }
    return this.hospitalityLinkDocumentUploads.get(linkGroup) ?? false;
  }

  clearHospitalityLinkDocument(linkGroup: AbstractControl): void {
    if (!(linkGroup instanceof FormGroup)) {
      return;
    }
    this.patchHospitalityLinkDocument(linkGroup, null);
  }

  private patchHospitalityLinkDocument(linkGroup: FormGroup, document: HospitalityLinkDocument | null): void {
    const control = this.getHospitalityLinkDocumentControl(linkGroup);
    if (!control) {
      return;
    }

    control.setValue(document);
    control.markAsDirty();
    control.markAsTouched();
    control.updateValueAndValidity({ emitEvent: false });

    linkGroup.markAsDirty();
    linkGroup.markAsTouched();
    linkGroup.updateValueAndValidity({ emitEvent: false });

    const root = linkGroup.root;
    if (root instanceof FormGroup) {
      root.markAsDirty();
    }
  }

  private getHospitalityLinkDocumentControl(linkGroup: FormGroup): FormControl | null {
    const control = linkGroup.get('document');
    return control instanceof FormControl ? control : null;
  }

  private setHospitalityLinkDocumentUploading(linkGroup: FormGroup, uploading: boolean): void {
    if (uploading) {
      this.hospitalityLinkDocumentUploads.set(linkGroup, true);
    } else {
      this.hospitalityLinkDocumentUploads.delete(linkGroup);
    }
  }

  private normalizeNzUploadFile(item: NzUploadXHRArgs): NzUploadFile {
    const uploadFile = item.file as NzUploadFile | undefined;
    if (uploadFile?.uid) {
      if (!uploadFile.originFileObj && item.postFile instanceof File) {
        uploadFile.originFileObj = item.postFile;
      }
      return uploadFile;
    }

    const rawFile =
      (uploadFile?.originFileObj as File | undefined) ||
      (item.postFile instanceof File ? item.postFile : undefined) ||
      undefined;

    const normalized: NzUploadFile = {
      uid: uploadFile?.uid || `${Date.now()}`,
      name: uploadFile?.name || rawFile?.name || 'file',
      status: uploadFile?.status,
      type: uploadFile?.type || rawFile?.type,
      size: uploadFile?.size || rawFile?.size,
      originFileObj: rawFile,
    };

    item.file = normalized;
    return normalized;
  }

  private validateHospitalityDocumentSize(file: File): boolean {
    if (!file?.size) {
      return true;
    }

    const maxBytes = this.HOSPITALITY_DOCUMENT_MAX_SIZE_MB * 1024 * 1024;
    if (file.size <= maxBytes) {
      return true;
    }

    this.message.error(
      this.translate.instant('HOSPITALITY_FIELDS.DOCUMENT_TOO_LARGE', {
        maxSize: this.HOSPITALITY_DOCUMENT_MAX_SIZE_MB,
      })
    );
    return false;
  }

  private getHospitalityLinkPropertyId(form: FormGroup): string | null {
    if (form === this.editPropertyForm && this.selectedProperty?._id) {
      return this.selectedProperty._id;
    }

    const control = form.get('_id');
    const value = typeof control?.value === 'string' ? control.value.trim() : '';
    if (value) {
      return value;
    }

    if (form === this.addPropertyForm && this.selectedProperty?._id) {
      return this.selectedProperty._id;
    }

    return null;
  }
  private initEmergencyInstructionForm(): void {
    this.emergencyInstructionForm = this.fb.group({
      title: [''],
    });
    this.resetEmergencyInstructionBuilder();
  }

  private readonly BLANK_CATEGORY_KEY: EmergencyInstructionUnifiedCategoryKey = '__blank__';

  private getDefaultEmergencyInstructionCategoryKey(): EmergencyInstructionUnifiedCategoryKey {
    return this.BLANK_CATEGORY_KEY;
  }

  private createBlankEmergencyInstructionDraft(): EmergencyInstructionBuilderDraft {
    return {
      category: 'other',
      title: '',
      who: '',
      showPhoneNumber: false,
      phone: null,
      how: null,
      version: 'v2',
      scenarioKey: 'custom',
      sourceLanguage: 'de',
      selectedCategoryKey: this.BLANK_CATEGORY_KEY,
      iconKey: 'warning',
      urgency: 'important',
      summary: '',
      steps: [this.createEmergencyInstructionStep({
        iconKey: 'warning',
        urgency: 'important',
        isExpanded: true,
      })],
    };
  }

  private createEmptyEmergencyInstructionDraft(): EmergencyInstructionBuilderDraft {
    return this.createBlankEmergencyInstructionDraft();
  }

  private createEmergencyInstructionStep(seed?: Partial<EmergencyInstructionBuilderStep>): EmergencyInstructionBuilderStep {
    const actionType = seed?.action?.type || seed?.actionType || 'none';
    const normalizedAction = seed?.action ? {
      ...seed.action,
      contactRef: actionType === 'phone' || actionType === 'email'
        ? this.normalizeEmergencyInstructionContactRefForBuilder(seed.action.contactRef, actionType)
        : null,
    } : null;
    const selectedContactKey = actionType === 'phone' || actionType === 'email'
      ? this.getEmergencyInstructionContactRefKey(
        normalizedAction?.contactRef,
        actionType,
        normalizedAction?.[actionType] || null,
      )
      : null;

    return {
      id: seed?.id || `step-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      order: seed?.order ?? 0,
      title: seed?.title || '',
      description: this.normalizeEmergencyInstructionMultilineText(seed?.description),
      iconKey: seed?.iconKey || null,
      urgency: seed?.urgency || 'normal',
      action: normalizedAction,
      actionType,
      selectedContactKey: seed?.selectedContactKey ?? selectedContactKey,
      actionLabelManuallyEdited: seed?.actionLabelManuallyEdited ?? false,
      lastAutoActionLabel: seed?.lastAutoActionLabel ?? null,
      selectedDocumentOptionKey: seed?.selectedDocumentOptionKey ?? null,
      isExpanded: seed?.isExpanded ?? true,
    };
  }

  private getEmergencyInstructionTemplates(language: EmergencyInstructionSourceLanguage): EmergencyInstructionTemplate[] {
    const phoneAction = (label: string, phone: string): EmergencyInstructionAction => ({
      type: 'phone',
      label,
      phone,
    });

    const legacyTemplates = language === 'de'
      ? [
        {
          key: 'key_access' as const,
          scenarioKey: 'custom' as const,
          category: 'key_access' as const,
          title: 'Zugang / Schlüssel',
          iconKey: 'key',
          urgency: 'important' as const,
          summary: 'Hinterlege hier die Schritte für Schlüssel-, Tür- oder Zugangsprobleme.',
          steps: [
            { title: 'Zugang prüfen', description: 'Prüfen Sie zuerst, welcher Eingang, Schließzylinder oder Transponder betroffen ist.', iconKey: 'key', urgency: 'important' as const },
            { title: 'Sichere Alternative nutzen', description: 'Nutzen Sie nur freigegebene Ersatzschlüssel oder bekannte Zugangswege.', iconKey: 'unlock', urgency: 'normal' as const },
            { title: 'Ansprechperson informieren', description: 'Kontaktieren Sie Hausverwaltung, Hausmeister oder Schlüsseldienst nur über freigegebene Kontakte.', iconKey: 'phone', urgency: 'important' as const },
          ],
        },
        {
          key: 'main_shut_off' as const,
          scenarioKey: 'custom' as const,
          category: 'main_shut_off' as const,
          title: 'Hauptabsperrung / Notabschaltung',
          iconKey: 'pushpin',
          urgency: 'important' as const,
          summary: 'Zeigen Sie hier, wo wichtige Hauptventile, Sicherungen oder Abschaltungen zu finden sind.',
          steps: [
            { title: 'Ort identifizieren', description: 'Nennen Sie Gebäude, Raum und genaue Position der Hauptabsperrung.', iconKey: 'pushpin', urgency: 'important' as const },
            { title: 'Nur wenn sicher handeln', description: 'Betätigen Sie Ventile oder Schalter nur, wenn keine Gefahr für Personen besteht.', iconKey: 'warning', urgency: 'critical' as const },
            { title: 'Verantwortliche informieren', description: 'Melden Sie die Abschaltung sofort an die zuständige Ansprechperson.', iconKey: 'phone', urgency: 'important' as const },
          ],
        },
        {
          key: 'emergency_tool_supply' as const,
          scenarioKey: 'custom' as const,
          category: 'emergency_tool_supply' as const,
          title: 'Technikraum / Notfallausrüstung',
          iconKey: 'tool',
          urgency: 'important' as const,
          summary: 'Beschreiben Sie hier, wo relevante Technik, Werkzeuge oder Notfallmittel liegen.',
          steps: [
            { title: 'Raum oder Schrank benennen', description: 'Geben Sie den genauen Ort der Ausrüstung oder des Technikraums an.', iconKey: 'tool', urgency: 'important' as const },
            { title: 'Nur freigegebene Nutzung', description: 'Beschreiben Sie kurz, welche Gegenstände genutzt werden dürfen und welche nicht.', iconKey: 'info-circle', urgency: 'normal' as const },
            { title: 'Nach Nutzung melden', description: 'Informieren Sie die zuständige Stelle, wenn Material entnommen oder der Raum geöffnet wurde.', iconKey: 'phone', urgency: 'important' as const },
          ],
        },
        {
          key: 'special_building_rule' as const,
          scenarioKey: 'custom' as const,
          category: 'special_building_rule' as const,
          title: 'Wichtiger Gebäudehinweis',
          iconKey: 'info-circle',
          urgency: 'important' as const,
          summary: 'Nutzen Sie diesen Leitfaden für objektspezifische Sicherheits- oder Verhaltenshinweise.',
          steps: [
            { title: 'Hinweis klar benennen', description: 'Beschreiben Sie die Regel oder Besonderheit des Gebäudes in einem Satz.', iconKey: 'info-circle', urgency: 'important' as const },
            { title: 'Richtiges Verhalten erklären', description: 'Erklären Sie knapp, was Bewohner oder externe Personen in dieser Situation tun sollen.', iconKey: 'team', urgency: 'normal' as const },
            { title: 'Kontakt ergänzen', description: 'Hinterlegen Sie bei Bedarf eine Ansprechperson oder weiterführende Information.', iconKey: 'phone', urgency: 'normal' as const },
          ],
        },
        {
          key: 'other' as const,
          scenarioKey: 'custom' as const,
          category: 'other' as const,
          title: 'Sonstiger Hinweis',
          iconKey: 'warning',
          urgency: 'normal' as const,
          summary: 'Nutzen Sie diese Vorlage für allgemeine Hinweise ohne feste Notfallkategorie.',
          steps: [
            { title: 'Situation benennen', description: 'Beschreiben Sie kurz, worum es geht und wo der Hinweis gilt.', iconKey: 'warning', urgency: 'important' as const },
            { title: 'Empfohlene Maßnahme', description: 'Erklären Sie die wichtigste Handlung in klarer, kurzer Form.', iconKey: 'team', urgency: 'normal' as const },
            { title: 'Weitere Hilfe verlinken', description: 'Ergänzen Sie bei Bedarf Kontakt, Link oder Dokument.', iconKey: 'file', urgency: 'normal' as const },
          ],
        },
      ]
      : [
        {
          key: 'key_access' as const,
          scenarioKey: 'custom' as const,
          category: 'key_access' as const,
          title: 'Access / Keys',
          iconKey: 'key',
          urgency: 'important' as const,
          summary: 'Add the key steps for lost keys, blocked access, or entry issues.',
          steps: [
            { title: 'Identify the access point', description: 'State which entrance, lock, or access device is affected.', iconKey: 'key', urgency: 'important' as const },
            { title: 'Use approved backup access', description: 'Only use approved spare keys or known fallback access routes.', iconKey: 'unlock', urgency: 'normal' as const },
            { title: 'Inform the responsible contact', description: 'Contact building management, caretaker, or locksmith only via approved channels.', iconKey: 'phone', urgency: 'important' as const },
          ],
        },
        {
          key: 'main_shut_off' as const,
          scenarioKey: 'custom' as const,
          category: 'main_shut_off' as const,
          title: 'Main Shut-Off / Emergency Switch',
          iconKey: 'pushpin',
          urgency: 'important' as const,
          summary: 'Use this template for main valves, shut-off switches, and emergency cut-offs.',
          steps: [
            { title: 'Identify the location', description: 'Specify the building, room, and exact position of the shut-off point.', iconKey: 'pushpin', urgency: 'important' as const },
            { title: 'Operate only if safe', description: 'Only touch valves or switches if there is no direct danger to people.', iconKey: 'warning', urgency: 'critical' as const },
            { title: 'Report the action', description: 'Inform the responsible contact immediately after any shut-off action.', iconKey: 'phone', urgency: 'important' as const },
          ],
        },
        {
          key: 'emergency_tool_supply' as const,
          scenarioKey: 'custom' as const,
          category: 'emergency_tool_supply' as const,
          title: 'Utility Room / Emergency Equipment',
          iconKey: 'tool',
          urgency: 'important' as const,
          summary: 'Use this for technical rooms, emergency tools, and important building equipment.',
          steps: [
            { title: 'Name the room or cabinet', description: 'Describe exactly where the room, cabinet, or equipment is located.', iconKey: 'tool', urgency: 'important' as const },
            { title: 'Clarify approved use', description: 'Explain which items may be used and which should be left untouched.', iconKey: 'info-circle', urgency: 'normal' as const },
            { title: 'Report after use', description: 'Notify the responsible contact if equipment was used or the room was opened.', iconKey: 'phone', urgency: 'important' as const },
          ],
        },
        {
          key: 'special_building_rule' as const,
          scenarioKey: 'custom' as const,
          category: 'special_building_rule' as const,
          title: 'Important Building Rule',
          iconKey: 'info-circle',
          urgency: 'important' as const,
          summary: 'Use this template for property-specific safety rules and operational notices.',
          steps: [
            { title: 'State the rule clearly', description: 'Summarize the building-specific rule or exception in one sentence.', iconKey: 'info-circle', urgency: 'important' as const },
            { title: 'Explain the required behavior', description: 'Describe what residents or external visitors should do in this situation.', iconKey: 'team', urgency: 'normal' as const },
            { title: 'Add contact details if needed', description: 'Provide a responsible contact or follow-up information when useful.', iconKey: 'phone', urgency: 'normal' as const },
          ],
        },
        {
          key: 'other' as const,
          scenarioKey: 'custom' as const,
          category: 'other' as const,
          title: 'Other Notice',
          iconKey: 'warning',
          urgency: 'normal' as const,
          summary: 'Use this starter template for general notices that do not fit a fixed category.',
          steps: [
            { title: 'Describe the situation', description: 'State briefly what this notice is about and where it applies.', iconKey: 'warning', urgency: 'important' as const },
            { title: 'Explain the recommended action', description: 'Describe the most important action in clear and simple terms.', iconKey: 'team', urgency: 'normal' as const },
            { title: 'Add supporting info', description: 'Optionally add a contact, website, or document for follow-up.', iconKey: 'file', urgency: 'normal' as const },
          ],
        },
      ];

    const scenarioTemplates = language === 'de'
      ? [
        {
          key: 'fire_smoke' as const,
          scenarioKey: 'fire_smoke' as const,
          category: 'emergency_tool_supply' as const,
          title: 'Feuer / Rauch',
          iconKey: 'fire',
          urgency: 'critical' as const,
          summary: 'Bleiben Sie ruhig und verlassen Sie den betroffenen Bereich sofort.',
          steps: [
            { title: 'Gefahrenbereich verlassen', description: 'Verlassen Sie Wohnung, Flur oder Treppenhaus sofort, wenn sich Rauch ausbreitet.', iconKey: 'environment', urgency: 'critical' as const },
            { title: 'Türen schließen', description: 'Schließen Sie nach Möglichkeit Türen, um die Ausbreitung von Rauch zu verlangsamen.', iconKey: 'home', urgency: 'important' as const },
            { title: 'Notruf wählen', description: `Alarmieren Sie die Feuerwehr.
Wer meldet?
Was ist passiert?
Wie viele sind betroffen/verletzt?
Wo ist es passiert?
Warten auf Rückfragen!`, iconKey: 'phone', urgency: 'critical' as const, action: phoneAction('112 anrufen', '112') },
            { title: 'Auf weitere Hinweise warten', description: 'Nutzen Sie keinen Aufzug und kehren Sie nicht in das Gebäude zurück, bis es freigegeben ist.', iconKey: 'notification', urgency: 'important' as const },
          ],
        },
        {
          key: 'water_damage' as const,
          scenarioKey: 'water_damage' as const,
          category: 'main_shut_off' as const,
          title: 'Wasserschaden / Überflutung',
          iconKey: 'tool',
          urgency: 'important' as const,
          summary: 'Begrenzen Sie den Schaden schnell und vermeiden Sie elektrische Gefahren.',
          steps: [
            { title: 'Wasserquelle sichern', description: 'Schließen Sie erreichbare Hähne oder Ventile, wenn dies gefahrlos möglich ist.', iconKey: 'tool', urgency: 'important' as const },
            { title: 'Strom fernhalten', description: 'Berühren Sie keine elektrischen Geräte im nassen Bereich.', iconKey: 'thunderbolt', urgency: 'critical' as const },
            { title: 'Schaden dokumentieren', description: 'Machen Sie kurze Fotos vom betroffenen Bereich und sichern Sie loses Inventar.', iconKey: 'file', urgency: 'normal' as const },
            { title: 'Verantwortliche informieren', description: 'Kontaktieren Sie die zuständige Ansprechperson oder den Notdienst.', iconKey: 'phone', urgency: 'important' as const },
          ],
        },
        {
          key: 'flooding' as const,
          scenarioKey: 'flooding' as const,
          category: 'main_shut_off' as const,
          title: 'Überflutung / Hochwasser',
          iconKey: 'environment',
          urgency: 'critical' as const,
          summary: 'Bringen Sie sich in Sicherheit und meiden Sie überflutete Bereiche sowie elektrische Gefahren.',
          steps: [
            { title: 'Gefahrenbereich verlassen', description: 'Verlassen Sie überflutete Keller, Tiefgaragen oder Außenbereiche sofort.', iconKey: 'environment', urgency: 'critical' as const },
            { title: 'Kein Wasser betreten', description: 'Gehen Sie nicht in unbekannt tiefes Wasser und meiden Sie Strömungen.', iconKey: 'alert', urgency: 'critical' as const },
            { title: 'Strom fernhalten', description: 'Halten Sie Abstand zu elektrischen Anlagen, Verteilern und Geräten.', iconKey: 'thunderbolt', urgency: 'critical' as const },
            { title: 'Notruf oder Gebäudekontakt nutzen', description: 'Melden Sie die Lage, wenn Personen gefährdet sind oder wichtige Bereiche betroffen sind.', iconKey: 'phone', urgency: 'important' as const, action: phoneAction('112 anrufen', '112') },
          ],
        },
        {
          key: 'power_outage' as const,
          scenarioKey: 'power_outage' as const,
          category: 'main_shut_off' as const,
          title: 'Stromausfall',
          iconKey: 'thunderbolt',
          urgency: 'important' as const,
          summary: 'Prüfen Sie zuerst, ob nur die Wohnung oder das ganze Gebäude betroffen ist.',
          steps: [
            { title: 'Sicherung prüfen', description: 'Kontrollieren Sie den Sicherungskasten nur, wenn keine Gefahr durch Wasser oder Rauch besteht.', iconKey: 'tool', urgency: 'important' as const },
            { title: 'Elektrische Geräte ausschalten', description: 'Schalten Sie Herd, Wasserkocher und empfindliche Geräte vorsorglich aus.', iconKey: 'alert', urgency: 'important' as const },
            { title: 'Gemeinschaftsflächen beachten', description: 'Nutzen Sie Taschenlampe statt Kerzen und helfen Sie gefährdeten Personen im Haus.', iconKey: 'team', urgency: 'normal' as const },
            { title: 'Störungsdienst kontaktieren', description: 'Melden Sie den Ausfall, wenn das Problem anhält oder mehrere Bereiche betroffen sind.', iconKey: 'phone', urgency: 'important' as const },
          ],
        },
        {
          key: 'gas_smell' as const,
          scenarioKey: 'gas_smell' as const,
          category: 'main_shut_off' as const,
          title: 'Gasgeruch / Gefahrstoff',
          iconKey: 'alert',
          urgency: 'critical' as const,
          summary: 'Vermeiden Sie Funken, lüften Sie und verlassen Sie bei starkem Geruch den Bereich.',
          steps: [
            { title: 'Nicht schalten oder zünden', description: 'Benutzen Sie keine Lichtschalter, Feuerzeuge oder elektrischen Geräte.', iconKey: 'alert', urgency: 'critical' as const },
            { title: 'Fenster öffnen', description: 'Lüften Sie den Bereich sofort, ohne weitere Zündquellen zu nutzen.', iconKey: 'environment', urgency: 'critical' as const },
            { title: 'Andere warnen', description: 'Informieren Sie Personen im Gebäude ruhig und verlassen Sie den Bereich gemeinsam.', iconKey: 'team', urgency: 'important' as const },
            { title: 'Notruf / Gasnotdienst', description: 'Rufen Sie den Notdienst von außerhalb des Gebäudes an.', iconKey: 'phone', urgency: 'critical' as const, action: phoneAction('112 anrufen', '112') },
          ],
        },
        {
          key: 'evacuation' as const,
          scenarioKey: 'evacuation' as const,
          category: 'special_building_rule' as const,
          title: 'Evakuierung',
          iconKey: 'notification',
          urgency: 'critical' as const,
          summary: 'Verlassen Sie das Gebäude geordnet und ohne Aufzug.',
          steps: [
            { title: 'Ruhe bewahren', description: 'Nehmen Sie nur das Nötigste mit und verlassen Sie die Einheit sofort.', iconKey: 'warning', urgency: 'important' as const },
            { title: 'Treppenhaus nutzen', description: 'Nutzen Sie niemals den Aufzug.', iconKey: 'environment', urgency: 'critical' as const },
            { title: 'Sammelpunkt aufsuchen', description: 'Gehen Sie zum bekannten Sammelpunkt und halten Sie Zufahrten frei.', iconKey: 'team', urgency: 'important' as const },
            { title: 'Anweisungen folgen', description: 'Warten Sie auf Feuerwehr, Polizei oder Hausverantwortliche.', iconKey: 'safety', urgency: 'important' as const },
          ],
        },
        {
          key: 'general_emergency' as const,
          scenarioKey: 'general_emergency' as const,
          category: 'special_building_rule' as const,
          title: 'Allgemeiner Notfall / 112',
          iconKey: 'phone',
          urgency: 'critical' as const,
          summary: 'Nutzen Sie diesen Leitfaden für akute Gefahrenlagen im oder am Gebäude.',
          steps: [
            { title: 'Lage einschätzen', description: 'Prüfen Sie kurz, ob unmittelbare Gefahr für Personen besteht.', iconKey: 'warning', urgency: 'critical' as const },
            { title: 'Menschen schützen', description: 'Bringen Sie sich und andere aus dem Gefahrenbereich.', iconKey: 'team', urgency: 'critical' as const },
            { title: 'Notruf absetzen', description: `Alarmieren Sie den Notruf/Feuerwehr.
Wer meldet?
Was ist passiert?
Wie viele sind betroffen/verletzt?
Wo ist es passiert?
Warten auf Rückfragen!`, iconKey: 'phone', urgency: 'critical' as const, action: phoneAction('112 anrufen', '112') },
            { title: 'Vor Ort bleiben', description: 'Bleiben Sie erreichbar und warten Sie auf Einsatzkräfte, sofern es sicher ist.', iconKey: 'notification', urgency: 'important' as const },
          ],
        },
      ]
      : [
        {
          key: 'fire_smoke' as const,
          scenarioKey: 'fire_smoke' as const,
          category: 'emergency_tool_supply' as const,
          title: 'Fire / Smoke',
          iconKey: 'fire',
          urgency: 'critical' as const,
          summary: 'Stay calm and leave the affected area immediately.',
          steps: [
            { title: 'Leave the danger area', description: 'Exit the apartment, corridor, or stairwell immediately if smoke is spreading.', iconKey: 'environment', urgency: 'critical' as const },
            { title: 'Close doors behind you', description: 'If possible, close doors to slow down smoke spread.', iconKey: 'home', urgency: 'important' as const },
            { title: 'Call emergency services', description: 'Call the fire brigade and share the address, floor, and visible hazards.', iconKey: 'phone', urgency: 'critical' as const, action: phoneAction('Call 112', '112') },
            { title: 'Wait for clearance', description: 'Do not use elevators and do not return until the building is released.', iconKey: 'notification', urgency: 'important' as const },
          ],
        },
        {
          key: 'water_damage' as const,
          scenarioKey: 'water_damage' as const,
          category: 'main_shut_off' as const,
          title: 'Water Damage / Flooding',
          iconKey: 'tool',
          urgency: 'important' as const,
          summary: 'Limit the damage quickly and avoid electrical hazards.',
          steps: [
            { title: 'Stop the water source', description: 'Close reachable taps or valves if this is safe to do.', iconKey: 'tool', urgency: 'important' as const },
            { title: 'Avoid electricity', description: 'Do not touch electrical devices in wet areas.', iconKey: 'thunderbolt', urgency: 'critical' as const },
            { title: 'Document the damage', description: 'Take a few photos and move loose belongings out of the affected area.', iconKey: 'file', urgency: 'normal' as const },
            { title: 'Contact the responsible party', description: 'Inform the caretaker, property manager, or emergency contractor.', iconKey: 'phone', urgency: 'important' as const },
          ],
        },
        {
          key: 'flooding' as const,
          scenarioKey: 'flooding' as const,
          category: 'main_shut_off' as const,
          title: 'Flooding / High Water',
          iconKey: 'environment',
          urgency: 'critical' as const,
          summary: 'Move to safety immediately and avoid flooded areas, basements, and electrical risks.',
          steps: [
            { title: 'Leave the danger area', description: 'Exit flooded basements, garages, and outdoor danger zones immediately.', iconKey: 'environment', urgency: 'critical' as const },
            { title: 'Do not enter the water', description: 'Avoid water of unknown depth and keep away from moving water.', iconKey: 'alert', urgency: 'critical' as const },
            { title: 'Stay away from electricity', description: 'Keep distance from electrical panels, devices, and technical installations.', iconKey: 'thunderbolt', urgency: 'critical' as const },
            { title: 'Call emergency help if needed', description: 'Report the situation if people are at risk or critical parts of the property are affected.', iconKey: 'phone', urgency: 'important' as const, action: phoneAction('Call 112', '112') },
          ],
        },
        {
          key: 'power_outage' as const,
          scenarioKey: 'power_outage' as const,
          category: 'main_shut_off' as const,
          title: 'Power Outage',
          iconKey: 'thunderbolt',
          urgency: 'important' as const,
          summary: 'Check first whether only the unit or the whole building is affected.',
          steps: [
            { title: 'Check the fuse box', description: 'Only inspect the fuse box if there is no water, smoke, or other hazard.', iconKey: 'tool', urgency: 'important' as const },
            { title: 'Turn devices off', description: 'Switch off stoves, kettles, and sensitive devices as a precaution.', iconKey: 'alert', urgency: 'important' as const },
            { title: 'Use safe lighting', description: 'Use a flashlight instead of candles and support vulnerable neighbors if needed.', iconKey: 'team', urgency: 'normal' as const },
            { title: 'Report a longer outage', description: 'Contact the service provider if the outage continues or affects multiple areas.', iconKey: 'phone', urgency: 'important' as const },
          ],
        },
        {
          key: 'gas_smell' as const,
          scenarioKey: 'gas_smell' as const,
          category: 'main_shut_off' as const,
          title: 'Gas Smell / Hazard',
          iconKey: 'alert',
          urgency: 'critical' as const,
          summary: 'Avoid sparks, ventilate the area, and leave if the smell is strong.',
          steps: [
            { title: 'Do not switch or ignite anything', description: 'Do not use light switches, lighters, or electrical devices.', iconKey: 'alert', urgency: 'critical' as const },
            { title: 'Open windows', description: 'Ventilate the area immediately without creating new ignition sources.', iconKey: 'environment', urgency: 'critical' as const },
            { title: 'Warn others', description: 'Calmly inform people nearby and leave the area together.', iconKey: 'team', urgency: 'important' as const },
            { title: 'Call from outside', description: 'Contact emergency services or the gas emergency service from outside the building.', iconKey: 'phone', urgency: 'critical' as const, action: phoneAction('Call 112', '112') },
          ],
        },
        {
          key: 'evacuation' as const,
          scenarioKey: 'evacuation' as const,
          category: 'special_building_rule' as const,
          title: 'Evacuation',
          iconKey: 'notification',
          urgency: 'critical' as const,
          summary: 'Leave the building in an orderly way and never use elevators.',
          steps: [
            { title: 'Stay calm', description: 'Take only essentials and leave the unit immediately.', iconKey: 'warning', urgency: 'important' as const },
            { title: 'Use the stairs', description: 'Do not use elevators under any circumstances.', iconKey: 'environment', urgency: 'critical' as const },
            { title: 'Move to the assembly point', description: 'Go to the known assembly point and keep access routes clear.', iconKey: 'team', urgency: 'important' as const },
            { title: 'Follow official instructions', description: 'Wait for fire brigade, police, or building management directions.', iconKey: 'safety', urgency: 'important' as const },
          ],
        },
        {
          key: 'general_emergency' as const,
          scenarioKey: 'general_emergency' as const,
          category: 'special_building_rule' as const,
          title: 'General Emergency / Call 112',
          iconKey: 'phone',
          urgency: 'critical' as const,
          summary: 'Use this guide for urgent incidents in or around the building.',
          steps: [
            { title: 'Assess the situation', description: 'Check briefly whether there is immediate danger to people.', iconKey: 'warning', urgency: 'critical' as const },
            { title: 'Protect people first', description: 'Move yourself and others out of danger.', iconKey: 'team', urgency: 'critical' as const },
            { title: 'Call emergency services', description: 'Share the address, floor, situation, and your callback number.', iconKey: 'phone', urgency: 'critical' as const, action: phoneAction('Call 112', '112') },
            { title: 'Stay reachable', description: 'Remain available and wait for responders if it is safe.', iconKey: 'notification', urgency: 'important' as const },
          ],
        },
      ];

    return [...legacyTemplates, ...scenarioTemplates];
  }

  private buildEmergencyInstructionTemplateDraft(
    categoryKey: EmergencyInstructionUnifiedCategoryKey,
    sourceLanguage: EmergencyInstructionSourceLanguage = 'de',
  ): EmergencyInstructionBuilderDraft {
    const template = this.getEmergencyInstructionTemplates(sourceLanguage)
      .find((entry) => entry.key === categoryKey)
      || this.getEmergencyInstructionTemplates(sourceLanguage)
        .find((entry) => entry.key === 'other')!;

    return {
      category: template.category,
      title: template.title,
      who: template.summary,
      showPhoneNumber: Boolean(template.steps.some((step) => step.action?.type === 'phone' && step.action.phone)),
      phone: template.steps.find((step) => step.action?.type === 'phone' && step.action.phone)?.action?.phone || null,
      how: template.steps[0]?.description || null,
      version: 'v2',
      scenarioKey: template.scenarioKey,
      sourceLanguage: 'de',
      selectedCategoryKey: template.key,
      iconKey: template.iconKey,
      urgency: template.urgency,
      summary: template.summary,
      steps: template.steps.map((step, index) => this.createEmergencyInstructionStep({
        id: `template-${template.key}-${index + 1}`,
        order: index,
        title: step.title,
        description: step.description,
        iconKey: step.iconKey || null,
        urgency: step.urgency || 'normal',
        action: step.action ? { ...step.action } : null,
        actionType: step.action?.type || 'none',
        lastAutoActionLabel: step.action?.label || null,
        isExpanded: index === 0,
      })),
    };
  }

  private buildEmergencyInstructionScratchDraft(
    categoryKey: EmergencyInstructionUnifiedCategoryKey = this.emergencyInstructionBuilder?.selectedCategoryKey || 'other',
  ): EmergencyInstructionBuilderDraft {
    const base = this.createEmptyEmergencyInstructionDraft();
    const option = this.emergencyInstructionUnifiedCategoryOptions.find((entry) => entry.key === categoryKey);
    const nextCategoryKey = option?.key || 'other';
    const isLegacyCategory = option?.kind === 'legacy';

    return {
      ...base,
      category: isLegacyCategory ? nextCategoryKey as EmergencyInstructionCategory : 'other',
      scenarioKey: isLegacyCategory ? 'custom' : nextCategoryKey as EmergencyInstructionScenarioKey,
      selectedCategoryKey: nextCategoryKey,
      iconKey: option?.iconKey || 'warning',
      urgency: 'important',
      summary: '',
      title: '',
      who: '',
      how: null,
      phone: null,
      showPhoneNumber: false,
      steps: [this.createEmergencyInstructionStep({
        title: '',
        description: '',
        iconKey: option?.iconKey || 'warning',
        urgency: 'important',
        isExpanded: true,
      })],
    };
  }

  private showEmergencyInstructionTemplateHint(): void {
    this.emergencyInstructionTemplateHintVisible = true;
    if (this.emergencyInstructionTemplateHintTimeout) {
      clearTimeout(this.emergencyInstructionTemplateHintTimeout);
    }
    this.emergencyInstructionTemplateHintTimeout = setTimeout(() => {
      this.emergencyInstructionTemplateHintVisible = false;
      this.emergencyInstructionTemplateHintTimeout = null;
    }, 2600);
  }

  private normalizeEmergencyInstructionForBuilder(instruction?: EmergencyInstruction | null): EmergencyInstructionBuilderDraft {
    if (!instruction) {
      return this.createBlankEmergencyInstructionDraft();
    }

    const sourceLanguage: EmergencyInstructionSourceLanguage = instruction.sourceLanguage || 'de';
    const isV2 = Array.isArray(instruction.steps) && instruction.steps.length > 0;
    const selectedCategoryKey = this.getEmergencyInstructionSelectedCategoryKey(instruction);

    if (isV2) {
      return {
        category: instruction.category || 'other',
        title: instruction.title || '',
        who: instruction.who || instruction.summary || '',
        showPhoneNumber: Boolean(instruction.showPhoneNumber),
        phone: instruction.phone || null,
        how: instruction.how || null,
        version: 'v2',
        scenarioKey: instruction.scenarioKey || 'custom',
        sourceLanguage,
        selectedCategoryKey,
        iconKey: instruction.iconKey || this.emergencyInstructionCategoryIconType(instruction.category || 'other'),
        urgency: instruction.urgency || 'normal',
        summary: instruction.summary || instruction.who || '',
        steps: (instruction.steps || []).slice().sort((a, b) => (a.order || 0) - (b.order || 0)).map((step, index) =>
          this.createEmergencyInstructionStep({
            ...step,
            order: index,
            description: step.description || '',
            urgency: step.urgency || 'normal',
            action: step.action ? { ...step.action } : null,
            actionType: step.action?.type || 'none',
            actionLabelManuallyEdited: false,
            lastAutoActionLabel: step.action?.label || null,
            selectedDocumentOptionKey: null,
            isExpanded: index === 0,
          })
        ),
      };
    }

    const legacyStepAction = instruction.showPhoneNumber && instruction.phone
      ? { type: 'phone' as const, label: sourceLanguage === 'de' ? 'Anrufen' : 'Call', phone: instruction.phone }
      : null;

    return {
      category: instruction.category || 'other',
      title: instruction.title || '',
      who: instruction.who || '',
      showPhoneNumber: Boolean(instruction.showPhoneNumber),
      phone: instruction.phone || null,
      how: instruction.how || null,
      version: 'v2',
      scenarioKey: 'custom',
      sourceLanguage,
      selectedCategoryKey,
      iconKey: this.getEmergencyInstructionDefaultIconKey(instruction.category || 'other'),
      urgency: 'important',
      summary: instruction.who || '',
      steps: [
        this.createEmergencyInstructionStep({
          id: instruction._id ? `${instruction._id}-legacy` : undefined,
          title: instruction.title || '',
          description: instruction.how || '',
          iconKey: this.getEmergencyInstructionDefaultIconKey(instruction.category || 'other'),
          urgency: instruction.showPhoneNumber ? 'important' : 'normal',
          action: legacyStepAction,
          actionType: legacyStepAction?.type || 'none',
          lastAutoActionLabel: legacyStepAction?.label || null,
          isExpanded: true,
        }),
      ],
    };
  }

  private resetEmergencyInstructionBuilder(instruction?: EmergencyInstruction | null): void {
    this.emergencyInstructionSaveAttempted = false;
    this.emergencyInstructionSaveMessages = [];
    this.emergencyInstructionBuilder = this.normalizeEmergencyInstructionForBuilder(instruction);
    this.refreshEmergencyInstructionDocumentOptions();
    this.maybeReconcileEmergencyInstructionSelectedContactKeys();
  }

  private getEmergencyInstructionDefaultIconKey(category: EmergencyInstructionCategory): string {
    const match = this.emergencyInstructionCategories.find((item) => item.value === category);
    return match?.iconType || 'warning';
  }

  getEmergencyInstructionSelectedCategoryKey(instruction: EmergencyInstruction): EmergencyInstructionUnifiedCategoryKey {
    const scenarioKey = instruction.scenarioKey;
    if (scenarioKey && scenarioKey !== 'custom' && this.emergencyInstructionUnifiedCategoryOptions.some((option) => option.key === scenarioKey)) {
      return scenarioKey;
    }

    const category = instruction.category || 'other';
    if (this.emergencyInstructionUnifiedCategoryOptions.some((option) => option.key === category)) {
      return category;
    }

    return 'other';
  }

  isEmergencyInstructionV2(instruction: EmergencyInstruction): boolean {
    return Array.isArray(instruction?.steps) && instruction.steps.length > 0;
  }

  emergencyInstructionIconTypeForInstruction(instruction: EmergencyInstruction | null | undefined): string {
    const categoryKey = instruction ? this.getEmergencyInstructionSelectedCategoryKey(instruction) : 'other';
    const categoryIconKey = this.emergencyInstructionUnifiedCategoryOptions.find((option) => option.key === categoryKey)?.iconKey;
    return this.resolveEmergencyInstructionIconType(categoryIconKey || instruction?.iconKey || 'warning');
  }

  resolveEmergencyInstructionIconType(iconKey?: string | null): string {
    if (!iconKey) return 'warning';
    return this.emergencyInstructionIconTypeByKey[iconKey] || iconKey;
  }

  emergencyInstructionUrgencyTagColor(urgency?: EmergencyInstructionUrgency | null): string {
    switch (urgency) {
      case 'critical':
        return 'red';
      case 'important':
        return 'orange';
      default:
        return 'blue';
    }
  }

  emergencyInstructionUrgencyLabelKey(urgency?: EmergencyInstructionUrgency | null): string {
    switch (urgency) {
      case 'critical':
        return 'PROPERTY_INSTRUCTIONS.URGENCY.CRITICAL';
      case 'important':
        return 'PROPERTY_INSTRUCTIONS.URGENCY.IMPORTANT';
      default:
        return 'PROPERTY_INSTRUCTIONS.URGENCY.NORMAL';
    }
  }

  emergencyInstructionUnifiedCategoryLabelKey(categoryKey?: EmergencyInstructionUnifiedCategoryKey | null): string {
    const match = this.emergencyInstructionUnifiedCategoryOptions.find((option) => option.key === categoryKey);
    return match?.labelKey || 'PROPERTY_INSTRUCTIONS.CATEGORY.OTHER';
  }

  applyEmergencyInstructionCategoryPreset(categoryKey: EmergencyInstructionUnifiedCategoryKey): void {
    if (categoryKey === this.BLANK_CATEGORY_KEY) return;
    this.modal.confirm({
      nzTitle: this.translate.instant('PROPERTY_INSTRUCTIONS.APPLY_TEMPLATE_CONFIRM_TITLE'),
      nzContent: this.translate.instant('PROPERTY_INSTRUCTIONS.APPLY_TEMPLATE_CONFIRM_CONTENT'),
      nzOkText: this.translate.instant('PROPERTY_INSTRUCTIONS.APPLY_TEMPLATE_CONFIRM_OK'),
      nzCancelText: this.translate.instant('PROPERTY_INSTRUCTIONS.APPLY_TEMPLATE_CONFIRM_CANCEL'),
      nzOnOk: () => {
        const nextDraft = this.buildEmergencyInstructionTemplateDraft(categoryKey, 'de');
        this.resetEmergencyInstructionBuilder(nextDraft);
        this.emergencyInstructionBuilder.selectedCategoryKey = categoryKey;
        this.emergencyInstructionTemplateHintVisible = false;
      },
    });
  }

  startEmergencyInstructionFromScratch(): void {
    this.modal.confirm({
      nzTitle: this.translate.instant('PROPERTY_INSTRUCTIONS.APPLY_TEMPLATE_CONFIRM_TITLE'),
      nzContent: this.translate.instant('PROPERTY_INSTRUCTIONS.SCRATCH_CONFIRM_CONTENT'),
      nzOkText: this.translate.instant('PROPERTY_INSTRUCTIONS.SCRATCH_CONFIRM_OK'),
      nzCancelText: this.translate.instant('PROPERTY_INSTRUCTIONS.APPLY_TEMPLATE_CONFIRM_CANCEL'),
      nzOnOk: () => {
        this.resetEmergencyInstructionBuilder(this.createBlankEmergencyInstructionDraft());
        this.emergencyInstructionTemplateHintVisible = false;
      },
    });
  }

  onEmergencyInstructionCategoryChange(categoryKey: EmergencyInstructionUnifiedCategoryKey): void {
    if (categoryKey === this.BLANK_CATEGORY_KEY) return;
    this.emergencyInstructionBuilder.selectedCategoryKey = categoryKey;
    this.showEmergencyInstructionTemplateHint();
    const option = this.emergencyInstructionUnifiedCategoryOptions.find((entry) => entry.key === categoryKey);
    if (!option) {
      return;
    }

    if (option.kind === 'legacy') {
      this.emergencyInstructionBuilder.category = categoryKey as EmergencyInstructionCategory;
      this.emergencyInstructionBuilder.scenarioKey = 'custom';
    } else {
      this.emergencyInstructionBuilder.category = 'other';
      this.emergencyInstructionBuilder.scenarioKey = categoryKey as EmergencyInstructionScenarioKey;
    }

    if (!this.emergencyInstructionBuilder.iconKey || this.emergencyInstructionBuilder.iconKey === 'warning') {
      this.emergencyInstructionBuilder.iconKey = option.iconKey;
    }
  }

  addEmergencyInstructionStep(): void {
    const nextSteps = [...(this.emergencyInstructionBuilder.steps || [])];
    nextSteps.push(this.createEmergencyInstructionStep({
      order: nextSteps.length,
      iconKey: this.emergencyInstructionBuilder.iconKey || 'warning',
      urgency: 'normal',
      isExpanded: true,
    }));
    this.emergencyInstructionBuilder.steps = nextSteps.map((step, index) => ({ ...step, order: index }));
  }

  duplicateEmergencyInstructionStep(index: number): void {
    const current = this.emergencyInstructionBuilder.steps?.[index];
    if (!current) return;
    const nextSteps = [...(this.emergencyInstructionBuilder.steps || [])];
    nextSteps.splice(index + 1, 0, this.createEmergencyInstructionStep({
      ...current,
      id: undefined,
      title: current.title ? `${current.title} Copy` : '',
      action: current.action ? { ...current.action } : null,
      actionType: current.actionType,
      isExpanded: true,
    }));
    this.emergencyInstructionBuilder.steps = nextSteps.map((step, stepIndex) => ({ ...step, order: stepIndex }));
  }

  removeEmergencyInstructionStep(index: number): void {
    const nextSteps = [...(this.emergencyInstructionBuilder.steps || [])];
    if (nextSteps.length <= 1) {
      this.message.warning(this.translate.instant('PROPERTY_INSTRUCTIONS.STEP_MINIMUM'));
      return;
    }
    nextSteps.splice(index, 1);
    this.emergencyInstructionBuilder.steps = nextSteps.map((step, stepIndex) => ({ ...step, order: stepIndex }));
  }

  toggleEmergencyInstructionStep(index: number): void {
    const step = this.emergencyInstructionBuilder.steps?.[index];
    if (!step) return;
    step.isExpanded = !step.isExpanded;
  }

  private normalizeEmergencyInstructionUrlInput(value?: string | null): string | null {
    const trimmed = typeof value === 'string' ? value.trim() : '';
    if (!trimmed) {
      return null;
    }
    if (/^https?:\/\//i.test(trimmed)) {
      return trimmed;
    }
    if (/^[^\s]+\.[^\s]{2,}(\/.*)?$/i.test(trimmed)) {
      return `https://${trimmed}`;
    }
    return trimmed;
  }

  normalizeEmergencyInstructionLinkField(step: EmergencyInstructionBuilderStep): void {
    if (step.actionType !== 'link' || !step.action) {
      return;
    }
    step.action.url = this.normalizeEmergencyInstructionUrlInput(step.action.url);
  }

  isEmergencyInstructionLinkInvalid(value?: string | null): boolean {
    const normalized = this.normalizeEmergencyInstructionUrlInput(value);
    if (!normalized) {
      return false;
    }
    return !/^https?:\/\/[^\s/$.?#].[^\s]*$/i.test(normalized);
  }

  getEmergencyInstructionFieldLength(value?: string | null): number {
    return (value || '').length;
  }

  isEmergencyInstructionFieldTooLong(value: string | null | undefined, max: number): boolean {
    return this.getEmergencyInstructionFieldLength(value) > max;
  }

  getEmergencyInstructionFieldMessages(
    value: string | null | undefined,
    options: { max: number; required?: boolean; requiredKey?: string; invalidKey?: string; invalid?: boolean }
  ): string[] {
    const messages: string[] = [];
    const normalized = (value || '').trim();
    if (options.required && !normalized) {
      messages.push(this.translate.instant(options.requiredKey || 'validation.emergencyInstructions.title.required'));
    }
    if (options.invalid && options.invalidKey) {
      messages.push(this.translate.instant(options.invalidKey));
    }
    if (this.isEmergencyInstructionFieldTooLong(value, options.max)) {
      messages.push(this.translate.instant('validation.emergencyInstructions.common.maxlength', { max: options.max }));
    }
    return messages;
  }

  private normalizeEmergencyInstructionContactSnapshotValue(
    field: 'phone' | 'mobile' | 'email',
    value: string | null | undefined,
  ): string {
    const normalized = (value || '').trim();
    return field === 'email' ? normalized.toLowerCase() : normalized;
  }

  private normalizeEmergencyInstructionContactKeyPart(value: string | null | undefined): string {
    return (value || '').trim().toLowerCase();
  }

  private getEmergencyInstructionContactSourceId(
    entity: { _id?: unknown; id?: unknown; serviceId?: unknown; sourceId?: unknown; toString?: () => string } | string | null | undefined
  ): string | null {
    if (typeof entity === 'string') {
      const normalized = entity.trim();
      return normalized || null;
    }
    const candidates = [entity?._id, entity?.id, entity?.serviceId, entity?.sourceId];
    for (const candidate of candidates) {
      const normalized = String(candidate || '').trim();
      if (normalized) {
        return normalized;
      }
    }
    if (entity && typeof entity === 'object' && typeof entity.toString === 'function') {
      const normalized = String(entity.toString() || '').trim();
      if (normalized && normalized !== '[object Object]') {
        return normalized;
      }
    }
    return null;
  }

  private resolveEmergencyInstructionAssignedEmployeeReferences(
    candidates: unknown,
    lookupList: Employee[] = [],
  ): Employee[] {
    const normalizedCandidates = Array.isArray(candidates)
      ? candidates
      : (typeof candidates === 'undefined' || candidates === null ? [] : [candidates]);
    const resolvedEmployees: Employee[] = [];
    const seen = new Set<string>();

    const pushResolved = (employee: Employee | null | undefined): void => {
      if (!employee) {
        return;
      }
      const employeeId = this.getEmergencyInstructionContactSourceId(employee)
        || `${(employee.name || '').trim().toLowerCase()}::${(employee.email || '').trim().toLowerCase()}`;
      if (!employeeId || seen.has(employeeId)) {
        return;
      }
      seen.add(employeeId);
      resolvedEmployees.push(employee);
    };

    normalizedCandidates.forEach((candidate) => {
      if (!candidate) {
        return;
      }

      if (typeof candidate === 'string') {
        const lookupMatch = lookupList.find((employee) => this.getEmergencyInstructionContactSourceId(employee) === candidate);
        pushResolved(lookupMatch);
        return;
      }

      if (typeof candidate === 'object') {
        const candidateId = this.getEmergencyInstructionContactSourceId(candidate as { _id?: unknown; id?: unknown });
        const candidateName = typeof (candidate as { name?: unknown }).name === 'string'
          ? String((candidate as { name?: unknown }).name).trim()
          : '';
        const candidateEmail = typeof (candidate as { email?: unknown }).email === 'string'
          ? String((candidate as { email?: unknown }).email).trim()
          : '';
        const hasEmployeeFields = Boolean(
          candidateName
          || candidateEmail
          || typeof (candidate as { phone?: unknown }).phone === 'string'
          || typeof (candidate as { mobile?: unknown }).mobile === 'string'
        );

        if (hasEmployeeFields) {
          pushResolved(candidate as Employee);
          return;
        }

        if (candidateId) {
          const lookupMatch = lookupList.find((employee) => this.getEmergencyInstructionContactSourceId(employee) === candidateId);
          pushResolved(lookupMatch);
        }
      }
    });

    return resolvedEmployees;
  }

  private resolveEmergencyInstructionAssignedEmployees(
    property: Property | null | undefined,
    sourceType: EmergencyInstructionActionContactSourceType,
  ): Employee[] {
    if (!property) {
      return [];
    }

    switch (sourceType) {
    case 'caretaker':
      return this.resolveEmergencyInstructionAssignedEmployeeReferences(property.caretaker, this.caretakers);
    case 'property_manager':
      return this.resolveEmergencyInstructionAssignedEmployeeReferences(property.propertyManagers, this.propertyManagersModel);
    case 'technical_assets_manager':
      return this.resolveEmergencyInstructionAssignedEmployeeReferences(property.technicalAssetsManagers, this.technicalAssetsManagers);
    case 'sev_manager':
      return this.resolveEmergencyInstructionAssignedEmployeeReferences(property.sevManagers, this.sevManagersModel);
    case 'accountant':
      return this.resolveEmergencyInstructionAssignedEmployeeReferences(property.accountants, this.accountantsModel);
    default:
      return [];
    }
  }

  private getEmergencyInstructionContactRefIdentity(
    contactRef: EmergencyInstructionActionContactRef | null | undefined,
    actionType: EmergencyInstructionBuilderActionType | 'phone' | 'email',
    snapshotValue?: string | null,
  ): string {
    const field = actionType === 'phone' && contactRef?.field === 'mobile'
      ? 'mobile'
      : (actionType === 'phone' || actionType === 'email' ? actionType : (contactRef?.field || 'phone'));
    if (!contactRef || contactRef.mode !== 'assigned_property_contact' || !contactRef.sourceType) {
      return this.emergencyInstructionManualContactOptionValue;
    }

    const sourceType = this.normalizeEmergencyInstructionContactKeyPart(contactRef.sourceType);
    const sourceId = this.normalizeEmergencyInstructionContactKeyPart(contactRef.sourceId || '');
    const serviceType = this.normalizeEmergencyInstructionContactKeyPart(contactRef.serviceType || '');

    if (sourceId) {
      return [field, sourceType, sourceId, serviceType].join('::');
    }

    const displayName = this.normalizeEmergencyInstructionContactKeyPart(contactRef.displayName || '');
    const normalizedSnapshotValue = this.normalizeEmergencyInstructionContactSnapshotValue(field, snapshotValue);
    return [field, sourceType, serviceType, displayName, this.normalizeEmergencyInstructionContactKeyPart(normalizedSnapshotValue)].join('::');
  }

  private getEmergencyInstructionContactRefKey(
    contactRef: EmergencyInstructionActionContactRef | null | undefined,
    actionType: EmergencyInstructionBuilderActionType | 'phone' | 'email',
    snapshotValue?: string | null,
  ): string {
    return this.getEmergencyInstructionContactRefIdentity(contactRef, actionType, snapshotValue);
  }

  private getEmergencyInstructionUnresolvedContactKey(
    contactRef: EmergencyInstructionActionContactRef | null | undefined,
    actionType: EmergencyInstructionBuilderActionType | 'phone' | 'email',
  ): string {
    return `${this.emergencyInstructionUnresolvedContactOptionPrefix}${this.getEmergencyInstructionContactRefKey(contactRef, actionType)}`;
  }

  isEmergencyInstructionUnresolvedContactKey(value: string | null | undefined): boolean {
    return Boolean(value && value.startsWith(this.emergencyInstructionUnresolvedContactOptionPrefix));
  }

  private normalizeEmergencyInstructionContactRefForBuilder(
    contactRef: EmergencyInstructionActionContactRef | null | undefined,
    field: 'phone' | 'email',
  ): EmergencyInstructionActionContactRef {
    if (contactRef?.mode === 'assigned_property_contact' && contactRef.sourceType) {
      return {
        mode: 'assigned_property_contact',
        sourceType: contactRef.sourceType,
        sourceId: this.getEmergencyInstructionContactSourceId(contactRef) || null,
        serviceType: contactRef.serviceType || null,
        field: field === 'phone' && contactRef.field === 'mobile' ? 'mobile' : field,
        displayName: contactRef.displayName || null,
      };
    }

    return {
      mode: 'manual',
      field,
    };
  }

  private getEmergencyInstructionEmployeePhone(employee?: Partial<Employee> | null): string {
    return (employee?.phone || employee?.mobile || '').trim();
  }

  private getEmergencyInstructionServicePhone(service?: Partial<Service> | null): string {
    return (service?.phone || service?.mobile || '').trim();
  }

  private getEmergencyInstructionContactSourceLabel(sourceType: EmergencyInstructionActionContactSourceType): string {
    const suffixMap: Record<EmergencyInstructionActionContactSourceType, string> = {
      caretaker: 'CARETAKER',
      caretaker_contact_person: 'CARETAKER_CONTACT_PERSON',
      property_manager: 'PROPERTY_MANAGER',
      technical_assets_manager: 'TECHNICAL_ASSETS_MANAGER',
      sev_manager: 'SEV_MANAGER',
      accountant: 'ACCOUNTANT',
      technical_service: 'TECHNICAL_SERVICE',
    };

    return this.translate.instant(`PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_${suffixMap[sourceType]}`);
  }

  private getEmergencyInstructionContactAutoLabelName(
    sourceType: EmergencyInstructionActionContactSourceType,
    displayName: string,
    serviceType?: string | null,
  ): string {
    if (sourceType === 'technical_service') {
      return this.translateEmergencyInstructionServiceType(serviceType || '') || this.getEmergencyInstructionContactSourceLabel('technical_service');
    }
    if (sourceType === 'caretaker_contact_person') {
      return this.getEmergencyInstructionContactSourceLabel('caretaker');
    }
    return this.getEmergencyInstructionContactSourceLabel(sourceType);
  }

  private buildEmergencyInstructionContactOptionKey(
    field: 'phone' | 'mobile' | 'email',
    sourceType: EmergencyInstructionActionContactSourceType,
    sourceId?: string | null,
    serviceType?: string | null,
    displayName?: string | null,
    value?: string | null,
  ): string {
    return this.getEmergencyInstructionContactRefKey({
      mode: 'assigned_property_contact',
      sourceType,
      sourceId: sourceId || null,
      serviceType: serviceType || null,
      field,
      displayName: displayName || null,
    }, field === 'mobile' ? 'phone' : field, value);
  }

  private buildEmergencyInstructionContactOption(
    field: 'phone' | 'email',
    sourceType: EmergencyInstructionActionContactSourceType,
    displayName: string,
    value: string,
    options?: {
      sourceId?: string | null;
      serviceType?: string | null;
      groupLabel?: string;
      contactField?: 'phone' | 'mobile' | 'email';
    },
  ): EmergencyInstructionContactOption {
    const contactField = options?.contactField || field;
    const normalizedValue = this.normalizeEmergencyInstructionContactSnapshotValue(field, value);
    const sourceLabel = this.getEmergencyInstructionContactSourceLabel(sourceType);
    const serviceTypeLabel = sourceType === 'technical_service'
      ? this.translateEmergencyInstructionServiceType(options?.serviceType || '')
      : '';
    const groupLabel = options?.groupLabel
      || (sourceType === 'technical_service'
        ? `${sourceLabel}: ${serviceTypeLabel || displayName}`
        : sourceLabel);
    const searchLabel = [sourceLabel, serviceTypeLabel, displayName, normalizedValue, groupLabel]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    const normalizedSourceId = this.getEmergencyInstructionContactSourceId({ sourceId: options?.sourceId }) || null;

    return {
      key: this.buildEmergencyInstructionContactOptionKey(
        contactField,
        sourceType,
        normalizedSourceId,
        options?.serviceType,
        displayName,
        normalizedValue,
      ),
      field,
      sourceType,
      sourceId: normalizedSourceId,
      serviceType: options?.serviceType || null,
      searchLabel,
      groupLabel,
      displayName,
      secondaryValue: normalizedValue,
      previewLabel: displayName,
      autoLabelName: this.getEmergencyInstructionContactAutoLabelName(sourceType, displayName, options?.serviceType),
      contactRef: {
        mode: 'assigned_property_contact',
        sourceType,
        sourceId: normalizedSourceId,
        serviceType: options?.serviceType || null,
        field: contactField,
        displayName,
      },
    };
  }

  private translateEmergencyInstructionServiceType(serviceType: string): string {
    const trimmed = (serviceType || '').trim();
    if (!trimmed) {
      return '';
    }
    const translationKey = SERVICE_TYPE_TRANSLATION_KEYS[trimmed];
    return translationKey
      ? this.translate.instant(`TECHNICAL_SERVICES.${translationKey}`)
      : formatServiceTypeHeader(trimmed);
  }

  private getEmergencyInstructionTechnicalServiceEntries(
    property: Property | null | undefined
  ): EmergencyInstructionAssignedTechnicalServiceEntry[] {
    if (!property) {
      return [];
    }

    const directServices = Array.isArray(property.technicalServices)
      ? property.technicalServices
          .filter((service): service is Service => Boolean(service))
          .map((service) => normalizeServiceContact(service))
      : [];
    const entries: EmergencyInstructionAssignedTechnicalServiceEntry[] = [];
    const seen = new Set<string>();
    const pushEntry = (service: Service | null | undefined, serviceType?: string | null, explicitSourceId?: string | null): void => {
      if (!service) {
        return;
      }

      const normalizedService = normalizeServiceContact(service);
      const sourceId = explicitSourceId || this.getEmergencyInstructionContactSourceId(normalizedService) || null;
      const resolvedServiceType = (serviceType || normalizedService.serviceType || '').trim();
      const dedupeKey = sourceId
        ? `${sourceId}::${this.normalizeServiceTypeKey(resolvedServiceType)}`
        : [
          this.normalizeServiceTypeKey(resolvedServiceType),
          this.normalizeEmergencyInstructionContactKeyPart(normalizedService.serviceName || ''),
          this.normalizeEmergencyInstructionContactKeyPart(normalizedService.email || normalizedService.emergencyNumber || normalizedService.phone || normalizedService.mobile || ''),
        ].join('::');
      if (seen.has(dedupeKey)) {
        return;
      }
      seen.add(dedupeKey);
      entries.push({
        service: normalizedService,
        sourceId,
        serviceType: resolvedServiceType || normalizedService.serviceType,
      });
    };

    this.buildPropertyServiceAssignmentsForPrefill(property).forEach((assignment) => {
      const sourceId = String(assignment?.serviceId || '').trim() || null;
      const assignmentServiceType = assignment?.serviceType || '';
      const resolvedService = directServices.find((service) => (
        (!sourceId || this.getEmergencyInstructionContactSourceId(service) === sourceId)
        && this.normalizeServiceTypeKey(service?.serviceType || '') === this.normalizeServiceTypeKey(assignmentServiceType)
      ))
        || directServices.find((service) => sourceId && this.getEmergencyInstructionContactSourceId(service) === sourceId)
        || (sourceId
          ? this.technicalServicesModel.find((candidate) => this.getEmergencyInstructionContactSourceId(candidate) === sourceId)
          : null);
      if (resolvedService) {
        pushEntry(resolvedService, assignmentServiceType, sourceId);
      }
    });

    return entries;
  }

  private getSelectedCaretakerContactPersonsForEmergency(property: Property): CaretakerContactPerson[] {
    const assignedCaretaker = this.resolveEmergencyInstructionAssignedEmployees(property, 'caretaker')[0];
    const assignedCaretakerId = this.getEmergencyInstructionContactSourceId(assignedCaretaker);
    const caretaker = this.caretakers.find(
      (candidate) => this.getEmergencyInstructionContactSourceId(candidate) === assignedCaretakerId
    ) || assignedCaretaker;
    const selectedIds = new Set(this.normalizeCaretakerContactPersonSelectionIds(property.caretakerContactPersonIds));
    const seen = new Set<string>();
    return (Array.isArray(caretaker?.contactPersons) ? caretaker.contactPersons : [])
      .filter((person): person is CaretakerContactPerson => {
        const id = String(person?._id || '').trim();
        if (!id || !selectedIds.has(id) || !String(person?.name || '').trim() || seen.has(id)) {
          return false;
        }
        seen.add(id);
        return true;
      })
      .sort((left, right) => Number(right.isPrimary) - Number(left.isPrimary));
  }

  private getEmergencyInstructionContactFieldLabel(field: 'phone' | 'mobile' | 'email'): string {
    if (field === 'mobile') {
      return this.translate.instant('PROPERTY_LIST.MOBILE');
    }
    return field === 'email'
      ? this.translate.instant('PROPERTY_LIST.EMAIL')
      : this.translate.instant('PROPERTY_LIST.PHONE');
  }

  private buildEmergencyInstructionContactOptions(
    property: Property | null | undefined,
    actionType: EmergencyInstructionBuilderActionType,
  ): EmergencyInstructionContactOptionGroup[] {
    if (!property || (actionType !== 'phone' && actionType !== 'email')) {
      return [];
    }

    const field: 'phone' | 'email' = actionType;
    const seen = new Set<string>();
    const groups: EmergencyInstructionContactOptionGroup[] = [];
    const pushGroup = (key: string, label: string, options: EmergencyInstructionContactOption[]) => {
      if (options.length) {
        groups.push({ key, label, options });
      }
    };
    const dedupe = (option: EmergencyInstructionContactOption | null): EmergencyInstructionContactOption | null => {
      if (!option?.secondaryValue) {
        return null;
      }
      const dedupeKey = [
        option.field,
        option.sourceType,
        (option.sourceId || '').trim(),
        (option.serviceType || '').trim().toLowerCase(),
        option.displayName.trim().toLowerCase(),
        option.secondaryValue.trim().toLowerCase(),
      ].join('::');
      if (seen.has(dedupeKey)) {
        return null;
      }
      seen.add(dedupeKey);
      return option;
    };

    const employeeOption = (
      employee: Partial<Employee> | null | undefined,
      sourceType: EmergencyInstructionActionContactSourceType,
    ): EmergencyInstructionContactOption | null => {
      const value = field === 'phone'
        ? this.getEmergencyInstructionEmployeePhone(employee)
        : this.normalizeEmergencyInstructionContactSnapshotValue('email', employee?.email || '');
      if (field === 'email' && value && !this.validateEmail(value)) {
        return null;
      }
      if (!value) {
        return null;
      }
      const displayName = (employee?.name || '').trim() || this.getEmergencyInstructionContactSourceLabel(sourceType);
      return dedupe(this.buildEmergencyInstructionContactOption(field, sourceType, displayName, value, {
        sourceId: this.getEmergencyInstructionContactSourceId(employee) || null,
      }));
    };

    const caretakerContactOptions = this.getSelectedCaretakerContactPersonsForEmergency(property)
      .flatMap((person) => {
        const fields: Array<'phone' | 'mobile' | 'email'> = field === 'phone'
          ? ['phone', 'mobile']
          : ['email'];
        return fields
          .map((contactField) => {
            const value = this.normalizeEmergencyInstructionContactSnapshotValue(
              field,
              person[contactField] || ''
            );
            if (!value || (contactField === 'email' && !this.validateEmail(value))) {
              return null;
            }
            const displayName = `${person.name} · ${this.getEmergencyInstructionContactFieldLabel(contactField)}`;
            return dedupe(this.buildEmergencyInstructionContactOption(
              field,
              'caretaker_contact_person',
              displayName,
              value,
              {
                sourceId: person._id || null,
                groupLabel: this.getEmergencyInstructionContactSourceLabel('caretaker'),
                contactField,
              }
            ));
          })
          .filter((option): option is EmergencyInstructionContactOption => Boolean(option));
      });
    const caretakerFallbackOptions = caretakerContactOptions.length
      ? caretakerContactOptions
      : this.resolveEmergencyInstructionAssignedEmployees(property, 'caretaker')
        .map((employee) => employeeOption(employee, 'caretaker'))
        .filter((option): option is EmergencyInstructionContactOption => Boolean(option));
    pushGroup(
      'caretaker',
      this.getEmergencyInstructionContactSourceLabel('caretaker'),
      caretakerFallbackOptions,
    );

    pushGroup(
      'property-manager',
      this.getEmergencyInstructionContactSourceLabel('property_manager'),
      this.resolveEmergencyInstructionAssignedEmployees(property, 'property_manager')
        .map((manager) => employeeOption(manager, 'property_manager'))
        .filter((option): option is EmergencyInstructionContactOption => Boolean(option)),
    );

    pushGroup(
      'technical-assets-manager',
      this.getEmergencyInstructionContactSourceLabel('technical_assets_manager'),
      this.resolveEmergencyInstructionAssignedEmployees(property, 'technical_assets_manager')
        .map((manager) => employeeOption(manager, 'technical_assets_manager'))
        .filter((option): option is EmergencyInstructionContactOption => Boolean(option)),
    );

    pushGroup(
      'sev-manager',
      this.getEmergencyInstructionContactSourceLabel('sev_manager'),
      this.resolveEmergencyInstructionAssignedEmployees(property, 'sev_manager')
        .map((manager) => employeeOption(manager, 'sev_manager'))
        .filter((option): option is EmergencyInstructionContactOption => Boolean(option)),
    );

    pushGroup(
      'accountant',
      this.getEmergencyInstructionContactSourceLabel('accountant'),
      this.resolveEmergencyInstructionAssignedEmployees(property, 'accountant')
        .map((accountant) => employeeOption(accountant, 'accountant'))
        .filter((option): option is EmergencyInstructionContactOption => Boolean(option)),
    );

    const serviceGroups = new Map<string, EmergencyInstructionContactOptionGroup>();
    this.getEmergencyInstructionTechnicalServiceEntries(property).forEach((entry) => {
      const service = entry.service;
      const resolvedServiceType = entry.serviceType || service?.serviceType || '';
      const value = field === 'phone'
        ? this.getEmergencyInstructionServicePhone(service)
        : this.normalizeEmergencyInstructionContactSnapshotValue('email', service?.email || '');
      if (field === 'email' && value && !this.validateEmail(value)) {
        return;
      }
      if (!value) {
        return;
      }

      const translatedServiceType = this.translateEmergencyInstructionServiceType(resolvedServiceType);
      const displayName = (service?.serviceName || '').trim()
        || translatedServiceType
        || this.getEmergencyInstructionContactSourceLabel('technical_service');
      const groupLabel = translatedServiceType
        ? `${this.getEmergencyInstructionContactSourceLabel('technical_service')}: ${translatedServiceType}`
        : this.getEmergencyInstructionContactSourceLabel('technical_service');
      const option = dedupe(this.buildEmergencyInstructionContactOption(field, 'technical_service', displayName, value, {
        sourceId: entry.sourceId,
        serviceType: resolvedServiceType || null,
        groupLabel,
      }));
      if (!option) {
        return;
      }

      const groupKey = `technical-service-${(resolvedServiceType || 'general').toString().trim().toLowerCase() || 'general'}`;
      if (!serviceGroups.has(groupKey)) {
        serviceGroups.set(groupKey, {
          key: groupKey,
          label: groupLabel,
          options: [],
        });
      }
      serviceGroups.get(groupKey)!.options.push(option);
    });

    Array.from(serviceGroups.values())
      .sort((left, right) => left.label.localeCompare(right.label))
      .forEach((group) => pushGroup(group.key, group.label, group.options));

    return groups;
  }

  private rebuildEmergencyInstructionContactOptionsForProperty(property: Property | null | undefined): void {
    const phoneGroups = this.buildEmergencyInstructionContactOptions(property, 'phone');
    const emailGroups = this.buildEmergencyInstructionContactOptions(property, 'email');
    this.emergencyInstructionContactOptionGroups = {
      phone: phoneGroups,
      email: emailGroups,
    };
    this.emergencyInstructionContactOptionsByKey.phone = new Map(
      phoneGroups.flatMap((group) => group.options).map((option) => [option.key, option])
    );
    this.emergencyInstructionContactOptionsByKey.email = new Map(
      emailGroups.flatMap((group) => group.options).map((option) => [option.key, option])
    );
    this.reconcileEmergencyInstructionSelectedContactKeys();
  }

  private maybeReconcileEmergencyInstructionSelectedContactKeys(): void {
    const hasCachedOptions = this.hasEmergencyInstructionContactOptions('phone')
      || this.hasEmergencyInstructionContactOptions('email');
    if (this.emergencyInstructionContactOptionsLoading && !hasCachedOptions) {
      return;
    }
    this.reconcileEmergencyInstructionSelectedContactKeys();
  }

  private findEmergencyInstructionContactOptionForRef(
    contactRef: EmergencyInstructionActionContactRef | null | undefined,
    field: 'phone' | 'email',
    snapshotValue?: string | null,
  ): EmergencyInstructionContactOption | null {
    if (!contactRef || contactRef.mode !== 'assigned_property_contact' || !contactRef.sourceType) {
      return null;
    }

    const expectedKey = this.getEmergencyInstructionContactRefIdentity(contactRef, field);
    const optionsByKey = this.emergencyInstructionContactOptionsByKey[field];
    const exactMatch = optionsByKey.get(expectedKey);
    if (exactMatch) {
      return exactMatch;
    }

    const options = this.getEmergencyInstructionContactOptionsByType(field);
    const normalizedSourceType = this.normalizeEmergencyInstructionContactKeyPart(contactRef.sourceType);
    const normalizedSourceId = this.normalizeEmergencyInstructionContactKeyPart(contactRef.sourceId || '');
    const normalizedServiceType = this.normalizeEmergencyInstructionContactKeyPart(contactRef.serviceType || '');
    const normalizedDisplayName = this.normalizeEmergencyInstructionContactKeyPart(contactRef.displayName || '');
    const normalizedSnapshotValue = this.normalizeEmergencyInstructionContactSnapshotValue(field, snapshotValue);

    if (normalizedSourceType === 'technical_service' && normalizedSourceId && normalizedServiceType) {
      const technicalServiceExactMatch = options.find((option) =>
        option.field === field
        && this.normalizeEmergencyInstructionContactKeyPart(option.sourceType) === normalizedSourceType
        && this.normalizeEmergencyInstructionContactKeyPart(option.sourceId || '') === normalizedSourceId
        && this.normalizeEmergencyInstructionContactKeyPart(option.serviceType || '') === normalizedServiceType
      );
      if (technicalServiceExactMatch) {
        return technicalServiceExactMatch;
      }

      return null;
    }

    if (normalizedSourceId) {
      const sourceIdMatch = options.find((option) =>
        option.field === field
        && this.normalizeEmergencyInstructionContactKeyPart(option.sourceType) === normalizedSourceType
        && this.normalizeEmergencyInstructionContactKeyPart(option.sourceId || '') === normalizedSourceId
      );
      if (sourceIdMatch) {
        return sourceIdMatch;
      }
    }

    if (normalizedSourceType === 'technical_service' && normalizedServiceType) {
      const technicalServiceMatch = options.find((option) =>
        option.field === field
        && this.normalizeEmergencyInstructionContactKeyPart(option.sourceType) === normalizedSourceType
        && this.normalizeEmergencyInstructionContactKeyPart(option.serviceType || '') === normalizedServiceType
      );
      if (technicalServiceMatch) {
        return technicalServiceMatch;
      }
    }

    if (normalizedDisplayName) {
      const displayNameMatch = options.find((option) =>
        option.field === field
        && this.normalizeEmergencyInstructionContactKeyPart(option.sourceType) === normalizedSourceType
        && this.normalizeEmergencyInstructionContactKeyPart(option.displayName) === normalizedDisplayName
      );
      if (displayNameMatch) {
        return displayNameMatch;
      }
    }

    if (normalizedSnapshotValue) {
      const valueMatch = options.find((option) =>
        option.field === field
        && this.normalizeEmergencyInstructionContactKeyPart(option.sourceType) === normalizedSourceType
        && option.secondaryValue === normalizedSnapshotValue
      );
      if (valueMatch) {
        return valueMatch;
      }
    }

    return null;
  }

  private resetEmergencyInstructionStepAction(step: EmergencyInstructionBuilderStep): void {
    step.actionType = 'none';
    step.action = null;
    step.selectedContactKey = null;
    step.selectedDocumentOptionKey = null;
    step.actionLabelManuallyEdited = false;
    step.lastAutoActionLabel = null;
  }

  private reconcileEmergencyInstructionSelectedContactKeys(): void {
    (this.emergencyInstructionBuilder.steps || []).forEach((step) => {
      if (!step.action || (step.actionType !== 'phone' && step.actionType !== 'email')) {
        step.selectedContactKey = null;
        return;
      }

      const optionsByKey = this.emergencyInstructionContactOptionsByKey[step.actionType];

      if (!step.action.contactRef || step.action.contactRef.mode !== 'assigned_property_contact') {
        if (
          step.selectedContactKey
          && step.selectedContactKey !== this.emergencyInstructionManualContactOptionValue
          && !this.isEmergencyInstructionUnresolvedContactKey(step.selectedContactKey)
        ) {
          const selectedOption = optionsByKey.get(step.selectedContactKey);
          if (selectedOption) {
            step.action.contactRef = { ...selectedOption.contactRef };
            step.action[step.actionType] = selectedOption.secondaryValue;
            step.selectedContactKey = selectedOption.key;
            return;
          }
        }

        step.selectedContactKey = this.emergencyInstructionManualContactOptionValue;
        return;
      }

      const selectedOption = this.findEmergencyInstructionContactOptionForRef(
        step.action.contactRef,
        step.actionType,
        step.action[step.actionType],
      );
      if (selectedOption) {
        step.selectedContactKey = selectedOption.key;
        const currentIdentity = this.getEmergencyInstructionContactRefIdentity(
          step.action.contactRef,
          step.actionType,
          step.action[step.actionType],
        );
        const selectedIdentity = this.getEmergencyInstructionContactRefIdentity(
          selectedOption.contactRef,
          step.actionType,
          selectedOption.secondaryValue,
        );
        const changed = currentIdentity !== selectedIdentity
          || this.normalizeEmergencyInstructionContactSnapshotValue(step.actionType, step.action[step.actionType]) !== selectedOption.secondaryValue;
        if (changed) {
          step.action.contactRef = { ...selectedOption.contactRef };
          step.action[step.actionType] = selectedOption.secondaryValue;
        }
      } else {
        this.resetEmergencyInstructionStepAction(step);
      }
    });
  }

  private scheduleEmergencyInstructionContactOptionsRefresh(property: Property | null | undefined = this.instructionsProperty): void {
    if (this.emergencyInstructionContactOptionsRefreshHandle) {
      clearTimeout(this.emergencyInstructionContactOptionsRefreshHandle);
      this.emergencyInstructionContactOptionsRefreshHandle = null;
    }

    const targetProperty = property || null;
    this.emergencyInstructionContactOptionsLoading = Boolean(targetProperty);
    if (!targetProperty?._id) {
      this.rebuildEmergencyInstructionContactOptionsForProperty(null);
      this.emergencyInstructionContactOptionsLoading = false;
      return;
    }

    this.emergencyInstructionContactOptionsRefreshHandle = setTimeout(() => {
      this.emergencyInstructionContactOptionsRefreshHandle = null;
      if (this.instructionsProperty?._id && targetProperty._id !== this.instructionsProperty._id) {
        return;
      }
      this.rebuildEmergencyInstructionContactOptionsForProperty(targetProperty);
      this.emergencyInstructionContactOptionsLoading = false;
    }, 0);
  }

  private getEmergencyInstructionContactOptionsByType(
    actionType: EmergencyInstructionBuilderActionType,
  ): EmergencyInstructionContactOption[] {
    if (actionType !== 'phone' && actionType !== 'email') {
      return [];
    }
    return this.emergencyInstructionContactOptionGroups[actionType].flatMap((group) => group.options);
  }

  hasEmergencyInstructionContactOptions(actionType: EmergencyInstructionBuilderActionType): boolean {
    return actionType === 'phone' || actionType === 'email'
      ? this.emergencyInstructionContactOptionGroups[actionType].some((group) => group.options.length > 0)
      : false;
  }

  getEmergencyInstructionContactEmptyMessage(actionType: EmergencyInstructionBuilderActionType): string {
    return this.translate.instant(
      actionType === 'phone'
        ? 'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_EMPTY_PHONE'
        : 'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_EMPTY_EMAIL'
    );
  }

  getEmergencyInstructionContactNotFoundContent(actionType: EmergencyInstructionBuilderActionType): string {
    if (this.instructionsModalLoading || this.emergencyInstructionContactOptionsLoading) {
      return this.translate.instant('PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_LOADING');
    }
    return this.getEmergencyInstructionContactEmptyMessage(actionType);
  }

  filterEmergencyInstructionContactOptions = (searchValue: string, item: any): boolean => {
    if (item?.nzValue === this.emergencyInstructionManualContactOptionValue || this.isEmergencyInstructionUnresolvedContactKey(String(item?.nzValue || ''))) {
      return true;
    }

    const search = (searchValue || '').toLowerCase().trim();
    if (!search) {
      return true;
    }

    const option = this.emergencyInstructionContactOptionsByKey.phone.get(String(item?.nzValue || ''))
      || this.emergencyInstructionContactOptionsByKey.email.get(String(item?.nzValue || ''));
    const label = ((option?.searchLabel ?? item?.nzLabel ?? '') + '').toLowerCase();
    return label.includes(search);
  };

  getEmergencyInstructionSelectedContactPreview(
    step: EmergencyInstructionBuilderStep
  ): EmergencyInstructionContactPreview | null {
    if (!step.action || (step.actionType !== 'phone' && step.actionType !== 'email')) {
      return null;
    }

    const field: 'phone' | 'email' = step.actionType;
    const selectedKey = step.selectedContactKey || this.getEmergencyInstructionContactRefKey(
      step.action.contactRef,
      step.actionType,
      step.action[field],
    );
    const option = this.emergencyInstructionContactOptionsByKey[step.actionType].get(selectedKey)
      || this.findEmergencyInstructionContactOptionForRef(step.action.contactRef, field, step.action[field]);
    if (option) {
      return {
        label: option.previewLabel,
        value: option.secondaryValue,
        groupLabel: option.groupLabel,
      };
    }

    if (step.action.contactRef?.mode === 'assigned_property_contact') {
      return {
        label: step.action.contactRef.displayName || this.translate.instant('PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_UNRESOLVED'),
        value: this.normalizeEmergencyInstructionContactSnapshotValue(field, step.action[field]) || this.translate.instant('PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_UNRESOLVED'),
        groupLabel: step.action.contactRef.sourceType
          ? this.getEmergencyInstructionContactSourceLabel(step.action.contactRef.sourceType)
          : null,
        unresolved: true,
      };
    }

    return null;
  }

  private buildEmergencyInstructionDefaultActionLabel(
    actionType: 'phone' | 'email',
    contactName: string,
  ): string {
    const translationKey = actionType === 'phone'
      ? 'PROPERTY_INSTRUCTIONS.ACTION_LABEL_DEFAULT_CALL'
      : 'PROPERTY_INSTRUCTIONS.ACTION_LABEL_DEFAULT_EMAIL';
    return this.translate.instant(translationKey, { name: contactName });
  }

  private applyEmergencyInstructionAutoActionLabel(step: EmergencyInstructionBuilderStep, nextAutoLabel: string): void {
    const previousAutoLabel = step.lastAutoActionLabel || '';
    const currentLabel = step.action?.label?.trim() || '';

    if (step.action && (!step.actionLabelManuallyEdited || !currentLabel || currentLabel === previousAutoLabel)) {
      step.action.label = nextAutoLabel;
      step.actionLabelManuallyEdited = false;
    }

    step.lastAutoActionLabel = nextAutoLabel || null;
  }

  onEmergencyInstructionActionContactRefChange(step: EmergencyInstructionBuilderStep, selectedKey: string | null): void {
    if (!step.action || (step.actionType !== 'phone' && step.actionType !== 'email')) {
      return;
    }

    const field: 'phone' | 'email' = step.actionType;
    if (!selectedKey || selectedKey === this.emergencyInstructionManualContactOptionValue) {
      if (step.action.contactRef?.mode === 'manual' && step.action.contactRef.field === field) {
        step.selectedContactKey = this.emergencyInstructionManualContactOptionValue;
        return;
      }
      step.action.contactRef = {
        mode: 'manual',
        field,
      };
      step.selectedContactKey = this.emergencyInstructionManualContactOptionValue;
      return;
    }

    if (this.isEmergencyInstructionUnresolvedContactKey(selectedKey)) {
      return;
    }

    const selectedOption = this.emergencyInstructionContactOptionsByKey[step.actionType].get(selectedKey);
    if (!selectedOption) {
      return;
    }

    const currentValue = this.normalizeEmergencyInstructionContactSnapshotValue(field, step.action[field]);
    const currentContactRef = step.action.contactRef;
    if (
      currentContactRef?.mode === 'assigned_property_contact'
      && this.getEmergencyInstructionContactRefIdentity(currentContactRef, field) === this.getEmergencyInstructionContactRefIdentity(selectedOption.contactRef, field)
      && currentValue === selectedOption.secondaryValue
    ) {
      step.selectedContactKey = selectedOption.key;
      return;
    }

    step.action.contactRef = { ...selectedOption.contactRef };
    step.selectedContactKey = selectedOption.key;
    if (currentValue !== selectedOption.secondaryValue) {
      step.action[field] = selectedOption.secondaryValue;
    }
    this.applyEmergencyInstructionAutoActionLabel(
      step,
      this.buildEmergencyInstructionDefaultActionLabel(field, selectedOption.autoLabelName),
    );
  }

  onEmergencyInstructionActionValueChange(
    step: EmergencyInstructionBuilderStep,
    field: 'phone' | 'email',
    value: string | null | undefined,
  ): void {
    if (!step.action || step.actionType !== field) {
      return;
    }

    const contactRef = step.action.contactRef;
    if (!contactRef || contactRef.mode !== 'assigned_property_contact') {
      if (!contactRef) {
        step.action.contactRef = {
          mode: 'manual',
          field,
        };
      }
      step.selectedContactKey = this.emergencyInstructionManualContactOptionValue;
      return;
    }

    const normalizedValue = this.normalizeEmergencyInstructionContactSnapshotValue(field, value);
    const selectedKey = step.selectedContactKey || this.getEmergencyInstructionContactRefKey(
      contactRef,
      field,
      step.action[field],
    );
    const selectedOption = this.emergencyInstructionContactOptionsByKey[field].get(selectedKey)
      || this.findEmergencyInstructionContactOptionForRef(contactRef, field, normalizedValue);
    if (selectedOption && selectedOption.secondaryValue === normalizedValue) {
      step.selectedContactKey = selectedOption.key;
      return;
    }

    step.action.contactRef = {
      mode: 'manual',
      field,
    };
    step.selectedContactKey = this.emergencyInstructionManualContactOptionValue;
  }

  onEmergencyInstructionStepDrop(event: CdkDragDrop<EmergencyInstructionBuilderStep[]>): void {
    if (event.previousIndex === event.currentIndex || !this.emergencyInstructionBuilder.steps) {
      return;
    }
    moveItemInArray(this.emergencyInstructionBuilder.steps, event.previousIndex, event.currentIndex);
    this.emergencyInstructionBuilder.steps = this.emergencyInstructionBuilder.steps.map((step, index) => ({ ...step, order: index }));
  }

  onEmergencyInstructionStepActionTypeChange(step: EmergencyInstructionBuilderStep, actionType: EmergencyInstructionBuilderActionType): void {
    step.actionType = actionType;
    step.selectedContactKey = null;
    step.selectedDocumentOptionKey = null;
    step.actionLabelManuallyEdited = false;
    step.lastAutoActionLabel = null;

    if (actionType === 'none') {
      step.action = null;
      return;
    }

    const retainedLabel = step.action?.label || '';

    step.action = {
      type: actionType,
      label: retainedLabel,
      phone: actionType === 'phone' ? '' : null,
      email: actionType === 'email' ? '' : null,
      url: actionType === 'link' ? '' : null,
      document: actionType === 'document' ? null : null,
      openInNewTab: actionType === 'link' ? true : undefined,
      contactRef: actionType === 'phone' || actionType === 'email'
        ? { mode: 'manual' as const, field: actionType }
        : null,
    };

    if (actionType === 'phone' || actionType === 'email') {
      step.selectedContactKey = this.emergencyInstructionManualContactOptionValue;
    }

    if (actionType === 'document' && this.instructionsProperty?._id && !this.emergencyInstructionDocumentOptions.length) {
      this.loadEmergencyInstructionDocumentOptions(this.instructionsProperty._id as string);
    }
    if (actionType === 'document') {
      this.refreshEmergencyInstructionDocumentOptions();
    }
  }

  onEmergencyInstructionDocumentChange(step: EmergencyInstructionBuilderStep, optionKey: string | null): void {
    if (!step.action || step.action.type !== 'document') {
      return;
    }
    const selected = this.emergencyInstructionDocumentOptions.find((option) => option.key === optionKey);
    const previousAutoLabel = step.lastAutoActionLabel || '';
    const currentLabel = step.action.label?.trim() || '';
    step.action.document = selected
      ? this.cloneEmergencyInstructionDocument(selected.file)
      : null;
    step.action.url = selected?.file?.url || null;
    step.selectedDocumentOptionKey = selected?.key || null;

    const nextAutoLabel = selected?.file?.fileName || '';
    if (selected && (!step.actionLabelManuallyEdited || !currentLabel || currentLabel === previousAutoLabel)) {
      step.action.label = nextAutoLabel;
    }
    step.lastAutoActionLabel = nextAutoLabel || null;
    this.refreshEmergencyInstructionDocumentOptions();
  }

  onEmergencyInstructionActionLabelChange(step: EmergencyInstructionBuilderStep, value: string): void {
    const normalized = (value || '').trim();
    const previousAutoLabel = step.lastAutoActionLabel || '';
    step.actionLabelManuallyEdited = Boolean(normalized && normalized !== previousAutoLabel);
    if (!normalized || normalized === previousAutoLabel) {
      step.actionLabelManuallyEdited = false;
    }
  }

  private cloneEmergencyInstructionDocument(
    file: Partial<EmergencyInstructionActionDocument> | PropertyDocumentSection['files'][number]
  ): EmergencyInstructionActionDocument {
    return {
      fileName: file.fileName || '',
      fileType: file.fileType || '',
      url: file.url || '',
      s3Key: file.s3Key,
      sourceS3Key: file.sourceS3Key,
      uploadedAt: file.uploadedAt,
    };
  }

  private normalizeEmergencyInstructionMultilineText(value: unknown): string {
    return typeof value === 'string' ? value.replace(/\r\n?/g, '\n') : '';
  }

  private toOptionalEmergencyInstructionMultilineText(value: unknown): string | null {
    const normalized = this.normalizeEmergencyInstructionMultilineText(value);
    return normalized.trim() ? normalized : null;
  }

  getEmergencyInstructionDocumentOptionKey(step: EmergencyInstructionBuilderStep): string | null {
    if (step.selectedDocumentOptionKey) {
      return step.selectedDocumentOptionKey;
    }
    const document = step.action?.document;
    if (!document) {
      return null;
    }
    const match = this.findEmergencyInstructionDocumentOption(document);
    if (match) {
      step.selectedDocumentOptionKey = match.key;
    }
    return match?.key || null;
  }

  private createEmergencyInstructionDocumentOption(
    file: EmergencyInstructionActionDocument | PropertyDocumentSection['files'][number],
    sectionTitle: string,
    keyPrefix: string,
    fallbackIndex = 0
  ): EmergencyInstructionDocumentOption {
    const identity = file.s3Key || file.url || `${file.fileName || 'document'}-${file.fileType || 'file'}-${fallbackIndex}`;
    const normalizedSectionTitle = sectionTitle || this.translate.instant('PROPERTY_INSTRUCTIONS.DOCUMENT_CURRENT_ATTACHMENT');
    return {
      key: `${keyPrefix}-${identity}`,
      sectionTitle: normalizedSectionTitle,
      file: this.cloneEmergencyInstructionDocument(file),
      label: `${normalizedSectionTitle} · ${file.fileName || this.translate.instant('PROPERTY_INSTRUCTIONS.DOCUMENT_LABEL')}`,
    };
  }

  private areEmergencyInstructionDocumentsEquivalent(
    left?: Partial<EmergencyInstructionActionDocument> | null,
    right?: Partial<EmergencyInstructionActionDocument> | null
  ): boolean {
    if (!left || !right) {
      return false;
    }
    if (left.s3Key && right.s3Key) {
      return left.s3Key === right.s3Key;
    }
    if (left.sourceS3Key && right.sourceS3Key) {
      return left.sourceS3Key === right.sourceS3Key;
    }
    if (left.s3Key && right.sourceS3Key) {
      return left.s3Key === right.sourceS3Key;
    }
    if (left.sourceS3Key && right.s3Key) {
      return left.sourceS3Key === right.s3Key;
    }
    if (left.url && right.url) {
      return left.url === right.url;
    }
    if (left.fileName && right.fileName) {
      const leftType = left.fileType || '';
      const rightType = right.fileType || '';
      return left.fileName === right.fileName && (!leftType || !rightType || leftType === rightType);
    }
    return false;
  }

  private findEmergencyInstructionDocumentOption(
    document?: Partial<EmergencyInstructionActionDocument> | null
  ): EmergencyInstructionDocumentOption | undefined {
    if (!document) {
      return undefined;
    }
    return this.emergencyInstructionDocumentOptions.find((option) =>
      this.areEmergencyInstructionDocumentsEquivalent(document, option.file)
    );
  }

  private getResolvedEmergencyInstructionPreviewDocument(
    document?: Partial<EmergencyInstructionActionDocument> | null,
    step?: EmergencyInstructionBuilderStep | null,
  ): EmergencyInstructionActionDocument | PropertyDocumentSection['files'][number] | null {
    if (!document) {
      const persistedDocument = this.getPersistedEmergencyInstructionStepDocument(step);
      return persistedDocument?.url ? persistedDocument : null;
    }

    const liveMatch = this.findEmergencyInstructionDocumentOption(document);
    if (liveMatch?.file?.url) {
      return liveMatch.file;
    }

    const persistedDocument = this.getPersistedEmergencyInstructionStepDocument(step);
    if (persistedDocument?.url) {
      return persistedDocument;
    }

    return document.url ? this.cloneEmergencyInstructionDocument(document as EmergencyInstructionActionDocument) : null;
  }

  private openResolvedEmergencyInstructionPreviewDocument(
    document?: Partial<EmergencyInstructionActionDocument> | null,
    step?: EmergencyInstructionBuilderStep | null,
  ): void {
    const resolvedDocument = this.getResolvedEmergencyInstructionPreviewDocument(document, step);
    if (!resolvedDocument) {
      this.message.error(this.translate.instant('PROPERTY_INSTRUCTIONS.DOCUMENT_PREVIEW_UNAVAILABLE'));
      return;
    }

    openDocumentSectionFile(resolvedDocument, (url) => this.openImagePreview(url));
  }

  onEmergencyInstructionPreviewDocumentClick(event: Event, step: EmergencyInstructionBuilderStep): void {
    event.preventDefault();

    const action = step.action;
    if (!action || action.type !== 'document') {
      return;
    }

    const propertyId = this.instructionsProperty?._id as string | undefined;
    if (!propertyId) {
      this.openResolvedEmergencyInstructionPreviewDocument(action.document, step);
      return;
    }

    const cached = this.emergencyInstructionDocumentOptionsCache.get(propertyId);
    if (cached) {
      this.applyEmergencyInstructionDocumentOptions(cached);
      this.openResolvedEmergencyInstructionPreviewDocument(action.document, step);
      return;
    }

    this.propertyService.getPropertyDocumentsAuth(propertyId).subscribe({
      next: (response: PropertyDocumentsResponse | PropertyDocumentSection[]) => {
        const sections = Array.isArray(response) ? response : (response?.scanafyUploads || []);
        this.syncEmergencyInstructionDocumentOptionsForProperty(propertyId, sections);
        this.openResolvedEmergencyInstructionPreviewDocument(action.document, step);
      },
      error: () => {
        this.openResolvedEmergencyInstructionPreviewDocument(action.document, step);
      },
    });
  }

  getEmergencyInstructionPreviewDocumentHref(step: EmergencyInstructionBuilderStep): string | null {
    return this.getResolvedEmergencyInstructionPreviewDocument(step.action?.document, step)?.url || null;
  }

  private getPersistedEmergencyInstructionStepDocument(
    step?: EmergencyInstructionBuilderStep | null
  ): EmergencyInstructionActionDocument | null {
    if (!step?.id || !this.editingEmergencyInstructionId) {
      return null;
    }

    const instruction = this.emergencyInstructionRecordById.get(this.editingEmergencyInstructionId);
    const persistedStep = instruction?.steps?.find((candidate) => candidate.id === step.id);
    return persistedStep?.action?.document
      ? this.cloneEmergencyInstructionDocument(persistedStep.action.document)
      : null;
  }

  private mergeSelectedEmergencyInstructionDocumentsIntoOptions(
    baseOptions: EmergencyInstructionDocumentOption[]
  ): EmergencyInstructionDocumentOption[] {
    const mergedOptions = [...baseOptions];
    const selectedSectionTitle = this.translate.instant('PROPERTY_INSTRUCTIONS.DOCUMENT_CURRENT_ATTACHMENT');

    (this.emergencyInstructionBuilder.steps || []).forEach((step, index) => {
      if (step.actionType !== 'document' || !step.action?.document) {
        return;
      }

      const currentDocument = step.action.document;
      const alreadyPresent = mergedOptions.some((option) =>
        this.areEmergencyInstructionDocumentsEquivalent(currentDocument, option.file)
      );
      if (alreadyPresent) {
        return;
      }

      mergedOptions.push(
        this.createEmergencyInstructionDocumentOption(
          this.cloneEmergencyInstructionDocument(currentDocument),
          selectedSectionTitle,
          `attached-${step.id || index}`,
          index
        )
      );
    });

    return mergedOptions;
  }

  private applyEmergencyInstructionDocumentOptions(baseOptions: EmergencyInstructionDocumentOption[]): void {
    this.emergencyInstructionDocumentOptions = this.mergeSelectedEmergencyInstructionDocumentsIntoOptions(baseOptions);

    (this.emergencyInstructionBuilder.steps || []).forEach((step) => {
      if (step.actionType !== 'document' || !step.action?.document) {
        return;
      }
      const match = this.findEmergencyInstructionDocumentOption(step.action.document);
      step.selectedDocumentOptionKey = match?.key || null;
    });
  }

  private refreshEmergencyInstructionDocumentOptions(): void {
    const propertyId = this.instructionsProperty?._id as string | undefined;
    if (!propertyId) {
      return;
    }

    const baseOptions = this.emergencyInstructionDocumentOptionsCache.get(propertyId);
    if (baseOptions) {
      this.applyEmergencyInstructionDocumentOptions(baseOptions);
    }
  }

  private loadEmergencyInstructionDocumentOptions(propertyId: string): void {
    const cached = this.emergencyInstructionDocumentOptionsCache.get(propertyId);
    if (cached) {
      this.applyEmergencyInstructionDocumentOptions(cached);
      return;
    }

    this.emergencyInstructionDocumentOptions = [];
    this.propertyService.getPropertyDocumentsAuth(propertyId).subscribe({
      next: (response: PropertyDocumentsResponse | PropertyDocumentSection[]) => {
        const sections = Array.isArray(response) ? response : (response?.scanafyUploads || []);
        const options = sections.flatMap((section: PropertyDocumentSection, sectionIndex: number) =>
          (section.files || []).map((file, fileIndex) =>
            this.createEmergencyInstructionDocumentOption(file, section.title, `${sectionIndex}-${fileIndex}`, fileIndex)
          )
        );
        this.emergencyInstructionDocumentOptionsCache.set(propertyId, options);
        this.applyEmergencyInstructionDocumentOptions(options);
      },
      error: () => {
        this.applyEmergencyInstructionDocumentOptions([]);
      },
    });
  }

  private getEmergencyInstructionPrimaryPhone(stepList: EmergencyInstructionStep[] = []): string | null {
    for (const step of stepList) {
      if (step.action?.type === 'phone' && step.action.phone?.trim()) {
        return step.action.phone.trim();
      }
    }
    return null;
  }

  private buildEmergencyInstructionPayload(): EmergencyInstruction {
    const steps = (this.emergencyInstructionBuilder.steps || []).map((step, index) => {
      const actionField = step.actionType === 'phone' || step.actionType === 'email'
        ? step.actionType
        : null;
      const selectedOption = actionField
        && step.selectedContactKey
        && step.selectedContactKey !== this.emergencyInstructionManualContactOptionValue
        && !this.isEmergencyInstructionUnresolvedContactKey(step.selectedContactKey)
        ? this.emergencyInstructionContactOptionsByKey[actionField].get(step.selectedContactKey)
        : null;
      const nextAction = step.actionType !== 'none' && step.action
        ? {
          ...step.action,
          type: step.actionType as EmergencyInstructionActionType,
          label: step.action.label?.trim() || null,
          phone: step.actionType === 'phone' ? (step.action.phone?.trim() || null) : null,
          email: step.actionType === 'email' ? (step.action.email?.trim().toLowerCase() || null) : null,
          url: step.actionType === 'link'
            ? this.normalizeEmergencyInstructionUrlInput(step.action.url)
            : (step.actionType === 'document' ? (step.action.url || step.action.document?.url || null) : null),
          document: step.actionType === 'document' && step.action.document ? { ...step.action.document } : null,
          openInNewTab: step.actionType === 'link' ? Boolean(step.action.openInNewTab) : undefined,
          contactRef: step.actionType === 'phone' || step.actionType === 'email'
            ? (selectedOption?.contactRef?.mode === 'assigned_property_contact'
              ? { ...selectedOption.contactRef }
              : this.normalizeEmergencyInstructionContactRefForBuilder(step.action.contactRef, step.actionType))
            : null,
          ...(actionField && selectedOption
            ? {
              [actionField]: selectedOption.secondaryValue,
            }
            : {}),
        }
        : undefined;

      return {
        id: step.id,
        order: index,
        title: (step.title || '').trim(),
        description: this.toOptionalEmergencyInstructionMultilineText(step.description),
        iconKey: step.iconKey || null,
        urgency: step.urgency || 'normal',
        action: nextAction,
      };
    });

    const primaryPhone = this.getEmergencyInstructionPrimaryPhone(steps);

    return {
      order: this.editingEmergencyInstructionId
        ? (this.emergencyInstructions.find((instruction) => this.normalizeEmergencyInstructionId(instruction._id) === this.editingEmergencyInstructionId)?.order ?? 0)
        : this.emergencyInstructions.length,
      category: this.emergencyInstructionBuilder.category || 'other',
      title: (this.emergencyInstructionBuilder.title || '').trim(),
      who: (this.emergencyInstructionBuilder.summary || '').trim() || null,
      showPhoneNumber: Boolean(primaryPhone),
      phone: primaryPhone,
      how: (steps[0]?.description || '').trim() || null,
      version: 'v2',
      scenarioKey: this.emergencyInstructionBuilder.scenarioKey || 'custom',
      sourceLanguage: this.emergencyInstructionBuilder.sourceLanguage || 'de',
      iconKey: this.emergencyInstructionBuilder.iconKey || null,
      urgency: this.emergencyInstructionBuilder.urgency || 'normal',
      summary: (this.emergencyInstructionBuilder.summary || '').trim() || null,
      steps,
    };
  }

  private buildEmergencyInstructionValidationMessages(): string[] {
    const draft = this.buildEmergencyInstructionPayload();
    const messages: string[] = [];

    if (!draft.title?.trim()) {
      messages.push(this.translate.instant('validation.emergencyInstructions.title.required'));
    }
    if (this.isEmergencyInstructionFieldTooLong(draft.title, this.emergencyInstructionMaxLengths.title)) {
      messages.push(this.translate.instant('validation.emergencyInstructions.title.maxlength'));
    }
    if (this.isEmergencyInstructionFieldTooLong(draft.summary, this.emergencyInstructionMaxLengths.summary)) {
      messages.push(this.translate.instant('validation.emergencyInstructions.summary.maxlength'));
    }
    if (!draft.steps?.length) {
      messages.push(this.translate.instant('validation.emergencyInstructions.steps.required'));
    }

    (draft.steps || []).forEach((step) => {
      if (!step.title?.trim()) {
        messages.push(this.translate.instant('validation.emergencyInstructions.steps.title.required'));
      }
      if (this.isEmergencyInstructionFieldTooLong(step.title, this.emergencyInstructionMaxLengths.stepTitle)) {
        messages.push(this.translate.instant('validation.emergencyInstructions.steps.title.maxlength'));
      }
      if (this.isEmergencyInstructionFieldTooLong(step.description, this.emergencyInstructionMaxLengths.stepDescription)) {
        messages.push(this.translate.instant('validation.emergencyInstructions.steps.description.maxlength'));
      }
      if (this.isEmergencyInstructionFieldTooLong(step.action?.label, this.emergencyInstructionMaxLengths.actionLabel)) {
        messages.push(this.translate.instant('validation.emergencyInstructions.steps.action.label.maxlength'));
      }
      if (step.action?.type === 'phone') {
        if (!step.action.phone?.trim()) {
          messages.push(this.translate.instant('validation.emergencyInstructions.steps.action.phone.required'));
        }
        if (this.isEmergencyInstructionFieldTooLong(step.action.phone, this.emergencyInstructionMaxLengths.phone)) {
          messages.push(this.translate.instant('validation.emergencyInstructions.common.maxlength', { max: this.emergencyInstructionMaxLengths.phone }));
        }
      }
      if (step.action?.type === 'email') {
        const email = step.action.email?.trim() || '';
        if (!email) {
          messages.push(this.translate.instant('validation.emergencyInstructions.steps.action.email.required'));
        } else if (!this.validateEmail(email)) {
          messages.push(this.translate.instant('validation.emergencyInstructions.steps.action.email.invalid'));
        }
        if (this.isEmergencyInstructionFieldTooLong(step.action.email, this.emergencyInstructionMaxLengths.email)) {
          messages.push(this.translate.instant('validation.emergencyInstructions.steps.action.email.maxlength'));
        }
      }
      if (step.action?.type === 'link') {
        if (!step.action.url?.trim()) {
          messages.push(this.translate.instant('validation.emergencyInstructions.steps.action.url.required'));
        } else if (this.isEmergencyInstructionLinkInvalid(step.action.url)) {
          messages.push(this.translate.instant('validation.emergencyInstructions.steps.action.url.invalid'));
        }
        if (this.isEmergencyInstructionFieldTooLong(step.action.url, this.emergencyInstructionMaxLengths.url)) {
          messages.push(this.translate.instant('validation.emergencyInstructions.common.maxlength', { max: this.emergencyInstructionMaxLengths.url }));
        }
      }
      if (step.action?.type === 'document' && !step.action.document?.fileName) {
        messages.push(this.translate.instant('validation.emergencyInstructions.steps.action.document.required'));
      }
    });

    return Array.from(new Set(messages.filter(Boolean)));
  }

  private expandEmergencyInstructionStepsWithValidationErrors(): void {
    const invalidStepIndexes = this.getInvalidEmergencyInstructionStepIndexes();
    if (!invalidStepIndexes.length) {
      return;
    }

    invalidStepIndexes.forEach((stepIndex) => {
      const step = this.emergencyInstructionBuilder.steps?.[stepIndex];
      if (step) {
        step.isExpanded = true;
      }
    });

    const firstInvalidStepIndex = invalidStepIndexes[0];
    setTimeout(() => {
      const element = document.querySelector(
        `[data-emergency-instruction-step-index="${firstInvalidStepIndex}"]`
      );
      element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  private getInvalidEmergencyInstructionStepIndexes(): number[] {
    return (this.emergencyInstructionBuilder.steps || [])
      .map((step, index) => this.isEmergencyInstructionStepInvalid(step) ? index : -1)
      .filter((index) => index >= 0);
  }

  private isEmergencyInstructionStepInvalid(step: EmergencyInstructionBuilderStep): boolean {
    if (!step.title?.trim()) {
      return true;
    }
    if (this.isEmergencyInstructionFieldTooLong(step.title, this.emergencyInstructionMaxLengths.stepTitle)) {
      return true;
    }
    if (this.isEmergencyInstructionFieldTooLong(step.description, this.emergencyInstructionMaxLengths.stepDescription)) {
      return true;
    }
    if (this.isEmergencyInstructionFieldTooLong(step.action?.label, this.emergencyInstructionMaxLengths.actionLabel)) {
      return true;
    }

    if (step.action?.type === 'phone') {
      return !step.action.phone?.trim()
        || this.isEmergencyInstructionFieldTooLong(step.action.phone, this.emergencyInstructionMaxLengths.phone);
    }

    if (step.action?.type === 'email') {
      const email = step.action.email?.trim() || '';
      return !email
        || !this.validateEmail(email)
        || this.isEmergencyInstructionFieldTooLong(step.action.email, this.emergencyInstructionMaxLengths.email);
    }

    if (step.action?.type === 'link') {
      return !step.action.url?.trim()
        || this.isEmergencyInstructionLinkInvalid(step.action.url)
        || this.isEmergencyInstructionFieldTooLong(step.action.url, this.emergencyInstructionMaxLengths.url);
    }

    if (step.action?.type === 'document') {
      return !step.action.document?.fileName;
    }

    return false;
  }

  getEmergencyInstructionsCount(property: Property): number {
    return property?.emergencyInstructions?.length || 0;
  }

  private countDocumentsFromSections(sections: PropertyDocumentSection[] | null | undefined): number {
    return (sections || []).reduce((acc, section) => acc + (section?.files?.length || 0), 0);
  }

  private buildEmergencyInstructionDocumentOptionsFromSections(
    sections: Array<Pick<PropertyDocumentSection, 'title' | 'files'>>
  ): EmergencyInstructionDocumentOption[] {
    return (sections || []).flatMap((section, sectionIndex) =>
      (section.files || []).map((file, fileIndex) =>
        this.createEmergencyInstructionDocumentOption(file, section.title, `${sectionIndex}-${fileIndex}`, fileIndex)
      )
    );
  }

  private syncEmergencyInstructionDocumentOptionsForProperty(
    propertyId: string | null | undefined,
    sections: Array<Pick<PropertyDocumentSection, 'title' | 'files'>>
  ): void {
    if (!propertyId) {
      return;
    }
    const options = this.buildEmergencyInstructionDocumentOptionsFromSections(sections);
    this.emergencyInstructionDocumentOptionsCache.set(propertyId, options);

    if (this.instructionsProperty?._id === propertyId) {
      this.applyEmergencyInstructionDocumentOptions(options);
    }
  }

  private preloadDocumentCounts(properties: Property[]): void {
    for (const p of properties || []) {
      const id = (p as any)?._id as string | undefined;
      if (!id) continue;

      // already loaded
      if (typeof this.documentCounts[id] === 'number') continue;

      // already in-flight
      if (this.documentCountLoading.has(id)) continue;

      this.documentCountLoading.add(id);

      this.propertyService.getPropertyDocumentsAuth(id).subscribe({
        next: (response: PropertyDocumentsResponse | PropertyDocumentSection[]) => {
          const sections = Array.isArray(response) ? response : (response?.scanafyUploads || []);
          this.documentCounts[id] = this.countDocumentsFromSections(sections);
          this.documentCountLoading.delete(id);
        },
        error: () => {
          this.documentCounts[id] = 0;
          this.documentCountLoading.delete(id);
        }
      });
    }
  }

  getDocumentsCount(property: Property): number {
    const id = (property as any)?._id as string | undefined;
    if (!id) return 0;
    const count = this.documentCounts[id];
    return typeof count === 'number' ? count : 0;
  }

  emergencyInstructionCategoryIconType(category: EmergencyInstructionCategory): string {
    return this.emergencyInstructionCategoryIconByValue[category] || 'info';
  }

  emergencyInstructionCategoryLabelKey(category: EmergencyInstructionCategory): string {
    return this.emergencyInstructionCategoryLabelByValue[category] || 'PROPERTY_INSTRUCTIONS.CATEGORY.OTHER';
  }

  private normalizeEmergencyInstructionId(value: unknown, depth = 0): string | null {
    if (depth > 3 || value == null) return null;
    if (typeof value === 'string') {
      const normalized = value.trim();
      return normalized || null;
    }
    if (typeof value === 'number') {
      return String(value);
    }
    if (typeof value === 'object') {
      const candidate = (value as { _id?: unknown; id?: unknown; $oid?: unknown })._id
        ?? (value as { _id?: unknown; id?: unknown; $oid?: unknown }).id
        ?? (value as { _id?: unknown; id?: unknown; $oid?: unknown }).$oid;
      const nestedId = this.normalizeEmergencyInstructionId(candidate, depth + 1);
      if (nestedId) {
        return nestedId;
      }
      if (typeof (value as { toHexString?: () => string }).toHexString === 'function') {
        const hexString = (value as { toHexString: () => string }).toHexString();
        if (hexString) {
          return hexString;
        }
      }
      if (typeof (value as { toString?: () => string }).toString === 'function') {
        const stringified = (value as { toString: () => string }).toString();
        if (stringified && stringified !== '[object Object]') {
          return stringified;
        }
      }
    }
    return null;
  }

  private normalizeEmergencyInstructionRecord(instruction: EmergencyInstruction): EmergencyInstruction {
    const normalized = {
      ...instruction,
      _id: this.normalizeEmergencyInstructionId(instruction._id || (instruction as { id?: unknown }).id) || undefined,
      steps: (instruction.steps || []).map((step) => ({
        ...step,
        description: this.toOptionalEmergencyInstructionMultilineText(step?.description),
      })),
    };
    return normalized;
  }

  private setEmergencyInstructionRecords(instructions: EmergencyInstruction[]): void {
    const normalizedInstructions = (instructions || [])
      .map((instruction, index) => ({
        ...this.normalizeEmergencyInstructionRecord(instruction),
        order: Number.isFinite(Number(instruction?.order)) ? Number(instruction.order) : index,
      }))
      .sort((first, second) => (first.order ?? 0) - (second.order ?? 0));
    this.emergencyInstructionRecordById.clear();
    normalizedInstructions.forEach((instruction) => {
      const instructionId = this.normalizeEmergencyInstructionId(instruction._id || (instruction as { id?: unknown }).id);
      if (instructionId) {
        this.emergencyInstructionRecordById.set(instructionId, instruction);
      }
    });
    this.emergencyInstructions = normalizedInstructions;
    if (this.instructionsModalVisible) {
      this.maybeReconcileEmergencyInstructionSelectedContactKeys();
    }
  }

  private resolveEmergencyInstructionTarget(value: EmergencyInstruction | string | null | undefined): {
    instructionId: string | null;
    instruction: EmergencyInstruction | null;
  } {
    const directId = this.normalizeEmergencyInstructionId(value);
    if (directId) {
      return {
        instructionId: directId,
        instruction: this.emergencyInstructionRecordById.get(directId)
          || (typeof value === 'object' && value ? this.normalizeEmergencyInstructionRecord(value as EmergencyInstruction) : null),
      };
    }

    if (typeof value === 'object' && value) {
      const normalizedInstruction = this.normalizeEmergencyInstructionRecord(value as EmergencyInstruction);
      const normalizedId = this.normalizeEmergencyInstructionId(normalizedInstruction._id || (normalizedInstruction as { id?: unknown }).id);
      if (normalizedId) {
        return {
          instructionId: normalizedId,
          instruction: this.emergencyInstructionRecordById.get(normalizedId) || normalizedInstruction,
        };
      }
    }

    return { instructionId: null, instruction: null };
  }

  private getEmergencyInstructionErrorMessages(error: any, fallbackKey: string): string[] {
    const candidates = [
      ...(Array.isArray(error?.error?.errors) ? error.error.errors.map((entry: { message?: string }) => entry?.message) : []),
      error?.error?.message,
    ].filter((value): value is string => typeof value === 'string' && !!value.trim());

    const resolvedMessages: string[] = [];
    for (const candidate of candidates) {
      const translated = this.translate.instant(candidate);
      if (translated && translated !== candidate) {
        resolvedMessages.push(translated);
        continue;
      }
      if (!candidate.startsWith('validation.')) {
        resolvedMessages.push(candidate);
      }
    }

    return resolvedMessages.length ? Array.from(new Set(resolvedMessages)) : [this.translate.instant(fallbackKey)];
  }

  trackByEmergencyInstruction = (index: number, ins: EmergencyInstruction): string => {
    return this.normalizeEmergencyInstructionId(ins._id || (ins as { id?: unknown }).id) || String(index);
  };

  trackByEmergencyInstructionStep = (index: number, step: EmergencyInstructionBuilderStep): string => {
    return step.id || `${index}`;
  };

  trackByEmergencyInstructionIcon = (_: number, icon: { key: string }): string => icon.key;

  trackByEmergencyInstructionDocumentOption = (_: number, option: EmergencyInstructionDocumentOption): string => option.key;

  trackByEmergencyInstructionContactGroup = (_: number, group: EmergencyInstructionContactOptionGroup): string => group.key;

  trackByEmergencyInstructionContactOption = (_: number, option: EmergencyInstructionContactOption): string => option.key;

  trackByEmergencyInstructionCategoryOption = (_: number, option: EmergencyInstructionUnifiedCategoryOption): string => option.key;

  trackByDistributionOverviewGroup = (_: number, group: DistributionOverviewGroup): string =>
    `${group.rootItemId}::${group.sourcePropertyId || 'source'}`;

  trackByDistributionOverviewProperty = (_: number, property: DistributionOverviewGroupProperty): string =>
    `${property.propertyId}::${property.matchedItemId || property.status}`;

  onEmergencyInstructionListDrop(event: CdkDragDrop<EmergencyInstruction[]>): void {
    if (!this.instructionsProperty?._id || this.instructionsSaving || event.previousIndex === event.currentIndex) {
      return;
    }

    const previousInstructions = [...this.emergencyInstructions];
    const nextInstructions = [...this.emergencyInstructions];
    moveItemInArray(nextInstructions, event.previousIndex, event.currentIndex);
    const normalizedNextInstructions = nextInstructions.map((instruction, index) => ({ ...instruction, order: index }));
    this.setEmergencyInstructionRecords(normalizedNextInstructions);
    this.patchEmergencyInstructions(this.instructionsProperty._id as string, this.emergencyInstructions);

    const instructionIds = normalizedNextInstructions
      .map((instruction) => this.normalizeEmergencyInstructionId(instruction._id || (instruction as { id?: unknown }).id))
      .filter((value): value is string => Boolean(value));

    if (instructionIds.length !== normalizedNextInstructions.length) {
      this.setEmergencyInstructionRecords(previousInstructions);
      this.patchEmergencyInstructions(this.instructionsProperty._id as string, this.emergencyInstructions);
      this.message.error(this.translate.instant('PROPERTY_INSTRUCTIONS.REORDER_ERROR'));
      return;
    }

    this.instructionsSaving = true;
    this.propertyService.reorderEmergencyInstructions(this.instructionsProperty._id as string, instructionIds)
      .pipe(finalize(() => (this.instructionsSaving = false)))
      .subscribe({
        next: (instructions) => {
          this.setEmergencyInstructionRecords(instructions || []);
          this.patchEmergencyInstructions(this.instructionsProperty!._id as string, this.emergencyInstructions);
        },
        error: (err) => {
          if (isForbiddenError(err)) {
            return;
          }
          this.setEmergencyInstructionRecords(previousInstructions);
          this.patchEmergencyInstructions(this.instructionsProperty!._id as string, this.emergencyInstructions);
          this.message.error(this.getEmergencyInstructionErrorMessages(err, 'PROPERTY_INSTRUCTIONS.REORDER_ERROR')[0]);
        },
      });
  }

  private getEmergencyInstructionStepById(stepId: string): EmergencyInstructionBuilderStep | null {
    return this.emergencyInstructionBuilder.steps?.find((step) => step.id === stepId) || null;
  }

  emergencyInstructionIconLabelKey(iconKey?: string | null): string {
    if (!iconKey) {
      return 'PROPERTY_INSTRUCTIONS.ICON.WARNING';
    }
    return this.emergencyInstructionIconOptions.find((icon) => icon.key === iconKey)?.labelKey || 'PROPERTY_INSTRUCTIONS.ICON.WARNING';
  }

  openEmergencyInstructionIconPickerForGuide(): void {
    this.emergencyInstructionIconPickerTarget = { type: 'guide' };
    this.emergencyInstructionIconPickerVisible = true;
  }

  openEmergencyInstructionIconPickerForStep(step: EmergencyInstructionBuilderStep): void {
    if (!step?.id) {
      return;
    }
    this.emergencyInstructionIconPickerTarget = { type: 'step', stepId: step.id };
    this.emergencyInstructionIconPickerVisible = true;
  }

  closeEmergencyInstructionIconPicker(): void {
    this.emergencyInstructionIconPickerVisible = false;
    this.emergencyInstructionIconPickerTarget = null;
  }

  getSelectedEmergencyInstructionIconKey(): string | null {
    if (!this.emergencyInstructionIconPickerTarget) {
      return null;
    }
    if (this.emergencyInstructionIconPickerTarget.type === 'guide') {
      return this.emergencyInstructionBuilder.iconKey || null;
    }
    return this.getEmergencyInstructionStepById(this.emergencyInstructionIconPickerTarget.stepId)?.iconKey || null;
  }

  selectEmergencyInstructionIcon(iconKey: string): void {
    if (!this.emergencyInstructionIconPickerTarget) {
      return;
    }
    if (this.emergencyInstructionIconPickerTarget.type === 'guide') {
      this.emergencyInstructionBuilder.iconKey = iconKey;
      this.closeEmergencyInstructionIconPicker();
      return;
    }

    const step = this.getEmergencyInstructionStepById(this.emergencyInstructionIconPickerTarget.stepId);
    if (!step) {
      this.closeEmergencyInstructionIconPicker();
      return;
    }

    step.iconKey = iconKey;
    this.closeEmergencyInstructionIconPicker();
  }

  openEmergencyInstructionsModal(property: Property): void {
    if (this.appMode !== 'emergency') return;

    this.instructionsProperty = property;
    this.instructionsModalVisible = true;
    if (
      this.caretakers.length === 0
      || this.propertyManagersModel.length === 0
      || this.technicalAssetsManagers.length === 0
      || this.sevManagersModel.length === 0
      || this.technicalServicesModel.length === 0
    ) {
      this.loadCompanyEmployeesAndServices().finally(() => {
        if (this.instructionsModalVisible && this.instructionsProperty?._id === property._id) {
          this.scheduleEmergencyInstructionContactOptionsRefresh(this.instructionsProperty);
        }
      });
    }
    this.scheduleEmergencyInstructionContactOptionsRefresh(property);
    this.resetEmergencyInstructionBuilder();

    // show what we already have immediately
    this.setEmergencyInstructionRecords(property.emergencyInstructions || []);

    // then refresh from BE
    this.instructionsModalLoading = true;
    this.propertyService
      .getEmergencyInstructions(property._id as string, property.companyId || this.company?._id)
      .pipe(finalize(() => (this.instructionsModalLoading = false)))
      .subscribe({
        next: (instructions) => {
          this.setEmergencyInstructionRecords(instructions || []);
          this.patchEmergencyInstructions(property._id as string, this.emergencyInstructions);
          this.scheduleEmergencyInstructionContactOptionsRefresh(this.instructionsProperty);
        },
        error: () => {
          this.message.error(this.translate.instant('PROPERTY_INSTRUCTIONS.LOAD_ERROR'));
        },
      });
  }

  closeEmergencyInstructionsModal(): void {
    this.instructionsModalVisible = false;
    this.closeBulkApplyModal();
    this.closeEmergencyInstructionIconPicker();
    if (this.emergencyInstructionContactOptionsRefreshHandle) {
      clearTimeout(this.emergencyInstructionContactOptionsRefreshHandle);
      this.emergencyInstructionContactOptionsRefreshHandle = null;
    }
    if (this.emergencyInstructionTemplateHintTimeout) {
      clearTimeout(this.emergencyInstructionTemplateHintTimeout);
      this.emergencyInstructionTemplateHintTimeout = null;
    }
    this.emergencyInstructionTemplateHintVisible = false;
    this.emergencyInstructionContactOptionsLoading = false;
    this.rebuildEmergencyInstructionContactOptionsForProperty(null);
    this.instructionsProperty = null;
    this.emergencyInstructions = [];
    this.emergencyInstructionRecordById.clear();
    this.editingEmergencyInstructionId = null;
    this.emergencyInstructionDocumentOptions = [];
    this.resetEmergencyInstructionBuilder();
  }

  addEmergencyInstruction(): void {
    if (this.appMode !== 'emergency') return;
    if (!this.instructionsProperty?._id) return;

    this.emergencyInstructionSaveAttempted = true;
    this.emergencyInstructionSaveMessages = this.buildEmergencyInstructionValidationMessages();
    if (this.emergencyInstructionSaveMessages.length) {
      this.expandEmergencyInstructionStepsWithValidationErrors();
      this.message.warning(this.emergencyInstructionSaveMessages[0]);
      return;
    }
    const payload = this.buildEmergencyInstructionPayload();

    const instructionId = this.normalizeEmergencyInstructionId(this.editingEmergencyInstructionId);
    const isEdit = Boolean(instructionId);
    if (this.editingEmergencyInstructionId && !instructionId) {
      this.message.error(this.translate.instant('PROPERTY_INSTRUCTIONS.INVALID_EDIT_TARGET'));
      return;
    }

    this.instructionsSaving = true;

    const req$ = isEdit
      ? this.propertyService.updateEmergencyInstruction(
        this.instructionsProperty._id as string,
        instructionId as string,
        payload
      )
      : this.propertyService.createEmergencyInstruction(this.instructionsProperty._id as string, payload);

    req$
      .pipe(finalize(() => (this.instructionsSaving = false)))
      .subscribe({
        next: (instructions) => {
          this.setEmergencyInstructionRecords(instructions || []);
          this.patchEmergencyInstructions(this.instructionsProperty!._id as string, this.emergencyInstructions);
          this.emergencyInstructionSaveMessages = [];

          this.message.success(this.translate.instant('PROPERTY_INSTRUCTIONS.SAVE_SUCCESS'));

          // exit edit mode + reset form (keep modal open)
          this.editingEmergencyInstructionId = null;
          this.resetEmergencyInstructionBuilder();
        },
        error: (err) => {
          if (isForbiddenError(err)) {
            return;
          }
          this.emergencyInstructionSaveMessages = this.getEmergencyInstructionErrorMessages(err, 'PROPERTY_INSTRUCTIONS.SAVE_ERROR');
          this.message.error(this.emergencyInstructionSaveMessages[0]);
        },
      });
  }

  editEmergencyInstruction(ins: EmergencyInstruction): void {
    const target = this.resolveEmergencyInstructionTarget(ins);
    if (!target.instructionId || !target.instruction) {
      this.message.error(this.translate.instant('PROPERTY_INSTRUCTIONS.INVALID_TARGET_REFRESH'));
      return;
    }

    this.editingEmergencyInstructionId = target.instructionId;
    this.resetEmergencyInstructionBuilder(target.instruction);
    this.maybeReconcileEmergencyInstructionSelectedContactKeys();
    this.scheduleEmergencyInstructionContactOptionsRefresh(this.instructionsProperty);
    if (this.instructionsProperty?._id && this.emergencyInstructionBuilder.steps.some((step) => step.actionType === 'document')) {
      this.loadEmergencyInstructionDocumentOptions(this.instructionsProperty._id as string);
    }
  }

  cancelEditEmergencyInstruction(): void {
    this.editingEmergencyInstructionId = null;
    this.resetEmergencyInstructionBuilder();
  }

  confirmDeleteEmergencyInstruction(ins: EmergencyInstruction): void {
    const target = this.resolveEmergencyInstructionTarget(ins);
    if (!this.instructionsProperty?._id) return;
    if (!target.instructionId) {
      this.message.error(this.translate.instant('PROPERTY_INSTRUCTIONS.INVALID_TARGET_REFRESH'));
      return;
    }

    this.modal.confirm({
      nzTitle: this.translate.instant('PROPERTY_INSTRUCTIONS.DELETE_CONFIRM_TITLE'),
      nzContent: this.translate.instant('PROPERTY_INSTRUCTIONS.DELETE_CONFIRM_CONTENT'),
      nzOkText: this.translate.instant('PROPERTY_INSTRUCTIONS.DELETE_CONFIRM_OK'),
      nzCancelText: this.translate.instant('PROPERTY_INSTRUCTIONS.DELETE_CONFIRM_CANCEL'),
      nzOkDanger: true,
      nzOnOk: () => this.deleteEmergencyInstruction(target.instructionId as string),
    });
  }

  private deleteEmergencyInstruction(instructionId: string): void {
    if (!this.instructionsProperty?._id) return;

    this.instructionsSaving = true;
    this.propertyService.deleteEmergencyInstruction(this.instructionsProperty._id as string, instructionId)
      .pipe(finalize(() => (this.instructionsSaving = false)))
      .subscribe({
      next: (instructions) => {
        this.setEmergencyInstructionRecords(instructions || []);
        this.patchEmergencyInstructions(this.instructionsProperty!._id as string, this.emergencyInstructions);

        // ✅ If we deleted the instruction currently being edited, exit edit mode and clear the form
        if (this.editingEmergencyInstructionId === instructionId) {
          this.editingEmergencyInstructionId = null;
          this.resetEmergencyInstructionBuilder();
        }

        this.message.success(this.translate.instant('PROPERTY_INSTRUCTIONS.DELETE_SUCCESS'));
      },
      error: (err) => {
        if (isForbiddenError(err)) {
          return;
        }
        this.message.error(err?.error?.message || this.translate.instant('PROPERTY_INSTRUCTIONS.DELETE_ERROR'));
      },
    });
  }

  private patchEmergencyInstructions(propertyId: string, instructions: EmergencyInstruction[]): void {
    const patch = (list: Property[]) => {
      const idx = list.findIndex(p => (p._id as string) === propertyId);
      if (idx >= 0) list[idx].emergencyInstructions = instructions;
    };

    patch(this.allProperties);
    patch(this.properties);

    if (this.selectedProperty?._id === propertyId) {
      this.selectedProperty.emergencyInstructions = instructions;
    }
  }

  private patchDocumentSectionsForProperty(propertyId: string, sections: PropertyDocumentSectionUi[]): void {
    const nextSections = sections.map((section) => ({ ...section }));
    const patch = (list: Property[]) => {
      const idx = list.findIndex((property) => (property._id as string) === propertyId);
      if (idx >= 0) {
        list[idx].documentSections = nextSections;
      }
    };

    patch(this.allProperties);
    patch(this.properties);

    if (this.selectedProperty?._id === propertyId) {
      this.selectedProperty.documentSections = nextSections;
    }
  }

  private clearDocumentSectionPromotionProvenance(section: Partial<PropertyDocumentSectionUi> | null | undefined): void {
    if (!section) {
      return;
    }
    section.originSectionId = undefined;
    section.originPropertyId = undefined;
    section.bulkGroupId = undefined;
    section.clonedFromSectionId = undefined;
  }

  private clearEmergencyInstructionPromotionProvenance(instruction: Partial<EmergencyInstruction> | null | undefined): void {
    if (!instruction) {
      return;
    }
    instruction.originInstructionId = undefined;
    instruction.originPropertyId = undefined;
    instruction.bulkGroupId = undefined;
    instruction.clonedFromInstructionId = undefined;
  }

  get technicalServicesControl(): AbstractControl | null {
    return this.technicalServices?.at(0)?.get('serviceType') ?? null;
  }

  get showTechnicalServicesRequiredError(): boolean {
    const c = this.technicalServicesControl;
    return !!(c && c.invalid && (c.touched || c.dirty));
  }

  get showPropertyManagersSectionError(): boolean {
    return this.propertyManagers.controls.some(ctrl => {
      const g = ctrl as FormGroup;
      return !!(g.hasError('emailOrPhoneRequired') && (g.touched || g.dirty));
    });
  }

  get canWriteTemplates(): boolean {
    return this.authService.hasPermission('company.templates.write');
  }

  get canBulkApplyDocumentSections(): boolean {
    return this.authService.hasPermission('company.property_documents.write');
  }

  get canBulkDeleteDocumentSections(): boolean {
    return this.authService.hasPermission('company.property_documents.delete');
  }

  get canBulkApplyEmergencyInstructions(): boolean {
    return this.authService.hasPermission('company.emergency_instructions.write');
  }

  get canDeleteEmergencyInstructions(): boolean {
    return this.authService.hasPermission('company.emergency_instructions.delete');
  }

  canUseDocumentSectionBulkActions(section: PropertyDocumentSectionUi): boolean {
    return Boolean(
      section?._id &&
      section?.isPersisted &&
      !this.documentModalHasUnsavedChanges &&
      !this.hasDocumentUploadsInProgress
    );
  }

  getDocumentSectionBulkActionDisabledReason(section: PropertyDocumentSectionUi): string {
    if (!section?._id || !section?.isPersisted) return 'DOCUMENT_MODAL.BULK_ACTIONS_REQUIRE_SAVE';
    if (this.hasDocumentUploadsInProgress) return 'DOCUMENT_MODAL.BULK_ACTIONS_WAIT_FOR_UPLOADS';
    if (this.documentModalHasUnsavedChanges) return 'DOCUMENT_MODAL.BULK_ACTIONS_REQUIRE_MODAL_SAVE';
    return '';
  }

  private positiveIntegerValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || typeof value === 'undefined' || value === '') {
      return null;
    }

    const numericValue = Number(value);
    if (!Number.isFinite(numericValue) || !Number.isInteger(numericValue)) {
      return { wholeNumber: true };
    }
    return null;
  }

  private propertyLimitIncreaseValidator(control: AbstractControl): ValidationErrors | null {
    const positiveIntegerError = this.positiveIntegerValidator(control);
    if (positiveIntegerError) {
      return positiveIntegerError;
    }

    const value = Number(control.value);
    if (!Number.isFinite(value) || control.value === null || control.value === '') {
      return null;
    }

    if (this.licensedMaxProperties !== null && value <= this.licensedMaxProperties) {
      return { mustExceedCurrent: true };
    }

    if (value < this.usedPropertiesCount) {
      return { belowUsed: true };
    }

    return null;
  }

  private openUpgradeContractDraftModalForProperties(): void {
    const suggestedRequestedMaxProperties = Math.max((this.licensedMaxProperties ?? 0) + 1, this.usedPropertiesCount + 1, 1);
    const modalRef = this.modal.create({
      nzContent: UpgradeContractModalComponent,
      nzTitle: this.translate.instant('UPGRADE_CONTRACT_MODAL.TITLE'),
      nzFooter: null,
      nzWidth: 860,
      nzClosable: false,
      nzMaskClosable: false,
      nzData: {
        source: 'properties',
        suggestedRequestedMaxProperties,
        suggestedAdditionalUsersCount: 0,
      },
    });

    modalRef.afterClose.subscribe((result) => {
      if (result?.signed) {
        if (result.pendingActivation) {
          this.pendingUpgrade = {
            plan: result.pendingPlan || result.plan || this.pendingUpgrade?.plan || null,
            maxProperties: result.pendingMaxProperties ?? this.pendingUpgrade?.maxProperties ?? null,
            seatLimit: result.pendingSeatLimit ?? this.pendingUpgrade?.seatLimit ?? null,
            contractStartDate: result.draft?.contractStartDate || this.pendingUpgrade?.contractStartDate || null,
            billingDocumentId: result.billingDocumentId || null,
          };
        } else {
          if (this.company) {
            this.company.plan = result.plan || this.company.plan;
            if (typeof result.maxProperties === 'number') {
              this.company.maxProperties = result.maxProperties;
            }
          }
          this.pendingUpgrade = null;
        }

        this.loadCompanyInfo().catch((error) => {
          console.error('Failed to refresh company after contract signing', error);
        });
    void this.loadUpgradeSettingsIfAdmin();

      }
    });
  }
}
